webpackJsonp([1],{

/***/ "+34z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_editor__ = __webpack_require__("+qPk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-html-editor',
  data: function data() {
    return {
      customToolbar: [['bold', 'italic'], [{ list: 'ordered' }, { list: 'bullet' }]],
      editorOptions: {
        formats: ['bold', 'italic', 'list']
      },
      isMounted: false,
      componentValid: true
    };
  },

  components: {
    'vue-editor': __WEBPACK_IMPORTED_MODULE_0_vue2_editor__["a" /* VueEditor */]
  },
  computed: {
    textLength: function textLength() {
      if (this.isMounted) {
        if (this.$refs['editor'] != null) {
          return this.$refs['editor'].quill.getLength() - 1;
        }
      }
      return 0;
    },

    text: {
      get: function get() {
        return this.value;
      },
      set: function set(v) {
        this.$emit('input', v);
      }
    },
    isValid: function isValid() {
      return this.textLength <= this.maxLength;
    },
    showError: function showError() {
      return this.type === 'is-danger';
    }
  },
  props: {
    maxLength: {
      type: Number,
      default: 1000
    },
    value: {
      type: String
    },
    type: {
      type: String
    }
  },
  mounted: function mounted() {
    this.isMounted = true;
  },

  watch: {
    isValid: function isValid(value) {
      this.componentValid = value;
    }
  }
});

/***/ }),

/***/ "+CPT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+DrZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maco", function() { return maco; });
// TODO:
// Maybe we should evaluate to read the maco token
// from the cookie "de.ul.leurisProfile"
// Cookie.getJSON('de.ul.leurisProfile').user.token (js-cookie)

var maco = function maco(state) {
  return state.maco;
};

/***/ }),

/***/ "+QKV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+U2w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicListViewHeader_vue__ = __webpack_require__("wmBm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_651011ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicListViewHeader_vue__ = __webpack_require__("DHmx");
function injectStyle (ssrContext) {
  __webpack_require__("TJVf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicListViewHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_651011ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicListViewHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+Uvw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);


/* harmony default export */ __webpack_exports__["a"] = ({
  organisationseinheit: {
    name: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) }
  },
  jahr: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minValue"])(1409) },
  email: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["email"] }
});

/***/ }),

/***/ "+n61":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  loading: false,
  rootData: {},
  selected: {
    id: 1,
    name: 'Universität Leipzig'
  },
  open: [],
  branch: {}
});

/***/ }),

/***/ "+pJ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setResourceType", function() { return setResourceType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changePage", function() { return changePage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPerPage", function() { return setPerPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSortField", function() { return setSortField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSortOrder", function() { return setSortOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateFilter", function() { return updateFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateListSchemaFields", function() { return updateListSchemaFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prefillOrga", function() { return prefillOrga; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveView", function() { return saveView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "switchView", function() { return switchView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetList", function() { return resetList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

// import api from '@/api'

var setResourceType = function setResourceType(_ref, type) {
  var state = _ref.state,
      commit = _ref.commit;

  commit('SET_RESOURCE_TYPE', type);
};

var changePage = function changePage(_ref2, page) {
  var state = _ref2.state,
      commit = _ref2.commit;

  commit('CHANGE_PAGE', page);
};

var setPerPage = function setPerPage(_ref3, perPage) {
  var state = _ref3.state,
      commit = _ref3.commit;

  commit('SET_PER_PAGE', perPage);
};

var setSortField = function setSortField(_ref4, sortField) {
  var state = _ref4.state,
      commit = _ref4.commit;

  commit('SET_SORT_FIELD', sortField);
};

var setSortOrder = function setSortOrder(_ref5, order) {
  var state = _ref5.state,
      commit = _ref5.commit;

  commit('SET_SORT_ORDER', order);
};

var updateFilter = function updateFilter(_ref6, updatedFilter) {
  var state = _ref6.state,
      commit = _ref6.commit;

  commit('UPDATE_FILTER', updatedFilter);
};

var updateListSchemaFields = function updateListSchemaFields(_ref7, updatedListSchemaFields) {
  var state = _ref7.state,
      commit = _ref7.commit;

  commit('UPDATE_LIST_SCHEMA_FIELDS', updatedListSchemaFields);
};

var prefillOrga = function prefillOrga(_ref8, orga) {
  var commit = _ref8.commit;

  commit('PREFILL_ORGA', orga);
};

var saveView = function saveView(_ref9, name) {
  var state = _ref9.state,
      dispatch = _ref9.dispatch;

  var visibleColumns = state.listSchema[state.resourceType].fields.filter(function (x) {
    return x.tableVisible;
  }).map(function (x) {
    return x.field;
  });
  var schema = state.listSchema[state.resourceType];
  var viewConfiguration = {
    name: name,
    className: schema.className,
    filter: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.filter[state.resourceType]),
    config: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.config[state.resourceType]),
    columns: visibleColumns
  };
  dispatch('user/saveView', viewConfiguration, { root: true });
};

var switchView = function switchView(_ref10, index) {
  var state = _ref10.state,
      rootState = _ref10.rootState,
      dispatch = _ref10.dispatch,
      commit = _ref10.commit;

  var view = rootState.user.savedViews.find(function (x) {
    return x.id === index;
  });
  console.log(view.className);
  commit('SET_RESOURCE_TYPE', view.className.toLowerCase());
  commit('UPDATE_FILTER', view.filter);
  commit('SET_PER_PAGE', view.config.perPage);
  commit('SET_SORT_ORDER', view.config.sortOrder);
  commit('SET_SORT_FIELD', view.config.sortField);
  commit('CHANGE_PAGE', view.config.page);
  commit('TOGGLE_COLUMNS', view.columns);
};

var resetList = function resetList(_ref11) {
  var commit = _ref11.commit;

  commit('RESET_LIST');
};

/***/ }),

/***/ "+qpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__ = __webpack_require__("cigy");

var Filter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__["a" /* default */])('Person');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Person',
  route: 'person',
  fields: [Filter.ReferenceByMultiValueSearchRep('organisationseinheiten', 'sitemap', 'organisationseinheit'), Filter.kumuliert(), Filter.String('titel'), Filter.String('vorname'), Filter.String('name'), Filter.String('fisPersid'), Filter.String('personIdentWert')]
});

/***/ }),

/***/ "+rFF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityTableSelectVertical_vue__ = __webpack_require__("sDBV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11f779b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityTableSelectVertical_vue__ = __webpack_require__("whBG");
function injectStyle (ssrContext) {
  __webpack_require__("9+kj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityTableSelectVertical_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11f779b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityTableSelectVertical_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+ueH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



function createRouterLink() {
  var initialObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var methods = {
    withQuery: function withQuery(params) {
      return createRouterLink(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this, {
        query: params
      }));
    }
  };

  var handler = {
    get: function get(target, prop) {
      if (prop in target) {
        return target[prop];
      }

      if (prop in methods) {
        return methods[prop].bind(target);
      }

      return undefined;
    }
  };

  return new Proxy(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initialObj), handler);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    activeResourceType: 'publicView/getResourceType',
    publicViewSelected: 'publicView/getSelected'
  })),
  methods: {
    currentPublicRoute: function currentPublicRoute() {
      return createRouterLink({
        name: 'public',
        params: {
          type: this.publicViewSelected.type || 'ou',
          id: this.publicViewSelected.id || 1,
          resourceType: this.activeResourceType || 'forschungsprojekt'
        }
      });
    }
  }
});

/***/ }),

/***/ "/+mb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("xCOD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__("iAEu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__("IKL4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("eoqk");





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__
});

/***/ }),

/***/ "/9tF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kooperation_vue__ = __webpack_require__("4mkt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34d51e02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Kooperation_vue__ = __webpack_require__("824M");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kooperation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34d51e02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Kooperation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/RB0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/jsf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  loading: false,
  schema: null,
  data: {}
});

/***/ }),

/***/ "04Ux":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFieldsGeneric__ = __webpack_require__("K13K");

var ListFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ListFieldsGeneric__["a" /* default */])('Kooperation');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Kooperation',
  route: 'kooperation',
  className: 'kooperation',
  fields: [ListFields.SortableTimestamp('_updateDate', false, 'updateDate', true), ListFields.SortableTimestamp('_createDate', false, 'createDate', true), ListFields.SortableReference('organisationseinheit', false), ListFields.UnsortableReference('weitereOrganisationseinheiten', false), ListFields.UnsortableReference('ansprechpartner', true), ListFields.SortableField('titelKooperation', true), ListFields.SortableDate('beginn', false), ListFields.SortableDate('ende', false), ListFields.UnsortableReference('beteiligteOrganisationen', false)]
});

/***/ }),

/***/ "0BjP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fob-entity-compact columns"},[_c('div',{staticClass:"column is-narrow fob-hide-in-print",staticStyle:{"width":"5rem"}},[_c('b-field',{attrs:{"addon":""}},[_c('router-link',{staticClass:"control",attrs:{"to":{ name: _vm.entityDetailsRoute,
              params: {
                resourceType: _vm.resourceType,
                resourceId: _vm.resourceId
              }
            }}},[_c('b-tooltip',{attrs:{"square":"","position":"is-top","label":_vm.$gettext('component.entity.compact.details')}},[_c('b-icon',{attrs:{"icon":"search","type":"is-aquamarine"}})],1)],1),_vm._v(" "),(_vm.userCanEditByKostenstelle(_vm.data))?_c('router-link',{staticClass:"control",attrs:{"to":{ name: _vm.entityEditRoute,
              params: {
                resourceType: _vm.resourceType,
                resourceId: _vm.resourceId
              }
            }}},[_c('b-tooltip',{attrs:{"square":"","position":"is-top","label":_vm.$gettext('component.entity.compact.edit')}},[_c('b-icon',{attrs:{"icon":"edit","type":"is-aquamarine"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.showStar)?_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.favourResearchActivity({
          resourceType: _vm.resourceType,
          resourceId: _vm.resourceId
        })}}},[_c('b-tooltip',{attrs:{"square":"","position":"is-top","label":_vm.isFavouredResearchActivity({resourceType: _vm.resourceType,resourceId: _vm.resourceId}) ?
            _vm.$gettext('component.entity.compact.favour.deselect') :
            _vm.$gettext('component.entity.compact.favour.select')}},[_c('b-icon',{attrs:{"icon":_vm.isFavouredResearchActivity({resourceType: _vm.resourceType,resourceId: _vm.resourceId}) ? 'star' : 'star-o',"type":"is-aquamarine"}})],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"column"},[(_vm.hasCompactComponent)?_c(_vm.compactComponentName,{tag:"component",staticClass:"fob-entity-compact-component",attrs:{"schema":_vm.schema,"data":_vm.data}}):_c('div',[_vm._v("\n      "+_vm._s(_vm.data._stringRep)+"\n    ")])],1),_vm._v(" "),(_vm.showPublicationType)?_c('div',{staticClass:"fob-hide-in-print"},[_c('translate',{staticClass:"tag is-aquamarine"},[_vm._v(_vm._s(("PublikationsTyp." + (_vm.data.publikationsTyp))))])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0IiM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticStyle:{"background":"white"}},[_c('nav',[_c('div',{staticClass:"level-right",staticStyle:{"padding-right":"50px"}},[_c('div',{staticClass:"level-item"},[_c('div',[(_vm.userIsAuthorized && _vm.userActiveViewState !== 1)?_c('div',[(_vm.userIsAuthorized && _vm.userOrgas.length > 0)?_c('b-dropdown',{model:{value:(_vm.activeOrga),callback:function ($$v) {_vm.activeOrga=$$v},expression:"activeOrga"}},[_c('button',{staticClass:"button is-basalt",attrs:{"slot":"trigger"},slot:"trigger"},[_c('span',[_vm._v(_vm._s(_vm.userOrgas[_vm.activeOrga].name))]),_vm._v(" "),_c('b-icon',{attrs:{"type":"is-small","icon":"angle-down"}})],1),_vm._v(" "),_vm._l((_vm.userOrgas),function(orga,i){return _c('b-dropdown-item',{key:orga.kst,attrs:{"value":i}},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-content"},[_c('h3',[_vm._v(_vm._s(orga.name))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(orga.parentName))])])])])})],2):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.userIsAuthorized || _vm.userActiveViewState === 1)?_c('div',{staticClass:"fob-public-menu",staticStyle:{"display":"flex","flex-direction":"row","justify-content":"flex-end"}},[_c('div',{staticClass:"navbar is-transparent fob-public-navbar",attrs:{"role":"navigation","aria-label":"dropdown navigation"}},[_c('div',{staticClass:"navbar-menu is-active"},[_c('div',{staticClass:"navbar-end"},[(this.$leurisMode === 'FOB')?_c('router-link',{staticClass:"navbar-item",attrs:{"to":{ name: 'start' },"exact":""}},[_c('b-icon',{staticStyle:{"margin-right":"5px"},attrs:{"icon":"home","size":"is-small"}}),_vm._v(" "),_c('translate',[_vm._v("menu.start")])],1):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"navbar-item",attrs:{"to":{ name: 'welcome'},"exact":""}},[_c('b-icon',{staticStyle:{"margin-right":"5px"},attrs:{"icon":"home","size":"is-small"}}),_vm._v(" "),_c('translate',[_vm._v("menu.start")])],1),_vm._v(" "),_c('router-link',{staticClass:"navbar-item",attrs:{"to":_vm.toCurrentRoute,"tag":"a"}},[_c('b-icon',{staticStyle:{"margin-right":"5px"},attrs:{"icon":"globe","size":"is-small"}}),_vm._v(" "),_c('translate',[_vm._v("menu.list.public")])],1),_vm._v(" "),(_vm.userIsAuthorized)?_c('div',{staticClass:"navbar-item is-hoverable has-dropdown"},[_c('a',{staticClass:"navbar-link"},[_c('b-icon',{staticStyle:{"margin-right":"5px"},attrs:{"icon":"question-circle","size":"is-small"}}),_vm._v(" "),_c('translate',[_vm._v("menu.help")])],1),_vm._v(" "),_c('div',{staticClass:"navbar-dropdown"},[_c('a',{staticClass:"navbar-item",attrs:{"href":"https://fob.uni-leipzig.de/wiki/doku.php?id=haeufige_fragen"}},[_c('translate',[_vm._v("menu.help.faq")])],1),_vm._v(" "),_c('a',{staticClass:"navbar-item",attrs:{"href":"https://fob.uni-leipzig.de/wiki/doku.php?id=start#das_allerwichtigste_in_kuerze"}},[_c('translate',[_vm._v("menu.help.mostImportantInANutshell")])],1),_vm._v(" "),_c('a',{staticClass:"navbar-item",attrs:{"href":"https://schulung.uni-leipzig.de/leuris-schulung"}},[_c('translate',[_vm._v("menu.help.videoTutorials")])],1),_vm._v(" "),_c('hr',{staticClass:"navbar-divider"}),_vm._v(" "),_c('div',{staticClass:"navbar-item"},[_vm._v("\n                        Version: "+_vm._s(_vm.version)+"\n                      ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"navbar-item has-dropdown is-boxed is-hoverable"},[_c('a',{staticClass:"navbar-link"},[_c('b-icon',{staticStyle:{"margin-right":"5px"},attrs:{"icon":"flag","size":"is-small"}}),_vm._v(" "),_c('translate',[_vm._v("menu.language")])],1),_vm._v(" "),_c('div',{staticClass:"navbar-dropdown"},_vm._l((_vm.$language.available),function(language,key){return _c('a',{key:key,staticClass:"navbar-item",class:{'is-active': _vm.$language.current === key},on:{"click":function($event){_vm.changeLanguage(key)}}},[_c('translate',[_vm._v(_vm._s(("menu.language." + language)))])],1)}))])],1)])])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0Uwt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0r7M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AbstractPerson__ = __webpack_require__("BP7K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Organisationseinheit__ = __webpack_require__("tTX3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Patent__ = __webpack_require__("pl+S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Person__ = __webpack_require__("Cfye");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Forschungsprojekt__ = __webpack_require__("bMTA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Kooperation__ = __webpack_require__("NWfb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Land__ = __webpack_require__("eFxi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Preis__ = __webpack_require__("pLHl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Publikation__ = __webpack_require__("6kgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Veranstaltung__ = __webpack_require__("I5KR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ExterneOrganisation__ = __webpack_require__("Vu0z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AppUser__ = __webpack_require__("q4Jw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Mittelgeber__ = __webpack_require__("TFk4");














/* harmony default export */ __webpack_exports__["a"] = (function (user) {
  var activities = [__WEBPACK_IMPORTED_MODULE_4__Forschungsprojekt__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__Publikation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__Preis__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__Kooperation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__Veranstaltung__["a" /* default */]];

  var masterdata = [];

  var administration = [];

  var editable = [__WEBPACK_IMPORTED_MODULE_0__AbstractPerson__["a" /* default */]];

  if (user.roles.TRANSFER || user.roles.ADMIN) {
    activities.push(__WEBPACK_IMPORTED_MODULE_2__Patent__["a" /* default */]);
  }

  if (user.roles.ADMIN) {
    masterdata.push(__WEBPACK_IMPORTED_MODULE_1__Organisationseinheit__["a" /* default */]);
    masterdata.push(__WEBPACK_IMPORTED_MODULE_3__Person__["a" /* default */]);
    masterdata.push(__WEBPACK_IMPORTED_MODULE_0__AbstractPerson__["a" /* default */]);
    masterdata.push(__WEBPACK_IMPORTED_MODULE_10__ExterneOrganisation__["a" /* default */]);
    masterdata.push(__WEBPACK_IMPORTED_MODULE_6__Land__["a" /* default */]);
    masterdata.push(__WEBPACK_IMPORTED_MODULE_12__Mittelgeber__["a" /* default */]);
    administration.push(__WEBPACK_IMPORTED_MODULE_11__AppUser__["a" /* default */]);
  }

  return [{
    label: 'Forschungsaktivitäten',
    entities: activities
  }, {
    label: 'Stammdaten',
    entities: masterdata
  }, {
    label: 'Administration',
    entities: administration
  }, {
    label: '__editable',
    entities: editable
  }];
});

/***/ }),

/***/ "0xDb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isLowerVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dateFormatter; });
/* unused harmony export timestampFormatter */
/* unused harmony export timestampAsDate */
/* unused harmony export fromNow */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return currentDateString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ToastError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ToastErrorGraphQL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ToastSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CopyToClipboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DetectMSBrowser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_buefy__ = __webpack_require__("MMSg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_buefy__);









function ToastError(error, duration, debugValues) {
  var msgTpl = void 0;
  if (debugValues) {
    // create html for debug values
    msgTpl = '<div class="toast-container" style="max-width: 800px">';
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(debugValues || {})), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref = _step.value;

        var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

        var key = _ref2[0];
        var value = _ref2[1];

        msgTpl += '\n      <div class="toast-item">\n        ' + key + '\n      </div>\n      <div class="toast-item">\n        ' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(value) + '\n      </div>';
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    msgTpl += '</div>';
    // append hr if debugValues
    msgTpl += '<hr>';
    // append error message
    msgTpl += '<div>' + error + '</div>';
  }

  __WEBPACK_IMPORTED_MODULE_7_buefy__["Toast"].open({
    duration: duration || 5000,
    message: msgTpl || error,
    position: 'is-bottom',
    type: 'is-carnelian',
    queue: false
  });
}

function ToastErrorGraphQL(_ref3) {
  var errors = _ref3.errors,
      duration = _ref3.duration;

  var msgTpl = 'A GraphQL error has occurred:<br><br>';

  errors.forEach(function (error) {
    msgTpl += error.message + '<br>';
  });

  __WEBPACK_IMPORTED_MODULE_7_buefy__["Toast"].open({
    duration: duration || 5000,
    message: msgTpl || 'A GraphQL error has occurred',
    position: 'is-bottom',
    type: 'is-carnelian',
    queue: false
  });
}

function ToastSuccess(msg, duration) {
  __WEBPACK_IMPORTED_MODULE_7_buefy__["Toast"].open({
    duration: duration || 5000,
    message: msg,
    position: 'is-bottom',
    type: 'is-aquamarine'
  });
}

function CopyToClipboard(text) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    // fallback if navigator.clipboard will not be supported by browser
    if (!navigator.clipboard) {
      var textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.bottom = 0;
      textArea.style.left = 0;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        document.body.removeChild(textArea);
        console.log('Fallback: Copying text command was ' + msg);
        if (msg === 'successful') {
          resolve();
        } else {
          reject();
        }
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
        document.body.removeChild(textArea);
        reject();
      }
    }
    // default clipboard function
    navigator.clipboard.writeText(text).then(function () {
      console.log('Async: Copying to clipboard was successful!');
      resolve();
    }, function (err) {
      console.error('Async: Could not copy text: ', err);
      reject();
    });
  });
}

/**
 * Detect Microsoft Browser (IE or Edge)
 * returns version of IE or false, if browser is not Internet Explorer
 * >= 12 : Edge
 * < 12  : IE
 * codepen: https://codepen.io/gapcode/pen/vEJNZN
 */
function DetectMSBrowser() {
  var ua = window.navigator.userAgent;

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}

// returns true if version `alt` is lower than version `neu`
// `alt` and `neu` are expected to be string of the
// form 'v0.31.2' or similar
var isLowerVersion = function isLowerVersion(alt, neu) {
  var toVersionInts = function toVersionInts(versionString) {
    return versionString.slice(1).split('.').map(function (x) {
      return Number(x);
    });
  };

  var zip = function zip(arr) {
    for (var _len = arguments.length, arrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      arrs[_key - 1] = arguments[_key];
    }

    return arr.map(function (val, i) {
      return arrs.reduce(function (a, arr) {
        return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(a), [arr[i]]);
      }, [val]);
    });
  };

  var valt = toVersionInts(alt);
  var vneu = toVersionInts(neu);
  var comparison = zip(valt, vneu);

  return comparison.reduce(function (acc, _ref4) {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
        a = _ref5[0],
        n = _ref5[1];

    return acc || a < n;
  }, false);
};

var dateFormatter = function dateFormatter(date, locale) {
  return (locale ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(date, __WEBPACK_IMPORTED_MODULE_6_moment___default.a.ISO_8601).locale(locale === 'de' ? 'de' : 'en-gb') : __WEBPACK_IMPORTED_MODULE_6_moment___default()(date)).format('L');
};

var timestampFormatter = function timestampFormatter(timestamp, locale) {
  return (locale ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(timestamp, __WEBPACK_IMPORTED_MODULE_6_moment___default.a.ISO_8601).locale(locale === 'de' ? 'de' : 'en-gb') : __WEBPACK_IMPORTED_MODULE_6_moment___default()(timestamp)).format('LL, LT');
};

var timestampAsDate = function timestampAsDate(timestamp, locale) {
  return (locale ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(timestamp, __WEBPACK_IMPORTED_MODULE_6_moment___default.a.ISO_8601).locale(locale === 'de' ? 'de' : 'en-gb') : __WEBPACK_IMPORTED_MODULE_6_moment___default()(timestamp)).format('L');
};

var fromNow = function fromNow(timestamp, locale) {
  return (locale ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(timestamp, __WEBPACK_IMPORTED_MODULE_6_moment___default.a.ISO_8601).locale(locale === 'de' ? 'de' : 'en-gb') : __WEBPACK_IMPORTED_MODULE_6_moment___default()(timestamp)).fromNow();
};

var currentDateString = function currentDateString(locale) {
  return locale ? __WEBPACK_IMPORTED_MODULE_6_moment___default()().locale(locale === 'de' ? 'de' : 'en-gb').format('LL, LT') : __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('LL, LT');
};



/***/ }),

/***/ "1/AK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    leipzigUniversityLink: function leipzigUniversityLink() {
      switch (this.currentLocale) {
        case 'de':
          return 'https://www.uni-leipzig.de';
        default:
          return 'https://www.uni-leipzig.de/en';
      }
    },
    imprintLink: function imprintLink() {
      switch (this.currentLocale) {
        case 'de':
          return 'https://www.uni-leipzig.de/impressum';
        default:
          return 'https://www.uni-leipzig.de/en/legal-notice';
      }
    },
    privacyPolicyLink: function privacyPolicyLink() {
      switch (this.currentLocale) {
        case 'de':
          return 'https://www.uni-leipzig.de/datenschutz';
        default:
          return 'https://www.uni-leipzig.de/en/privacy';
      }
    },
    portalEditLink: function portalEditLink() {
      return '/fob/bearbeiten/' + this.resourceType + '/' + (this.internalId || this.resourceId);
    },
    sdgPortalLink: function sdgPortalLink() {
      switch (this.currentLocale) {
        case 'de':
          return 'https://sdg-portal.de/de/ueber-das-projekt/17-ziele';
        default:
          return 'https://sdgs.un.org/goals';
      }
    }
  },
  methods: {
    wikiLink: function wikiLink(id, anchor) {
      var url = "https://home.uni-leipzig.de/~leuriswiki/doku.php" + '?id=' + id;
      if (anchor) {
        url += '#' + anchor;
      }
      return url;
    }
  }
});

/***/ }),

/***/ "197X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.data[_vm.activeResourceType] && _vm.data[_vm.activeResourceType].length > 0)?_c('div',[_c('fob-entity-list-pagination',{attrs:{"disable-switch":true,"per-page":_vm.config[_vm.activeResourceType].perPage,"page":_vm.config[_vm.activeResourceType].page,"total":_vm.total[_vm.activeResourceType]},on:{"update:current":_vm.onPageChange}}),_vm._v(" "),_c('div',{staticClass:"fob-entity-compact-view"},[_c('fob-entity-list-compact-cyan',{attrs:{"data":_vm.data[_vm.activeResourceType],"show-publication-type":_vm.activeResourceType === 'publikation',"loading":_vm.isLoading,"entityDetailsRoute":"anzeigen_einzeln","entityEditRoute":"editieren","show-star":"true"}})],1),_vm._v(" "),_c('fob-entity-list-pagination',{attrs:{"disable-switch":true,"per-page":_vm.config[_vm.activeResourceType].perPage,"page":_vm.config[_vm.activeResourceType].page,"total":_vm.total[_vm.activeResourceType]},on:{"update:current":_vm.onPageChange}})],1):_c('div',{staticClass:"fob-public-view-no-data",staticStyle:{"padding":"1rem"}},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column",staticStyle:{"max-width":"50px"}},[_c('b-icon',{attrs:{"icon":"exclamation","type":"is-garnet"}})],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('em',[_c('translate',[_vm._v("list.noData")])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1BEw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) }
});

/***/ }),

/***/ "1CWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition-group',{attrs:{"name":"formfields","tag":"div"}},_vm._l((_vm.schema.fields.filter(function (x) { return _vm.inEditView(x) !== false; })),function(bit,i){return _c('div',{key:bit.field || bit.label,staticClass:"field formfields-item"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(bit.view === undefined || bit.view(_vm.resourceData, _vm.user) || bit.inEditView === true),expression:"bit.view === undefined || bit.view(resourceData, user) || bit.inEditView === true"}]},[(bit.type == 'prefetchedObject')?[_c('fob-label',{key:(i + "a"),attrs:{"label":bit.label,"asterisk":_vm.hasAsterisk(bit.field)}}),_vm._v(" "),_c('fob-entity-select-prefetched',{attrs:{"entity":bit.entity,"searchMethod":"findAll","icon":bit.icon,"groupBy":bit.groupBy,"orderBy":bit.orderBy,"reorder":bit.reorder,"type":(_vm.showErrors && _vm.isInvalid(bit.field)) ? 'is-danger' : '',"preselect":bit.preselect,"prefilter":bit.prefilter},model:{value:(_vm.resourceData[bit.field]),callback:function ($$v) {_vm.$set(_vm.resourceData, bit.field, $$v)},expression:"resourceData[bit.field]"}})]:(bit.type == 'object')?[(bit.cardinality == 'single')?[_c('fob-entity-select',{key:i,ref:bit.field,refInFor:true,attrs:{"type":(_vm.showErrors && _vm.isInvalid(bit.field)) ? 'is-danger' : '',"allowCreate":bit.allowCreate || false,"label":bit.label,"extraButton":bit.extraButton,"asterisk":_vm.hasAsterisk(bit.field),"icon":bit.icon,"method":bit.finder,"route":bit.schema.className,"schema":bit.schema},on:{"input":function($event){_vm.touchField(bit.field)},"custom":function (val) { return _vm.$emit('custom', val); }},model:{value:(_vm.resourceData[bit.field]),callback:function ($$v) {_vm.$set(_vm.resourceData, bit.field, $$v)},expression:"resourceData[bit.field]"}})]:_vm._e(),_vm._v(" "),(bit.cardinality === 'many')?[_c('div',{key:i,staticStyle:{"margin-bottom":"20px"}},[(!bit.onlyCreate)?[(bit.widget === 'tableSelectVertical')?[_c('fob-entity-multi-select-vertical',{attrs:{"asterisk":_vm.hasAsterisk(bit.field),"schema":bit,"type":(_vm.showErrors && _vm.isInvalid(bit.field)) ? 'is-danger' : ''},model:{value:(_vm.resourceData[bit.field]),callback:function ($$v) {_vm.$set(_vm.resourceData, bit.field, $$v)},expression:"resourceData[bit.field]"}})]:[_c('fob-entity-multi-select',{attrs:{"asterisk":_vm.hasAsterisk(bit.field),"schema":bit,"type":(_vm.showErrors && _vm.isInvalid(bit.field)) ? 'is-danger' : ''},model:{value:(_vm.resourceData[bit.field]),callback:function ($$v) {_vm.$set(_vm.resourceData, bit.field, $$v)},expression:"resourceData[bit.field]"}})]]:(bit.render === 'projektleiter')?[_c('fob-projektleiter',{attrs:{"label":"Projektleitung","asterisk":true,"validation":_vm.$v.resourceData[bit.field],"showErrors":_vm.showErrors},model:{value:(_vm.resourceData[bit.field]),callback:function ($$v) {_vm.$set(_vm.resourceData, bit.field, $$v)},expression:"resourceData[bit.field]"}})]:[_c('fob-label',{attrs:{"label":bit.label,"asterisk":_vm.hasAsterisk(bit.field)}}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('transition-group',{attrs:{"name":"list","tag":"div"}},_vm._l((_vm.resourceData[bit.field]),function(embedded,j){return _c('div',{key:embedded._id,staticClass:"box",staticStyle:{"margin-bottom":"20px"}},[_c('button',{staticClass:"button pull-right is-small is-white has-text-carnelian",on:{"click":function($event){_vm.removeEmbedded(bit.field, j)}}},[_c('b-tooltip',{staticClass:"is-carnelian",attrs:{"square":"","position":"is-top","label":_vm.$gettext(("embedded.button.remove." + (bit.field)))}},[_c('b-icon',{attrs:{"icon":"trash"}})],1)],1),_vm._v(" "),_c('fob-entity-create-form',{attrs:{"route":bit.schema.route,"icon":bit.icon,"schema":bit.schema,"showErrors":_vm.showErrors},model:{value:(_vm.resourceData[bit.field][j]),callback:function ($$v) {_vm.$set(_vm.resourceData[bit.field], j, $$v)},expression:"resourceData[bit.field][j]"}})],1)})),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){_vm.pushToEmbedded(bit.field, bit.schema.entityName)}}},[_c('translate',[_vm._v(_vm._s(("embedded.button.add." + (bit.field))))])],1)],1)]],2)]:_vm._e()]:(bit.type === Date)?[_c('fob-label',{key:(i + "a"),attrs:{"label":bit.label,"asterisk":_vm.hasAsterisk(bit.field)}}),_vm._v(" "),_c('b-field',{key:i,attrs:{"type":(_vm.showErrors && _vm.isInvalid(bit.field)) ? 'is-danger' : ''}},[_c('b-datepicker',{attrs:{"placeholder":"Type or select a date...","icon":"calendar","readonly":false,"max-date":_vm.maxDate},model:{value:(_vm.resourceData[bit.field]),callback:function ($$v) {_vm.$set(_vm.resourceData, bit.field, $$v)},expression:"resourceData[bit.field]"}})],1),_vm._v(" "),((_vm.showErrors && _vm.isInvalid(bit.field)))?[(_vm.$v.resourceData[bit.field].isAtLeastFrom === false)?_c('translate',{staticClass:"help is-danger"},[_vm._v("EntityCreateForm.invalid.date.isAtLeastFrom")]):_vm._e()]:_vm._e()]:(bit.type === 'link')?[_c('fob-label',{key:(i + "a"),attrs:{"label":bit.label,"asterisk":_vm.hasAsterisk(bit.field)}}),_vm._v(" "),_c('b-field',{key:i,attrs:{"type":(_vm.showErrors && _vm.isInvalid(bit.field)) ? 'is-danger' : ''}},[_c('b-input',{attrs:{"placeholder":"","type":"text","icon":bit.icon ? bit.icon : ''},model:{value:(_vm.resourceData[bit.field]),callback:function ($$v) {_vm.$set(_vm.resourceData, bit.field, $$v)},expression:"resourceData[bit.field]"}})],1)]:(bit.type === Number)?[_c('fob-label',{key:(i + "a"),attrs:{"label":bit.label,"asterisk":_vm.hasAsterisk(bit.field)}}),_vm._v(" "),_c('b-field',{key:i,attrs:{"grouped":"","type":(_vm.showErrors && _vm.isInvalid(bit.field)) ? 'is-danger' : ''}},[_c('b-input',{attrs:{"placeholder":"Number","type":"number","icon":bit.icon ? bit.icon : '',"min":bit.min,"max":bit.max},model:{value:(_vm.resourceData[bit.field]),callback:function ($$v) {_vm.$set(_vm.resourceData, bit.field, $$v)},expression:"resourceData[bit.field]"}}),_vm._v(" "),_c('b-tooltip',{attrs:{"square":"","position":"is-top","label":_vm.$gettext("form.xbutton")}},[_c('button',{staticClass:"button contol is-aquamarine",attrs:{"tabindex":"-1"},on:{"click":function($event){_vm.resourceData[bit.field] = null}}},[_c('b-icon',{attrs:{"icon":"times","size":"is-small"}})],1)])],1)]:(bit.type === Boolean)?[(bit.narrow)?_c('div',{key:i,staticClass:"field",staticStyle:{"margin-top":"1rem","margin-left":"1rem"}},[_c('b-checkbox',{model:{value:(_vm.resourceData[bit.field]),callback:function ($$v) {_vm.$set(_vm.resourceData, bit.field, $$v)},expression:"resourceData[bit.field]"}},[_c('span',[_c('translate',[_vm._v(" "+_vm._s(bit.label)+" ")])],1)])],1):_c('div',{key:i,staticClass:"field",staticStyle:{"margin-top":"2.5rem"}},[_c('b-checkbox',{model:{value:(_vm.resourceData[bit.field]),callback:function ($$v) {_vm.$set(_vm.resourceData, bit.field, $$v)},expression:"resourceData[bit.field]"}},[_c('span',[_c('translate',[_vm._v(" "+_vm._s(bit.label)+" ")])],1)])],1)]:(bit.type === 'select')?[_c('fob-label',{key:(i + "a"),attrs:{"asterisk":_vm.hasAsterisk(bit.field),"label":bit.label}},[(_vm.showErrors && _vm.isInvalid(bit.field))?_c('b-icon',{attrs:{"icon":"exclamation-circle","type":"is-danger"}}):_vm._e()],1),_vm._v(" "),_c('b-field',{key:i,attrs:{"grouped":"","type":(_vm.showErrors && _vm.isInvalid(bit.field)) ? 'is-danger' : ''}},[_c('b-select',{model:{value:(_vm.resourceData[bit.field]),callback:function ($$v) {_vm.$set(_vm.resourceData, bit.field, $$v)},expression:"resourceData[bit.field]"}},_vm._l((bit.values),function(option){return _c('option',{key:option.value,domProps:{"value":option.value}},[(bit.translatable)?_c('span',[_c('translate',[_vm._v(" "+_vm._s(option.label)+" ")])],1):_c('span',[_vm._v("\n                "+_vm._s(option.label)+"\n              ")])])})),_vm._v(" "),(bit.nullable !== false)?_c('b-tooltip',{attrs:{"square":"","position":"is-top","label":_vm.$gettext("form.xbutton")}},[_c('button',{staticClass:"button contol is-aquamarine",attrs:{"tabindex":"-1"},on:{"click":function($event){_vm.resourceData[bit.field] = null}}},[_c('b-icon',{attrs:{"icon":"times","size":"is-small"}})],1)]):_vm._e()],1)]:(bit.type === 'label')?[_c('fob-label',{key:i,attrs:{"label":bit.label,"asterisk":_vm.hasAsterisk(bit.field)}})]:(bit.type === 'html-text')?[_c('fob-label',{key:(i + "a"),attrs:{"asterisk":_vm.hasAsterisk(bit.field),"label":bit.label}}),_vm._v(" "),_c('fob-html-editor',{ref:bit.field,refInFor:true,attrs:{"type":(_vm.showErrors && _vm.isInvalid(bit.field)) ? 'is-danger' : '',"maxLength":bit.maxLength},on:{"input":function($event){_vm.touchField(bit.field)}},model:{value:(_vm.resourceData[bit.field]),callback:function ($$v) {_vm.$set(_vm.resourceData, bit.field, $$v)},expression:"resourceData[bit.field]"}})]:(!bit.computed)?[_c('transition',{attrs:{"name":"delay"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(bit.view === undefined || bit.view(_vm.resourceData)),expression:"bit.view === undefined || bit.view(resourceData)"}]},[_c('fob-label',{key:(i + "a"),attrs:{"asterisk":_vm.hasAsterisk(bit.field),"label":bit.label}}),_vm._v(" "),_c('b-field',{key:i,attrs:{"grouped":"","type":(_vm.showErrors && _vm.isInvalid(bit.field)) ? 'is-danger' : ''}},[(bit.type === 'text')?_c('b-input',{attrs:{"expanded":"","type":"textarea","maxlength":bit.maxlength,"value":"","placeholder":""},model:{value:(_vm.resourceData[bit.field]),callback:function ($$v) {_vm.$set(_vm.resourceData, bit.field, $$v)},expression:"resourceData[bit.field]"}}):[_c('b-input',{attrs:{"expanded":"","maxlength":bit.maxlength || 255,"has-counter":false,"icon":"pencil","value":"","placeholder":""},on:{"input":function($event){_vm.touchField(bit.field)}},model:{value:(_vm.resourceData[bit.field]),callback:function ($$v) {_vm.$set(_vm.resourceData, bit.field, $$v)},expression:"resourceData[bit.field]"}})],_vm._v(" "),_c('b-tooltip',{attrs:{"square":"","position":"is-top","label":_vm.$gettext("form.xbutton")}},[_c('button',{staticClass:"button contol is-aquamarine",attrs:{"tabindex":"-1"},on:{"click":function($event){_vm.resourceData[bit.field] = null}}},[_c('b-icon',{attrs:{"icon":"times","size":"is-small"}})],1)])],2)],1)])]:_vm._e()],2)])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1NbI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__ = __webpack_require__("9fz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldsGeneric__ = __webpack_require__("WWW9");




var Fields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__FieldsGeneric__["a" /* default */])('PreisBezeichnung');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'PreisBezeichnung',
  route: 'preisBezeichnung',
  class: __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__["PreisBezeichnung"],
  className: 'preisBezeichnung',
  fields: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.String('name'), {
    table: true
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.String('beschreibung'), {
    table: true
  })]
});

/***/ }),

/***/ "1jLr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2/cz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("/jsf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__("kL4d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__("h2RA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("VtdD");





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__
});

/***/ }),

/***/ "2Jc1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schema_list__ = __webpack_require__("izx2");


/* harmony default export */ __webpack_exports__["a"] = ({
  loading: false,
  data: {},
  id: null,
  resourceType: 'forschungsprojekt',
  listSchema: __WEBPACK_IMPORTED_MODULE_0__schema_list__["a" /* ListSchema */],
  filterSchema: __WEBPACK_IMPORTED_MODULE_0__schema_list__["b" /* FilterSchema */],
  filter: {
    forschungsprojekt: {
      kumuliert: false
    },
    kooperation: {
      kumuliert: false
    },
    publikation: {
      kumuliert: false
    },
    person: {},
    organisationseinheit: {},
    abstractperson: {},
    veranstaltung: {
      kumuliert: false
    },
    preis: {
      kumuliert: false
    },
    externeorganisation: {},
    patent: {
      kumuliert: false
    },
    land: {},
    appuser: {},
    mittelgeber: {}
  },
  config: {
    forschungsprojekt: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    kooperation: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    publikation: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    veranstaltung: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    preis: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    abstractperson: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    organisationseinheit: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    person: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    externeorganisation: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    patent: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    land: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    appuser: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    mittelgeber: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    }
  }
});

/***/ }),

/***/ "2PmH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Foerderung__ = __webpack_require__("F+TQ");




var isAtLeastFrom = function isAtLeastFrom(to, vm) {
  var from = vm.projektBeginn;
  if (to && from) {
    return from <= to;
  } else {
    return true;
  }
};

var isAtLeast = function isAtLeast(field) {
  return function (to, vm) {
    var lowerBound = vm[field];
    if (to && lowerBound) {
      return lowerBound <= to;
    } else {
      return true;
    }
  };
};

var isAtMost = function isAtMost(field) {
  return function (to, vm) {
    var upperBound = vm[field];
    if (to && upperBound) {
      return to <= upperBound;
    } else {
      return true;
    }
  };
};

var isBetween = function isBetween(beginn, ende) {
  return function (v) {
    if (!beginn) {
      return false;
    }
    if (v == null) {
      return true;
    }
    return v >= beginn && (ende == null || v <= ende);
  };
};

/* harmony default export */ __webpack_exports__["a"] = (function (beginn, ende) {
  return {
    organisationseinheit: {
      name: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) }
    },
    projektBeginn: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] },
    projektEnde: {
      isAtLeastFrom: isAtLeastFrom
    },
    titelDE: {
      required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["requiredIf"])(function (resourceData) {
        return resourceData.titelEN == null || resourceData.titelEN.length === 0;
      }),
      minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1)
    },
    titelEN: {
      required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["requiredIf"])(function (resourceData) {
        return resourceData.titelDE == null || resourceData.titelDE.length === 0;
      }),
      minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1)
    },
    beschreibungDE: {
      required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["requiredIf"])(function (resourceData) {
        return resourceData.beschreibungEN == null || resourceData.beschreibungEN.length === 0;
      }),
      minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1)
    },
    beschreibungEN: {
      required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["requiredIf"])(function (resourceData) {
        return resourceData.beschreibungDE == null || resourceData.beschreibungDE.length === 0;
      }),
      minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1)
    },
    externeProjektwebsite: {
      url: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["url"]
    },
    // projektLeiter: {
    //   name: { required, minLength: minLength(1) }
    // },
    projektleiter: {
      nonEmpty: function nonEmpty(pl) {
        return pl.length >= 1;
      },
      $each: {
        person: {
          required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
          name: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) }
        },
        startdatum: {
          withinProjectBounds: isBetween(beginn, ende),
          beforeEnddatum: isAtMost('enddatum')
        },
        enddatum: {
          withinProjectBounds: isBetween(beginn, ende),
          afterStartDatum: isAtLeast('startdatum')
        }
      }
    },
    foerderung: {
      $each: __WEBPACK_IMPORTED_MODULE_1__Foerderung__["a" /* default */]
    }
  };
});

/***/ }),

/***/ "2WFi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2WkA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_EntityListCompactCyan__ = __webpack_require__("ht1h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_EntityListPagination__ = __webpack_require__("LXsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_PublicViewHelper__ = __webpack_require__("VlMm");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-public-list-compact',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_mixins_PublicViewHelper__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    userIsLoggedIn: 'user/isAuthorized',
    data: 'publicView/getData',
    config: 'publicView/getConfig',
    schema: 'publicView/getSchema',
    total: 'publicView/getTotal',
    isLoading: 'publicView/isLoading'
  }), {
    userIsAdmin: function userIsAdmin() {
      return this.userIsLoggedIn && this.$store.getters['user/roles'].ADMIN === true;
    }
  }),
  methods: {
    onPageChange: function onPageChange(page) {
      this.$store.dispatch('publicView/changePage', {
        resourceType: this.activeResourceType,
        page: page
      });
      this.loadAsyncData();
    }
  },
  components: {
    'fob-entity-list-compact-cyan': __WEBPACK_IMPORTED_MODULE_2__components_EntityListCompactCyan__["a" /* default */],
    'fob-entity-list-pagination': __WEBPACK_IMPORTED_MODULE_3__components_EntityListPagination__["a" /* default */]
  }
});

/***/ }),

/***/ "2hmK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_CompactViewHelper__ = __webpack_require__("TGNV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-publikation-compact',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_CompactViewHelper__["a" /* default */]],
  props: ['schema', 'data'],
  computed: {
    authors: function authors() {
      var authors = this.data.author.map(this.shortNameWithIntial);

      if (authors.length > 15) {
        return authors.slice(0, 3).join('; ') + ' et al.';
      } else {
        return authors.join('; ');
      }
    },
    buchtitel: function buchtitel() {
      return this.data.buchtitel;
    },
    journal: function journal() {
      return this.data.journal;
    },
    journalNumber: function journalNumber() {
      return this.data.journalNummer;
    },
    band: function band() {
      return this.data.band;
    },
    doi: function doi() {
      var doi = this.data.publicPubIdent.filter(function (pubIdent) {
        return pubIdent.pubIdentTyp.kennung === 'DOI';
      })[0];
      var id = doi && doi.wert || '';
      var uri = encodeURI('https://doi.org/' + id);

      return { id: id, uri: uri };
    },
    herausgeber: function herausgeber() {
      var herausgeber = this.data.herausgeber.map(this.shortNameWithIntial);

      // if no editor is set, then set the institution as editor
      if (herausgeber && herausgeber.length === 0) {
        herausgeber = this.institution ? [this.institution] : [];
      }

      if (herausgeber.length === 1) {
        return herausgeber.join('; ') + ' (' + this.$gettext('Publikation.compact.Abkuerzung.Herausgeber') + '.)';
      } else if (herausgeber.length > 1) {
        return herausgeber.join('; ') + ' (' + this.$gettext('Publikation.compact.Abkuerzung.HerausgeberPlural') + '.)';
      } else {
        return '';
      }
    },
    institution: function institution() {
      return this.data.institution;
    },
    isbn: function isbn() {
      var isbn = this.data.publicPubIdent.filter(function (pubIdent) {
        return pubIdent.pubIdentTyp.kennung === 'ISBN';
      })[0];
      var id = isbn && isbn.wert || '';
      var uri = encodeURI('https://www.worldcat.org/isbn/' + id);

      return { id: id, uri: uri };
    },
    seiteEnde: function seiteEnde() {
      return this.data.seiteEnde;
    },
    seiteStart: function seiteStart() {
      return this.data.seiteStart;
    },
    title: function title() {
      return this.data.titelPublikation;
    },
    type: function type() {
      return this.data.publikationsTyp.toLowerCase();
    },
    verlagsort: function verlagsort() {
      return this.data.verlagsort;
    },
    verleger: function verleger() {
      return this.data.verleger;
    },
    year: function year() {
      return this.data.veroeffentlichungsJahr;
    }
  }
});

/***/ }),

/***/ "2i92":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);


/* harmony default export */ __webpack_exports__["a"] = ({
  pubIdentTyp: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] },
  wert: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] }
});

/***/ }),

/***/ "2kkt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMe_vue__ = __webpack_require__("bAiX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37d365f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutMe_vue__ = __webpack_require__("FXe8");
function injectStyle (ssrContext) {
  __webpack_require__("foU5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37d365f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutMe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2q6c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_EntityDetails__ = __webpack_require__("iBzs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_EntityHeader__ = __webpack_require__("sGAB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__schema_Selection__ = __webpack_require__("0r7M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__schema__ = __webpack_require__("uDTM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mixins_DynamicTitle__ = __webpack_require__("IqS5");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-entity',
  mixins: [__WEBPACK_IMPORTED_MODULE_7__components_mixins_DynamicTitle__["a" /* default */]],
  data: function data() {
    return {
      resourceTypes: __WEBPACK_IMPORTED_MODULE_5__schema__["a" /* default */].baseTypes,
      printDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["f" /* currentDateString */])(),
      leurisHead: {
        inner: 'leuris:Forschungsbericht',
        complement: 'menu.details'
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.viewEntityType !== null) {
      this.$router.push({
        name: 'anzeigen_einzeln',
        params: {
          resourceType: this.$store.getters['resource/getViewEntityType'],
          resourceId: this.$store.getters['resource/getId']
        }
      });
    }

    setInterval(function () {
      _this.printDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["f" /* currentDateString */])();
    }, 30 * 1000);
  },

  components: {
    'fob-entity-details': __WEBPACK_IMPORTED_MODULE_1__components_EntityDetails__["a" /* default */],
    'fob-entity-header': __WEBPACK_IMPORTED_MODULE_2__components_EntityHeader__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    resourceSchema: 'resource/getSchema',
    resourceData: 'resource/getData',
    resourceId: 'resource/getId',
    viewEntityType: 'resource/getViewEntityType',
    loading: 'resource/isLoading'
  }), {
    userIsAtLeastManager: function userIsAtLeastManager() {
      var roles = this.$store.getters['user/roles'];
      return roles['ADMIN'] === true || roles['MANAGER'] === true;
    },
    userCanEdit: function userCanEdit() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__schema_Selection__["a" /* default */])(this.$store.getters['user/getUser']).map(function (x) {
        return x.entities;
      }).reduce(function (x, y) {
        return x.concat(y);
      }, []).map(function (x) {
        return x.className;
      }).includes(this.resourceSchema.className) && this.userCanEditByKostenstelle(this.resourceData);
    },
    needsDeduplication: function needsDeduplication() {
      return ['person', 'forschungsprojekt'].includes(this.resourceSchema.className);
    },

    selectedType: {
      get: function get() {
        var _this2 = this;

        var index = this.resourceTypes.findIndex(function (x) {
          return x.schema.route === _this2.viewEntityType;
        });
        if (index !== -1) {
          return index;
        }
        return null;
      },
      set: function set(newType) {
        this.$router.push({
          name: 'anzeigen_einzeln',
          params: {
            resourceType: this.resourceTypes[newType].schema.route,
            resourceId: this.resourceId
          }
        });
      }
    },
    id: {
      get: function get() {
        return this.$store.getters['resource/getId'];
      },
      set: function set(value) {
        this.$router.push({
          name: 'anzeigen_einzeln',
          params: {
            resourceType: this.resourceSchema.route,
            resourceId: value
          }
        });
        // this.$store.dispatch('resource/setResource', { id: value })
        // .then(() => {
        // })
      }
    }
  }),
  methods: {
    deleteEntity: function deleteEntity() {
      var _this3 = this;

      this.$dialog.confirm({
        title: 'Datensatz löschen',
        message: 'Sind Sie wirklich sicher, dass Sie den Datensatz <strong>"' + this.resourceData._stringRep + '"</strong> l\xF6schen wollen? Diese Aktion kann <i>nicht</i> r\xFCckg\xE4ngig gemacht werden!',
        cancelText: 'Abbrechen',
        confirmText: 'Ja, jetzt löschen!',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: function onConfirm() {
          _this3.$store.dispatch('resource/doDelete').then(function () {
            _this3.$router.push({
              name: 'anzeigen'
            });
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["h" /* ToastSuccess */])(_this3.$gettext('toast.delete.record'));
          }).catch(function () {
            _this3.$store.dispatch('resetLoading');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* ToastError */])(_this3.$gettext('toast.delete.record.error'));
          });
        }
      });
    },
    editEntity: function editEntity() {
      this.$router.push({
        name: 'editieren_einzeln',
        params: {
          resourceType: this.resourceTypes[this.selectedType].schema.route,
          resourceId: this.resourceId
        }
      });
    },
    userCanEditByKostenstelle: function userCanEditByKostenstelle(data) {
      var userKst = this.$store.getters['user/selectedOrga'].kostenstelle;
      if (data.organisationseinheit != null) {
        var kostenstellen = data.organisationseinheit.kostenstellenpfad;
        if (data.weitereOrganisationseinheiten != null) {
          kostenstellen += data.weitereOrganisationseinheiten.map(function (x) {
            return x.kostenstellenpfad;
          }).join(' ');
        }
        return kostenstellen.includes(userKst) || this.$store.getters['user/roles'].ADMIN === true;
      } else {
        return true;
      }
    },
    print: function print() {
      window.print();
    }
  }
});

/***/ }),

/***/ "2zM6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AbstractPerson__ = __webpack_require__("blDO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Forschungsprojekt__ = __webpack_require__("2PmH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Publikation__ = __webpack_require__("iFDA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ExterneOrganisation__ = __webpack_require__("1BEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Foerderung__ = __webpack_require__("F+TQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Person__ = __webpack_require__("J5Ry");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PersonIdent__ = __webpack_require__("Ie2l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PubIdent__ = __webpack_require__("2i92");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Kooperation__ = __webpack_require__("w+Sa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Veranstaltung__ = __webpack_require__("E5FI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Patent__ = __webpack_require__("t1ej");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Preis__ = __webpack_require__("4Nzo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Mittelgeber__ = __webpack_require__("sM6F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Organisationseinheit__ = __webpack_require__("s17A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Export__ = __webpack_require__("+Uvw");
















/*
BEWARE:

Some of those Validations are functions, currently 'publikation' and 'preis'.
This was done so that the current year get injected into the validation
rule whenever it is imported, i.e. the rule is dynamic.

The downside is that the importing module (components/form/EntityCreateForm.vue)
now has do differentiate between the two possibilities. Ideally, every
validation could be converted into that function type rule but there is
currently no need to do so and the now implemented variant was faster.
*/
/* harmony default export */ __webpack_exports__["a"] = ({
  person: __WEBPACK_IMPORTED_MODULE_5__Person__["a" /* default */],
  abstractPerson: __WEBPACK_IMPORTED_MODULE_0__AbstractPerson__["a" /* default */],
  publikation: __WEBPACK_IMPORTED_MODULE_2__Publikation__["a" /* default */],
  forschungsprojekt: __WEBPACK_IMPORTED_MODULE_1__Forschungsprojekt__["a" /* default */],
  externeOrganisation: __WEBPACK_IMPORTED_MODULE_3__ExterneOrganisation__["a" /* default */],
  foerderung: __WEBPACK_IMPORTED_MODULE_4__Foerderung__["a" /* default */],
  personIdent: __WEBPACK_IMPORTED_MODULE_6__PersonIdent__["a" /* default */],
  pubIdent: __WEBPACK_IMPORTED_MODULE_7__PubIdent__["a" /* default */],
  kooperation: __WEBPACK_IMPORTED_MODULE_8__Kooperation__["a" /* default */],
  veranstaltung: __WEBPACK_IMPORTED_MODULE_9__Veranstaltung__["a" /* default */],
  patent: __WEBPACK_IMPORTED_MODULE_10__Patent__["a" /* default */],
  preis: __WEBPACK_IMPORTED_MODULE_11__Preis__["a" /* default */],
  mittelgeber: __WEBPACK_IMPORTED_MODULE_12__Mittelgeber__["a" /* default */],
  organisationseinheit: __WEBPACK_IMPORTED_MODULE_13__Organisationseinheit__["a" /* default */],
  export: __WEBPACK_IMPORTED_MODULE_14__Export__["a" /* default */]
});

/***/ }),

/***/ "3LY0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"label",staticStyle:{"margin-top":"40px","margin-bottom":"10px"}},[_c('translate',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),(_vm.asterisk)?_c('span',[_vm._v("*")]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3N7C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_CompactViewHelper__ = __webpack_require__("TGNV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_DateTimeHelper__ = __webpack_require__("5W2G");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob--compact',
  props: ['schema', 'data'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_CompactViewHelper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__components_mixins_DateTimeHelper__["a" /* default */]],
  computed: {
    title: function title() {
      if (this.currentLocale === 'de') {
        return this.data.titelDE != null && this.data.titelDE.trim() !== '' ? this.data.titelDE : this.data.titelEN || '';
      } else {
        return this.data.titelEN != null && this.data.titelEN.trim() !== '' ? this.data.titelEN : this.data.titelDE || '';
      }
    },
    funding: function funding() {
      var fundingAgency = [];
      this.data.foerderung.forEach(function (funding) {
        if (funding.mittelgeber && funding.mittelgeber.name && !fundingAgency.includes(funding.mittelgeber.name)) {
          fundingAgency.push(funding.mittelgeber.name);
        }
      });
      return fundingAgency.join('; ');
    },
    organisationalUnits: function organisationalUnits() {
      // fetch all ous
      var ous = [];
      if (this.data.organisationseinheit) {
        ous.push(this.data.organisationseinheit.name);
      }
      if (Array.isArray(this.data.weitereOrganisationseinheiten) && this.data.weitereOrganisationseinheiten.length > 0) {
        ous = ous.concat(this.data.weitereOrganisationseinheiten.map(function (ou) {
          return ou.name;
        }));
      }
      // build ous string
      return ous.join('; ');
    }
  }
});

/***/ }),

/***/ "3bPL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fob-entity-compact columns"},[_c('div',{staticClass:"column is-narrow fob-hide-in-print",staticStyle:{"width":"5rem"}},[_c('b-field',{attrs:{"addon":""}},[_c('router-link',{staticClass:"control",attrs:{"to":{ name: _vm.entityDetailsRoute,
              params: {
                resourceType: _vm.resourceType,
                resourceId: _vm.resourceId
              }
            }}},[_c('b-tooltip',{attrs:{"square":"","position":"is-top","label":_vm.$gettext('component.entity.compact.details')}},[_c('b-icon',{attrs:{"icon":"search","type":"is-aquamarine"}})],1)],1),_vm._v(" "),(_vm.userCanEditByKostenstelle(_vm.data))?[(_vm.$leurisMode === 'PORTAL')?[_c('a',{attrs:{"href":_vm.portalEditLink}},[_c('b-tooltip',{attrs:{"square":"","position":"is-top","label":_vm.$gettext('component.entity.compact.edit')}},[_c('b-icon',{attrs:{"icon":"edit","type":"is-aquamarine"}})],1)],1)]:_vm._e(),_vm._v(" "),(_vm.$leurisMode === 'FOB')?[_c('router-link',{staticClass:"control",attrs:{"to":{ name: _vm.entityEditRoute,
                  params: {
                    resourceType: _vm.resourceType,
                    resourceId: _vm.resourceId
                  }
                }}},[_c('b-tooltip',{attrs:{"square":"","position":"is-top","label":_vm.$gettext('component.entity.compact.edit')}},[_c('b-icon',{attrs:{"icon":"edit","type":"is-aquamarine"}})],1)],1)]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.showStar)?_c('span',{class:{ 'fob-menu-is-disabled': !_vm.maco.loggedIn },staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.favourResearchActivity({
          resourceType: _vm.resourceType,
          resourceId: _vm.resourceId
        })}}},[_c('b-tooltip',{attrs:{"square":"","position":"is-top","label":_vm.isFavouredResearchActivity({resourceType: _vm.resourceType,resourceId: _vm.resourceId}) ?
            _vm.$gettext('component.entity.compact.favour.deselect') :
            _vm.$gettext('component.entity.compact.favour.select')}},[_c('b-icon',{attrs:{"icon":_vm.isFavouredResearchActivity({resourceType: _vm.resourceType,resourceId: _vm.resourceId}) ? 'star' : 'star-o',"type":"is-aquamarine"}})],1)],1):_vm._e()],2)],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.html[_vm.currentLocale])}})]),_vm._v(" "),(_vm.showPublicationsCount)?_c('div',{staticClass:"extra-info"},[(_vm.data.publications_count > 0)?_c('div',{staticClass:"tag is-aquamarine pubcount"},[_vm._v("\n      "+_vm._s(_vm.data.publications_count)+" "+_vm._s(_vm.data.publications_count > 1 ? this.$gettext("Publikationen") : this.$gettext("Publikation"))+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"small-icon-row"},_vm._l((_vm.data.sdg),function(sdg,index){return _c('div',{key:index},[_c('b-tooltip',{attrs:{"label":"SDG " + (sdg._id) + ": " + _vm.$gettext(("Sdg.SDG" + (sdg._id))),"position":"is-left"}},[_c('router-link',{attrs:{"to":_vm.currentPublicRoute().withQuery({ sdg: ("SDG" + (sdg._id)) })}},[_c('img',{attrs:{"src":_vm.sdgLink(sdg._id),"width":"24"}})])],1)],1)}))]):_vm._e(),_vm._v(" "),(_vm.showPublicationType)?_c('div',{staticClass:"fob-hide-in-print"},[_c('translate',{staticClass:"tag is-aquamarine"},[_vm._v(_vm._s(("PublikationsTyp." + (_vm.data.publikationsTyp))))])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3hk8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3kht":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__ = __webpack_require__("cigy");

var Filter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__["a" /* default */])('AppUser');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'AppUser',
  route: 'appuser',
  fields: [
  // Filter.Reference(
  //   'organisationseinheit',
  //   'sitemap',
  //   'organisationseinheit',
  //   {
  //     name: 'bySearchRepLikeUnrestricted',
  //     multiValue: false,
  //     minLength: 0
  //   }
  // ),
  Filter.String('userName'), Filter.String('email'), Filter.ReferenceBySearchRep('applicationRoles', 'user-secret', 'appRole'), Filter.ReferenceBySearchRep('organisationseinheiten', 'sitemap', 'organisationseinheit'), Filter.ReferenceBySearchRep('zstzlOrganisationseinheiten', 'sitemap', 'organisationseinheit')
  // Filter.String('verleihungsJahr')
  ]
});

/***/ }),

/***/ "4+79":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__ = __webpack_require__("cigy");

var Filter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__["a" /* default */])('ExterneOrganisation');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Externe Organisation',
  route: 'externeorganisation',
  className: 'externeOrganisation',
  fields: [Filter.String('name'), Filter.String('stadt'), Filter.String('kurzname'), Filter.String('beschreibung'), Filter.ReferenceBySearchRep('land', 'globe')]
});

/***/ }),

/***/ "41M/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-width":"900px"}},[_c('h2',{staticClass:"is-size-5",staticStyle:{"margin-bottom":"0.5em"}},[_c('span',{staticClass:"has-text-weight-bold",domProps:{"innerHTML":_vm._s(_vm.$gettext('start.help.heading'))}})]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"margin-bottom":"20px"}},[_c('div',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$gettext('start.help'))}})])])]),_vm._v(" "),_c('div',{staticClass:"buttons is-centered",staticStyle:{"margin":"0px 0 30px 40px"}},[_c('a',{staticClass:"control button is-link is-outlined",attrs:{"href":_vm.wikiLink('start', 'das_allerwichtigste_in_kuerze'),"target":"_blank"}},[_c('translate',[_vm._v("start.help.intro")]),_vm._v(" "),_c('b-icon',{attrs:{"icon":"external-link","size":"is-small"}})],1),_vm._v(" "),_c('a',{staticClass:"control button is-link",attrs:{"href":_vm.wikiLink('haeufige_fragen'),"target":"_blank"}},[_c('translate',[_vm._v("start.help.faq")]),_vm._v(" "),_c('b-icon',{attrs:{"icon":"external-link","size":"is-small"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"20px"}},[_c('translate',[_vm._v("start.video.tutorials.text")])],1),_vm._v(" "),_c('div',{staticClass:"buttons is-centered",staticStyle:{"margin":"0px 0 30px 40px"}},[_c('a',{staticClass:"control button is-link is-outlined",attrs:{"href":"https://schulung.uni-leipzig.de/leuris-schulung","target":"_blank"}},[_c('translate',[_vm._v("start.video.tutorials.link")]),_vm._v(" "),_c('b-icon',{attrs:{"icon":"external-link","size":"is-small"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4Dw1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_compact_Forschungsprojekt__ = __webpack_require__("7uWV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_compact_Patent__ = __webpack_require__("DAx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_compact_Publikation__ = __webpack_require__("LgZK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_compact_Preis__ = __webpack_require__("yGR3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_compact_Kooperation__ = __webpack_require__("/9tF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_compact_Veranstaltung__ = __webpack_require__("m0ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mixins_UserCanEditByKostenstelle__ = __webpack_require__("jh8f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mixins_FavourResearchActivity__ = __webpack_require__("LwcP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-entity-compact',
  mixins: [__WEBPACK_IMPORTED_MODULE_6__components_mixins_UserCanEditByKostenstelle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__components_mixins_FavourResearchActivity__["a" /* default */]],
  props: ['schema', 'data', 'entityDetailsRoute', 'entityEditRoute', 'showPublicationType', 'showStar'],
  computed: {
    hasCompactComponent: function hasCompactComponent() {
      return 'fob-' + this.schema.className + '-compact' in this.$options.components;
    },
    compactComponentName: function compactComponentName() {
      return 'fob-' + this.schema.className + '-compact';
    },
    resourceType: function resourceType() {
      return this.data._entityName.split('.').splice(-1)[0].toLowerCase();
    },
    resourceId: function resourceId() {
      return this.data._id;
    }
  },
  components: {
    'fob-forschungsprojekt-compact': __WEBPACK_IMPORTED_MODULE_0__components_compact_Forschungsprojekt__["a" /* default */],
    'fob-patent-compact': __WEBPACK_IMPORTED_MODULE_1__components_compact_Patent__["a" /* default */],
    'fob-publikation-compact': __WEBPACK_IMPORTED_MODULE_2__components_compact_Publikation__["a" /* default */],
    'fob-preis-compact': __WEBPACK_IMPORTED_MODULE_3__components_compact_Preis__["a" /* default */],
    'fob-kooperation-compact': __WEBPACK_IMPORTED_MODULE_4__components_compact_Kooperation__["a" /* default */],
    'fob-veranstaltung-compact': __WEBPACK_IMPORTED_MODULE_5__components_compact_Veranstaltung__["a" /* default */]
  }
});

/***/ }),

/***/ "4HNN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__ = __webpack_require__("cigy");
 // Template für vordefinierte Filter
var Filter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__["a" /* default */])('Mittelgeber'); // Initialisieren des Templates für eine Entität

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Mittelgeber',
  route: 'mittelgeber',
  fields: [Filter.String('name'), Filter.Number('finSchluessel')]
});

/***/ }),

/***/ "4Nzo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);


// import Foerderung from './Foerderung'

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var maxYear = new Date().getFullYear() || 2025;

  return {
    organisationseinheit: {
      name: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) }
    },
    namePreis: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) },
    preisBezeichnung: {
      name: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) }
    },
    verleihungsJahr: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minValue"])(1409), maxValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxValue"])(maxYear) },
    preisTraeger: {
      name: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) }
    }
  };
});

/***/ }),

/***/ "4SYB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4mkt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_DateTimeHelper__ = __webpack_require__("5W2G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_CompactViewHelper__ = __webpack_require__("TGNV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-kooperation-compact',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_DateTimeHelper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__components_mixins_CompactViewHelper__["a" /* default */]],
  props: ['schema', 'data'],
  computed: {
    organisation_unit: function organisation_unit() {
      return this.data.organisationseinheit.name;
    },
    title: function title() {
      return this.data.titelKooperation;
    },
    hasBeginDate: function hasBeginDate() {
      return this.data.beginn != null;
    },
    beginDate: function beginDate() {
      return this.asDate(this.data.beginn);
    },
    hasEnded: function hasEnded() {
      return this.data.ende != null ? new Date() > this.data.ende : false;
    },
    endDate: function endDate() {
      return this.asDate(this.data.ende);
    },
    hasExternalOrganisations: function hasExternalOrganisations() {
      return this.data.beteiligteOrganisationen != null && this.data.beteiligteOrganisationen.length > 0;
    },
    externalOrganisations: function externalOrganisations() {
      return this.data.beteiligteOrganisationen.map(this.externalOrgaRep).join('; ');
    },
    hasInvolvedPeople: function hasInvolvedPeople() {
      return this.involvedPeople !== '';
    },
    involvedPeople: function involvedPeople() {
      var persons = [];
      if (this.data.ansprechpartner != null) {
        persons = persons.concat(this.data.ansprechpartner);
      }
      if (this.data.beteiligtePersonen != null) {
        persons = persons.concat(this.data.beteiligtePersonen);
      }
      persons = persons.reduce(function (acc, x) {
        return acc.map(function (x) {
          return x._id;
        }).includes(x._id) ? acc : acc.concat(x);
      }, []);
      return persons.map(this.fullName).join('; ');
    },
    hasAdditionalOUs: function hasAdditionalOUs() {
      return this.data.weitereOrganisationseinheiten != null && this.data.weitereOrganisationseinheiten.length > 0;
    },
    additionalOUs: function additionalOUs() {
      return this.data.weitereOrganisationseinheiten.map(function (x) {
        return x.name;
      }).join('; ');
    }
  },
  methods: {
    externalOrgaRep: function externalOrgaRep(xorga) {
      var land = xorga.land;
      var landname = void 0;
      if (land != null) {
        landname = this.currentLocale === 'de' ? land.nameDE : land.nameEN;
      }

      var location = [xorga.stadt, landname].filter(function (x) {
        return x != null;
      });
      return location.length === 0 ? xorga.name : xorga.name + ' (' + location.join(', ') + ')';
    }
  }
});

/***/ }),

/***/ "4tOy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityCreate_vue__ = __webpack_require__("QQXh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dd921e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityCreate_vue__ = __webpack_require__("ldSI");
function injectStyle (ssrContext) {
  __webpack_require__("0Uwt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dd921e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityCreate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5DfW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMeListCompact_vue__ = __webpack_require__("zY9s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a7506a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutMeListCompact_vue__ = __webpack_require__("197X");
function injectStyle (ssrContext) {
  __webpack_require__("Bg5f")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMeListCompact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a7506a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutMeListCompact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5W2G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    asDate: function asDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date, __WEBPACK_IMPORTED_MODULE_0_moment___default.a.ISO_8601).locale(this.currentLocale === 'de' ? 'de' : 'en-gb').format('L');
    },
    timestampAsDate: function timestampAsDate(timestamp) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp, __WEBPACK_IMPORTED_MODULE_0_moment___default.a.ISO_8601).locale(this.currentLocale === 'de' ? 'de' : 'en-gb').format('L');
    },
    asTimestamp: function asTimestamp(timestamp) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp, __WEBPACK_IMPORTED_MODULE_0_moment___default.a.ISO_8601).locale(this.currentLocale === 'de' ? 'de' : 'en-gb').format('LL, LT');
    },
    asFromNow: function asFromNow(timestamp) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp, __WEBPACK_IMPORTED_MODULE_0_moment___default.a.ISO_8601).locale(this.currentLocale === 'de' ? 'de' : 'en-gb').fromNow();
    },
    changeLanguage: function changeLanguage(locale) {
      this.$store.dispatch('setLanguage', locale);
    },
    currentDateString: function currentDateString() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()().locale(this.currentLocale === 'de' ? 'de' : 'en-gb').format('LL, LT');
    },
    duration: function duration(beginDate, endDate) {
      if (this.currentLocale === 'de') {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(beginDate, __WEBPACK_IMPORTED_MODULE_0_moment___default.a.ISO_8601).format('MM.YYYY') + ' - ' + (endDate ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(endDate, __WEBPACK_IMPORTED_MODULE_0_moment___default.a.ISO_8601).format('MM.YYYY') : 'laufend');
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(beginDate, __WEBPACK_IMPORTED_MODULE_0_moment___default.a.ISO_8601).format('MM/YYYY') + ' - ' + (endDate ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(endDate, __WEBPACK_IMPORTED_MODULE_0_moment___default.a.ISO_8601).format('MM/YYYY') : 'ongoing');
      }
    }
  },
  computed: {
    currentLocale: function currentLocale() {
      return this.$language.current.substring(0, 2).toLowerCase();
    }
  }
});

/***/ }),

/***/ "5krH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-bottom":"30px"}},[_c('div',{staticClass:"is-size-5",staticStyle:{"font-variant":"small-caps"}},[_c('translate',[_vm._v("\n      "+_vm._s(_vm.type.charAt(0).toUpperCase() + _vm.type.slice(1))+"\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"is-size-4 has-text-weight-semibold"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('span',{staticClass:"is-size-7"},[(_vm.createUser || _vm.createDate)?[_c('translate',[_vm._v("form.header.created")]),_vm._v(" "),(_vm.createDate)?[_c('b-tooltip',{attrs:{"label":_vm.asTimestamp(_vm.createDate),"dashed":""}},[_vm._v(" "+_vm._s(_vm.asFromNow(_vm.createDate)))])]:_vm._e(),_vm._v(" "),(_vm.createUser)?[_c('translate',[_vm._v("form.header.by")]),_vm._v(" "+_vm._s(_vm.createUser)+"\n      ")]:_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"-0.4ch"}},[_vm._v(",")])]:_vm._e(),_vm._v(" "),(_vm.updateUser || _vm.updateDate)?[_c('translate',[_vm._v("form.header.lastEdited")]),_vm._v(" "),(_vm.updateDate)?[_c('b-tooltip',{attrs:{"label":_vm.asTimestamp(_vm.updateDate),"dashed":""}},[_vm._v(" "+_vm._s(_vm.asFromNow(_vm.updateDate)))])]:_vm._e(),_vm._v(" "),(_vm.updateUser)?[_c('translate',[_vm._v("form.header.by")]),_vm._v(" "+_vm._s(_vm.updateUser)+"\n      ")]:_vm._e()]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "63V6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fob-label',{attrs:{"label":_vm.label,"asterisk":_vm.asterisk}}),_vm._v(" "),_c('div',{staticClass:"projektleiter-container",style:({ height: _vm.containerHeight, transition: 'all .5s' })},[_c('draggable',{attrs:{"options":{
          handle: '.handle',
          draggable: '.projektleiter-item',
        }},on:{"change":function () { return _vm.$emit('input', _vm.data); }},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}},[_c('transition-group',{attrs:{"name":"projektleiter","tag":"div"}},_vm._l((_vm.data),function(leiter,j){return _c('div',{key:leiter._id,staticClass:"projektleiter-item",class:{'pl-changing': _vm.changing},staticStyle:{"padding-bottom":"1rem"},attrs:{"id":("projektleiter-" + (leiter._id))}},[_c('div',{staticClass:"box projektleiter-wrapper"},[(_vm.data.length > 1)?_c('div',{staticClass:"unselectable handle"},[_vm._v("\n                ⠿\n              ")]):_c('div',{staticClass:"unselectable mute-handle"},[_vm._v("\n                ⠿\n              ")]),_vm._v(" "),_c('div',{staticClass:"projektleiter"},[_c('div',{staticClass:"projektleiter-person"},[_c('fob-entity-select',{key:j,ref:"projektleiter",refInFor:true,attrs:{"allowCreate":true,"label":"projektleiter_person","icon":"user","method":_vm.finder,"type":_vm.showErrors && (_vm.validation.$each[j] == null || _vm.validation.$each[j].person == null || _vm.validation.$each[j].person.$invalid) ? 'is-danger' : '',"route":_vm.personSchema.className,"schema":_vm.personSchema},on:{"input":function () { return _vm.touch(leiter._id); }},model:{value:(_vm.data[j].person),callback:function ($$v) {_vm.$set(_vm.data[j], "person", $$v)},expression:"data[j].person"}}),_vm._v(" "),_c('button',{staticClass:"button is-small projektleiter-remove-button has-text-carnelian",attrs:{"disabled":_vm.data.length == 1},on:{"click":function($event){_vm.removeProjektleiter(leiter._id)}}},[_c('b-tooltip',{staticClass:"is-carnelian",attrs:{"square":"","position":"is-top","label":"Entfernen"}},[_c('b-icon',{attrs:{"icon":"trash"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"projektleiter-dates"},[_c('fob-nullable-date',{attrs:{"placeholder":_vm.$gettext('Leitung Projektstart'),"invalid":_vm.showErrors && (_vm.validation.$each[j] == null || _vm.validation.$each[j].startdatum == null || (_vm.validation.$each[j].startdatum.$invalid) ? true : false)},on:{"input":function () { return _vm.touch(leiter._id); }},model:{value:(_vm.data[j].startdatum),callback:function ($$v) {_vm.$set(_vm.data[j], "startdatum", $$v)},expression:"data[j].startdatum"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"grid","place-items":"center","padding":"0 1rem"}},[_c('translate',[_vm._v("Leitung bis")])],1),_vm._v(" "),_c('fob-nullable-date',{attrs:{"placeholder":_vm.$gettext('Leitung Projektende'),"invalid":_vm.showErrors && (_vm.validation.$each[j] == null || _vm.validation.$each[j].enddatum == null || (_vm.validation.$each[j].enddatum.$invalid) ? true : false)},on:{"input":function () { return _vm.touch(leiter._id); }},model:{value:(_vm.data[j].enddatum),callback:function ($$v) {_vm.$set(_vm.data[j], "enddatum", $$v)},expression:"data[j].enddatum"}})],1),_vm._v(" "),_c('div',{staticClass:"error-message has-text-carnelian"},[_c('div',{staticClass:"is-size-7",class:{'hide-errors': !_vm.showErrors}},[_c('translate',[_vm._v("\n                      "+_vm._s(_vm.errorMsg(j) ||
                        (_vm.data[j].person === null ? 'no_person_1' : '') ||
                        (_vm.data[j].person.name === '' ? 'no_person_2' : ''))+"\n                    ")])],1)])])])])}))],1)],1),_vm._v(" "),_c('button',{key:"projektleiter-add-button",staticClass:"button",class:{'pl-changing': _vm.changing},attrs:{"disabled":_vm.changing},on:{"click":_vm.addProjektleiter}},[_c('translate',[_vm._v("\n        Projektleiter hinzufügen\n      ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6Yhf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hasSelectionGroups)?_c('b-select',{ref:"plainSelector",model:{value:(_vm.resourceType),callback:function ($$v) {_vm.resourceType=$$v},expression:"resourceType"}},_vm._l((_vm.nonEmptySelectionGroups[0].entities),function(item,i){return _c('option',{key:i,domProps:{"value":item.className.toLowerCase()}},[_c('translate',[_vm._v("\n      "+_vm._s(item.className[0].toUpperCase() + item.className.slice(1))+"\n    ")])],1)})):_c('b-select',{ref:"groupSelector",model:{value:(_vm.resourceType),callback:function ($$v) {_vm.resourceType=$$v},expression:"resourceType"}},_vm._l((_vm.nonEmptySelectionGroups),function(group,i){return _c('optgroup',{key:i,attrs:{"label":group.label}},_vm._l((group.entities),function(item,j){return _c('option',{key:j,domProps:{"value":item.className.toLowerCase()}},[_c('translate',[_vm._v("\n        "+_vm._s(item.className[0].toUpperCase() + item.className.slice(1))+"\n      ")])],1)}))}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6gk7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-field',{staticClass:"fob-entity-list-bar",staticStyle:{"margin-bottom":"50px"},attrs:{"grouped":"","group-multiline":""}},[_c('fob-entity-palette',{model:{value:(_vm.resourceType),callback:function ($$v) {_vm.resourceType=$$v},expression:"resourceType"}}),_vm._v(" "),_c('b-select',{model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}},[_c('option',{attrs:{"value":"5"}},[_vm._v("5 "),_c('translate',[_vm._v("list.header.perPage")])],1),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10 "),_c('translate',[_vm._v("list.header.perPage")])],1),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15 "),_c('translate',[_vm._v("list.header.perPage")])],1),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20 "),_c('translate',[_vm._v("list.header.perPage")])],1),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100 "),_c('translate',[_vm._v("list.header.perPage")])],1)]),_vm._v(" "),_c('fob-entity-list-column-visibility',{staticClass:"control",model:{value:(_vm.tableFields),callback:function ($$v) {_vm.tableFields=$$v},expression:"tableFields"}}),_vm._v(" "),_c('button',{staticClass:"control button is-primary",on:{"click":_vm.saveView}},[_c('b-icon',{attrs:{"pack":"fa","icon":"save"}}),_vm._v(" "),_c('translate',[_vm._v("list.button.save")])],1),_vm._v(" "),_c('button',{staticClass:"control button is-primary",on:{"click":_vm.print}},[_c('b-icon',{attrs:{"pack":"fa","icon":"print"}}),_vm._v(" "),_c('translate',[_vm._v("list.button.print")])],1)],1),_vm._v(" "),_c('fob-entity-list-options',{staticClass:"fob-entity-list-options",attrs:{"tableFields":_vm.tableFields,"filterSchema":_vm.filterSchema,"page":_vm.page,"per-page":_vm.perPage,"total":_vm.total},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('div',{staticClass:"card"},[_c('fob-entity-list-pagination',{attrs:{"per-page":_vm.perPage,"page":_vm.page,"total":_vm.total,"compact":_vm.isCompact},on:{"update:current":_vm.onPageChange,"update:compact":_vm.updateCompact}}),_vm._v(" "),(_vm.total > 0)?[(_vm.isCompact)?_c('div',{staticClass:"fob-entity-compact-view"},[_c('fob-entity-list-compact',{attrs:{"data":_vm.data,"schema":_vm.schema,"loading":_vm.loading,"entityDetailsRoute":"anzeigen_einzeln","entityEditRoute":"editieren"}})],1):_c('div',{staticClass:"fob-entity-list"},[_c('fob-entity-list-table',{key:_vm.resourceType,attrs:{"tableFields":_vm.tableFields,"data":_vm.data,"loading":_vm.loading,"sortOrder":_vm.sortOrder,"sortField":_vm.sortField,"entityDetailsRoute":"anzeigen_einzeln","entityEditRoute":"editieren"},on:{"updateSorting":_vm.updateSorting}})],1)]:_c('div',[_c('div',{staticClass:"level"},[_c('div',{staticClass:"level-item has-text-centered"},[_c('b-icon',{attrs:{"icon":"exclamation","type":"is-garnet"}}),_vm._v(" "),_c('em',[_c('translate',[_vm._v("list.noData")])],1)],1)])]),_vm._v(" "),_c('fob-entity-list-pagination',{attrs:{"per-page":_vm.perPage,"page":_vm.page,"total":_vm.total,"compact":_vm.isCompact},on:{"update:current":_vm.onPageChange,"update:compact":_vm.updateCompact}})],2),_vm._v(" "),_c('div',{staticClass:"print-footer"},[_c('span',[_c('translate',{attrs:{"translate-params":{printDate: _vm.printDate}}},[_vm._v("list.printedOn")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6kgN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AbstractPerson__ = __webpack_require__("BP7K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fobclient_lib_entity__ = __webpack_require__("9fz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fobclient_lib_entity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fobclient_lib_entity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__schema_PublikationsTyp__ = __webpack_require__("IhzH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__schema_Mittelgeber__ = __webpack_require__("TFk4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FieldsGeneric__ = __webpack_require__("WWW9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lang_codes__ = __webpack_require__("wx9V");







var Fields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__FieldsGeneric__["a" /* default */])('Publikation');



/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Publikation',
  route: 'publikation',
  className: 'publikation',
  class: __WEBPACK_IMPORTED_MODULE_2_fobclient_lib_entity__["Publikation"],
  fields: [Fields.organisationseinheit, Fields.relevantFuerWeitere, Fields.weitereOrganisationseinheiten, __WEBPACK_IMPORTED_MODULE_3__schema_PublikationsTyp__["a" /* default */], {
    label: 'Publikation.form.veroeffentlichungsJahr',
    field: 'veroeffentlichungsJahr',
    type: Number,
    icon: 'calendar-o',
    view: function view(data, user) {
      return data.publikationsTyp != null && data.publikationsTyp !== '';
    }
  }, {
    label: 'Publikation.form.titelPublikation',
    field: 'titelPublikation',
    maxlength: 500,
    type: 'string',
    view: function view(data, user) {
      return data.publikationsTyp != null && data.publikationsTyp !== '';
    }
  }, {
    label: 'Publikation.form.author',
    singularLabel: 'Autor',
    field: 'author',
    render: 'stringRep',
    type: 'object',
    schema: __WEBPACK_IMPORTED_MODULE_1__AbstractPerson__["a" /* default */],
    finder: {
      name: 'byMultiValueSearchRep',
      multiValue: true,
      minLength: 3
    },
    view: function view(data, user) {
      return data.publikationsTyp != null && data.publikationsTyp !== '' && ['ARTIKEL', 'SAMMELBANDBEITRAG', 'TAGUNGSBEITRAG', 'MONOGRAPHIE', 'QUELLENEDITION', 'BERICHT', 'WORKINGPAPER', 'BEITRAGINNICHTWISSENSCHAFTLICHENMEDIEN', 'DISSERTATION', 'HABILITATIONSSCHRIFT', 'SONSTIGE', 'BUCHBEITRAG'].includes(data.publikationsTyp);
    },

    icon: 'user',
    cardinality: 'many'
  }, {
    label: 'Publikation.form.herausgeber',
    field: 'herausgeber',
    render: 'stringRep',
    type: 'object',
    schema: __WEBPACK_IMPORTED_MODULE_1__AbstractPerson__["a" /* default */],
    finder: {
      name: 'byMultiValueSearchRep',
      multiValue: true,
      minLength: 3
    },
    view: function view(data, user) {
      return data.publikationsTyp != null && data.publikationsTyp !== '' && !['ARTIKEL', 'DISSERTATION', 'HABILITATIONSSCHRIFT'].includes(data.publikationsTyp);
    },

    icon: 'user',
    cardinality: 'many'
  }, {
    label: 'Publikation.form.institution',
    field: 'institution',
    type: 'string',
    view: function view(data, user) {
      return data.publikationsTyp != null && data.publikationsTyp !== '' && !['ARTIKEL', 'DISSERTATION', 'HABILITATIONSSCHRIFT'].includes(data.publikationsTyp);
    }
  }, {
    label: 'Publikation.form.internalPubIdent',
    className: 'pubIdent',
    field: 'pubIdent',
    type: 'object',
    render: 'stringRep',
    onlyCreate: true,
    cardinality: 'many',
    inEditView: function inEditView(_data, user) {
      // inEditView must return a Boolean
      return user.roles.ADMIN === true;
    },
    plain: true,
    editable: true,
    view: function view(data, _user) {
      return data.publikationsTyp != null && data.publikationsTyp;
    },

    schema: {
      label: 'PubIdent',
      route: 'pubident',
      entityName: 'de.ul.fob.domain.PubIdent',
      class: __WEBPACK_IMPORTED_MODULE_2_fobclient_lib_entity__["PubIdent"],
      className: 'pubIdent',
      fields: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.PrefetchedSingleReference('pubIdentTyp', 'pubIdentTyp', 'folder-open'), {
        preselect: function preselect(typ) {
          return typ.kennung === 'PUBMAN';
        },
        prefilter: function prefilter(typ) {
          return typ.kennung === 'PUBMAN';
        },
        label: 'Publikation.form.publicPubIdent.pubIdentTyp'
      }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.String('wert'), {
        label: 'Publikation.form.publicPubIdent.wert'
      })]
    }
  }, {
    label: 'Publikation.form.publicPubIdent',
    field: 'publicPubIdent',
    type: 'object',
    render: 'embedded',
    onlyCreate: true,
    cardinality: 'many',
    view: function view(data, user) {
      return data.publikationsTyp != null && data.publikationsTyp !== '';
    },

    schema: {
      route: 'pubident',
      className: 'pubIdent',
      entityName: 'de.ul.fob.domain.PubIdent',
      compactPrintView: true,
      fields: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.PrefetchedSingleReference('pubIdentTyp', 'pubIdentTyp', 'folder-open'), {
        prefilter: function prefilter(typ) {
          return typ.kennung !== 'PUBMAN';
        },
        orderBy: 'kennung',
        appendClass: ['compact-print-view-label']
      }), {
        label: 'Publikation.form.publicPubIdent.wert',
        field: 'wert',
        appendClass: ['compact-print-view-value'],
        view: function view(data) {
          return !(data.externalLink && data.externalLink.href);
        }
      }, {
        field: 'externalLink',
        label: 'Publikation.form.publicPubIdent.wert',
        type: 'link',
        computed: function computed(data) {
          var pubIdentTyp = data.pubIdentTyp.kennung.toLowerCase();
          var hrefs = {
            urn: function urn(id) {
              if (id.includes('urn:nbn')) {
                // try to fix URNn that already contain a resolver or other random stuff
                var parts = id.split('/');
                var theURN = parts[parts.length - 1];
                // second check to see if we actually got a URN
                if (theURN.startsWith('urn:nbn')) {
                  return 'https://nbn-resolving.org/' + theURN;
                } else {
                  return null;
                }
              } else {
                return null;
              }
            },
            doi: function doi(id) {
              return 'https://doi.org/' + id;
            },
            pmid: function pmid(id) {
              return 'https://www.ncbi.nlm.nih.gov/pubmed/' + id;
            },
            isbn: function isbn(id) {
              return 'https://www.worldcat.org/isbn/' + id;
            },
            issn: function issn(id) {
              return 'https://katalog.ub.uni-leipzig.de/Search/Results?lookfor0[]=' + id + '&amp;type0[]=ISN';
            },
            ismn: function ismn(id) {
              return 'https://katalog.ub.uni-leipzig.de/Search/Results?lookfor0[]=' + id + '&amp;type0[]=ISN';
            },
            isi: function isi(id) {
              return 'https://ws.isiknowledge.com/cps/openurl/service?url_ver=Z39.88-2004&rft_id=info:ut/' + id;
            },
            uri: function uri(id) {
              return id;
            }
          };

          var href = null;

          if (hrefs[pubIdentTyp] && hrefs[pubIdentTyp](data.wert.trim())) {
            href = encodeURI(hrefs[pubIdentTyp](data.wert.trim()));
          }

          return { href: href, text: data.wert };
        },
        view: function view(data) {
          return data.externalLink && data.externalLink.href;
        }
      }]
    }
  }, {
    label: 'Publikation.form.journal',
    field: 'journal',
    type: 'string',
    view: function view(data, user) {
      return data.publikationsTyp != null && data.publikationsTyp !== '' && ['ARTIKEL', 'BEITRAGINNICHTWISSENSCHAFTLICHENMEDIEN', 'SONDERHEFT'].includes(data.publikationsTyp);
    }
  }, {
    label: 'Publikation.form.buchtitel',
    field: 'buchtitel',
    type: 'string',
    view: function view(data, user) {
      return data.publikationsTyp != null && data.publikationsTyp !== '' && ['SAMMELBANDBEITRAG', 'TAGUNGSBEITRAG', 'BEITRAGINNICHTWISSENSCHAFTLICHENMEDIEN'].includes(data.publikationsTyp);
    }
  }, {
    label: 'Publikation.form.serientitel',
    field: 'serientitel',
    type: 'string',
    view: function view(data, user) {
      return data.publikationsTyp != null && data.publikationsTyp !== '' && !['ARTIKEL', 'DISSERTATION', 'HABILITATIONSSCHRIFT', 'SONDERHEFT'].includes(data.publikationsTyp);
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.SimpleMultiReference('foerderer', 'credit-card', __WEBPACK_IMPORTED_MODULE_4__schema_Mittelgeber__["a" /* default */]), {
    finder: {
      name: 'bySearchRepLike',
      multiValue: false,
      minLength: 0,
      opts: {
        sort: 'finSchluessel'
      }
    },
    allowCreate: false,
    view: function view(data, user) {
      return data.publikationsTyp != null && data.publikationsTyp !== '';
    }
  }), {
    label: 'Publikation.form.inProjekt',
    field: 'inProjekt',
    view: function view(data, user) {
      return data.publikationsTyp != null && data.publikationsTyp !== '';
    },

    type: 'select',
    translatable: true,
    values: [{
      value: true,
      label: 'boolean.yes'
    }, {
      value: false,
      label: 'boolean.no'
    }, {
      value: null,
      label: ''
    }]
  }, {
    label: 'Publikation.form.forschungsprojekt',
    field: 'forschungsprojekt',
    type: 'object',
    cardinality: 'single',
    schema: {
      route: 'forschungsprojekt',
      className: 'forschungsprojekt'
    },
    finder: {
      name: 'byMultiValueSearchRep',
      multiValue: true,
      minLength: 0
    },
    view: function view(data, user) {
      return data.publikationsTyp != null && data.publikationsTyp !== '' && data.inProjekt === true;
    }
  }, {
    label: 'Publikation.form.verleger',
    field: 'verleger',
    type: 'string',
    view: function view(data, user) {
      return data.publikationsTyp != null && data.publikationsTyp !== '' && !['DISSERTATION', 'HABILITATIONSSCHRIFT'].includes(data.publikationsTyp);
    }
  }, {
    label: 'Publikation.form.verlagsort',
    field: 'verlagsort',
    type: 'string',
    view: function view(data, user) {
      return data.publikationsTyp != null && data.publikationsTyp !== '' && !['DISSERTATION', 'HABILITATIONSSCHRIFT'].includes(data.publikationsTyp);
    }
  }, {
    label: 'Publikation.form.band',
    field: 'band',
    type: 'string',
    view: function view(data, user) {
      return data.publikationsTyp != null && data.publikationsTyp !== '' && !['DISSERTATION', 'HABILITATIONSSCHRIFT'].includes(data.publikationsTyp);
    }
  }, {
    label: 'Publikation.form.journalNummer',
    field: 'journalNummer',
    type: 'string',
    view: function view(data, user) {
      return data.publikationsTyp != null && data.publikationsTyp !== '' && ['ARTIKEL', 'BEITRAGINNICHTWISSENSCHAFTLICHENMEDIEN', 'SONDERHEFT'].includes(data.publikationsTyp);
    }
  }, {
    label: 'Publikation.form.seiteStart',
    field: 'seiteStart',
    type: 'string',
    view: function view(data, user) {
      return data.publikationsTyp != null && data.publikationsTyp !== '' && ['ARTIKEL', 'BUCHBEITRAG', 'BEITRAGINNICHTWISSENSCHAFTLICHENMEDIEN', 'SAMMELBANDBEITRAG', 'TAGUNGSBEITRAG', 'WORKINGPAPER', 'BERICHT', 'SONSTIGE'].includes(data.publikationsTyp);
    }
  }, {
    label: 'Publikation.form.seiteEnde',
    field: 'seiteEnde',
    type: 'string',
    view: function view(data, user) {
      return data.publikationsTyp != null && data.publikationsTyp !== '' && ['ARTIKEL', 'BUCHBEITRAG', 'BEITRAGINNICHTWISSENSCHAFTLICHENMEDIEN', 'SAMMELBANDBEITRAG', 'TAGUNGSBEITRAG', 'WORKINGPAPER', 'BERICHT', 'SONSTIGE'].includes(data.publikationsTyp);
    }
  }, {
    label: 'Publikation.form.sprache',
    field: 'sprache',
    type: 'string',
    translatable: true,
    view: function view(data, user) {
      return data.publikationsTyp != null && data.publikationsTyp !== '';
    },
    render: function render(val) {
      var codes = val.split(',').map(function (s) {
        return s.trim();
      }).filter(function (s) {
        return s.length !== 0;
      }).map(function (code) {
        if (__WEBPACK_IMPORTED_MODULE_6__lang_codes__["a" /* validIsoLangCodes */].has(code)) {
          return 'iso639-2b::' + code;
        } else {
          return code;
        }
      });
      return codes;
    }
  }, {
    label: 'Publikation.form.istFinal',
    field: 'istFinal',
    inPublicView: false,
    type: Boolean,
    view: function view(data, user) {
      return data.publikationsTyp != null && data.publikationsTyp !== '';
    }
  }, {
    label: 'Publikation.form.validiert',
    field: 'validiert',
    inPublicView: false,
    inEditView: false,
    type: Boolean,
    view: function view(data, user) {
      return data.publikationsTyp != null && data.publikationsTyp !== '';
    },

    editable: false
  }]
});

/***/ }),

/***/ "6oxK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6zwT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("fLMI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__("+DrZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__("NJ16");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("hGmp");





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__
});

/***/ }),

/***/ "71Rs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_EntityValue__ = __webpack_require__("YRcE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_form_EntityCreateModal__ = __webpack_require__("tyB9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_EntityDecorator__ = __webpack_require__("vlR/");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-entity-table-select',
  data: function data() {
    return {
      created: null,
      showCreateModal: false,
      tableQuery: '',
      isFetching: false,
      tableContent: [],
      selectedContent: this.value || []
    };
  },

  props: {
    route: String,
    field: String,
    method: Object,
    schema: Object,
    allowCreate: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a,
    'fob-entity-value': __WEBPACK_IMPORTED_MODULE_3__components_EntityValue__["a" /* default */],
    'fob-entity-create-modal': __WEBPACK_IMPORTED_MODULE_4__components_form_EntityCreateModal__["a" /* default */],
    'fob-entity-decorator': __WEBPACK_IMPORTED_MODULE_5__components_EntityDecorator__["a" /* default */]
  },
  methods: {
    prepareCreation: function prepareCreation() {
      var Constructor = this.schema.class;
      this.created = new Constructor({
        _id: '__' + Date.now()
      });
      this.showCreateModal = true;
    },
    submitCreated: function submitCreated() {
      var Constructor = this.schema.class;
      var newPerson = new Constructor(this.created);
      newPerson._stringRep = this.schema.preliminaryStringRep(newPerson);
      this.selectedContent.push(newPerson);
      this.$emit('input', this.selectedContent);
    },
    dropRow: function dropRow(theid) {
      this.selectedContent = this.selectedContent.filter(function (item) {
        return item._id !== theid;
      });
      this.$emit('input', this.selectedContent);
    },
    selectRow: function selectRow(theid) {
      var result = this.tableContent.find(function (data) {
        return data._id === theid;
      });
      if (!this.selectedContent.includes(result)) {
        this.selectedContent.push(result);
        this.$emit('input', this.selectedContent);
      }
      // if filteredTableContent length is 1,
      // then reset input (correct empty table message)
      if (this.filteredTableContent.length === 0) {
        this.tableQuery = '';
      }
    },
    queryForTable: function queryForTable() {
      var _this = this;

      if (this.tableQuery.length >= this.method.minLength) {
        this.isFetching = true;
        var param = void 0;
        if (this.method.multiValue) {
          param = this.tableQuery.split(/\s+/).filter(function (x) {
            return x !== '';
          });
        } else {
          param = this.tableQuery;
        }

        var opts = this.method.opts || {};

        this.autocomplete(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ rep: param }, opts)).then(function (result) {
          // optional chaining `result?.data` not supported
          var data = result ? result.data : null;

          if (_this.data && _this.data.length === 0) {
            _this.tableContent = [];
          } else if (data) {
            _this.tableContent = data;
          } else {
            _this.tableContent = [];
          }
          _this.isFetching = false;
        }, function (response) {
          _this.isFetching = false;
        });
      }
    }
  },
  mounted: function mounted() {
    this.$refs.input.focus();
    // if minlength is set to zero on start,
    // trigger fetching available data and show it on table
    this.queryForTable();
  },

  computed: {
    tableColumns: function tableColumns() {
      if (this.schema) {
        if (this.schema.tableSelectColumns) {
          return this.schema.tableSelectColumns;
        }
        return this.schema.fields.filter(function (x) {
          return x.table === true;
        });
      } else {
        return [{
          field: '_id',
          label: 'ID',
          width: '50'
        }, {
          field: 'vorname',
          label: 'Vorname',
          width: '200'
        }, {
          field: 'name',
          label: 'Nachame',
          width: '200'
        }];
      }
    },
    entityName: function entityName() {
      return this.schema.className[0].toUpperCase() + this.schema.className.slice(1);
    },
    autocomplete: function autocomplete() {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].methods.autocomplete(this.route, this.method.name);
    },
    filteredTableContent: function filteredTableContent() {
      var _this2 = this;

      return this.tableContent.filter(function (item) {
        return !_this2.selectedContent.some(function (selected) {
          return item._id === selected._id;
        });
      });
    },
    filteredDataArray: function filteredDataArray() {
      var _this3 = this;

      return this.arrayExample.data.filter(function (option) {
        return option.toString().toLowerCase().indexOf(_this3.arrayExample.name.toLowerCase()) >= 0;
      });
    }
  }
});

/***/ }),

/***/ "7Igb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fob-compact-award-prize"},[_c('span',[(_vm.type)?_c('span',[_vm._v(_vm._s(_vm.type)+":")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"fob-compact-award-prize-label"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"fob-compact-award-prize-awardee"},[_c('span',[_vm._v(_vm._s(_vm.awardee))]),_vm._v(" "),_c('span',[_vm._v("("+_vm._s(_vm.organizationalUnit)+")")])]),_vm._v(" "),(_vm.year && !_vm.awardedBy)?_c('div',[_c('span',[_c('translate',[_vm._v("Preis.compact.verliehenIn")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.year)+".")])]):(_vm.year && _vm.awardedBy)?_c('div',[_c('span',[_c('translate',[_vm._v("Preis.compact.verliehenIn")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.year))]),_vm._v(" "),_c('span',[_c('translate',[_vm._v("Preis.compact.vergebenDurch")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.awardedBy)+".")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7KWU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showLabel)?_c('fob-label',{attrs:{"label":_vm.schema.label,"asterisk":_vm.asterisk}},[(!_vm.schema.onlyCreate && !_vm.deactivated)?_c('button',{staticClass:"multi-select-edit-btn",on:{"click":_vm.showTableSelect}},[_c('translate',[_vm._v("form.editlink")])],1):_vm._e(),_vm._v(" "),(_vm.type === 'is-danger')?_c('b-icon',{attrs:{"icon":"exclamation-circle","type":"is-danger"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.resourceData && _vm.resourceData.length > 0)?_c('div',[(_vm.draggable && !_vm.deactivated)?_c('div',[_c('draggable',{attrs:{"options":{ draggable: '.fob-tag', filter: 'button'}},model:{value:(_vm.resourceData),callback:function ($$v) {_vm.resourceData=$$v},expression:"resourceData"}},[_vm._l((_vm.resourceData),function(item,i){return [_c('div',{key:i,staticClass:"fob-tag"},[_c('b-field',[_c('div',{staticClass:"box control fob-tag-text fob-draggable",attrs:{"expanded":""}},[_c('b-icon',{attrs:{"type":"is-lightgray","icon":_vm.schema.icon}}),_vm._v(" "),_c('fob-entity-decorator',{attrs:{"resourceData":item}},[_vm._v("\n                  "+_vm._s(item._stringRep)+"\n                ")])],1),_vm._v(" "),_c('b-tooltip',{attrs:{"square":"","position":"is-top","label":_vm.$gettext(("form.xbutton.remove.multiSelect." + (_vm.schema.field)))}},[_c('button',{staticClass:"control button is-aquamarine",staticStyle:{"margin-left":"12px","margin-top":"0px"},attrs:{"control":""},on:{"click":function($event){_vm.dropRow(item._id)}}},[_c('b-icon',{attrs:{"icon":"times","size":"is-small"}})],1)])],1)],1)]})],2)],1):_c('div',[_vm._l((_vm.resourceData),function(item,i){return [_c('div',{key:i,staticClass:"fob-tag",class:{'fob-tag-deactivated': _vm.deactivated}},[_c('b-field',[_c('div',{staticClass:"box control fob-tag-text fob-undraggable",attrs:{"expanded":""}},[_c('b-icon',{attrs:{"type":"is-lightgray","icon":_vm.schema.icon}}),_vm._v(" "),_c('fob-entity-decorator',{attrs:{"resourceData":item}},[_vm._v("\n                "+_vm._s(item._stringRep)+"\n              ")])],1),_vm._v(" "),(!_vm.deactivated)?_c('b-tooltip',{attrs:{"square":"","position":"is-top","label":_vm.$gettext(("form.xbutton.remove.multiSelect." + (_vm.schema.field)))}},[_c('button',{staticClass:"control button is-aquamarine",staticStyle:{"margin-left":"12px","margin-top":"0px"},attrs:{"control":""},on:{"click":function($event){_vm.dropRow(item._id)}}},[_c('b-icon',{attrs:{"icon":"times","size":"is-small"}})],1)]):_vm._e()],1)],1)]})],2)]):_vm._e(),_vm._v(" "),(!_vm.deactivated)?_c('b-modal',{staticClass:"multi-wrapper",attrs:{"active":_vm.tableSelectVisible,"canCancel":true,"has-modal-card":""},on:{"update:active":function($event){_vm.tableSelectVisible=$event}}},[_c('fob-entity-table-select',{attrs:{"route":_vm.schema.schema.className,"method":_vm.schema.finder,"field":_vm.schema.field,"icon":_vm.schema.icon,"schema":_vm.schema.schema,"allowCreate":_vm.schema.allowCreate},model:{value:(_vm.resourceData),callback:function ($$v) {_vm.resourceData=$$v},expression:"resourceData"}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Qhh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_public_PublicListSort__ = __webpack_require__("IsdL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_public_PublicListFilter__ = __webpack_require__("jK7k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_PublicViewHelper__ = __webpack_require__("VlMm");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-public-list-options',
  props: ['resourceType'],
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_mixins_PublicViewHelper__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    config: 'publicView/getConfig',
    total: 'publicView/getTotal',
    filter: 'publicView/getFilter'
  }), {
    activeFilter: function activeFilter() {
      return this.filter[this.activeResourceType].filter;
    },
    page: function page() {
      return this.config[this.activeResourceType].page;
    },
    totalTablePages: function totalTablePages() {
      return Math.ceil(this.total[this.activeResourceType] / this.config[this.activeResourceType].perPage);
    }
  }),
  methods: {
    onPerPageChange: function onPerPageChange(perPage) {
      var _this = this;

      this.$store.dispatch('publicView/changePerPage', {
        resourceType: this.activeResourceType,
        perPage: perPage
      }).then(function () {
        _this.loadAsyncData();
      });
    },
    filterTagLabelLeft: function filterTagLabelLeft(filterField) {
      return this.filter[this.activeResourceType].filters.find(function (filter) {
        return filter.value === filterField;
      }).label;
    },
    filterTagLabelRight: function filterTagLabelRight(filterField, filterValue) {
      var filterConfig = this.filter[this.activeResourceType].filters.find(function (filter) {
        return filter.value === filterField;
      });
      if (filterConfig.type === 'select') {
        return this.$gettext('Public.filter.' + filterField + '.' + filterValue.toLowerCase());
      } else {
        return filterValue;
      }
    },
    onUpdateSortField: function onUpdateSortField(sortField) {
      var _this2 = this;

      this.$store.dispatch('publicView/setSortField', {
        resourceType: this.resourceType,
        sortField: sortField
      }).then(function () {
        _this2.loadAsyncData();
      });
    },
    onUpdateSortOrder: function onUpdateSortOrder(sortOrder) {
      var _this3 = this;

      this.$store.dispatch('publicView/setSortOrder', {
        resourceType: this.resourceType,
        sortOrder: sortOrder
      }).then(function () {
        _this3.loadAsyncData();
      });
    }
  },
  components: {
    'fob-public-list-sort': __WEBPACK_IMPORTED_MODULE_2__components_public_PublicListSort__["a" /* default */],
    'fob-public-list-filter': __WEBPACK_IMPORTED_MODULE_3__components_public_PublicListFilter__["a" /* default */]
  }
});

/***/ }),

/***/ "7uWV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forschungsprojekt_vue__ = __webpack_require__("3N7C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e06285c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forschungsprojekt_vue__ = __webpack_require__("l2vt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forschungsprojekt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e06285c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forschungsprojekt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "824M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("\n    "+_vm._s(_vm.organisation_unit)),(_vm.hasAdditionalOUs)?_c('span',[_vm._v("; "+_vm._s(_vm.additionalOUs))]):_vm._e()]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])]),_vm._v(" "),(_vm.hasBeginDate)?_c('div',[_c('em',[_c('translate',[_vm._v("Kooperation.compact.beginn")])],1),_vm._v(": "+_vm._s(_vm.beginDate)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.hasEnded)?_c('div',[_c('em',[_c('translate',[_vm._v("Kooperation.compact.ende")])],1),_vm._v(": "+_vm._s(_vm.endDate)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.hasExternalOrganisations)?_c('div',[_c('em',[_c('translate',[_vm._v("Kooperation.compact.beteiligteOrganisationen")])],1),_vm._v(":\n    "+_vm._s(_vm.externalOrganisations)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.hasInvolvedPeople)?_c('div',[_c('em',[_c('translate',[_vm._v("Kooperation.compact.beteiligtePersonen")])],1),_vm._v(":\n    "+_vm._s(_vm.involvedPeople)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "84oZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticStyle:{"padding":"1em"}},_vm._l((_vm.data),function(item){return _c('li',{key:item._id,staticStyle:{"margin-bottom":"1rem"}},[_c('fob-entity-compact',{attrs:{"schema":_vm.schema,"data":item,"entityDetailsRoute":_vm.entityDetailsRoute,"entityEditRoute":_vm.entityEditRoute,"show-publication-type":_vm.showPublicationType,"show-star":_vm.showStar}})],1)})),_vm._v(" "),_c('b-loading',{attrs:{"is-full-page":false,"active":_vm.loading},on:{"update:active":function($event){_vm.loading=$event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "85W9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_DateTimeHelper__ = __webpack_require__("5W2G");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_DateTimeHelper__["a" /* default */]],
  props: ['type', 'title', 'createUser', 'createDate', 'updateUser', 'updateDate']
});

/***/ }),

/***/ "8Dql":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchStatsQuery; });
function fetchStatsQuery(id) {
  var variables = {
    id: id || 1
  };
  return {
    operationName: 'fetchStats',
    variables: variables,
    query: '\n      query fetchStats($id: ID!) {\n        organisationalUnit(id: $id) {\n          forschungsprojekt: projects {\n            meta { totalEntries }\n          }\n          publikation: publications {\n            meta { totalEntries }\n          }\n          preis: awards {\n            meta { totalEntries }\n          }\n          kooperation: cooperations {\n            meta { totalEntries }\n          }\n          veranstaltung: events {\n            meta { totalEntries }\n          }\n        }\n      }\n    '
  };
}



/***/ }),

/***/ "8IlM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchOuDetailsQuery; });
function fetchOuDetailsQuery(id) {
  var variables = { id: id };

  return {
    operationName: 'fetchOuDetailsQuery',
    query: '\n      query fetchOuDetailsQuery ($id: ID!) {\n        organisationalUnit (id: $id) {\n          stringRep: _stringRep\n          description {\n            de\n            en\n          }\n          begin\n          end\n        }\n      }\n    ',
    variables: variables
  };
}



/***/ }),

/***/ "8eFq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicListCompact_vue__ = __webpack_require__("2WkA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bbd803b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicListCompact_vue__ = __webpack_require__("yCrn");
function injectStyle (ssrContext) {
  __webpack_require__("a87m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicListCompact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bbd803b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicListCompact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9+AE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicSelectPerson_vue__ = __webpack_require__("M8Iu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_093b846a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicSelectPerson_vue__ = __webpack_require__("YCyQ");
function injectStyle (ssrContext) {
  __webpack_require__("Pn/Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicSelectPerson_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_093b846a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicSelectPerson_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9+kj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Bhn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMeListView_vue__ = __webpack_require__("lULL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dc62ec9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutMeListView_vue__ = __webpack_require__("XsV+");
function injectStyle (ssrContext) {
  __webpack_require__("MjnN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMeListView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dc62ec9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutMeListView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9R/T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicListExport_vue__ = __webpack_require__("R2wm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66591f68_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicListExport_vue__ = __webpack_require__("MH+L");
function injectStyle (ssrContext) {
  __webpack_require__("4SYB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66591f68"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicListExport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66591f68_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicListExport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9YsO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Help_vue__ = __webpack_require__("JAcS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e462fb34_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__ = __webpack_require__("41M/");
function injectStyle (ssrContext) {
  __webpack_require__("zjDv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e462fb34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Help_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e462fb34_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "A1GC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AN2u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"2rem"}},[_c('div',{staticClass:"container",staticStyle:{"max-width":"1000px"}},[_c('div',{staticClass:"container has-text-centered",staticStyle:{"max-width":"900px","margin-bottom":"4rem"}},[_c('h2',{staticClass:"is-size-5"},[_vm._v("\n        404: "),_c('translate',[_vm._v("notFound")])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"1rem"}},[(this.$leurisMode === 'PORTAL')?_c('router-link',{staticClass:"button is-primary",attrs:{"to":"welcome"}},[_c('translate',[_vm._v("btn.back")])],1):_c('router-link',{staticClass:"button is-primary",attrs:{"to":"/"}},[_c('translate',[_vm._v("btn.back")])],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ANWq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAuthorized", function() { return isAuthorized; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "name", function() { return name; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orgas", function() { return orgas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasOrga", function() { return hasOrga; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeOrga", function() { return activeOrga; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeViewState", function() { return activeViewState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeViewStates", function() { return activeViewStates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fisPersid", function() { return fisPersid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "email", function() { return email; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "researcher", function() { return researcher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectedOrga", function() { return selectedOrga; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "remainingSessionLength", function() { return remainingSessionLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUser", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "roles", function() { return roles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "token", function() { return token; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoading", function() { return isLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSavedViews", function() { return getSavedViews; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var isAuthorized = function isAuthorized(state) {
  return state.token !== null;
};

var name = function name(state) {
  return state.name;
};

var orgas = function orgas(state) {
  return state.orgas;
};

var hasOrga = function hasOrga(state) {
  return state.orgas && state.orgas.length > 0 || false;
};

var activeOrga = function activeOrga(state) {
  return state.activeOrga;
};

var activeViewState = function activeViewState(state) {
  return state.activeViewState;
};

var activeViewStates = function activeViewStates(state) {
  return state.activeViewStates;
};

var fisPersid = function fisPersid(state) {
  return state.fisPersid;
};

var email = function email(state) {
  return state.email;
};

var researcher = function researcher(state) {
  return state.forscher;
};

var selectedOrga = function selectedOrga(state) {
  if (state.orgas != null && state.orgas.length > 0) {
    var orgasByID = state.orgas.filter(function (x) {
      return x._id === state.selectedOrgaID;
    });
    if (orgasByID.length > 0) {
      return orgasByID[0];
    } else {
      return state.orgas[0];
    }
  } else {
    return null;
  }
};

var remainingSessionLength = function remainingSessionLength(state, getters, rootState) {
  if (state.token == null) {
    return 0;
  } else {
    var sessionDestroyDate = parseInt(state.token.split(':')[1]);
    var _remainingSessionLength = __WEBPACK_IMPORTED_MODULE_0_moment___default()(sessionDestroyDate).diff(rootState.now);
    return _remainingSessionLength;
  }
};

var getUser = function getUser(state) {
  return {
    name: state.name,
    organisationseinheiten: state.orgas,
    roles: state.roles
  };
};

var roles = function roles(state) {
  return state.roles;
};

var token = function token(state) {
  return state.token;
};

var isLoading = function isLoading(state) {
  return state.loading;
};

var getSavedViews = function getSavedViews(state) {
  return state.savedViews;
};

/***/ }),

/***/ "APWZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_DynamicTitle__ = __webpack_require__("IqS5");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_DynamicTitle__["a" /* default */]],
  data: function data() {
    return {
      leurisHead: {
        inner: 'leuris:Forschungsbericht',
        complement: 'menu.upload'
      }
    };
  },

  computed: {
    subject: function subject() {
      return encodeURIComponent('Publikationsupload, ' + this.$store.getters['user/selectedOrga'].name);
    },
    text: function text() {
      return encodeURIComponent('Im Anhang / attachment eine Publikationsliste f\xFCr die Organisationseinheit ' + this.$store.getters['user/selectedOrga']._stringRep);
    }
  }
});

/***/ }),

/***/ "AROG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_EntityValue__ = __webpack_require__("YRcE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_UserCanEditByKostenstelle__ = __webpack_require__("jh8f");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// COMPONENTS

// MIXINS


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-entity-list-table',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_mixins_UserCanEditByKostenstelle__["a" /* default */]],
  data: function data() {
    return {
      total: 0,
      defaultSortOrder: 'asc'
    };
  },

  props: {
    data: { default: [] },
    loading: { default: false },
    resourceType: {},
    sortField: {},
    sortOrder: {},
    entityDetailsRoute: { default: 'anzeigen_einzeln' },
    entityEditRoute: { default: 'editieren' },
    tableFields: { default: [] }
  },
  methods: {
    updateSorting: function updateSorting(field, order) {
      this.$emit('updateSorting', { field: field, order: order });
    }
  },
  components: {
    'fob-entity-value': __WEBPACK_IMPORTED_MODULE_0__components_EntityValue__["a" /* default */]
  }
});

/***/ }),

/***/ "Aa4s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      maxLengthOfTags: 30
    };
  },

  methods: {
    labelFormatter: function labelFormatter(label) {
      if (this.maxLengthOfTags && label.length > this.maxLengthOfTags) {
        return label.substring(0, this.maxLengthOfTags) + "...";
      } else {
        return label;
      }
    },
    showTooltip: function showTooltip(label) {
      /* show tooltips if:
         - maxLength was set AND tooltip prop is true
         - maxLength was set AND tooltip prop is not set (null)
       */
      if (this.maxLengthOfTags && label.length > this.maxLengthOfTags) {
        return true;
      } else {
        return false; // default
      }
    }
  }
});

/***/ }),

/***/ "Agex":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOADING_START", function() { return LOADING_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOADING_DONE", function() { return LOADING_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DATA", function() { return SET_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ID", function() { return SET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SCHEMA", function() { return SET_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_VIEW_ENTITY_TYPE", function() { return SET_VIEW_ENTITY_TYPE; });
var LOADING_START = function LOADING_START(state) {
  state.loading = true;
};

var LOADING_DONE = function LOADING_DONE(state) {
  state.loading = false;
};

var SET_DATA = function SET_DATA(state, data) {
  state.data = data;
};

var SET_ID = function SET_ID(state, id) {
  state.id = id;
};

var SET_SCHEMA = function SET_SCHEMA(state, schema) {
  state.schema = schema;
};

var SET_VIEW_ENTITY_TYPE = function SET_VIEW_ENTITY_TYPE(state, type) {
  state.viewEntityType = type;
};

/***/ }),

/***/ "AuJ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type === 'ou')?_c('fob-public-select-organisational-unit'):(_vm.type === 'person')?_c('fob-public-select-person'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B6Sg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityCreateForm_vue__ = __webpack_require__("xljB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65a1fc79_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityCreateForm_vue__ = __webpack_require__("1CWi");
function injectStyle (ssrContext) {
  __webpack_require__("j6WB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityCreateForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65a1fc79_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityCreateForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B91y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"fob-only-for-print-view fob-entity-list-options",staticStyle:{"display":"flex"}},[_c('div',[_c('b-field',{staticClass:"fob-entity-list-filter-tags fob-entity-list-options-tag-list-static",attrs:{"grouped":"","group-multiline":""}},[_c('div',{staticStyle:{"display":"flex","flex-flow":"row wrap","align-content":"space-between"}},_vm._l((_vm.activeFilter),function(value,field){return _c('div',{key:field},[(value && value.length > 0)?_c('b-taglist',{attrs:{"attached":""}},[_c('b-tag',{attrs:{"type":"is-aquamarine"}},[_vm._v("\n                "+_vm._s(_vm.$gettext(_vm.filterTagLabelLeft(field)))+"\n              ")]),_vm._v(" "),_c('b-tag',{attrs:{"type":"is-basalt"}},[_vm._v("\n                "+_vm._s(_vm.filterTagLabelRight(field, value))+"\n              ")])],1):_vm._e()],1)}))])],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"print-metadata-box"},[_c('div',{staticClass:"print-metadata-columns"},[_c('div',{staticClass:"print-metadata-label"},[_c('translate',[_vm._v("tag.static.printedPageOfPagesLabel")])],1),_vm._v(" "),_c('div',{staticClass:"print-metadata-value"},[_c('translate',{attrs:{"translate-params":{page: _vm.page, totalTablePages: _vm.totalTablePages}}},[_vm._v("tag.static.printedPageOfPagesValue")])],1)]),_vm._v(" "),_c('div',{staticClass:"print-metadata-columns"},[_c('div',{staticClass:"print-metadata-label"},[_c('translate',[_vm._v("tag.static.resultCount")])],1),_vm._v(" "),_c('div',{staticClass:"print-metadata-value"},[_vm._v(_vm._s(_vm.total[_vm.resourceType]))])]),_vm._v(" "),_c('div',{staticClass:"print-metadata-columns"},[_c('div',{staticClass:"print-metadata-label"},[_c('translate',[_vm._v("tag.static.entriesPerPage")])],1),_vm._v(" "),_c('div',{staticClass:"print-metadata-value"},[_vm._v(_vm._s(_vm.config[_vm.resourceType].perPage))])])])])]),_vm._v(" "),_c('div',{staticClass:"fob-hide-in-print",staticStyle:{"display":"flex","margin-bottom":"15px","align-items":"center"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('b-icon',{staticClass:"has-text-aquamarine",staticStyle:{"margin-right":"10px"},attrs:{"pack":"fa","icon":"list-ul"}}),_vm._v(" "),_c('b-select',{staticStyle:{"margin-right":"0px"},on:{"input":_vm.onPerPageChange},model:{value:(_vm.config[_vm.resourceType].perPage),callback:function ($$v) {_vm.$set(_vm.config[_vm.resourceType], "perPage", $$v)},expression:"config[resourceType].perPage"}},[_c('option',{attrs:{"value":"5"}},[_vm._v("5 "),_c('translate',[_vm._v("list.header.perPage")])],1),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10 "),_c('translate',[_vm._v("list.header.perPage")])],1),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15 "),_c('translate',[_vm._v("list.header.perPage")])],1),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20 "),_c('translate',[_vm._v("list.header.perPage")])],1),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100 "),_c('translate',[_vm._v("list.header.perPage")])],1)])],1),_vm._v(" "),_c('fob-public-list-sort',{key:_vm.resourceType,attrs:{"resourceType":_vm.resourceType,"sortOrder":_vm.config[_vm.resourceType].sortOrder,"sortField":_vm.config[_vm.resourceType].sortField,"sortFields":_vm.config[_vm.resourceType].sortFields},on:{"update:sortOrderPublicView":_vm.onUpdateSortOrder,"update:sortFieldPublicView":_vm.onUpdateSortField}})],1),_vm._v(" "),_c('div',{staticClass:"fob-hide-in-print",staticStyle:{"display":"flex","margin-bottom":"15px","align-items":"center"}},[_c('fob-public-list-filter',{key:_vm.resourceType,attrs:{"resourceType":_vm.resourceType}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BCQj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql__ = __webpack_require__("lwCg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schema_list__ = __webpack_require__("izx2");




/* harmony default export */ __webpack_exports__["a"] = ({
  loading: false,
  showOrgaTree: true,
  selected: {
    id: null,
    type: null,
    rootQueryType: null,
    typeLabel: null
  },
  leurisProfile: {
    data: null,
    query: __WEBPACK_IMPORTED_MODULE_0__graphql__["a" /* fetchLeurisProfileQuery */],
    orcid: null,
    ulWebsiteProfile: {
      de: null,
      en: null
    }
  },
  ouDetails: {
    stringRep: null,
    begin: null,
    end: null,
    description: null
  },
  staff: {
    loading: false,
    startsWith: null,
    fullName: null,
    letterCount: {},
    pageSize: 500,
    page: 1,
    data: [],
    totalEntries: 0,
    query: __WEBPACK_IMPORTED_MODULE_0__graphql__["h" /* fetchStaffQuery */]
  },
  data: {
    forschungsprojekt: [],
    kooperation: [],
    publikation: [],
    veranstaltung: [],
    preis: []
  },
  id: null,
  total: {
    forschungsprojekt: 0,
    kooperation: 0,
    publikation: 0,
    veranstaltung: 0,
    preis: 0
  },
  activeTab: 0,
  label: null,
  resourceType: 'forschungsprojekt',
  resourceTypes: [{
    type: 'forschungsprojekt',
    label: 'Projekte',
    query: __WEBPACK_IMPORTED_MODULE_0__graphql__["b" /* fetchResearchProjectQuery */]
  }, {
    type: 'publikation',
    label: 'Publikationen',
    query: __WEBPACK_IMPORTED_MODULE_0__graphql__["c" /* fetchPublicationQuery */]
  }, {
    type: 'preis',
    label: 'Preise',
    query: __WEBPACK_IMPORTED_MODULE_0__graphql__["d" /* fetchAwardQuery */]
  }, {
    type: 'kooperation',
    label: 'Kooperationen',
    query: __WEBPACK_IMPORTED_MODULE_0__graphql__["e" /* fetchCooperationQuery */]
  }, {
    type: 'veranstaltung',
    label: 'Veranstaltungen',
    query: __WEBPACK_IMPORTED_MODULE_0__graphql__["f" /* fetchEventQuery */]
  }],
  listSchema: __WEBPACK_IMPORTED_MODULE_1__schema_list__["a" /* ListSchema */],
  filter: {
    forschungsprojekt: {
      filter: {},
      filters: [{ type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } }, { type: 'select', value: 'status', label: 'Public.filter.status', options: ['ONGOING', 'TERMINATED'] }, { type: 'input', value: 'funding', label: 'Public.filter.mittelgeber', icon: 'credit-card' }, { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' }, { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }, { type: 'select', value: 'sdg', label: 'Public.filter.sdg', icon: 'bullseye', hidden: true }]
    },
    kooperation: {
      filter: {},
      filters: [{ type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } }, { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' }, { type: 'input', value: 'externalPartner', label: 'Public.filter.externalPartner', icon: 'globe' }, { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }]
    },
    publikation: {
      filter: {},
      filters: [{ type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } }, { type: 'select', value: 'category', label: 'Public.filter.publikationstypen', options: ['ARTICLE', 'MONOGRAPHY', 'EDITORSHIP', 'CONTRIBUTION', 'REPORT'] }, { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' }, { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' },
      // this is only here to get a translation for the print view (see PublicListOptions)
      { type: 'other', value: 'fundedByCategory', label: 'Public.filter.fundedByPrintLabel', icon: 'credit-card' }]
    },
    veranstaltung: {
      filter: {},
      filters: [{ type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } }, { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' }, { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }]
    },
    preis: {
      filter: {},
      filters: [{ type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } }, { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' }, { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' },
      // this is only here to get a translation for the print view (see PublicListOptions)
      { type: 'select', value: 'typeIds', label: 'Public.filter.awardsTypePrintLabel', icon: 'graduation-cap', hidden: true }]
    }
  },
  config: {
    forschungsprojekt: {
      page: 1,
      perPage: 10,
      sortField: 'START_DATE',
      sortFields: [
      // { field: 'TITLE_DE', label: 'Public.sort.titel', locale: 'de' },
      // { field: 'TITLE_EN', label: 'Public.sort.titel', locale: 'en' },
      { field: 'START_DATE', label: 'Public.sort.beginn' }],
      sortOrder: 'DESC'
    },
    kooperation: {
      page: 1,
      perPage: 10,
      sortField: 'START_DATE',
      sortFields: [
      // { field: 'TITLE', label: 'Public.sort.titel' },
      { field: 'START_DATE', label: 'Public.sort.beginn' }],
      sortOrder: 'DESC'
    },
    publikation: {
      page: 1,
      perPage: 10,
      sortField: 'YEAR',
      sortFields: [{ field: 'TYPE', label: 'Public.sort.typ' },
      // { field: 'TITLE', label: 'Public.sort.titel' },
      { field: 'YEAR', label: 'Public.sort.jahr' }],
      sortOrder: 'DESC'
    },
    veranstaltung: {
      page: 1,
      perPage: 10,
      sortField: 'START_DATE',
      sortFields: [{ field: 'TYPE', label: 'Public.sort.typ' }, { field: 'START_DATE', label: 'Public.sort.beginn'
        // { field: 'NAME', label: 'Public.sort.name' }
      }],
      sortOrder: 'DESC'
    },
    preis: {
      page: 1,
      perPage: 10,
      sortField: 'YEAR',
      sortFields: [{ field: 'TYPE', label: 'Public.sort.typ' }, { field: 'YEAR', label: 'Public.sort.jahr' }, { field: 'AWARDEE', label: 'Public.sort.preisTraeger'
        // { field: 'NAME', label: 'Public.sort.name' }
      }],
      sortOrder: 'DESC'
    }
  }
});

/***/ }),

/***/ "BE/q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("0xDb");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-aboutme-list-quick-actions',
  props: {
    'qa-share': Boolean,
    'qa-share-compact-view': Boolean,
    'qa-print': Boolean
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    userFisPersid: 'user/fisPersid',
    activeResourceType: 'aboutme/getResourceType'
  })),
  methods: {
    print: function print() {
      window.print();
    },
    share: function share(_ref) {
      var _this = this;

      var compact = _ref.compact;

      var to = {
        name: 'public',
        params: {
          type: 'person',
          id: this.userFisPersid,
          resourceType: this.activeResourceType || 'forschungsprojekt'
        }
      };

      if (compact) {
        to.query = {
          compact: true
        };
      }
      // retrieve route information for public
      var route = this.$router.resolve(to, this.$route);
      var url = '' + window.location.origin + route.href;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["g" /* CopyToClipboard */])(url).then(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["h" /* ToastSuccess */])(_this.$gettext('AboutMe.toast.clipboard.success'));
      }, function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* ToastError */])(_this.$gettext('AboutMe.toast.clipboard.error'));
      });
    }
  }
});

/***/ }),

/***/ "BF6l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicListQuickActions_vue__ = __webpack_require__("KxDk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a8d5630_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicListQuickActions_vue__ = __webpack_require__("zEQw");
function injectStyle (ssrContext) {
  __webpack_require__("srBO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicListQuickActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a8d5630_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicListQuickActions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BGld":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fob-compact-patent"},[_c('div',[(_vm.organizationalUnit)?_c('span',[_vm._v(_vm._s(_vm.organizationalUnit))]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.title)?_c('span',{staticClass:"has-text-weight-bold"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.publicationNumber)?_c('span',[_vm._v("("+_vm._s(_vm.publicationNumber)+")")]):_vm._e()]),_vm._v(" "),(_vm.mainInventor)?_c('div',[_c('span',[_vm._v(_vm._s(_vm.mainInventor))])]):_vm._e(),_vm._v(" "),(_vm.priorityDate)?_c('div',[_c('span',[_c('translate',{staticClass:"is-italic"},[_vm._v("Patent.compact.datumDerPrioritaetsbegruendendenErstanmeldung")]),_vm._v(": "+_vm._s(_vm.priorityDate))],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BKPO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchCooperationQuery; });
function fetchCooperationQuery(rootQueryType, id, pageSize, page, sortField, sortOrder, filter) {
  rootQueryType = ['organisationalUnit', 'person'].includes(rootQueryType) ? rootQueryType : null;
  id = rootQueryType === 'organisationalUnit' ? Number(id) : '' + id;

  // if the rootQueryType does not match for organisational unit or person then return nulls
  if (!rootQueryType) {
    return null;
  }

  var variables = {
    id: id || null,
    pageSize: Number(pageSize) || 20,
    page: Number(page) || 1
  };

  if (sortOrder) {
    variables['sortOrder'] = sortOrder;
  }

  if (sortField) {
    variables['sortField'] = sortField;
  }

  if (filter && filter.year && Number(filter.year)) {
    variables['filterYear'] = Number(filter.year);
  }

  if (filter && filter.freetext && filter.freetext.length > 0) {
    variables['filterFreetext'] = filter.freetext;
  }

  if (filter && filter.person && filter.person.length > 0) {
    variables['filterPerson'] = filter.person;
  }

  if (filter && filter.externalPartner && filter.externalPartner.length > 0) {
    variables['filterExternalPartner'] = filter.externalPartner;
  }

  return {
    operationName: 'fetchCooperationQuery',
    query: '\n      query fetchCooperationQuery($id: ID!, $pageSize:Int!, $page:Int!, $sortOrder:SortOrder, $sortField:CooperationSortKeys, $filterYear:Int, $filterFreetext:String, $filterPerson:String, $filterExternalPartner:String) {\n        ' + rootQueryType + '(id: $id) {\n          kooperation:cooperations(pageSize: $pageSize, page: $page, sortOrder: $sortOrder, orderBy:$sortField, filter: {year: $filterYear freeText: $filterFreetext person:$filterPerson externalPartner:$filterExternalPartner }) {\n            meta {\n              pageNumber\n              pageSize\n              totalEntries\n              totalPages\n            }\n            entries {\n              ... on Cooperation {\n                _id:id\n                _entityName\n                html {\n                  de\n                  en\n                }\n              }\n            }\n          }\n        }\n      }\n    ',
    variables: variables
  };
}



/***/ }),

/***/ "BO1V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BP7K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity__ = __webpack_require__("9fz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schema_PersonIdent__ = __webpack_require__("y/j1");



/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Externe Person',
  route: 'abstractperson',
  class: __WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity__["AbstractPerson"],
  className: 'abstractPerson',
  preliminaryStringRep: function preliminaryStringRep(data) {
    return data.vorname + ' ' + data.name;
  },

  tableSelectColumns: [{
    label: '_id',
    field: '_id'
  }, {
    label: '_stringRep',
    field: '_stringRep'
  }],
  fields: [{
    label: 'AbstractPerson.form.vorname',
    field: 'vorname',
    type: 'string'
  }, {
    label: 'AbstractPerson.form.nachname',
    field: 'name',
    type: 'string'
  }, __WEBPACK_IMPORTED_MODULE_1__schema_PersonIdent__["a" /* default */]]
});

/***/ }),

/***/ "BPUV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel fobpanel"},[_c('div',{staticClass:"panel-heading"},[_c('translate',[_vm._v("Projektleitung")])],1),_vm._v(" "),_c('div',{staticClass:"panel-block"},[_c('ul',_vm._l((_vm.resourceData),function(leiter,index){return _c('li',{key:index},[_c('fob-entity-value',{attrs:{"bit":_vm.bit,"resourceData":leiter.person,"isPublic":false,"plain":false,"linkProvider":_vm.linkProvider}}),_vm._v(" "),(leiter.startdatum === null && leiter.enddatum !== null)?[_vm._v("\n            ("),_c('translate',[_vm._v("Leitung bis")]),_vm._v(" "+_vm._s(_vm.asDate(leiter.enddatum))+")\n          ")]:(leiter.startdatum !== null && leiter.enddatum === null)?[_vm._v("\n            ("),_c('translate',[_vm._v("Leitung ab")]),_vm._v(" "+_vm._s(_vm.asDate(leiter.startdatum))+")\n          ")]:(leiter.startdatum !== null && leiter.enddatum !== null)?[_vm._v("\n            ("+_vm._s(_vm.asDate(leiter.startdatum))+" – "+_vm._s(_vm.asDate(leiter.enddatum))+")\n          ")]:_vm._e()],2)}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bg5f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BgBo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BygF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__ = __webpack_require__("cigy");

var Filter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__["a" /* default */])('Land');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Land',
  route: 'land',
  fields: [Filter.String('alpha2code'), Filter.String('alpha3code'), Filter.String('nameDE'), Filter.String('nameEN'), Filter.String('numericCode')]
});

/***/ }),

/***/ "C+FT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cflg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__ = __webpack_require__("cigy");

var Filter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__["a" /* default */])('Kooperation');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Kooperation',
  route: 'kooperation',
  fields: [Filter.ReferenceByMultiValueSearchRep('organisationseinheit', 'sitemap', 'organisationseinheit'), Filter.kumuliert(), Filter.Number('berichtsjahr', 'calendar-o'), Filter.ReferenceByMultiValueSearchRep('beteiligte', 'user', 'abstractPerson'), Filter.String('titelKooperation'), Filter.ReferenceBySearchRep('beteiligteOrganisationen', 'user', 'externeOrganisation')]
});

/***/ }),

/***/ "Cfye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity__ = __webpack_require__("9fz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Organisationseinheit__ = __webpack_require__("tTX3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schema_PersonIdent__ = __webpack_require__("y/j1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FieldsGeneric__ = __webpack_require__("WWW9");





var Fields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__FieldsGeneric__["a" /* default */])('Person');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Interne Person',
  route: 'person',
  class: __WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity__["Person"],
  className: 'person',
  fields: [Fields.String('vorname'), Fields.String('name'), Fields.String('titel'), Fields.String('fisPersid'), __WEBPACK_IMPORTED_MODULE_2__schema_PersonIdent__["a" /* default */], {
    label: 'Person.form.organisationseinheiten',
    field: 'organisationseinheiten',
    type: 'object',
    cardinality: 'many',
    schema: __WEBPACK_IMPORTED_MODULE_1__Organisationseinheit__["a" /* default */],
    finder: {
      name: 'byMultiValueSearchRep',
      multiValue: true,
      minLength: 3
    }
  }]
});

/***/ }),

/***/ "DAx7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Patent_vue__ = __webpack_require__("ZaTp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_713e7f39_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Patent_vue__ = __webpack_require__("BGld");
function injectStyle (ssrContext) {
  __webpack_require__("Q3mG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Patent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_713e7f39_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Patent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DEzH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DHmx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"level"},[_c('div',{staticClass:"level-left"},[_c('div',{staticClass:"fob-public-heading",staticStyle:{"max-width":"840px"}},[_c('div',{staticClass:"fob-public-heading-label"},[_c('div',{staticClass:"is-size-5",staticStyle:{"font-weight":"bold","font-variant":"small-caps","margin-bottom":"4px","line-height":"normal"}},[_vm._t("heading")],2),_vm._v(" "),_c('div',{staticClass:"is-size-6"},[_vm._t("subheading")],2)])])]),_vm._v(" "),_c('div',{staticClass:"level-right fob-hide-in-print",staticStyle:{"margin-bottom":"auto"}},[_vm._t("quick-actions")],2)]),_vm._v(" "),_c('div',{staticClass:"leurisProfile fob-hide-in-print",staticStyle:{"margin-bottom":"2rem","padding":"0 8rem 0 2rem","border-left":"3px solid rgb(138, 193, 208)"}},[_vm._t("description")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DSDm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_EntityCompact__ = __webpack_require__("FyeQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-entity-list-compact',
  props: ['data', 'entityDetailsRoute', 'entityEditRoute', 'schema', 'showPublicationType', 'showStar', 'loading'],
  components: {
    'fob-entity-compact': __WEBPACK_IMPORTED_MODULE_0__components_EntityCompact__["a" /* default */]
  }
});

/***/ }),

/***/ "DVHc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityListView_vue__ = __webpack_require__("fn+S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d138fc6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityListView_vue__ = __webpack_require__("6gk7");
function injectStyle (ssrContext) {
  __webpack_require__("+CPT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityListView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d138fc6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityListView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Du0s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-width":"1200px"}},[(_vm.userIsAuthorized && _vm.userHasOrga)?[_c('div',{staticClass:"section",staticStyle:{"margin-top":"-50px"}},[_c('h1',{staticClass:"is-size-3",staticStyle:{"margin-bottom":"20px"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$gettext('start.headline'))}})]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"2rem"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$gettext('start.intro'))}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasNews),expression:"hasNews"}],staticClass:"leuris-news fob-box"},[_c('h2',[_c('b-icon',{attrs:{"icon":"exclamation"}}),_vm._v(" "),_c('translate',[_vm._v("leuris news heading")])],1),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.news)}})]),_vm._v(" "),_c('div',[_c('h2',{staticClass:"is-size-5",staticStyle:{"margin-bottom":"0.5em"}},[_c('span',{staticClass:"has-text-weight-bold",domProps:{"innerHTML":_vm._s(_vm.$gettext('start.help.heading'))}})]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"20px"},domProps:{"innerHTML":_vm._s(_vm.$gettext('start.help'))}})]),_vm._v(" "),_c('div',{staticClass:"buttons is-centered",staticStyle:{"margin":"0px 0 30px 40px"}},[_c('a',{staticClass:"control button is-link is-outlined",attrs:{"href":_vm.wikiLink('start', 'das_allerwichtigste_in_kuerze'),"target":"_blank"}},[_c('translate',[_vm._v("start.help.intro")]),_vm._v(" "),_c('b-icon',{attrs:{"icon":"external-link","size":"is-small"}})],1),_vm._v(" "),_c('a',{staticClass:"control button is-link",attrs:{"href":_vm.wikiLink('haeufige_fragen'),"target":"_blank"}},[_c('translate',[_vm._v("start.help.faq")]),_vm._v(" "),_c('b-icon',{attrs:{"icon":"external-link","size":"is-small"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"20px"}},[_c('translate',[_vm._v("start.video.tutorials.text")])],1),_vm._v(" "),_c('div',{staticClass:"buttons is-centered",staticStyle:{"margin":"0px 0 30px 40px"}},[_c('a',{staticClass:"control button is-link is-outlined",attrs:{"href":"https://schulung.uni-leipzig.de/leuris-schulung","target":"_blank"}},[_c('translate',[_vm._v("start.video.tutorials.link")]),_vm._v(" "),_c('b-icon',{attrs:{"icon":"external-link","size":"is-small"}})],1)]),_vm._v(" "),(_vm.userIsAuthorized)?[_c('h2',{staticClass:"is-size-5",staticStyle:{"margin-bottom":"0.5em"}},[_c('span',{staticClass:"has-text-weight-bold"},[_c('translate',[_vm._v("start.firstSteps.heading")])],1)]),_vm._v(" "),_c('div',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"v-translate-params":{ renderedRouterLinkListActivities: _vm.renderedRouterLinkListActivities }}},[_vm._v("start.firstSteps")]),_vm._v(" "),_c('div',{staticClass:"buttons is-centered",staticStyle:{"margin":"30px 0 30px 40px"}},[_c('router-link',{staticClass:"control button is-medium has-text-basalt is-medium",attrs:{"to":{name: 'auflisten'}}},[_c('b-icon',{attrs:{"size":"is-small","icon":"table"}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$gettext('start.listSavedViews'))}})],1),_vm._v(" "),_c('router-link',{staticClass:"control button is-medium has-text-basalt is-medium",attrs:{"to":{name: 'eintragen'}}},[_c('b-icon',{attrs:{"size":"is-small","icon":"pencil-square-o"}}),_vm._v(" "),_c('span',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$gettext('start.addActivity'))}})])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"20px","margin-top":"40px"}},[_c('h2',{staticClass:"is-size-5"},[_c('span',{staticClass:"has-text-weight-bold",domProps:{"innerHTML":_vm._s(_vm.$gettext('start.shortcuts'))}})])]),_vm._v(" "),_c('fob-saved-views',{staticStyle:{"margin-left":"40px"}})]:[_c('div',[_vm._v("\n          Um die Weboberfläche nutzen zu können, müssen Sie sich\n          zunächst "),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("einloggen.")])],1)]],2)]:(_vm.userIsAuthorized && !_vm.userHasOrga)?[_c('div',{staticStyle:{"padding":"1rem","max-width":"1200px"}},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column",staticStyle:{"max-width":"50px"}},[_c('b-icon',{attrs:{"icon":"exclamation","type":"is-aquamarine","size":"is-large"}})],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('translate',[_vm._v("start.noOU")]),_vm._v(" "),_c('a',{attrs:{"href":("mailto:fob@uni-leipzig.de?subject=" + _vm.subject)}},[_c('b-icon',{attrs:{"icon":"envelope","size":"is-small"}}),_vm._v(" "),_c('translate',[_vm._v("FOB-Team")])],1),_vm._v("\n          .\n        ")],1)])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"content has-text-centered",staticStyle:{"margin-top":"3rem"}},[_c('div',{staticClass:"is-size-7 has-text-grey-light"},[_c('span',{staticStyle:{"padding-right":"0.5rem"}},[_vm._v("FOBGUI "+_vm._s(_vm.version))]),_vm._v(" "),(this.hasUpdateAvailable)?_c('a',{staticClass:"has-text-grey-light",staticStyle:{"padding-right":"0.5rem"},attrs:{"title":_vm.$gettext('ReloadPage')},on:{"click":_vm.reloadPage}},[_c('translate',[_vm._v("UpdateAvailable")])],1):_vm._e(),_vm._v(" "),(this.userIsAuthorized)?_c('a',{staticClass:"has-text-grey-light",staticStyle:{"padding-right":"0.5rem"},on:{"click":_vm.dropLocalStorage}},[_vm._v("Browserspeicher löschen")]):_vm._e()])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DxGe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFieldsGeneric__ = __webpack_require__("K13K");

var ListFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ListFieldsGeneric__["a" /* default */])('AbstractPerson');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Externe Person',
  route: 'abstractperson',
  className: 'abstractPerson', // wird von fob-js-client benutzt
  fields: [ListFields.SortableField('vorname', true), ListFields.SortableField('name', true), ListFields.UnsortableReference('personIdent', false)]
});

/***/ }),

/***/ "Dz6P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-dropdown',{ref:"column-dropdown",attrs:{"open":_vm.visibilityOpen},on:{"update:open":function($event){_vm.visibilityOpen=$event}},nativeOn:{"mouseleave":function($event){return _vm.hideOnMouseLeave($event)}}},[_c('a',{staticClass:"button",attrs:{"slot":"trigger"},slot:"trigger"},[_c('span',[_c('translate',[_vm._v("list.spaltensichtbarkeit")])],1),_vm._v(" "),_c('b-icon',{attrs:{"type":"is-aquamarine","icon":"angle-down"}})],1),_vm._v(" "),_vm._l((_vm.value),function(column){return _c('div',{key:column.key || column.field},[_c('b-field',{staticClass:"dropdown-item"},[_c('b-checkbox',{on:{"input":_vm.emitChange},model:{value:(column.tableVisible),callback:function ($$v) {_vm.$set(column, "tableVisible", $$v)},expression:"column.tableVisible"}},[_c('translate',[_vm._v(_vm._s(column.label))])],1)],1)],1)})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E5FI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);


var isAtLeastFrom = function isAtLeastFrom(to, vm) {
  var from = vm.veranstaltungStart;
  if (to && from) {
    return from <= to;
  } else {
    return true;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  organisationseinheit: {
    name: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) }
  },
  name: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) },
  veranstaltungsTyp: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) },
  veranstaltungStart: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] },
  veranstaltungEnde: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], isAtLeastFrom: isAtLeastFrom },
  externeWebsite: { url: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["url"] }
});

/***/ }),

/***/ "E5fF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E7wU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EBNI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_EntityCompactCyan__ = __webpack_require__("rwyJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-entity-list-compact-cyan',
  props: ['data', 'entityDetailsRoute', 'entityEditRoute', 'showPublicationsCount', 'showPublicationType', 'showStar', 'loading'],
  components: {
    'fob-entity-compact-cyan': __WEBPACK_IMPORTED_MODULE_0__components_EntityCompactCyan__["a" /* default */]
  }
});

/***/ }),

/***/ "EU3M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_debounce__ = __webpack_require__("91kW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_promise_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("0xDb");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-entity-list-pagination',
  data: function data() {
    return {
      currentPage: this.page || 1,
      currentPageActive: false
    };
  },

  props: ['perPage', 'page', 'total', 'compact', 'disableSwitch'],
  computed: {
    isCompact: {
      get: function get() {
        return this.compact;
      },
      set: function set(v) {
        this.$emit('update:compact', v);
      }
    },
    totalTablePages: function totalTablePages() {
      return Math.ceil(this.total / this.perPage);
    }
  },
  methods: {
    onChangePageByPagination: function onChangePageByPagination(v) {
      this.$emit('update:current', v);
    },

    onChangePageManually: __WEBPACK_IMPORTED_MODULE_1_es6_promise_debounce___default()(function (v) {
      var isNaN = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(Number(v.target.value));
      var inputNumber = isNaN ? this.page : Number(v.target.value);
      var isEmpty = v.target.value.length === 0;
      var isEqual = inputNumber === this.page;

      if (!isEmpty) {
        if (inputNumber < 1 || inputNumber > this.totalTablePages) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* ToastError */])(this.$gettext('Pagination.pageNotAvailable'), 1000);
          // reset page on input field if validation fails
          this.currentPage = this.page;
        } else if (!isEqual) {
          // only fetch manually set page if 'this.currentPage' is valid
          // and equals not 'page' (from b-pagination)
          this.$emit('update:current', inputNumber);
        } else {
          // reset by default in else condition ...
          this.currentPage = this.page;
          // ... but only show toast if value is not valid number
          if (isNaN) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* ToastError */])(this.$gettext('Pagination.pageNotAvailable'), 1000);
          }
        }
      }
    }, 500)
  },
  watch: {
    page: function page() {
      // watch page value to fill input value
      // (especially if another fob-entity-list-pagination
      // will change this value). If we set the page
      this.currentPage = this.page;
    }
  }
});

/***/ }),

/***/ "Ej7L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("c1ol");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__("i3YD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__("Agex");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("tbhY");





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__
});

/***/ }),

/***/ "Eti6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFieldsGeneric__ = __webpack_require__("K13K");

var ListFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ListFieldsGeneric__["a" /* default */])('Land');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Land',
  route: 'land',
  className: 'land',
  fields: [ListFields.SortableReference('alpha2code', true), ListFields.SortableReference('alpha3code', true), ListFields.SortableReference('nameDE', true), ListFields.SortableReference('nameEN', true), ListFields.SortableReference('numericCode', true)]
});

/***/ }),

/***/ "Ev9m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoading", function() { return isLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoadingStaff", function() { return isLoadingStaff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getShowOrgaTree", function() { return getShowOrgaTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getData", function() { return getData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDataResearchProject", function() { return getDataResearchProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDataPublication", function() { return getDataPublication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSchema", function() { return getSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSelected", function() { return getSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStaffStartsWithData", function() { return getStaffStartsWithData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStaffStartsWith", function() { return getStaffStartsWith; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStaffFullName", function() { return getStaffFullName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStaffLetterCount", function() { return getStaffLetterCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStaffTotalEntries", function() { return getStaffTotalEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getResourceType", function() { return getResourceType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getConfig", function() { return getConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTotal", function() { return getTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getActiveTab", function() { return getActiveTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getId", function() { return getId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFilter", function() { return getFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resourceTypes", function() { return resourceTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLabel", function() { return getLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPage", function() { return getPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPerPage", function() { return getPerPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSortField", function() { return getSortField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSortOrder", function() { return getSortOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLeurisProfile", function() { return getLeurisProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLeurisProfileFisPersid", function() { return getLeurisProfileFisPersid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getORCID", function() { return getORCID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUlWebsiteProfile", function() { return getUlWebsiteProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOuDescription", function() { return getOuDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOuDetails", function() { return getOuDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRootQueryType", function() { return getRootQueryType; });
var isLoading = function isLoading(state) {
  return state.loading;
};

var isLoadingStaff = function isLoadingStaff(state) {
  return state.staff.loading;
};

var getShowOrgaTree = function getShowOrgaTree(state) {
  return state.showOrgaTree;
};

var getData = function getData(state) {
  return state.data;
};

var getDataResearchProject = function getDataResearchProject(state) {
  return state.data.forschungsprojekt;
};

var getDataPublication = function getDataPublication(state) {
  return state.data.publikation;
};

var getSchema = function getSchema(state) {
  return state.listSchema;
};

var getSelected = function getSelected(state) {
  return state.selected;
};

var getStaffStartsWithData = function getStaffStartsWithData(state) {
  return state.staff.data;
};

var getStaffStartsWith = function getStaffStartsWith(state) {
  return state.staff.startsWith;
};

var getStaffFullName = function getStaffFullName(state) {
  return state.staff.fullName;
};

var getStaffLetterCount = function getStaffLetterCount(state) {
  return state.staff.letterCount;
};

var getStaffTotalEntries = function getStaffTotalEntries(state) {
  return state.staff.totalEntries;
};

var getResourceType = function getResourceType(state) {
  return state.resourceType;
};

var getConfig = function getConfig(state) {
  return state.config;
};

var getTotal = function getTotal(state) {
  return state.total;
};

var getActiveTab = function getActiveTab(state) {
  return state.activeTab;
};

var getId = function getId(state) {
  return state.id;
};

var getFilter = function getFilter(state) {
  return state.filter;
};

var resourceTypes = function resourceTypes(state) {
  return state.resourceTypes;
};

var getLabel = function getLabel(state) {
  return state.label;
};

var getPage = function getPage(state) {
  return state.config[state.resourceType].page;
};

var getPerPage = function getPerPage(state) {
  return state.config[state.resourceType].perPage;
};

var getSortField = function getSortField(state) {
  return state.config[state.resourceType].sortField;
};

var getSortOrder = function getSortOrder(state) {
  return state.config[state.resourceType].sortOrder;
};

var getLeurisProfile = function getLeurisProfile(state) {
  return state.leurisProfile.data;
};

var getLeurisProfileFisPersid = function getLeurisProfileFisPersid(state) {
  return state.leurisProfile.fisPersid;
};

var getORCID = function getORCID(state) {
  return state.leurisProfile.orcid;
};

var getUlWebsiteProfile = function getUlWebsiteProfile(state) {
  return state.leurisProfile.ulWebsiteProfile;
};

var getOuDescription = function getOuDescription(state) {
  return state.ouDetails.description;
};

var getOuDetails = function getOuDetails(state) {
  return state.ouDetails;
};

var getRootQueryType = function getRootQueryType(state) {
  return state.selected.rootQueryType;
};

/***/ }),

/***/ "Extr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFieldsGeneric__ = __webpack_require__("K13K");

var ListFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ListFieldsGeneric__["a" /* default */])('AppUser');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'AppUser',
  route: 'appuser',
  className: 'appUser',
  fields: [ListFields.SortableTimestamp('_updateDate', false, 'updateDate', true), ListFields.SortableTimestamp('_createDate', false, 'createDate', true), ListFields.UnsortableReference('applicationRoles', true), ListFields.SortableField('userName', true), ListFields.SortableField('email', false), ListFields.SortableBoolean('forscher', false), ListFields.UnsortableReference('organisationseinheiten', false), ListFields.UnsortableReference('zstzlOrganisationseinheiten', false), ListFields.SortableTimestamp('lastLogin', true)]
});

/***/ }),

/***/ "F+TQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);


/* harmony default export */ __webpack_exports__["a"] = ({
  mittelgeber: {
    name: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) }
    // foerderkennzeichen: { required }
  } });

/***/ }),

/***/ "FA/a":
/***/ (function(module, exports) {

module.exports = {"de_DE":{"skipValidation":"Validierung aussetzen (Ich weiß was ich tue)","ReadMore":"Mehr erfahren","extern":"extern","UpdateAvailable":"Update verfügbar","ReloadPage":"Aktualisieren","ClearCache":"Browserspeicher löschen","leuris news heading":"Das leuris-Team informiert","notFound":"Seite nicht gefunden","btn.back":"Zurück zur Startseite","browser.outdated":"Sie benutzen einen veralteten Browser, der die heutigen Sicherheitsanforderungen sowie moderne Webstandards nicht unterstützt. Deshalb kann es mit diesem Browser zu Funktionseinschränkungen auf dieser Seite kommen. Bitte benutzen Sie aktuelle Alternativen wie Firefox, Chrome, Safari oder Edge.","confirmPrivacyPolicy":"Wir speichern Ihre Sitzungsdaten in einer mit Cookies vergleichbaren Technologie um Benutzerfreundlichkeit zu gewährleisten.","welcome.researchActivities":"Forschungsaktivitäten","welcome.heading":"Forschungsportal der Universität Leipzig","welcome.text.above":"<p>Willkommen auf den Seiten des Forschungsportals der Universität Leipzig. Hier finden Sie einen Einblick in die %{renderedRouterLinkPublicActivities} der Wissenschaftlerinnen und Wissenschaftler der Universität Leipzig. </p>\n<p>Die hier dargestellten Informationen basieren auf den von den Wissenschaftlerinnen und Wissenschaftlern selbst berichteten Aktivitäten zu Forschungsprojekten, Publikationen, Preisen/Auszeichnungen/Ehrungen, Internationalen Kooperationen sowie wissenschaftlichen Veranstaltungen. Ältere Aktivitäten von 2008 bis 2016 sind in der Forschungsdatenbank (<a href=\"http://forschen.uni-leipzig.de\" target=\"_blank\">Archiv</a>) gespeichert und abrufbar.</p>\n<p>Bei Fragen und Anregungen schreiben Sie bitte eine Nachricht an <a href=\"mailto:leuris@uni-leipzig.de\">leuris@uni-leipzig.de</a></p>","welcome.btn.readmore":"Mehr erfahren","welcome.text.like":"Das könnte Sie auch interessieren","welcome.tile.techtransfer.title":"Wissens- und Technologietransfer","welcome.tile.techtransfer.content":"<a href=\"https://www.uni-leipzig.de/forschung/wissens-und-technologietransfer\" target=\"_blank\" rel=\"noopener noreferrer\"> <span style=\"text-transform: uppercase; letter-spacing: 1px; padding-right: 0.5rem;\" class=\"is-size-6\">Mehr erfahren</span>  <i class=\"fa fa-external-link\" aria-hidden=\"true\"></i></a>","welcome.tile.researchprofile.title":"Forschungsprofil","welcome.tile.researchprofile.content":"<a href=\"https://www.uni-leipzig.de/forschung/forschungsprofil\" target=\"_blank\" rel=\"noopener noreferrer\"> <span style=\"text-transform: uppercase; letter-spacing: 1px; padding-right: 0.5rem;\" class=\"is-size-6\">Mehr erfahren</span>  <i class=\"fa fa-external-link\" aria-hidden=\"true\"></i></a>","welcome.tile.researchservice.title":"Forschungsservice","welcome.tile.researchservice.content":"<a href=\"https://www.uni-leipzig.de/forschung/forschungsservice\" target=\"_blank\" rel=\"noopener noreferrer\"> <span style=\"text-transform: uppercase; letter-spacing: 1px; padding-right: 0.5rem;\" class=\"is-size-6\">Mehr erfahren</span>  <i class=\"fa fa-external-link\" aria-hidden=\"true\"></i></a>","footer.main":"<strong class=\"is-uppercase\">leuris:Forschungsbericht und leuris:Portal</strong> - eine Kooperation von <br><a class=\"is-uppercase\" href=\"https://www.uni-leipzig.de/universitaet/struktur/verwaltung-und-stabsstellen/dezernat-1/\" target=\"_blank\" rel=\"noopener noreferrer\">Dezernat 1: Forschung und Transfer</a>, <a class=\"is-uppercase\" href=\"https://www.urz.uni-leipzig.de\" target=\"_blank\" rel=\"noopener noreferrer\">Universitätsrechenzentrum</a> und <a class=\"is-uppercase\" href=\"https://www.ub.uni-leipzig.de\" target=\"_blank\" rel=\"noopener noreferrer\">Universitätsbibliothek Leipzig</a>.","footer.link.imprint":"<a style=\"padding-right: 0.5rem;\" href=\"https://www.uni-leipzig.de/impressum\">Impressum</a>","footer.link.privacyPolicy":"<a style=\"padding-right: 0.5rem;\" href=\"https://www.uni-leipzig.de/datenschutz\">Datenschutzerklärung</a>","footer.link.contact":"<a title=\"Schreiben Sie uns eine E-Mail\" href=\"mailto:fob@uni-leipzig.de\">Kontakt</a>","boolean.yes":"Ja","boolean.no":"Nein","list.total":"Ergebnis","list.total.plural":"Ergebnisse","und":"und","and":"und","or":"oder","page":"Seite","list.header.perPage":"pro Seite","list.button.print":"Drucken","list.printedOn":"Gedruckt am %{printDate} Uhr aus dem Forschungsbericht der Universität Leipzig (https://fob.uni-leipzig.de)","list.button.save":"Einstellung speichern","list.button.compactView":"Kompaktansicht","list.options.adjust.searchparameters":"Suchparameter anpassen","list.noData":"Keine Daten vorhanden","savedView.dialog.message":"Geben Sie einen Namen für diese Einstellung ein:","savedView.dialog.confirm":"Speichern","savedView.dialog.cancel":"Abbrechen","savedView.button.activate":"Laden","savedView.button.activate.toolTip":"Diese Einstellung in die Listenansicht laden","savedView.button.delete.toolTip":"Diese Sucheinstellung löschen","PersonIdentTyp":"Personenidentifikator-Typ","PersonIdentTyp.form.kennung":"Kürzel","PersonIdentTyp.form.anmerkung":"Anmerkung","PreisBezeichnung":"Auszeichnungsart","PreisBezeichnung.form.name":"Name","PreisBezeichnung.form.beschreibung":"Kategorie","form.header.created":"Erstellt","form.header.lastEdited":"zuletzt bearbeitet","form.header.by":"von","Login Description":"Der leuris:Forschungsbericht ist das zentrale Werkzeug zur Forschungsberichterstattung an unserer Universität. Mitarbeiterinnen und Mitarbeiter können hier ihre Forschungsaktivitäten eintragen und verwalten. Bereits eingetragene Daten stehen auch weiterhin zur Verfügung und können jederzeit aktualisiert werden.","Login Systemrequirements Heading":"Zugang zur Weboberfläche - Systemvoraussetzungen","Login Systemrequirements Text":"Loggen Sie sich <em>oben rechts</em> mit dem Button „Login“ ein. Der Login erfolgt über den Uni-Login, bspw. <code>ab80xyzy</code> und das dazugehörige Passwort. Hinweise zum Uni-Login und dem Passwort finden Sie auf den <a href=\"https://www.urz.uni-leipzig.de/dienste/uni-login/\"> Webseiten des Universitätsrechenzentrums Leipzig</a>.","Login Not Working Heading":"Login funktioniert nicht?","Login Not Working Text":"<strong>Achtung:</strong> Es kann vorkommen, dass bei Mitarbeiter_innen, die vorher an der Universität studiert haben, der Mitarbeiterstatus im sogenannten Active Directory (AD), der den Zugang zum System regelt, nicht aktualisiert wurde. Falls Sie befürchten, sich deshalb nicht einloggen zu können, schreiben Sie bitte an <a href=\"mailto:servicedesk@uni-leipzig.de?subject=Aktualisierung des Affiliierungsstatus im AD\">servicedesk@uni-leipzig.de</a> eine E-Mail mit der Bitte, im AD ihren Status zu aktualisieren.","AbstractPerson":"Externe Person","AbstractPerson.form.tableSelect._id":"FOB-ID","AbstractPerson.form.tableSelect._stringRep":"Person - Titel, Name und Organisationseinheit","AbstractPerson.form.vorname":"Vorname","AbstractPerson.form.nachname":"(Nach-) Name","AbstractPerson.form.column.personIdent":"Personen-Identifikatoren","AbstractPerson.list.column.vorname":"Vorname","AbstractPerson.list.column.name":"(Nach-) Name","AbstractPerson.list.column.personIdent":"Personen-Identifikatoren","AbstractPerson.list.filter.vorname":"Vorname","AbstractPerson.list.filter.name":"(Nach-) Name","AbstractPerson.list.filter.personIdentWert":"Suche nach Personen-Identifikatoren","AppUser":"FOB-Nutzer","AppUser.form.userName":"Uni-Login","AppUser.form.lastLogin":"Letzter Login","AppUser.form.forscher":"Als Forscher tätig?","AppUser.list.column.forscher":"Forscher?","AppUser.form.applicationRoles":"FOB-Rollen","AppUser.form.organisationseinheiten":"OE aus der AD","AppUser.form.zstzlOrganisationseinheiten":"Hinzugefügte OE","AppUser.list.column.applicationRoles":"FOB-Rollen","AppUser.list.column.lastLogin":"Letzter Login","AppUser.list.column._updateDate":"Update Datum","AppUser.list.column._createDate":"Erstellt Datum","AppUser.list.column.organisationseinheiten":"Auto OE","AppUser.list.column.zstzlOrganisationseinheiten":"FOB OE","AppUser.list.column.email":"E-Mail","AppUser.list.column.userName":"Username","AppUser.list.filter.userName":"Uni-Login","AppUser.list.filter.applicationRoles":"FOB-Rollen","AppUser.list.filter.lastLogin":"Letzter Login","AppUser.list.filter.organisationseinheiten":"OE aus der AD","AppUser.list.filter.zstzlOrganisationseinheiten":"Hinzugefügte OE","AppUser.list.filter.email":"E-Mail","component.entity.compact.details":"Detailansicht","component.entity.compact.edit":"Bearbeiten","component.entity.compact.favour.select":"Als Favorit setzen","component.entity.compact.favour.deselect":"Favorit abwählen","component.entity.list.table.details":"Detailansicht","component.entity.list.table.edit":"Bearbeiten","createModal.button.cancel":"Abbrechen","createModal.button.create":"Neu anlegen","createModal.header.beteiligteOrganisationen":"Externe Organisation neu anlegen","createModal.header.beteiligtePersonen":"Externe Person neu anlegen","createModal.header.antragsteller":"Externe Person als Antragsteller_in neu anlegen","createModal.header.projektLeiter":"Externe Person als Projektleiter_in neu anlegen","createModal.header.projektleiter_person":"Externe Person als Projektleiter_in neu anlegen","createModal.header.mitarbeiter":"Externe Person als Projektmitarbeiter_in neu anlegen","createModal.header.author":"Externe Person als Autor_in neu anlegen","createModal.header.herausgeber":"Externe Person als Herausgeber_in neu anlegen","createModal.header.veranstalter":"Externe Person als Veranstalter_in neu anlegen","details.button.edit":"Bearbeiten","details.button.delete":"Löschen","details.button.print":"Drucken","details.printedOn":"Gedruckt am %{printDate} Uhr aus dem Forschungsbericht der Universität Leipzig (https://fob.uni-leipzig.de)","ExterneOrganisation":"Externe Organisation","ExterneOrganisation.form.tableSelect.Name":"Name der Externen Organisation","ExterneOrganisation.form.tableSelect.Stadt":"Stadt der Externen Organisation","ExterneOrganisation.list.filter.beschreibung":"Beschreibung der Externen Organisation","ExterneOrganisation.list.filter.kurzname":"Kurzname der Externen Organisation","ExterneOrganisation.list.filter.land":"Land der Externen Organisation","ExterneOrganisation.list.filter.name":"Name der Externen Organisation","ExterneOrganisation.list.filter.stadt":"Stadt der Externen Organisation","ExterneOrganisation.form.land":"Land","ExterneOrganisation.form.stadt":"Stadt","ExterneOrganisation.form.name":"Name","ExterneOrganisation.form.beschreibung":"Beschreibung der Externen Organisation","ExterneOrganisation.form.kurzname":"Kurzname der Externen Organisation","externalLink":"Externer Link","Mittelgeber":"Mittelgeber","Forschungsprojekt":"Forschungsprojekt","Forschungsprojekte":"Forschungsprojekte","Projekt":"Projekt","Projekte":"Projekte","Projektleitung":"Projektleitung","Projektleiter hinzufügen":"Projektleiter*in hinzufügen","Projektleiterrolle GESAMTLEITUNG":"Gesamtleitung","Projektleiterrolle FACHLICHE_LEITUNG":"Fachliche Leitung","Projektleiterrolle TECHNISCHE_LEITUNG":"Technische Leitung","projektleiter_no_person":"Keine Person ausgewählt","startdate_out_of_scope":"Startdatum nicht im Projektzeitraum","enddate_out_of_scope":"Enddatum nicht im Projektzeitraum","enddate_before_startdate":"Enddatum liegt vor Startdatum","Leitung Projektstart":"Projektbeginn","Leitung Projektende":"Projektende","Leitung als":"als","Leitung ab":"ab","Leitung bis":"bis","Forschungsprojekt.form.primaryPublicIdent":"Permalink","Forschungsprojekt.form.antragsteller":"Antragsteller_in","Forschungsprojekt.form.finanzierung":"Finanzierung des Projekts durch","Forschungsprojekt.form.foerderung.foerderkennzeichen":"Förderkennzeichen","Forschungsprojekt.form.foerderung.mittelgeber":"Mittelgeber","Forschungsprojekt.form.hinweistext":"<b>Tragen Sie hier nur Forschungsprojekte ein, die im Forschungsbericht noch nicht vorhanden sind!</b><br> Viele Projekte werden aus den Vorjahren noch vorhanden sein. Bitte prüfen Sie unbedingt die Laufzeit der Projekte. Bei etlichen alten Eintragungen fehlt noch das Datum des Projektbeginns. Nutzen Sie die Suche unter <i>Aktivitäten auflisten</i> um zu sehen, welche Projekte es zu Ihrer Organisationseinheit bereits gibt.","Forschungsprojekt.form.mitarbeiter":"Am Projekt beteiligte Mitarbeiter_innen","Forschungsprojekt.form.organisationseinheit":"Dem Projekt zugeordnete Organisationseinheit","Forschungsprojekt.form.projektBeginn":"Projektbeginn","Forschungsprojekt.form.projektEnde":"Projektende","Forschungsprojekt.form.externeProjektwebsite":"Externe Projektwebsite","Forschungsprojekt.form.projektLeiter":"Projektleiter_in","Forschungsprojekt.form.projektLeiter.plusbutton":"Hinzufügen","projektleiter_person.plusbutton":"Neu anlegen","Forschungsprojekt.form.publikation":"Publikation","Forschungsprojekt.form.relevantFuerWeitere":"Weitere beteiligte Organisationseinheiten","Forschungsprojekt.form.sprecherhochschule":"Sprecherhochschule des Verbundprojekts","Forschungsprojekt.form.titelDE":"Titel (Deutsch)","Forschungsprojekt.form.titelEN":"Titel (Englisch)","Forschungsprojekt.form.uebergeordnetesProjekt":"Übergeordnetes Projekt","Forschungsprojekt.form.verbundprojekt":"Verbundprojekt","Forschungsprojekt.form.weitereOrganisationseinheiten":"Weitere beteiligte Organisationseinheiten","Forschungsprojekt.form.beschreibungDE":"Beschreibung (Deutsch)","Forschungsprojekt.form.beschreibungEN":"Beschreibung (Englisch)","Forschungsprojekt.form.istFinal":"Dateneingabe final","Forschungsprojekt.list.column._createDate":"Eingetragen am","Forschungsprojekt.list.column._updateDate":"Letzte Änderung","Forschungsprojekt.list.column.antragsteller":"Antragsteller_in","Forschungsprojekt.list.column.foerderung":"Mittelgeber","Forschungsprojekt.list.column.foerderkennzeichen":"Förderkennzeichen","Forschungsprojekt.list.column.istFinal":"Dateneingabe final","Forschungsprojekt.list.column.organisationseinheit":"Organisationseinheit","Forschungsprojekt.list.column.projektBeginn":"Projektbeginn","Forschungsprojekt.list.column.projektEnde":"Projektende","Forschungsprojekt.list.column.projektLeiter":"Projektleiter_in","Forschungsprojekt.list.column.projektleiter":"Projektleitung","Forschungsprojekt.list.column.titelDE":"Titel (Deutsch)","Forschungsprojekt.list.column.titelEN":"Titel (Englisch)","Forschungsprojekt.list.column.weitereOrganisationseinheiten":"Weitere Organisationseinheiten","Forschungsprojekt.list.column.uebergeordnetesProjekt":"Übergeordnetes Projekt","Forschungsprojekt.list.filter.antragsteller":"Antragsteller_in","Forschungsprojekt.list.filter.organisationseinheit":"Organisationseinheit","Forschungsprojekt.list.filter.kumuliert":"Untereinheiten einbeziehen","Forschungsprojekt.list.filter.berichtsjahr":"Berichtsjahr","Forschungsprojekt.list.filter.projektLeiter":"Projektleiter_in","Forschungsprojekt.list.filter.projektleiter":"Projektleitung","Forschungsprojekt.list.filter.titelDE":"Titel (Deutsch)","Forschungsprojekt.list.filter.titelEN":"Titel (Englisch)","Forschungsprojekt.list.filter.mittelgeber":"Projekt gefördert durch","Forschungsprojekt.list.filter.beteiligte":"Beteiligte Personen (Antragsteller_innen, Projektleiter_in oder Mitarbeiter_innen)","Forschungsprojekt.list.filter.uebergeordnetesProjekt":"Übergeordnetes Projekt","Forschungsprojekt.compact.Laufzeit":"Laufzeit","Forschungsprojekt.compact.Mittelgeber":"Mittelgeber","Forschungsprojekt.compact.weitereOrganisationseinheiten":"Weitere beteiligte Organisationseinheiten","Forschungsprojekt.compact.organisationseinheiten":"Beteiligte Organisationseinheiten der UL","Kooperation":"Intern. Kooperation","Kooperationen":"Kooperationen","Kooperation.compact.beginn":"Beginn der Kooperation","Kooperation.compact.ende":"Endete am","Kooperation.compact.beteiligteOrganisationen":"Beteiligte externe Organisationen","Kooperation.compact.beteiligtePersonen":"Beteiligte Personen","Kooperation.compact.weitereOEderUL":"Weitere OE der UL","Kooperation.form.andereKooperation":"Andere Arten der Aktivitäten, bitte erläutern","Kooperation.form.ansprechpartner":"Ansprechpartner_in","Kooperation.form.beginn":"Datum Beginn der Kooperation","Kooperation.form.beteiligteOrganisationen":"Beteiligte externe Organisationen","Kooperation.form.beteiligtePersonen":"Beteiligte Personen","Kooperation.form.doktorandenProgramm":"Durchführung mindestens eines Studien- oder Doktorandenprogrammes","Kooperation.form.ende":"Datum des derzeit geplanten Endes der Kooperation","Kooperation.form.endeGeplant":"Das Ende der Kooperation ist geplant.","Kooperation.form.gastaufenthalte":"Gegenseitige oder wiederholte Gastaufenthalte wissenschaftlichen Personals","Kooperation.form.gegenseiteHilfe":"Austausch/gegenseitige Hilfestellung bei methodischen Fragen/Implementationen (z.B. Durchführung von Experimenten)","Kooperation.form.gemeinsamePublikationen":"Gemeinsames institutionalisiertes Verfassen oder Herausgeben von Publikationen","Kooperation.form.gemeinsameTagungen":"Veranstaltung gemeinsamer Tagungen/Workshops","Kooperation.form.gemeinsameThemen":"Arbeit an gemeinsamen Themen/Fragestellungen","Kooperation.form.hinweistext":"<b>Tragen Sie hier nur internationale Kooperationen ein, die im Forschungsbericht noch nicht vorhanden sind!</b><br> Viele langfristige Kooperationen werden aus den Vorjahren noch vorhanden sein. Bitte prüfen Sie unbedingt die Laufzeit der Kooperationen. Nutzen Sie die Suche unter <i>Aktivitäten auflisten</i> um zu sehen, welche Kooperationen schon eingetragen sind.","Kooperation.form.kooperationsTyp":"Kooperationstyp","Kooperation.form.kooperationsarten":"Aktivitäten innerhalb der Kooperation","Kooperation.form.kurzbeschreibung":"Kurzbeschreibung/Abstract der Kooperation","Kooperation.form.organisationseinheit":"Für die Kooperation verantwortliche Organisationseinheit der UL","Kooperation.form.relevantFuerWeitere":"An dieser Kooperation sind weitere Organisationseinheiten der UL beteiligt","Kooperation.form.titelKooperation":"Titel der Kooperation","Kooperation.form.weitereOrganisationseinheiten":"Weitere beteiligte Organisationseinheiten der UL","Kooperation.form.kooperationsartFreitext":"Erläuterung zu anderen Arten von Aktivitäten in der Kooperation","Kooperation.list.column._createDate":"Eingetragen am","Kooperation.list.column._updateDate":"Letzte Änderung","Kooperation.list.column.ansprechpartner":"Ansprechpartner_in","Kooperation.list.column.beginn":"Startdatum","Kooperation.list.column.beteiligteOrganisationen":"Externe Organisationen","Kooperation.list.column.ende":"Endedatum","Kooperation.list.column.kooperationsTyp":"Typ der Kooperation","Kooperation.list.column.organisationseinheit":"Verantwortliche Organisationseinheit","Kooperation.list.column.titelKooperation":"Titel der Kooperation","Kooperation.list.column.weitereOrganisationseinheiten":"Weitere UL-Organisationseinheiten","Kooperation.list.filter.organisationseinheit":"Organisationseinheit der UL","Kooperation.list.filter.kumuliert":"Untereinheiten einbeziehen","Kooperation.list.filter.berichtsjahr":"Berichtsjahr","Kooperation.list.filter.titelKooperation":"Titel der Kooperation","Kooperation.list.filter.beteiligte":"Ansprechpartner_in und weitere beteiligte Personen","Kooperation.list.filter.beteiligteOrganisationen":"Beteiligte externe Organisationen","Mittelgeber.form.tableSelect.name":"Mittelgeber","Mittelgeber.form.tableSelect.Mittelgeber.form.name":"Mittelgeber","Organisationseinheit.form.orgaIdent":"Organisationen-Identifikatoren","OrgaIdent.form.typ":"Typ des Identifikators","OrgaIdent.form.wert":"Identifikator","Organisationseinheit.list.column.orgaIdent":"Orga-IDs","embedded.button.add.orgaIdent":"Organisations-ID hinzufügen","embedded.button.remove.orgaIdent":"Organisations-ID entfernen","Organisationseinheit":"Organisationseinheit","Organisationseinheit.form.tableSelect.name":"Name","Organisationseinheit.form.tableSelect.parent":"Übergeordnete Einheit","Organisationseinheit.form.tableSelect.kostenstelle":"Kostenstelle","Organisationseinheit.form.name":"Name","Organisationseinheit.form.beginn":"Aktiv seit","Organisationseinheit.form.ende":"Aktiv bis","Organisationseinheit.form.beschreibungDE":"Beschreibung (Deutsch)","Organisationseinheit.form.beschreibungEN":"Beschreibung (Englisch)","Organisationseinheit.form.kostenstelle":"Kostenstelle","Organisationseinheit.form.inPubfob":"Im leuris:Portal sichtbar","Organisationseinheit.form.obsolet":"Ist obsolet/inaktiv","Organisationseinheit.form.ueberOrganisationseinheit":"Übergeordnete Organisationseinheit","Organisationseinheit.form.unterOrganisationseinheiten":"Unterorganisationseinheiten","Organisationseinheit.list.column.name":"Name","Organisationseinheit.list.column.beginn":"Seit","Organisationseinheit.list.column.ende":"Bis","Organisationseinheit.list.column.kostenstelle":"Kostenstelle","Organisationseinheit.list.column.inPubfob":"Öffentlich?","Organisationseinheit.list.column.obsolet":"Obsolet?","Organisationseinheit.list.column.ueberOrganisationseinheit":"Übergeordnete Organisationseinheit","Organisationseinheit.list.column.unterOrganisationseinheiten":"Unterorganisationseinheiten","Organisationseinheit.list.filter.ueberOrganisationseinheit":"Übergeordnete Organisationseinheite","Organisationseinheit.list.filter.name":"Name","Organisationseinheit.list.filter.kostenstelle":"Kostenstelle","Organisationseinheit.list.filter.inPubfob":"Status der Sichtbarkeit im öffentlichen FOB","Organisationseinheit.inPubfob.TRUE":"Sichtbar","Organisationseinheit.inPubfob.FALSE":"Nicht sichtbar","Pagination.jumpToPage":"Springe zu Seite","Pagination.pageNotAvailable":"Seite nicht verfügbar","Person":"Person","PersonIdent":"Personen-Identifikatoren","PersonIdent.form.personIdentTyp":"Typ des Personen-Identifikators","PersonIdent.form.wert":"Identifikator","Person.form.vorname":"Vorname","Person.form.name":"(Nach-) Name","Person.form.nachname":"(Nach-) Name","Person.form.titel":"Titel","Person.form.fisPersid":"FIS-Identifier","Person.form.personIdent":"Personenidentifikation","Person.form.organisationseinheiten":"Organisationseinheiten","Person.list.column.titel":"Titel","Person.list.column.fisPersid":"FIS-Identifier","Person.list.column.vorname":"Vorname","Person.list.column.name":"(Nach-) Name","Person.list.column.personIdent":"Personen-Identifikatoren","Person.list.filter.titel":"Titel","Person.list.filter.fisPersid":"FIS-Identifier","Person.list.filter.vorname":"Vorname","Person.list.filter.name":"(Nach-) Name","Person.list.filter.personIdentWert":"Suche nach Personen-Identifikatoren","Preis":"Auszeichnung/Preis","Preise":"Preise","Preis.hatPreisgeld.TRUE":"Ja","Preis.hatPreisgeld.FALSE":"Nein","Preis.hatPreisgeld.NULL":"keine Angabe","Preis.compact.verliehenIn":"verliehen in","Preis.compact.vergebenDurch":"durch","Preis.form.hatPreisgeld":"Die Auszeichnung ist dotiert","Preis.form.hinweistext":"<b>Tragen Sie hier nur Auszeichnungen, Preise und Ehrungen ein, die im Forschungsbericht noch nicht vorhanden sind!</b><br> Nutzen Sie die Suche unter <i>Aktivitäten auflisten</i> um zu sehen, welche Auszeichnungen schon eingetragen sind.","Preis.form.namePreis":"Bezeichnung der Auszeichnung / des Preises","Preis.form.organisationseinheit":"Organisationseinheit des Preisträgers/der Preisträgerin","Preis.form.preisBezeichnung":"Art der Auszeichnung / des Preises","Preis.form.preisTraeger":"Preisträger_in","Preis.form.preisTraeger.plusbutton":"Preisträger_in neu anlegen","Preis.form.vergebenDurch":"Vergeben durch","Preis.form.verleihungsJahr":"Jahr der Verleihung","Preis.list.column._createDate":"Eingetragen am","Preis.list.column._updateDate":"Letzte Änderung","Preis.list.column.hatPreisgeld":"Preis ist dotiert","Preis.list.column.namePreis":"Bezeichnung","Preis.list.column.organisationseinheit":"Organisationseinheit","Preis.list.column.preisBezeichnung":"Art der Auszeichnung","Preis.list.column.preisTraeger":"Preisträger_in","Preis.list.column.verleihungsJahr":"Jahr der Verleihung","Preis.list.filter.namePreis":"Bezeichnung der Auszeichnung/des Preises","Preis.list.filter.organisationseinheit":"Organisationseinheit des Preisträgers/der Preisträgerin","Preis.list.filter.kumuliert":"Untereinheiten einbeziehen","Preis.list.filter.preisBezeichnung":"Art des Preises/der Auszeichnung","Preis.list.filter.preisTraeger":"Preisträger_in","Preis.list.filter.verleihungsJahr":"Jahr der Verleihung","Preis.list.filter.hatPreisgeld":"Die Auszeichnung/der Preis ist dotiert","Public.person":"Person(en)","Public.noselection":"Keine Auswahl getroffen","Public.loading":"Lade Daten zur ausgewählten","Public.toast.clipboard.success":"Link erfolgreich in die Zwischenablage kopiert","Public.toast.clipboard.error":"Link konnte nicht in die Zwischenablage kopiert werden","Public.filter.jahr":"Jahr","Public.filter.status":"Status","Public.filter.mittelgeber":"Mittelgeber","Public.filter.inProject":"Entstanden in einem Projekt","Public.filter.fundedBy":", gefördert durch: ","Public.filter.fundedByPrintLabel":"Förderung","Public.filter.awardsTypePrintLabel":"Preis","Public.filter.beliebigerMittelgeber":"Beliebiger Mittelgeber","Public.filter.funded_by.DFG":"DFG","Public.filter.funded_by.EU":"EU","Public.filter.funded_by.BMBF":"BMBF","Public.filter.funded_by.ANDERE_BM":"Andere Bundesministerien (ohne BMBF)","Public.filter.funded_by.SMWK":"SMWK","Public.filter.funded_by.ANDERE_SAECHSISCHE_MINISTERIEN":"Andere sächsische Ministerien (ohne SMWK)","Public.filter.funded_by.DAAD":"DAAD","Public.filter.funded_by.UNI_LE":"Universität Leipzig","Public.filter.funded_by.WIRTSCHAFT":"Wirtschaft","Public.filter.funded_by.STIFTUNGEN_DE":"Stiftungen in Deutschland","Public.filter.funded_by.ANDERE":"Andere","Public.filter.person":"Person","Public.filter.suche":"Suche","Public.filter.externalPartner":"Partner","Public.filter.publikationstypen":"Publikationstypen","Public.filter.beliebigerPreis":"Beliebiger Preis","Public.filter.typeIds.preis_2":"Gottfried Wilhelm Leibniz-Preis","Public.filter.typeIds.preis_3":"Max-Planck-Humboldt-Forschungspreis","Public.filter.typeIds.preis_4":"Heinz Maier-Leibnitz-Preis","Public.filter.typeIds.preis_29":"Akademiepreis der Berlin-Brandenburgischen Akademie der Wissenschaften","Public.filter.typeIds.preis_30":"Alfried Krupp-Förderpreis für junge Hochschullehrer","Public.filter.typeIds.preis_31":"Greve-Preis der Leopoldina","Public.filter.typeIds.preis_32":"Hector Wissenschaftspreis","Public.filter.typeIds.preis_33":"Carl-Friedrich-von-Weizsäcker-Preis","Public.filter.typeIds.preis_34":"Deutscher Umweltpreis","Public.filter.typeIds.preis_35":"Deutscher Zukunftspreis","Public.filter.typeIds.preis_36":"DFG Communicator-Preis","Public.filter.typeIds.preis_37":"Leipziger Wissenschaftspreis","Public.filter.typeIds.weiterePreise":"weitere Preise","Public.filter.typeIds.weitere_preise":"weitere Preise","Public.sort.changeOrder":"Sortierung ändern","Public.sort.order.ASC":"Aufsteigend","Public.sort.order.DESC":"Absteigend","Public.sort.by":"Sortieren nach","Public.sort.titel":"Titel","Public.sort.beginn":"Beginn","Public.sort.typ":"Typ","Public.sort.jahr":"Jahr","Public.sort.name":"Name","Public.sort.preisTraeger":"Preisträger","Public.action.share":"Link teilen","Public.action.share.default":"Standardansicht","Public.action.share.compact":"Kompaktansicht","Public.action.print":"Drucken","Public.action.export":"Exportieren","Public.action.export.disabled":"Bitte loggen Sie sich ein um einen Export anzufordern.","Public.select.reset":"Keine Auswahl","Public.headline.organisationalUnit":"Struktur der Universität Leipzig","Public.headline.person":"Personen der Universität Leipzig","Public.switch.ou.person":"Umschalten zwischen","Public.person.search":"Personensuche","Public.person.search.limit":"100 von %{staffTotalEntries} Personen angezeigt.","Public.person.search.match":"%{staffTotalEntries} Person(en) gefunden.","Public.person.search.nomatch":"Keine Personen gefunden.","Public.person.list.limit":"Bitte Suche weiter einschränken.<br>Personenliste zu lang.","Public.filter.category.article":"Zeitschriftenartikel","Public.filter.category.monography":"Monographie","Public.filter.category.editorship":"Herausgeberschaft","Public.filter.category.contribution":"Beitrag","Public.filter.category.report":"Report","Public.filter.status.ongoing":"Laufend","Public.filter.status.terminated":"Abgeschlossen","Public.entity.backToList":"Zurück zur Liste","Public.placeholder.ousearch":"Suche nach Organisationseinheit...","Export.header":"Datenexport anfordern","Export.infotext":"Sie können hier die Forschungsaktivitäten einer Organisationseinheit als PDF-Datei exportieren. Die Datei wird Ihnen per E-Mail zugesandt.","Export.currentOrga":"Aktuelle Einheit","Export.close":"Schließen","Export.continue":"Fortfahren","Export.success":"Ihr Export wird erstellt und Ihnen in Kürze zugeschickt.","Export.error":"Es ist ein Fehler aufgetreten, bitte versuchen Sie es später erneut.","Export.list.filter.jahr":"Jahr","Export.list.filter.format":"Dateiformat","Export.list.filter.email":"E-Mail","Export.list.filter.organisationseinheit":"Organisationseinheit","Publikation":"Publikation","Publikationen":"Publikationen","Publikation.compact.dissertation":"Dissertationsschrift","Publikation.compact.habilitationsschrift":"Habilitationsschrift","Publikation.compact.Abkuerzung.Seite":"S","Publikation.compact.Abkuerzung.SeitePlural":"S","Publikation.compact.Abkuerzung.Herausgeber":"Hrsg","Publikation.compact.Abkuerzung.HerausgeberPlural":"Hrsg","Publikation.form.author":"Autor_innen","Publikation.form.band":"Bandnummer / Volume","Publikation.form.buchtitel":"Buchtitel","Publikation.form.foerderer":"Mittelgeber, die sich an den Publikationskosten beteiligt haben. ","Publikation.form.forschungsprojekt":"Zugehöriges Projekt","Publikation.form.herausgeber":"Herausgeber_innen","Publikation.form.hinweistext":"<b>Tragen Sie hier nur Publikationen ein, die im Forschungsbericht noch nicht vorhanden sind!</b><br> Ihre Kolleg_innen bzw. Koautor_innen haben gemeinsame Publikationen evtl. bereits eingetragen. Wir haben den Forschungsbericht für Sie vorbefüllt mit allen Publikationen der Universität Leipzig aus dem Web of Science. Nutzen Sie die Suche unter <i>Aktivitäten auflisten</i> um zu sehen, welche Publikationsmeldungen es zu Ihrer Organisationseinheit bereits gibt.","Publikation.form.inProjekt":"Publikation entstand aus einem Projekt an der Universität Leipzig","Publikation.form.institution":"Herausgebende Organisation","Publikation.form.istFinal":"Daten sind final eingegeben","Publikation.form.journal":"Zeitschrift / Medientitel","Publikation.form.journalNummer":"Heftnummer","Publikation.form.organisationseinheit":"Organisationseinheit des/der Autor_in","Publikation.form.pubIdent":"Publikations-ID","Publikation.form.pubIdentTyp":"Typ des Publikations-Identifiers","Publikation.form.publicPubIdent":"Publikations-ID","Publikation.form.internalPubIdent":"Interne Publikations-ID","Publikation.form.publicPubIdent.pubIdentTyp":"Typ des Publikations-Identifiers","Publikation.form.publicPubIdent.wert":"ID","Publikation.form.publikationsTyp":"Typ der Publikation","Publikation.form.relevantFuerWeitere":"An dieser Publikation sind weitere Organisationseinheiten der UL beteiligt","Publikation.form.seiteEnde":"Letzte Seite des Artikels/Beitrags","Publikation.form.seiteStart":"Erste Seite des Artikels/Beitrags oder Nummer des Artikels","Publikation.form.serientitel":"Reihentitel","Publikation.form.sprache":"Sprache der Publikation","Publikation.form.titelPublikation":"Titel der Publikation","Publikation.form.validiert":"Angaben zur Publikation sind durch UBL validiert.","Publikation.form.verlagsort":"Verlagsort","Publikation.form.verleger":"Verlag","Publikation.form.veroeffentlichungsJahr":"Jahr der Veröffentlichung","Publikation.form.weitereOrganisationseinheiten":"Weitere beteiligte Organisationseinheiten der UL","Publikation.list.column._createDate":"Eingetragen am","Publikation.list.column._updateDate":"Letzte Änderung am","Publikation.list.column.author":"Autor_innen","Publikation.list.column.herausgeber":"Herausgeber_innen","Publikation.list.column.istFinal":"Dateneingabe final","Publikation.list.column.organisationseinheit":"Organisationseinheit","Publikation.list.column.publicPubIdent":"Publikations-ID","Publikation.list.column.publikationsTyp":"Publikationstyp","Publikation.list.column.titelPublikation":"Titel","Publikation.list.column.validiert":"UBL validiert","Publikation.list.column.veroeffentlichungsJahr":"Jahr","Publikation.list.column.weitereOrganisationseinheiten":"Weitere Organisationseinheiten","Publikation.list.filter.author":"Autor_innen","Publikation.list.filter.beteiligte":"Beteiligte_r Autor_in oder Herausgeber_in","Publikation.list.filter.freieID":"Suche nach Publikations-ID","Publikation.list.filter.herausgeber":"Herausgeber_innen","Publikation.list.filter.organisationseinheit":"Organisationseinheit des/der Autor_in","Publikation.list.filter.kumuliert":"Untereinheiten einbeziehen","Publikation.list.filter.titelPublikation":"Titel der Publikation","Publikation.list.filter.validiert":"Angaben sind durch UBL validiert","Publikation.list.filter.veroeffentlichungsJahr":"Jahr der Veröffentlichung","PublikationValidiert.TRUE":"Ja","PublikationValidiert.FALSE":"Noch nicht","PublikationsTyp.ARTIKEL":"Zeitschriftenartikel","PublikationsTyp.BEITRAGINNICHTWISSENSCHAFTLICHENMEDIEN":"Beitrag/Interview in nicht-wissenschaftlichen Medien","PublikationsTyp.BERICHT":"Forschungsbericht / Report","PublikationsTyp.BUCHBEITRAG":"Beitrag in Buch","PublikationsTyp.DISSERTATION":"Dissertation","PublikationsTyp.HABILITATIONSSCHRIFT":"Habilitationsschrift","PublikationsTyp.MONOGRAPHIE":"Monographie","PublikationsTyp.QUELLENEDITION":"Quellenedition","PublikationsTyp.SAMMELBAND":"Sammelband (Herausgabe)","PublikationsTyp.SAMMELBANDBEITRAG":"Beitrag in Sammelband","PublikationsTyp.SONDERHEFT":"Sonderheft einer Zeitschrift (Herausgabe)","PublikationsTyp.SONSTIGE":"Anderer Publikationstyp","PublikationsTyp.TAGUNGSBAND":"Konferenzband (Herausgabe)","PublikationsTyp.TAGUNGSBEITRAG":"Beitrag in Konferenzband","PublikationsTyp.WORKINGPAPER":"Working Paper","Veranstaltung":"Wiss. Veranstaltung","Veranstaltungen":"Veranstaltungen","Veranstaltung.virtuell.TRUE":"Ja","Veranstaltung.virtuell.FALSE":"Nein","Veranstaltung.form.hinweistext":"<b>Tragen Sie hier nur wiss. Veranstaltungen ein, die im Forschungsbericht noch nicht vorhanden sind!</b><br> Nutzen Sie die Suche unter <i>Aktivitäten auflisten</i> um zu sehen, welche Veranstaltungen schon eingetragen sind.<br><br>Bitte beachten Sie, dass im leuris:Forschungsbericht nur wissenschaftliche Veranstaltungen eingetragen werden sollen, die von Forschenden oder Einrichtungen der UL (mit)organisiert wurden.","Veranstaltung.form.name":"Titel der Veranstaltung","Veranstaltung.form.organisationseinheit":"Veranstaltende Organisationseinheit","Veranstaltung.form.relevantFuerWeitere":"An dieser Veranstaltung waren weitere Organisationseinheiten der UL beteiligt","Veranstaltung.form.veranstalter":"Veranstalter_in","Veranstaltung.form.veranstaltungEnde":"Datum Ende der Veranstaltung","Veranstaltung.form.veranstaltungStart":"Datum Beginn der Veranstaltung","Veranstaltung.form.veranstaltungsTyp":"Typ der Veranstaltung","Veranstaltung.form.weitereOrganisationseinheiten":"Weitere beteiligte Organisationseinheiten der UL","Veranstaltung.list.column._createDate":"Eingetragen am","Veranstaltung.list.column._updateDate":"Letzte Änderung am","Veranstaltung.list.column.name":"Titel","Veranstaltung.list.column.organisationseinheit":"Organisationseinheit","Veranstaltung.list.column.veranstalter":"Veranstalter_in","Veranstaltung.list.column.veranstaltungEnde":"Ende","Veranstaltung.list.column.veranstaltungStart":"Beginn","Veranstaltung.list.column.veranstaltungsTyp":"Typ der Veranstaltung","Veranstaltung.list.column.weitereOrganisationseinheiten":"Weitere Organisationseinheiten","Veranstaltung.list.column.stadt":"Stadt","Veranstaltung.list.column.land":"Land","Veranstaltung.list.column.virtuell":"virtuell","Veranstaltung.list.filter.name":"Titel der Veranstaltung","Veranstaltung.list.filter.organisationseinheit":"Veranstaltende Organisationseinheit","Veranstaltung.list.filter.kumuliert":"Untereinheiten einbeziehen","Veranstaltung.list.filter.berichtsjahr":"Berichtsjahr","Veranstaltung.list.filter.veranstalter":"Veranstalter_in","Veranstaltung.list.filter.veranstaltungsTyp":"Typ der Veranstaltung","Veranstaltung.list.filter.stadt":"Stadt","Veranstaltung.list.filter.land":"Land","Veranstaltung.list.filter.virtuell":"Virtuelle bzw. Online-Veranstaltung","Veranstaltung.form.externeWebsite":"Externe Veranstaltungswebsite","Veranstaltung.form.beschreibungDE":"Beschreibung (Deutsch)","Veranstaltung.form.beschreibungEN":"Beschreibung (Englisch)","Veranstaltung.form.stadt":"Stadt","Veranstaltung.form.land":"Land","Veranstaltung.form.virtuell":"Virtuelle bzw. Online-Veranstaltung","Patent":"Patent","Patente":"Patente","Patent.form.hinweistext":"<b>Tragen Sie hier nur Patente ein, die im Forschungsbericht noch nicht vorhanden sind!</b><br> Nutzen Sie die Suche unter <i>Aktivitäten auflisten</i> um zu sehen, welche Patente schon eingetragen sind.","Patent.form.organisationseinheit":"Organisationseinheit des an der UL beschäftigten Haupterfinders","Patent.form.titel":"Titel der Stammanmeldung","Patent.form.veroeffentlichungsnummer":"Veröffentlichungsnummer","Patent.form.datumDerPrioritaetsbegruendendenErstanmeldung":"Datum der prioritätsbegründeten Erstanmeldung","Patent.form.haupterfinder":"Haupterfinder_in an der UL","Patent.form.anmelderExtern":"Anmeldende externe Organisation","Patent.form.anmelderIntern":"Anmeldende interne Organisation","Patent.form.lizenzen":"Übertragung/Lizenzen","Patent.form.link":"Link zur Anmeldung","Patent.form.forschungsgebiet":"Forschungsgebiet / Forschungsgegenstand","Patent.form.kurzbeschreibung":"Abstrakt der Patentanmeldung","Patent.form.ansprechpartner":"Ansprechpartner im Sachgebiet Transfer","Patent.form.land":"Nationale Anmeldungen","Patent.form.ansprechpartner.plusbutton":"Hinzufügen","Patent.list.column.titel":"Titel","Patent.list.column.haupterfinder":"Haupterfinder_in","Patent.list.column.veroeffentlichungsnummer":"Veröffentlichungsnummer","Patent.list.column.datumDerPrioritaetsbegruendendenErstanmeldung":"Erstanmeldung am","Patent.list.column.lizenzen":"Lizenzen","Patent.list.column.forschungsgebiet":"Forschungsgebiet","Patent.list.column.anmelderExtern":"Anmeldende externe Organisation","Patent.list.column.anmelderIntern":"Anmeldende interne Organisation","Patent.list.column.ansprechpartner":"Ansprechpartner im SG Transfer","Patent.list.column.land":"Nationale Anmeldungen","Patent.list.filter.organisationseinheit":"Organisationseinheit des an der UL beschäftigten Haupterfinders","Patent.list.filter.kumuliert":"Untereinheiten einbeziehen","Patent.list.filter.jahrDerPrioritaetsbegruendendenErstanmeldung":"Jahr der prioritätsbegründeten Erstanmeldung","Patent.list.filter.haupterfinder":"Haupterfinder_in an der UL","Patent.list.filter.titel":"Titel der Stammanmeldung","Patent.list.filter.veroeffentlichungsnummer":"Veröffentlichungsnummer","Patent.list.filter.lizenzen":"Übertragung/Lizenzen","Patent.list.filter.link":"Link zur Anmeldung","Patent.list.filter.forschungsgebiet":"Forschungsgebiet / Forschungsgegenstand","Patent.list.filter.kurzbeschreibung":"Abstrakt der Patentanmeldung","Patent.list.filter.anmelderExtern":"Anmeldende externe Organisation","Patent.list.filter.anmelderIntern":"Anmeldende interne Organisation","Patent.list.filter.ansprechpartner":"Ansprechpartner im Sachgebiet Transfer","Patent.list.filter.land":"Nationale Anmeldungen","Patent.compact.datumDerPrioritaetsbegruendendenErstanmeldung":"Datum der prioritätsbegründeten Erstanmeldung","Land":"Land","Länder":"Länder","Land.list.filter.alpha2code":"Alpha-2 Code","Land.list.filter.alpha3code":"Alpha-3 Code","Land.list.filter.nameDE":"Land (DE)","Land.list.filter.nameEN":"Land (EN)","Land.list.filter.numericCode":"Numerischer Ländercode","Land.list.column.alpha2code":"Alpha-2 Code","Land.list.column.alpha3code":"Alpha-3 Code","Land.list.column.nameDE":"Land (DE)","Land.list.column.nameEN":"Land (EN)","Land.list.column.numericCode":"Numerischer Ländercode","Land.form.alpha2code":"Alpha-2 Code","Land.form.alpha3code":"Alpha-3 Code","Land.form.nameDE":"Land (DE)","Land.form.nameEN":"Land (EN)","Land.form.numericCode":"Numerischer Ländercode","Land.form.tableSelect.nameDE":"Land (DE)","Land.form.tableSelect.nameEN":"Land (EN)","Land.form.tableSelect.alpha2code":"Alpha-2 Code","Land.form.tableSelect.alpha3code":"Alpha-3 Code","Land.form.tableSelect.numericCode":"Numerischer Ländercode","tableSelect.header.haupterfinder":"Auswahl der Haupterfinder_innen","tableSelect.header.anmelderExtern":"Auswahl der anmeldenden externen Organisation/en","tableSelect.header.anmelderIntern":"Auswahl der anmeldenden internen Organisation/en","tableSelect.header.ansprechpartner":"Auswahl der Ansprechpartner_in","tableSelect.header.land":"Auswahl der Länder mit nationalen Anmeldungen","form.xbutton.remove.multiSelect.anmelderExtern":"Anmeldende externe Organisation aus der Liste nehmen","form.xbutton.remove.multiSelect.anmelderIntern":"Anmeldende interne Organisation aus der Liste nehmen","form.xbutton.remove.multiSelect.haupterfinder":"Hautperfinder_in aus der Liste nehmen","form.xbutton.remove.multiSelect.land":"Land aus der Liste nehmen","createModal.header.ansprechpartner":"Ansprechpartner im Sachgebiet Transfer","embedded.button.add.foerderung":"Mittelgeber hinzufügen","embedded.button.add.personIdent":"Personen Identifier hinzufügen","embedded.button.remove.personIdent":"Personen-Identifier entfernen","embedded.button.add.publicPubIdent":"Publikations-ID hinzufügen","embedded.button.add.pubIdent":"Interne Publikations-ID hinzufügen","embedded.button.remove.foerderung":"Mittelgeber entfernen","embedded.button.remove.publicPubIdent":"Publikations-ID entfernen","embedded.button.remove.pubIdent":"Publikations-ID entfernen","form.editlink":"Auswahl bearbeiten","form.xbutton":"Feld leeren","form.xbutton.remove.multiSelect.author":"Autor_in aus der Liste nehmen","form.xbutton.remove.multiSelect.herausgeber":"Herausgeber_in aus der Liste nehmen","form.xbutton.remove.multiSelect.beteiligteOrganisationen":"Organisation aus der Liste nehmen","form.xbutton.remove.multiSelect.beteiligtePersonen":"Person aus der Liste nehmen","form.xbutton.remove.multiSelect.weitereOrganisationseinheiten":"Organisationseinheit aus der Liste nehmen","form.xbutton.remove.multiSelect.mitarbeiter":"Mitarbeiter_in aus der Liste nehmen","form.xbutton.remove.multiSelect.antragsteller":"Antragssteller_in aus der Liste nehmen","form.xbutton.remove.multiSelect.veranstalter":"Veranstalter_in aus der Liste nehmen","form.xbutton.remove.multiSelect.foerderer":"Mittelgeber aus der Liste nehmen","form.heading.choose_activity":"Bitte wählen Sie einen Aktivitätstyp.","list.spaltensichtbarkeit":"Sichtbare Spalten","menu.aboutme":"Meine Aktivitäten","menu.create":"Aktivität eintragen","menu.create*":"Aktivität eintragen*","menu.details":"Detailansicht","menu.editor":"Editor","menu.list":"Aktivitäten auflisten","menu.login":"Anmelden","menu.loggedInAs":"Angemeldet als %{username}","menu.logout":"Abmelden","menu.report":"Berichte verwalten","menu.start":"Startseite","menu.imprint":"Impressum","menu.privacyPolicy":"Datenschutzerklärung","menu.list.public":"Forschungsaktivitäten","menu.list.public.internal":"leuris:Forschungsbericht","menu.list.public.internal.desc":"Eintragen und Editieren von Forschungsaktivitäten","menu.list.public.external":"leuris:Portal","menu.list.public.external.desc":"Öffentliche Darstellung der Forschungsaktivitäten","menu.list.public.profile":"Meine Seite im leuris:Portal","menu.list.public.profile.desc":"Übersicht über die eigenen Forschungsaktivitäten","menu.help":"Hilfe","menu.help.faq":"FAQ","menu.help.knownBugs":"Bekannte Fehler","menu.help.videoTutorials":"Zum leuris-Schulungsraum","menu.help.mostImportantInANutshell":"Das Allerwichtigste in Kürze","menu.language":"Sprache","menu.language.DE":"Deutsch","menu.language.EN":"Englisch","preisBezeichnung.beschreibung.Preis.Kategorie1":"Forschungspreise","preisBezeichnung.beschreibung.Preis.Kategorie2":"Innovationspreise","preisBezeichnung.beschreibung.Preis.Kategorie3":"Kommunikationspreise","preisBezeichnung.beschreibung.Preis.Kategorie4":"Regionale Preise","preisBezeichnung.beschreibung.Preis.Kategorie5":"sonstige Preise / Auszeichnungen","savedViews.heading":"Im Browser gespeicherte Sucheinstellungen","savedViews.noneSaved":"Noch keine Einstellungen gespeichert.","tableSelect.button.close":"Auswahl in das Formular übernehmen","tableSelect.button.create":"Neu anlegen","tableSelect.emptyTablePlaceholder.isFetching":"Lade Daten...","tableSelect.emptyTablePlaceholder.noInput":"Keine Eingabe getätigt.","tableSelect.emptyTablePlaceholder.minLength":"Bitte min. drei Zeichen eingeben.","tableSelect.emptyTablePlaceholder.noResults":"Kein Treffer gefunden. Bitte passen Sie die Suche an.","tableSelect.header.weitereOrganisationseinheiten":"Auswahl der weiteren beteiligten Organisationseinheiten der UL","tableSelect.header.veranstalter":"Auswahl der die Veranstaltung organisierenden Personen","tableSelect.header.author":"Auswahl der Autor_innen","tableSelect.header.antragsteller":"Auswahl der Antragsteller_innen","tableSelect.header.beteiligtePersonen":"Auswahl der beteiligten Personen","tableSelect.header.beteiligteOrganisationen":"Auswahl der beteiligten externen Organisationen","tableSelect.header.foerderer":"Auswahl der Typen von Mittelgebern","tableSelect.header.herausgeber":"Auswahl der Herausgeber_innen","tableSelect.header.mitarbeiter":"Auswahl der am Projekt beteiligten Mitarbeiter_innen","tableSelect.queryString":"Suche","tableSelect.selected":"Auswahl","tag.static.researchActivity":"Forschungsaktivität","tag.static.printedPageOfPagesLabel":"Gedruckte Tabellen-Seite","tag.static.printedPageOfPagesValue":"%{page} von %{totalTablePages}","tag.static.resultCount":"Gefundene Suchergebnisse","tag.static.entriesPerPage":"Maximale Einträge pro Seite","toast.login.failed":"Anmeldung fehlgeschlagen","toast.delete.record":"Datensatz erfolgreich gelöscht","toast.delete.record.error":"Löschen aufgrund eines Konfliks fehlgeschlagen","toast.savedView.save":"Listeneinstellungen gespeichert","toast.validation.failed":"Validierung fehlgeschlagen","toast.session.expired":"Sitzung abgelaufen. Bitte erneut anmelden.","toast.session.will.expired.soon":"Ihre Sitzung läuft bald ab","tree.loading":"Lade","tree.loading.error":"Abrufen der Organisationseinheiten fehlgeschlagen","tree.open":"Aufklappen","tree.collapse":"Einklappen","warnung.create.abbrechen":"Achtung: Sie brechen die Eintragung einer Aktivität ab.<br><br>Wenn Sie dies beabsichtigen, klicken Sie auf Fortsetzen.","warnung.create.cancel":"Abbrechen","warnung.create.confirm":"Fortsetzen","warnung.create.nachricht":"Achtung: Sie möchten den Aktivitätstyp wechseln, obwohl Ihre Bearbeitungen noch nicht gespeichert sind.<br><br>Wenn Sie die vorhandenen Bearbeitungen abschließen möchten, klicken Sie bitte auf <b>Abbrechen</b>. <br><br>Wenn Sie die Änderungen der im Editor befindlichen Aktivitäten verwerfen möchten und eine neuen Aktivitätstyp eintragen möchten, klicken Sie auf <b>Fortsetzen</b>.","warnung.edit.cancel":"Abbrechen","warnung.edit.confirm":"Fortsetzen","warnung.edit.nachricht":"Achtung: Sie haben eine Aktivität in Bearbeitung.<br><br>Wenn Sie deren Bearbeitung abschließen möchten, klicken Sie bitte auf <b>Abbrechen</b>.<br><br>Wenn Sie die Änderungen der im Editor befindlichen Aktivitäten verwerfen möchten und die eben ausgewählte Aktivität bearbeiten möchten, klicken Sie auf <b>Fortsetzen</b>.","repeat":"Wiederholen","upload.heading":"Publikationsupload","upload.infotext":"<p>\n  Hier haben Sie die Möglichkeit, uns eine oder mehrere Publikationslisten\n  für Ihre Organisationseinheit per E-Mail zuzusenden. Wenn Sie uns\n  Publikationslisten als Dateien schicken, werden diese nicht sofort\n  in den leuris:Forschungsbericht bzw. das leuris:Portal importiert.\n  Die Publikationen werden zuerst von der Universitätsbibliothek in\n  einem eigenen System gesammelt, validiert und später paketweise in\n  den leuris:Forschungsbericht übertragen. Die weiteren Angaben zu\n  den Publikationen (wie Projektzuordnung) können erst nach der\n  Übertragung erfolgen.\n</p>\n\n<p>\n  Falls Sie uns Listen schicken, beachten Sie bitte die folgenden Grundsätze:\n</p>\n\n<ul>\n  <li>\n    Die Bibliothek kann nur strukturierte Literaturverwaltungsformate\n    annehmen (z. B. Dateiformate wie BibTeX, EndNote, Citavi).\n    Word- oder PDF-Dateien werden nicht akzeptiert.\n  </li>\n  <li>\n    Die Listen dürfen nur Publikationen enthalten, die bis jetzt\n    noch nicht im leuris:Forschungsbericht eingetragen sind.\n  </li>\n  <li>\n    Die Listen dürfen nur Publikationen enthalten, die auf Forschung\n    an der Universität Leipzig zurückgehen.\n  </li>\n  <li>\n    Derzeit dauert es in der Regel mindestens zwei Monate, bis\n    Publikationen aus diesen Listen im leuris:Forschungsbericht\n    erscheinen. Wir arbeiten an einer Verbesserung dieses Prozesses.\n  </li>\n</ul>\n","upload.linktext":"Jetzt eine Publikationsliste per E-Mail versenden","Person.list.column.organisationseinheiten":"Organisationseinheiten","Person.list.filter.organisationseinheiten":"Organisationseinheiten","Person.list.filter.kumuliert":"Untereinheiten einbeziehen","menu.upload":"Publikationsupload","start.headline":"<strong>Herzlich Willkommen auf der Weboberfläche des Forschungsberichts der Universität Leipzig</strong>","start.intro":"Im leuris:Forschungsbericht können Sie fortlaufend Ihre Forschungsaktivitäten melden und bearbeiten. Daten, die bereits eingetragen wurden, stehen auch weiterhin zur Verfügung und können aktualisiert werden. Die Weboberfläche wird fortlaufend weiterentwickelt und das leuris-Team freut sich über Feedback an <a href=\"mailto:leuris@uni-leipzig.de\">leuris@uni-leipzig.de</a>.","start.help.heading":"Hilfe erhalten","start.help":"<span class=\"has-text-weight-bold\">Hilfe</span> zum Eintragen von Aktivitäten und zur Bedienung der Oberfläche finden Sie in unserem <a href=\"https://home.uni-leipzig.de/~leuriswiki/doku.php\" target=\"_blank\">Wiki</a>:","start.help.intro":"Das Allerwichtigste in Kürze","start.help.faq":"Häufige Fragen","start.video.tutorials.text":"Im virtuellen Schulungsraum erhalten Sie jederzeit schnell Informationen zur Nutzung von leuris. Zahlreiche Video-Tutorials stellen die verschiedenen Bereiche von leuris vor:","start.video.tutorials.link":"leuris-Schulungsraum","start.firstSteps.heading":"Erste Schritte","start.firstSteps":"<p>Zur Vermeidung unnötiger doppelter Arbeit beachten Sie, dass viele Angaben zu Forschungsaktivitäten schon in der Datenbank hinterlegt sind. Bitte nutzen Sie daher die %{renderedRouterLinkListActivities}-Funktion.</p><p>Um Ihnen erneute Suchen zu erleichtern können Sie die Einstellungen zu Suchen, Filtern und die Tabellendarstellung eines Aktivitätstyps abspeichern und dann direkt von dieser Startseite aufrufen.</p>","start.listSavedViews":"Vorhandene Aktivitäten auflisten","start.addActivity":"Neue Aktivitäten eintragen","start.shortcuts":"Schnellzugriffe","start.noOU":"Ihr Account wurde keiner Kostenstelle zugeordnet. Bitte wenden Sie sich per E-Mail an das","LeurisProfile.abstract.empty":"Kein Kurzprofil vorhanden.","LeurisProfile.abstract.edit":"Kurzprofil bearbeiten","AboutMe.loading":"Lade Daten zur ausgewählten","AboutMe.toast.clipboard.success":"Link erfolgreich in die Zwischenablage kopiert","AboutMe.toast.clipboard.error":"Link konnte nicht in die Zwischenablage kopiert werden","AboutMe.filter.jahr":"Jahr","AboutMe.filter.status":"Status","AboutMe.filter.mittelgeber":"Mittelgeber","AboutMe.filter.person":"Person","AboutMe.filter.suche":"Suche","AboutMe.filter.externalPartner":"Partner","AboutMe.filter.publikationstypen":"Publikationstypen","AboutMe.sort.changeOrder":"Sortierung ändern","AboutMe.sort.order.ASC":"Aufsteigend","AboutMe.sort.order.DESC":"Absteigend","AboutMe.sort.by":"Sortieren nach","AboutMe.sort.titel":"Titel","AboutMe.sort.beginn":"Beginn","AboutMe.sort.typ":"Typ","AboutMe.sort.jahr":"Jahr","AboutMe.sort.name":"Name","AboutMe.sort.preisTraeger":"Preisträger","AboutMe.action.share":"Link teilen","AboutMe.action.share.default":"Standardansicht","AboutMe.action.share.compact":"Kompaktansicht","Public.action.share.defaultWithSearchOptions":"Standardansicht mit Sucheinstellung","Public.action.share.compactWithSearchOptions":"Kompaktansicht mit Sucheinstellung","AboutMe.action.print":"Drucken","AboutMe.select.reset":"Keine Auswahl","AboutMe.filter.category.article":"Zeitschriftenartikel","AboutMe.filter.category.monography":"Monographie","AboutMe.filter.category.editorship":"Herausgeberschaft","AboutMe.filter.category.contribution":"Beitrag","AboutMe.filter.category.report":"Report","AboutMe.filter.status.ongoing":"Laufend","AboutMe.filter.status.terminated":"Abgeschlossen","AboutMe.toast.select":"Forschungsaktivität in der leuris Profilseite als Favorit ausgewählt","AboutMe.toast.deselect":"Forschungsaktivität in der leuris Profilseite als Favorit abgewählt","AboutMe.toast.researchSelectionLimit":"Maximale Anzahl an Favoriten für die Forschungsaktivät erreicht (5/5)","EntityCreateForm.invalid.date.isAtLeastFrom":"Das Enddatum darf nicht vor dem Startdatum liegen.","Mittelgeber.form.name":"Name","Mittelgeber.form.finSchluessel":"Finanzierungsschlüssel","Mittelgeber.list.column.name":"Name","Mittelgeber.list.column.finSchluessel":"Finanzierungsschlüssel","Mittelgeber.list.filter.name":"Name","Mittelgeber.list.filter.finSchluessel":"Finanzierungsschlüssel","UL Profile Link":"Profil auf der Website der Universität Leipzig","Forschungsprojekt.list.column.sdg":"SDGs","tableSelect.header.sdg":"Auswahl der Nachhaltigkeitsziele (SDGs) des Projekts","Forschungsprojekt.form.sdg":"Nachhaltigkeitsziele (SDGs)","form.xbutton.remove.multiSelect.sdg":"SDG entfernen","Sdg.form.tableSelect._id":"ID","Sdg.form.tableSelect._stringRep":"Name","Sdg.Placeholder":"UN-Nachhaltigkeitsziele (SDGs)","Sdg.NoSelection":"Keine Auswahl","Sdg.Category":"Kategorie","Sdg.Any":"Beliebiges Nachhaltigkeitsziel","Sdg.Biosphere":"Biosphäre","Sdg.Society":"Soziale Gemeinschaft","Sdg.Economy":"Ökonomisches System","Sdg.SingleSelection":"Einzelauswahl","Sdg.SDG1":"Keine Armut","Sdg.SDG2":"Kein Hunger","Sdg.SDG3":"Gesundheit und Wohlergehen","Sdg.SDG4":"Hochwertige Bildung","Sdg.SDG5":"Geschlechtergerechtigkeit","Sdg.SDG6":"Sauberes Wasser und Sanitäreinrichtungen","Sdg.SDG7":"Bezahlbare und saubere Energie","Sdg.SDG8":"Menschenwürdige Arbeit und Wirtschaftswachstum","Sdg.SDG9":"Industrie, Innovation und Infrastruktur","Sdg.SDG10":"Weniger Ungleichheiten","Sdg.SDG11":"Nachhaltige Städte und Gemeinden","Sdg.SDG12":"Nachhaltig Produzieren und Konsumieren","Sdg.SDG13":"Maßnahmen zum Klimaschutz","Sdg.SDG14":"Leben unter Wasser","Sdg.SDG15":"Leben an Land","Sdg.SDG16":"Frieden, Gerechtigkeit und starke Institutionen","Sdg.SDG17":"Partnerschaften zur Erreichung der Ziele","Public.filter.sdg":"SDG","Public.filter.sdg.any":"Beliebiges Nachhaltigkeitsziel","Public.filter.sdg.biosphere":"Biosphäre","Public.filter.sdg.society":"Soziale Gemeinschaft","Public.filter.sdg.economy":"Ökonomisches System","Public.filter.sdg.sdg1":"Keine Armut","Public.filter.sdg.sdg2":"Kein Hunger","Public.filter.sdg.sdg3":"Gesundheit und Wohlergehen","Public.filter.sdg.sdg4":"Hochwertige Bildung","Public.filter.sdg.sdg5":"Geschlechtergerechtigkeit","Public.filter.sdg.sdg6":"Sauberes Wasser und Sanitäreinrichtungen","Public.filter.sdg.sdg7":"Bezahlbare und saubere Energie","Public.filter.sdg.sdg8":"Menschenwürdige Arbeit und Wirtschaftswachstum","Public.filter.sdg.sdg9":"Industrie, Innovation und Infrastruktur","Public.filter.sdg.sdg10":"Weniger Ungleichheiten","Public.filter.sdg.sdg11":"Nachhaltige Städte und Gemeinden","Public.filter.sdg.sdg12":"Nachhaltig Produzieren und Konsumieren","Public.filter.sdg.sdg13":"Maßnahmen zum Klimaschutz","Public.filter.sdg.sdg14":"Leben unter Wasser","Public.filter.sdg.sdg15":"Leben an Land","Public.filter.sdg.sdg16":"Frieden, Gerechtigkeit und starke Institutionen","Public.filter.sdg.sdg17":"Partnerschaften zur Erreichung der Ziele","iso639-2b::aar":"Danakil-Sprache","iso639-2b::abk":"Abchasisch","iso639-2b::ace":"Aceh-Sprache","iso639-2b::ach":"Acholi-Sprache","iso639-2b::ada":"Adangme-Sprache","iso639-2b::ady":"Adygisch","iso639-2b::afa":"Hamitosemitische Sprachen","iso639-2b::afh":"Afrihili","iso639-2b::afr":"Afrikaans","iso639-2b::ain":"Ainu-Sprache","iso639-2b::aka":"Akan-Sprache","iso639-2b::akk":"Akkadisch","iso639-2b::alb":"Albanisch","iso639-2b::ale":"Aleutisch","iso639-2b::alg":"Algonkin-Sprachen","iso639-2b::alt":"Altaisch","iso639-2b::amh":"Amharisch","iso639-2b::ang":"Altenglisch","iso639-2b::anp":"Anga-Sprache","iso639-2b::apa":"Apachen-Sprachen","iso639-2b::ara":"Arabisch","iso639-2b::arc":"Aramäisch","iso639-2b::arg":"Aragonesisch","iso639-2b::arm":"Armenisch","iso639-2b::arn":"Arauka-Sprachen","iso639-2b::arp":"Arapaho-Sprache","iso639-2b::art":"Kunstsprachen","iso639-2b::arw":"Arawak-Sprachen","iso639-2b::asm":"Assamesisch","iso639-2b::ast":"Asturisch","iso639-2b::ath":"Athapaskische Sprachen","iso639-2b::aus":"Australische Sprachen","iso639-2b::ava":"Awarisch","iso639-2b::ave":"Avestisch","iso639-2b::awa":"Awadhi","iso639-2b::aym":"Aymará-Sprache","iso639-2b::aze":"Aserbeidschanisch","iso639-2b::bad":"Banda-Sprachen","iso639-2b::bai":"Bamileke-Sprachen","iso639-2b::bak":"Baschkirisch","iso639-2b::bal":"Belutschisch","iso639-2b::bam":"Bambara-Sprache","iso639-2b::ban":"Balinesisch","iso639-2b::baq":"Baskisch","iso639-2b::bas":"Basaa-Sprache","iso639-2b::bat":"Baltische Sprachen","iso639-2b::bej":"Bedauye","iso639-2b::bel":"Weißrussisch","iso639-2b::bem":"Bemba-Sprache","iso639-2b::ben":"Bengali","iso639-2b::ber":"Berbersprachen","iso639-2b::bho":"Bhojpuri","iso639-2b::bih":"Bihari","iso639-2b::bik":"Bikol-Sprache","iso639-2b::bin":"Edo-Sprache","iso639-2b::bis":"Beach-la-mar","iso639-2b::bla":"Blackfoot-Sprache","iso639-2b::bnt":"Bantusprachen","iso639-2b::tib":"Tibetisch","iso639-2b::bos":"Bosnisch","iso639-2b::bra":"Braj-Bhakha","iso639-2b::bre":"Bretonisch","iso639-2b::btk":"Batak-Sprache","iso639-2b::bua":"Burjatisch","iso639-2b::bug":"Bugi-Sprache","iso639-2b::bul":"Bulgarisch","iso639-2b::bur":"Birmanisch","iso639-2b::byn":"Bilin-Sprache","iso639-2b::cad":"Caddo-Sprachen","iso639-2b::cai":"Indianersprachen, Zentralamerika","iso639-2b::car":"Karibische Sprachen","iso639-2b::cat":"Katalanisch","iso639-2b::cau":"Kaukasische Sprachen","iso639-2b::ceb":"Cebuano","iso639-2b::cel":"Keltische Sprachen","iso639-2b::cze":"Tschechisch","iso639-2b::cha":"Chamorro-Sprache","iso639-2b::chb":"Chibcha-Sprachen","iso639-2b::che":"Tschetschenisch","iso639-2b::chg":"Tschagataisch","iso639-2b::chi":"Chinesisch","iso639-2b::chk":"Trukesisch","iso639-2b::chm":"Tscheremissisch","iso639-2b::chn":"Chinook-Jargon","iso639-2b::cho":"Choctaw-Sprache","iso639-2b::chp":"Chipewyan-Sprache","iso639-2b::chr":"Cherokee-Sprache","iso639-2b::chu":"Kirchenslawisch","iso639-2b::chv":"Tschuwaschisch","iso639-2b::chy":"Cheyenne-Sprache","iso639-2b::cmc":"Cham-Sprachen","iso639-2b::cop":"Koptisch","iso639-2b::cor":"Kornisch","iso639-2b::cos":"Korsisch","iso639-2b::cpe":"Kreolisch-Englisch","iso639-2b::cpf":"Kreolisch-Französisch","iso639-2b::cpp":"Kreolisch-Portugiesisch","iso639-2b::cre":"Cree-Sprache","iso639-2b::crh":"Krimtatarisch","iso639-2b::crp":"Kreolische Sprachen","iso639-2b::csb":"Kaschubisch","iso639-2b::cus":"Kuschitische Sprachen","iso639-2b::wel":"Kymrisch","iso639-2b::dak":"Dakota-Sprache","iso639-2b::dan":"Dänisch","iso639-2b::dar":"Darginisch","iso639-2b::day":"Dajakisch","iso639-2b::del":"Delaware-Sprache","iso639-2b::den":"Slave-Sprache","iso639-2b::ger":"Deutsch","iso639-2b::dgr":"Dogrib-Sprache","iso639-2b::din":"Dinka-Sprache","iso639-2b::div":"Maledivisch","iso639-2b::doi":"Dogri","iso639-2b::dra":"Drawidische Sprachen","iso639-2b::dsb":"Niedersorbisch","iso639-2b::dua":"Duala-Sprachen","iso639-2b::dum":"Mittelniederländisch","iso639-2b::dut":"Niederländisch","iso639-2b::dyu":"Dyula-Sprache","iso639-2b::dzo":"Dzongkha","iso639-2b::efi":"Efik","iso639-2b::egy":"Ägyptisch","iso639-2b::eka":"Ekajuk","iso639-2b::gre":"Neugriechisch","iso639-2b::elx":"Elamisch","iso639-2b::eng":"Englisch","iso639-2b::enm":"Mittelenglisch","iso639-2b::epo":"Esperanto","iso639-2b::est":"Estnisch","iso639-2b::ewe":"Ewe-Sprache","iso639-2b::ewo":"Ewondo","iso639-2b::fan":"Pangwe-Sprache","iso639-2b::fao":"Färöisch","iso639-2b::per":"Persisch","iso639-2b::fat":"Fante-Sprache","iso639-2b::fij":"Fidschi-Sprache","iso639-2b::fil":"Pilipino","iso639-2b::fin":"Finnisch","iso639-2b::fiu":"Finnougrische Sprachen","iso639-2b::fon":"Fon-Sprache","iso639-2b::fre":"Französisch","iso639-2b::frm":"Mittelfranzösisch","iso639-2b::fro":"Altfranzösisch","iso639-2b::frr":"Nordfriesisch","iso639-2b::frs":"Ostfriesisch","iso639-2b::fry":"Friesisch","iso639-2b::ful":"Ful","iso639-2b::fur":"Friulisch","iso639-2b::gaa":"Ga-Sprache","iso639-2b::gay":"Gayo-Sprache","iso639-2b::gba":"Gbaya-Sprache","iso639-2b::gem":"Germanische Sprachen","iso639-2b::geo":"Georgisch","iso639-2b::gez":"Altäthiopisch","iso639-2b::gil":"Gilbertesisch","iso639-2b::gla":"Gälisch-Schottisch","iso639-2b::gle":"Irisch","iso639-2b::glg":"Galicisch","iso639-2b::glv":"Manx","iso639-2b::gmh":"Mittelhochdeutsch","iso639-2b::goh":"Althochdeutsch","iso639-2b::gon":"Gondi-Sprache","iso639-2b::gor":"Gorontalesisch","iso639-2b::got":"Gotisch","iso639-2b::grb":"Grebo-Sprache","iso639-2b::grc":"Griechisch","iso639-2b::grn":"Guaraní-Sprache","iso639-2b::gsw":"Schweizerdeutsch","iso639-2b::guj":"Gujarati-Sprache","iso639-2b::gwi":"Kutchin-Sprache","iso639-2b::hai":"Haida-Sprache","iso639-2b::hat":"Haïtien","iso639-2b::hau":"Haussa-Sprache","iso639-2b::haw":"Hawaiisch","iso639-2b::heb":"Hebräisch","iso639-2b::her":"Herero-Sprache","iso639-2b::hil":"Hiligaynon-Sprache","iso639-2b::him":"Himachali","iso639-2b::hin":"Hindi","iso639-2b::hit":"Hethitisch","iso639-2b::hmn":"Miao-Sprachen","iso639-2b::hmo":"Hiri-Motu","iso639-2b::hrv":"Kroatisch","iso639-2b::hsb":"Obersorbisch","iso639-2b::hun":"Ungarisch","iso639-2b::hup":"Hupa-Sprache","iso639-2b::iba":"Iban-Sprache","iso639-2b::ibo":"Ibo-Sprache","iso639-2b::ice":"Isländisch","iso639-2b::ido":"Ido","iso639-2b::iii":"Lalo-Sprache","iso639-2b::ijo":"Ijo-Sprache","iso639-2b::iku":"Inuktitut","iso639-2b::ile":"Interlingue","iso639-2b::ilo":"Ilokano-Sprache","iso639-2b::ina":"Interlingua","iso639-2b::inc":"Indoarische Sprachen","iso639-2b::ind":"Bahasa Indonesia","iso639-2b::ine":"Indogermanische Sprachen","iso639-2b::inh":"Inguschisch","iso639-2b::ipk":"Inupik","iso639-2b::ira":"Iranische Sprachen","iso639-2b::iro":"Irokesische Sprachen","iso639-2b::ita":"Italienisch","iso639-2b::jav":"Javanisch","iso639-2b::jbo":"Lojban","iso639-2b::jpn":"Japanisch","iso639-2b::jpr":"Jüdisch-Persisch","iso639-2b::jrb":"Jüdisch-Arabisch","iso639-2b::kaa":"Karakalpakisch","iso639-2b::kab":"Kabylisch","iso639-2b::kac":"Kachin-Sprache","iso639-2b::kal":"Grönländisch","iso639-2b::kam":"Kamba-Sprache","iso639-2b::kan":"Kannada","iso639-2b::kar":"Karenisch","iso639-2b::kas":"Kaschmiri","iso639-2b::kau":"Kanuri-Sprache","iso639-2b::kaw":"Kawi","iso639-2b::kaz":"Kasachisch","iso639-2b::kbd":"Kabardinisch","iso639-2b::kha":"Khasi-Sprache","iso639-2b::khi":"Khoisan-Sprachen","iso639-2b::khm":"Kambodschanisch","iso639-2b::kho":"Sakisch","iso639-2b::kik":"Kikuyu-Sprache","iso639-2b::kin":"Rwanda-Sprache","iso639-2b::kir":"Kirgisisch","iso639-2b::kmb":"Kimbundu-Sprache","iso639-2b::kok":"Konkani","iso639-2b::kom":"Komi-Sprache","iso639-2b::kon":"Kongo-Sprache","iso639-2b::kor":"Koreanisch","iso639-2b::kos":"Kosraeanisch","iso639-2b::kpe":"Kpelle-Sprache","iso639-2b::krc":"Karatschaiisch-Balkarisch","iso639-2b::krl":"Karelisch","iso639-2b::kro":"Kru-Sprachen","iso639-2b::kru":"Oraon-Sprache","iso639-2b::kua":"Kwanyama-Sprache","iso639-2b::kum":"Kumükisch","iso639-2b::kur":"Kurdisch","iso639-2b::kut":"Kutenai-Sprache","iso639-2b::lad":"Judenspanisch","iso639-2b::lah":"Lahnda","iso639-2b::lam":"Lamba-Sprache","iso639-2b::lao":"Laotisch","iso639-2b::lat":"Latein","iso639-2b::lav":"Lettisch","iso639-2b::lez":"Lesgisch","iso639-2b::lim":"Limburgisch","iso639-2b::lin":"Lingala","iso639-2b::lit":"Litauisch","iso639-2b::lol":"Mongo-Sprache","iso639-2b::loz":"Rotse-Sprache","iso639-2b::ltz":"Luxemburgisch","iso639-2b::lua":"Lulua-Sprache","iso639-2b::lub":"Luba-Katanga-Sprache","iso639-2b::lug":"Ganda-Sprache","iso639-2b::lui":"Luiseño-Sprache","iso639-2b::lun":"Lunda-Sprache","iso639-2b::luo":"Luo-Sprache","iso639-2b::lus":"Lushai-Sprache","iso639-2b::mac":"Makedonisch","iso639-2b::mad":"Maduresisch","iso639-2b::mag":"Khotta","iso639-2b::mah":"Marschallesisch","iso639-2b::mai":"Maithili","iso639-2b::mak":"Makassarisch","iso639-2b::mal":"Malayalam","iso639-2b::man":"Malinke-Sprache","iso639-2b::mao":"Maori-Sprache","iso639-2b::map":"Austronesische Sprachen","iso639-2b::mar":"Marathi","iso639-2b::mas":"Massai-Sprache","iso639-2b::may":"Malaiisch","iso639-2b::mdf":"Mokscha-Sprache","iso639-2b::mdr":"Mandaresisch","iso639-2b::men":"Mende-Sprache","iso639-2b::mga":"Mittelirisch","iso639-2b::mic":"Micmac-Sprache","iso639-2b::min":"Minangkabau-Sprache","iso639-2b::mis":"Einzelne andere Sprachen","iso639-2b::mkh":"Mon-Khmer-Sprachen","iso639-2b::mlg":"Malagassi-Sprache","iso639-2b::mlt":"Maltesisch","iso639-2b::mnc":"Mandschurisch","iso639-2b::mni":"Meithei-Sprache","iso639-2b::mno":"Manobo-Sprachen","iso639-2b::moh":"Mohawk-Sprache","iso639-2b::mon":"Mongolisch","iso639-2b::mos":"Mossi-Sprache","iso639-2b::mul":"Mehrere Sprachen","iso639-2b::mun":"Mundasprachen","iso639-2b::mus":"Muskogisch","iso639-2b::mwl":"Mirandesisch","iso639-2b::mwr":"Marwari","iso639-2b::myn":"Maya-Sprachen","iso639-2b::myv":"Erza-Mordwinisch","iso639-2b::nah":"Nahuatl","iso639-2b::nai":"Indianersprachen, Nordamerika","iso639-2b::nap":"Neapel / Mundart","iso639-2b::nau":"Nauruanisch","iso639-2b::nav":"Navajo-Sprache","iso639-2b::nbl":"Ndebele-Sprache (Transvaal)","iso639-2b::nde":"Ndebele-Sprache (Simbabwe)","iso639-2b::ndo":"Ndonga","iso639-2b::nds":"Niederdeutsch","iso639-2b::nep":"Nepali","iso639-2b::new":"Newari","iso639-2b::nia":"Nias-Sprache","iso639-2b::nic":"Nigerkordofanische Sprachen","iso639-2b::niu":"Niue-Sprache","iso639-2b::nno":"Nynorsk","iso639-2b::nob":"Bokmål","iso639-2b::nog":"Nogaisch","iso639-2b::non":"Altnorwegisch","iso639-2b::nor":"Norwegisch","iso639-2b::nqo":"N'Ko","iso639-2b::nso":"Pedi-Sprache","iso639-2b::nub":"Nubische Sprachen","iso639-2b::nwc":"Alt-Newari","iso639-2b::nya":"Nyanja-Sprache","iso639-2b::nym":"Nyamwezi-Sprache","iso639-2b::nyn":"Nkole-Sprache","iso639-2b::nyo":"Nyoro-Sprache","iso639-2b::nzi":"Nzima-Sprache","iso639-2b::oci":"Okzitanisch","iso639-2b::oji":"Ojibwa-Sprache","iso639-2b::ori":"Oriya-Sprache","iso639-2b::orm":"Galla-Sprache","iso639-2b::osa":"Osage-Sprache","iso639-2b::oss":"Ossetisch","iso639-2b::ota":"Osmanisch","iso639-2b::oto":"Otomangue-Sprachen","iso639-2b::paa":"Papuasprachen","iso639-2b::pag":"Pangasinan-Sprache","iso639-2b::pal":"Mittelpersisch","iso639-2b::pam":"Pampanggan-Sprache","iso639-2b::pan":"Pandschabi-Sprache","iso639-2b::pap":"Papiamento","iso639-2b::pau":"Palau-Sprache","iso639-2b::peo":"Altpersisch","iso639-2b::phi":"Philippinisch-Austronesisch","iso639-2b::phn":"Phönikisch","iso639-2b::pli":"Pali","iso639-2b::pol":"Polnisch","iso639-2b::pon":"Ponapeanisch","iso639-2b::por":"Portugiesisch","iso639-2b::pra":"Prakrit","iso639-2b::pro":"Altokzitanisch","iso639-2b::pus":"Paschtu","iso639-2b::que":"Quechua-Sprache","iso639-2b::raj":"Rajasthani","iso639-2b::rap":"Osterinsel-Sprache","iso639-2b::rar":"Rarotonganisch","iso639-2b::roa":"Romanische Sprachen","iso639-2b::roh":"Rätoromanisch","iso639-2b::rom":"Romani (Sprache)","iso639-2b::rum":"Rumänisch","iso639-2b::run":"Rundi-Sprache","iso639-2b::rup":"Aromunisch","iso639-2b::rus":"Russisch","iso639-2b::sad":"Sandawe-Sprache","iso639-2b::sag":"Sango-Sprache","iso639-2b::sah":"Jakutisch","iso639-2b::sai":"Indianersprachen, Südamerika","iso639-2b::sal":"Salish-Sprache","iso639-2b::sam":"Samaritanisch","iso639-2b::san":"Sanskrit","iso639-2b::sas":"Sasak","iso639-2b::sat":"Santali","iso639-2b::scn":"Sizilianisch","iso639-2b::sco":"Schottisch","iso639-2b::sel":"Selkupisch","iso639-2b::sem":"Semitische Sprachen","iso639-2b::sga":"Altirisch","iso639-2b::sgn":"Zeichensprachen","iso639-2b::shn":"Schan-Sprache","iso639-2b::sid":"Sidamo-Sprache","iso639-2b::sin":"Singhalesisch","iso639-2b::sio":"Sioux-Sprachen","iso639-2b::sit":"Sinotibetische Sprachen","iso639-2b::sla":"Slawische Sprachen","iso639-2b::slo":"Slowakisch","iso639-2b::slv":"Slowenisch","iso639-2b::sma":"Südsaamisch","iso639-2b::sme":"Nordsaamisch","iso639-2b::smi":"Saamisch","iso639-2b::smj":"Lulesaamisch","iso639-2b::smn":"Inarisaamisch","iso639-2b::smo":"Samoanisch","iso639-2b::sms":"Skoltsaamisch","iso639-2b::sna":"Schona-Sprache","iso639-2b::snd":"Sindhi-Sprache","iso639-2b::snk":"Soninke-Sprache","iso639-2b::sog":"Sogdisch","iso639-2b::som":"Somali","iso639-2b::son":"Songhai-Sprache","iso639-2b::sot":"Süd-Sotho-Sprache","iso639-2b::spa":"Spanisch","iso639-2b::srd":"Sardisch","iso639-2b::srn":"Sranantongo","iso639-2b::srp":"Serbisch","iso639-2b::srr":"Serer-Sprache","iso639-2b::ssa":"Nilosaharanische Sprachen","iso639-2b::ssw":"Swasi-Sprache","iso639-2b::suk":"Sukuma-Sprache","iso639-2b::sun":"Sundanesisch","iso639-2b::sus":"Susu","iso639-2b::sux":"Sumerisch","iso639-2b::swa":"Swahili","iso639-2b::swe":"Schwedisch","iso639-2b::syc":"Syrisch","iso639-2b::syr":"Neuostaramäisch","iso639-2b::tah":"Tahitisch","iso639-2b::tai":"Thaisprachen","iso639-2b::tam":"Tamil","iso639-2b::tat":"Tatarisch","iso639-2b::tel":"Telugu-Sprache","iso639-2b::tem":"Temne-Sprache","iso639-2b::ter":"Tereno-Sprache","iso639-2b::tet":"Tetum-Sprache","iso639-2b::tgk":"Tadschikisch","iso639-2b::tgl":"Tagalog","iso639-2b::tha":"Thailändisch","iso639-2b::tig":"Tigre-Sprache","iso639-2b::tir":"Tigrinja-Sprache","iso639-2b::tiv":"Tiv-Sprache","iso639-2b::tkl":"Tokelauanisch","iso639-2b::tlh":"Klingonisch","iso639-2b::tli":"Tlingit-Sprache","iso639-2b::tmh":"Tamaeq","iso639-2b::tog":"Tonga (Sambia)","iso639-2b::ton":"Tongaisch","iso639-2b::tpi":"Neumelanesisch","iso639-2b::tsi":"Tsimshian-Sprache","iso639-2b::tsn":"Tswana-Sprache","iso639-2b::tso":"Tsonga-Sprache","iso639-2b::tuk":"Turkmenisch","iso639-2b::tum":"Tumbuka-Sprache","iso639-2b::tup":"Tupi-Sprache","iso639-2b::tur":"Türkisch","iso639-2b::tut":"Altaische Sprachen","iso639-2b::tvl":"Elliceanisch","iso639-2b::twi":"Twi-Sprache","iso639-2b::tyv":"Tuwinisch","iso639-2b::udm":"Udmurtisch","iso639-2b::uga":"Ugaritisch","iso639-2b::uig":"Uigurisch","iso639-2b::ukr":"Ukrainisch","iso639-2b::umb":"Mbundu-Sprache","iso639-2b::und":"Nicht zu entscheiden","iso639-2b::urd":"Urdu","iso639-2b::uzb":"Usbekisch","iso639-2b::vai":"Vai-Sprache","iso639-2b::ven":"Venda-Sprache","iso639-2b::vie":"Vietnamesisch","iso639-2b::vol":"Volapük","iso639-2b::vot":"Wotisch","iso639-2b::wak":"Wakash-Sprachen","iso639-2b::wal":"Walamo-Sprache","iso639-2b::war":"Waray","iso639-2b::was":"Washo-Sprache","iso639-2b::wen":"Sorbisch","iso639-2b::wln":"Wallonisch","iso639-2b::wol":"Wolof-Sprache","iso639-2b::xal":"Kalmückisch","iso639-2b::xho":"Xhosa-Sprache","iso639-2b::yao":"Yao-Sprache","iso639-2b::yap":"Yapesisch","iso639-2b::yid":"Jiddisch","iso639-2b::yor":"Yoruba-Sprache","iso639-2b::ypk":"Ypik-Sprachen","iso639-2b::zap":"Zapotekisch","iso639-2b::zbl":"Bliss-Symbol","iso639-2b::zen":"Zenaga","iso639-2b::zgh":"Tamazight","iso639-2b::zha":"Zhuang","iso639-2b::znd":"Zande-Sprachen","iso639-2b::zul":"Zulu-Sprache","iso639-2b::zun":"Zuñi-Sprache","iso639-2b::zxx":"Kein linguistischer Inhalt","iso639-2b::zza":"Zazaki"},"en_150":{"skipValidation":"Skip validation (I know what I'm doing)","ReadMore":"Read more","extern":"external","UpdateAvailable":"Update available","ReloadPage":"Refresh","ClearCache":"Clear browser cache","leuris news heading":"The leuris team informs","notFound":"Page not found","btn.back":"Back to Home","browser.outdated":"Your are using an outdated browser which no longer meets today's safety requirements as well as modern web standards. This browser therefore can restrict the functionality of this page. Please use alternatives such as Firefox, Chrome, Safari or Edge in their latest version.","confirmPrivacyPolicy":"We store your session data in a technology comparable to cookies to ensure user-friendliness.","welcome.researchActivities":"research activities","welcome.heading":"Research Portal of Leipzig University","welcome.text.above":"<p>Welcome to the website of the research portal of Leipzig University. Here you will find an insight into the %{renderedRouterLinkPublicActivities} of the scientists of Leipzig University.</p>\n<p>The information presented here is based on the activities on research projects, publications, awards/awards, international cooperation and scientific events reported by the researchers themselves. Older activities from 2008 to 2016 are stored and retrievable in the \"Forschungsdatenbank\" (<a href=\"http://forschen.uni-leipzig.de\" target=\"_blank\">Archive</a>).</p>\n<p>If you have any questions or suggestions, please send a message to <a href=\"mailto:leuris@uni-leipzig.de\">leuris@uni-leipzig.de</a></p>","welcome.btn.readmore":"Read more","welcome.text.like":"You may also like","welcome.tile.techtransfer.title":"Wissens- und Technologietransfer","welcome.tile.techtransfer.content":"<a href=\"https://www.uni-leipzig.de/forschung/wissens-und-technologietransfer/\" target=\"_blank\" rel=\"noopener noreferrer\"> <span style=\"text-transform: uppercase; letter-spacing: 1px; padding-right: 0.5rem;\" class=\"is-size-6\">Read more</span>  <i class=\"fa fa-external-link\" aria-hidden=\"true\"></i></a>","welcome.tile.researchprofile.title":"Forschungsprofil","welcome.tile.researchprofile.content":"<a href=\"https://www.uni-leipzig.de/forschung/forschungsprofil\" target=\"_blank\" rel=\"noopener noreferrer\"> <span style=\"text-transform: uppercase; letter-spacing: 1px; padding-right: 0.5rem;\" class=\"is-size-6\">Read more</span>  <i class=\"fa fa-external-link\" aria-hidden=\"true\"></i></a>","welcome.tile.researchservice.title":"Forschungsservice","welcome.tile.researchservice.content":"<a href=\"https://www.uni-leipzig.de/forschung/forschungsservice\" target=\"_blank\" rel=\"noopener noreferrer\"> <span style=\"text-transform: uppercase; letter-spacing: 1px; padding-right: 0.5rem;\" class=\"is-size-6\">Read more</span>  <i class=\"fa fa-external-link\" aria-hidden=\"true\"></i></a>","footer.main":"<strong class=\"is-uppercase\">leuris:Forschungsbericht and leuris:Portal</strong> - a cooperation among <br><a class=\"is-uppercase\" href=\"https://www.uni-leipzig.de/en/university/structure/administration-and-departments/department-1-research-services/\" target=\"_blank\" rel=\"noopener noreferrer\">Department 1: Research and Transfer</a>, <a class=\"is-uppercase\" href=\"https://www.urz.uni-leipzig.de\" target=\"_blank\" rel=\"noopener noreferrer\">Universitätsrechenzentrum</a> and <a class=\"is-uppercase\" href=\"https://www.ub.uni-leipzig.de/en\" target=\"_blank\" rel=\"noopener noreferrer\">Universitätsbibliothek Leipzig</a>.","footer.link.imprint":"<a style=\"padding-right: 0.5rem;\" href=\"https://www.uni-leipzig.de/en/legal-notice\">Legal notice</a>","footer.link.privacyPolicy":"<a style=\"padding-right: 0.5rem;\" href=\"https://www.uni-leipzig.de/en/privacy\">Privacy</a>","footer.link.contact":"<a title=\"Send us an email\" href=\"mailto:fob@uni-leipzig.de\">Contact</a>","boolean.yes":"Yes","boolean.no":"No","list.total":"result","list.total.plural":"results","und":"and","and":"and","or":"or","page":"Page","list.header.perPage":"per page","list.button.print":"Print","list.printedOn":"Printed on %{printDate} o'clock from Forschungsbericht by Leipzig University (https://fob.uni-leipzig.de)","list.button.save":"Save view configuration","list.button.compactView":"Compact view","list.options.adjust.searchparameters":"Adjust search parameters","list.noData":"No data available","savedView.dialog.message":"Please enter a name for the view configuration:","savedView.dialog.confirm":"OK","savedView.dialog.cancel":"Cancel","savedView.button.activate":"Load","savedView.button.activate.toolTip":"Load this view configuration in the list view","savedView.button.delete.toolTip":"Delete this view configuration","PersonIdentTyp":"Person identifier type","PersonIdentTyp.form.kennung":"Code","PersonIdentTyp.form.anmerkung":"Remark","PreisBezeichnung":"Award type","PreisBezeichnung.form.name":"Name","PreisBezeichnung.form.beschreibung":"Category","form.header.created":"Created","form.header.lastEdited":"last edited","form.header.by":"by","Login Description":"leuris:Forschungsbericht (“leuris research report”) is the central tool for research reporting at our university. Staff can enter and manage their research activities here. Data already entered is still available and can be updated at any time. ","Login Systemrequirements Heading":"Access to the web interface - System requirements","Login Systemrequirements Text":"Sign in with the button “Login” top right. The login is done via the Uni-Login, e.g. <code>ab80xyzy</code> and the corresponding password. Information on the university login and the password can be found on the <a href=\"https://www.urz.uni-leipzig.de/dienste/uni-login/\"> websites of the University Computer Centre</a>.","Login Not Working Heading":"Login does not work?","Login Not Working Text":"<strong>Please note:</strong> It can happen that for employees who have previously studied at the university, the employee status in the so-called Active Directory (AD), which regulates access to the system, has not been updated. If you are afraid that you will not be able to log in due to this issue, please send an e-mail to <a href=\"mailto:servicedesk@uni-leipzig.de?subject=Update Affiliation Status in AD\">servicedesk@uni-leipzig.de</a> asking to update your status in AD.","AbstractPerson":"External Person","AbstractPerson.form.tableSelect._id":"FOB-ID","AbstractPerson.form.tableSelect._stringRep":"Person - Title, Name and Affiliation","AbstractPerson.form.vorname":"First name","AbstractPerson.form.nachname":"Last name","AbstractPerson.form.column.personIdent":"Person Identifiers","AbstractPerson.list.column.vorname":"First name","AbstractPerson.list.column.name":"Last name","AbstractPerson.list.column.personIdent":"Person Identifiers","AbstractPerson.list.filter.vorname":"First name","AbstractPerson.list.filter.name":"Last name","AbstractPerson.list.filter.personIdentWert":"Search in Person Identifiers","AppUser":"FOB-User","AppUser.form.userName":"Uni-Login","AppUser.form.lastLogin":"Last Login","AppUser.form.forscher":"Works as researcher","AppUser.list.column.forscher":"Researcher?","AppUser.form.applicationRoles":"FOB-Rollen","AppUser.form.organisationseinheiten":"OE from AD","AppUser.form.zstzlOrganisationseinheiten":"Added OE","AppUser.list.column.applicationRoles":"FOB-Rollen","AppUser.list.column.lastLogin":"Last Login","AppUser.list.column._updateDate":"Update Date","AppUser.list.column._createDate":"Create Date","AppUser.list.column.organisationseinheiten":"Auto OE","AppUser.list.column.zstzlOrganisationseinheiten":"FOB OE","AppUser.list.column.email":"E-Mail","AppUser.list.column.userName":"Uni-Login","AppUser.list.filter.userName":"Uni-Login","AppUser.list.filter.applicationRoles":"FOB-Rollen","AppUser.list.filter.lastLogin":"Last Login","AppUser.list.filter.organisationseinheiten":"OE from AD","AppUser.list.filter.zstzlOrganisationseinheiten":"Added OE","AppUser.list.filter.email":"E-Mail","component.entity.compact.details":"Details","component.entity.compact.edit":"Edit","component.entity.compact.favour.select":"Select as favourite","component.entity.compact.favour.deselect":"Deselect favourite","component.entity.list.table.details":"Details","component.entity.list.table.edit":"Edit","createModal.button.cancel":"Cancel","createModal.button.create":"Create","createModal.header.beteiligteOrganisationen":"Create new External Organisation","createModal.header.beteiligtePersonen":"Create new external Person","createModal.header.antragsteller":"Create new external Person as project applicant","createModal.header.projektLeiter":"Create new external Person as project manager","createModal.header.projektleiter_person":"Create new external Person as project manager","createModal.header.mitarbeiter":"Create new external Person as project collaborator","createModal.header.author":"Create new external Person as author","createModal.header.herausgeber":"Create new external Person as editor","createModal.header.veranstalter":"Create new external Person as organiser","details.button.edit":"Edit","details.button.delete":"Delete","details.button.print":"Print","details.printedOn":"Printed on %{printDate} o'clock from Forschungsbericht by Leipzig University (https://fob.uni-leipzig.de)","ExterneOrganisation":"External Organisation","ExterneOrganisation.form.tableSelect.Name":"Name of External Organisation","ExterneOrganisation.form.tableSelect.Stadt":"City of External Organisation","ExterneOrganisation.list.filter.beschreibung":"Description External Organisation","ExterneOrganisation.list.filter.kurzname":"Short Name of Organisation","ExterneOrganisation.list.filter.land":"Country","ExterneOrganisation.list.filter.name":"Name of Organisation","ExterneOrganisation.list.filter.stadt":"City","ExterneOrganisation.form.land":"Country","ExterneOrganisation.form.stadt":"City","ExterneOrganisation.form.name":"Name","ExterneOrganisation.form.beschreibung":"Description External Organisation","ExterneOrganisation.form.kurzname":"Short Name of Organisation","externalLink":"External link","Mittelgeber":"Funding Agency","Forschungsprojekt":"Research Project","Forschungsprojekte":"Research Projects","Projekt":"Project","Projekte":"Projects","Projektleitung":"Project Management","Projektleiter hinzufügen":"Add project lead","Projektleiterrolle GESAMTLEITUNG":"General Management","Projektleiterrolle FACHLICHE_LEITUNG":"Domain Lead","Projektleiterrolle TECHNISCHE_LEITUNG":"Technical Lead","projektleiter_no_person":"No person selected","startdate_out_of_scope":"Start date not within project duration","enddate_out_of_scope":"End date not within project duration","enddate_before_startdate":"End data is earlier that start date","Leitung Projektstart":"Project start","Leitung Projektende":"Project end","Leitung als":"as","Leitung ab":"from","Leitung bis":"until","Forschungsprojekt.form.primaryPublicIdent":"Permalink","Forschungsprojekt.form.antragsteller":"Project Applicants","Forschungsprojekt.form.finanzierung":"Project is funded by","Forschungsprojekt.form.foerderung.foerderkennzeichen":"Funding Code","Forschungsprojekt.form.foerderung.mittelgeber":"Third-Party Funding Agency","Forschungsprojekt.form.hinweistext":"<b>Please record only those research projects that are not listed in the Research Report yet!</b><br>Many projects from previous years are still available. Please be sure to check the duration of the projects. Some old entries are missing the date of the project start. Use the search under <i>List activities</i> to see which projects are already listed.","Forschungsprojekt.form.mitarbeiter":"Project Collaborator/s","Forschungsprojekt.form.organisationseinheit":"Organisational Unit","Forschungsprojekt.form.projektBeginn":"Start Date","Forschungsprojekt.form.projektEnde":"End Date","Forschungsprojekt.form.externeProjektwebsite":"External Project Website","Forschungsprojekt.form.projektLeiter":"Project Manager","Forschungsprojekt.form.projektLeiter.plusbutton":"Add Project Manager","projektleiter_person.plusbutton":"Create new","Forschungsprojekt.form.publikation":"Publication","Forschungsprojekt.form.relevantFuerWeitere":"Other organisational units of Leipzig University participate in this project","Forschungsprojekt.form.sprecherhochschule":"University of Spokesperson","Forschungsprojekt.form.titelDE":"German Title","Forschungsprojekt.form.titelEN":"English Title","Forschungsprojekt.form.uebergeordnetesProjekt":"Superordinate Project","Forschungsprojekt.form.verbundprojekt":"Collaborative Research Project","Forschungsprojekt.form.weitereOrganisationseinheiten":"Other Participating Organisational Units of Leipzig University","Forschungsprojekt.form.beschreibungDE":"Description in German","Forschungsprojekt.form.beschreibungEN":"Description in English","Forschungsprojekt.form.istFinal":"Data entry final","Forschungsprojekt.list.column._createDate":"Created on","Forschungsprojekt.list.column._updateDate":"Updated on","Forschungsprojekt.list.column.antragsteller":"Project Applicants","Forschungsprojekt.list.column.foerderung":"Funding agency","Forschungsprojekt.list.column.foerderkennzeichen":"Funding code","Forschungsprojekt.list.column.istFinal":"Data entry final","Forschungsprojekt.list.column.organisationseinheit":"Organisational Unit","Forschungsprojekt.list.column.projektBeginn":"Startdate","Forschungsprojekt.list.column.projektEnde":"Enddate","Forschungsprojekt.list.column.projektLeiter":"Project Manager","Forschungsprojekt.list.column.projektleiter":"Project Management","Forschungsprojekt.list.column.titelDE":"German Title","Forschungsprojekt.list.column.titelEN":"English Title","Forschungsprojekt.list.column.weitereOrganisationseinheiten":"Other Organisational Units","Forschungsprojekt.list.column.uebergeordnetesProjekt":"Superordinate Project","Forschungsprojekt.list.filter.antragsteller":"Project Applicants","Forschungsprojekt.list.filter.organisationseinheit":"Organisational Unit","Forschungsprojekt.list.filter.kumuliert":"Include subordinate units","Forschungsprojekt.list.filter.berichtsjahr":"Reporting year","Forschungsprojekt.list.filter.projektLeiter":"Project Manager","Forschungsprojekt.list.filter.projektleiter":"Project Management","Forschungsprojekt.list.filter.titelDE":"German Title","Forschungsprojekt.list.filter.titelEN":"English Title","Forschungsprojekt.list.filter.mittelgeber":"Project funded by","Forschungsprojekt.list.filter.beteiligte":"Involved persons (applicants, manager or associates)","Forschungsprojekt.list.filter.uebergeordnetesProjekt":"Superordinate Project","Forschungsprojekt.compact.Laufzeit":"Duration","Forschungsprojekt.compact.Mittelgeber":"Funded by","Forschungsprojekt.compact.weitereOrganisationseinheiten":"Other involved organisational units of Leipzig University","Forschungsprojekt.compact.organisationseinheiten":"Involved organisational units of Leipzig University","Kooperation":"International Collaboration","Kooperationen":"Collaborations","Kooperation.compact.beginn":"Start of collaboration","Kooperation.compact.ende":"Ended on","Kooperation.compact.beteiligteOrganisationen":"External participating organisations","Kooperation.compact.beteiligtePersonen":"Involved persons","Kooperation.compact.weitereOEderUL":"Additional OUs of UL","Kooperation.form.andereKooperation":"Other kinds of activities, please illustrate these","Kooperation.form.ansprechpartner":"Contact person","Kooperation.form.beginn":"Start Date of Collaboration","Kooperation.form.beteiligteOrganisationen":"External Participating Organisations","Kooperation.form.beteiligtePersonen":"Involved Persons","Kooperation.form.doktorandenProgramm":"Conduction of at least one study or doctoral programme","Kooperation.form.ende":"End Date of Collaboration","Kooperation.form.endeGeplant":"End of Collaboration is planned","Kooperation.form.gastaufenthalte":"Reciprocal or repeated guest stays of academic staff","Kooperation.form.gegenseiteHilfe":"Exchange/mutual support for methodical questions/implementations (e. g. carrying out experiments)","Kooperation.form.gemeinsamePublikationen":"Joint institutionalized authoring or editoring of publications","Kooperation.form.gemeinsameTagungen":"Organisation of joint meetings/workshops","Kooperation.form.gemeinsameThemen":"Working on common research topics/questions","Kooperation.form.hinweistext":"<b>Please record only those international collaborations that are not listed in the Research Report yet!</b><br>Previously entered long-term collaborations are available in the Research Report. Please check their duration. Use the search under <i>List activities</i> to see which collaborations are already listed.","Kooperation.form.kooperationsTyp":"Type of Collaboration","Kooperation.form.kooperationsarten":"Activities within this collaboration","Kooperation.form.kurzbeschreibung":"Short Description / Abstract of Collaboration","Kooperation.form.organisationseinheit":"Organisational Unit of Leipzig University that is responsible for this Collaboration","Kooperation.form.relevantFuerWeitere":"Other organisational units of Leipzig University participate in this collaboration","Kooperation.form.titelKooperation":"Title of Collaboration","Kooperation.form.weitereOrganisationseinheiten":"Other Participating Organisational Units of Leipzig University","Kooperation.form.kooperationsartFreitext":"Illustration of other kinds of activities done in this collaboration","Kooperation.list.column._createDate":"Created on","Kooperation.list.column._updateDate":"Updated on","Kooperation.list.column.ansprechpartner":"Contact person","Kooperation.list.column.beginn":"Start date","Kooperation.list.column.beteiligteOrganisationen":"External organisations","Kooperation.list.column.ende":"End date","Kooperation.list.column.kooperationsTyp":"Type of Collaboration","Kooperation.list.column.organisationseinheit":"Organisational Unit","Kooperation.list.column.titelKooperation":"Description","Kooperation.list.column.weitereOrganisationseinheiten":"Other Organisational Units","Kooperation.list.filter.organisationseinheit":"Organisational Unit","Kooperation.list.filter.kumuliert":"Include subordinate units","Kooperation.list.filter.berichtsjahr":"Reporting year","Kooperation.list.filter.titelKooperation":"Title","Kooperation.list.filter.beteiligte":"Contact person and other involved persons","Kooperation.list.filter.beteiligteOrganisationen":"External participating organisations","Mittelgeber.form.tableSelect.name":"Funding agency","Mittelgeber.form.tableSelect.Mittelgeber.form.name":"Funding agency","Organisationseinheit.form.orgaIdent":"Organisation Identifiers","OrgaIdent.form.typ":"Type of the identifier","OrgaIdent.form.wert":"Identifier","Organisationseinheit.list.column.orgaIdent":"Orga IDs","embedded.button.add.orgaIdent":"Add organisation ID","embedded.button.remove.orgaIdent":"Remove organisation ID","Organisationseinheit":"Organisational Unit","Organisationseinheit.form.tableSelect.name":"Name","Organisationseinheit.form.tableSelect.parent":"Parent Unit","Organisationseinheit.form.tableSelect.kostenstelle":"Cost Unit","Organisationseinheit.form.name":"Name","Organisationseinheit.form.beginn":"Active since","Organisationseinheit.form.ende":"Active until","Organisationseinheit.form.beschreibungDE":"Description (German)","Organisationseinheit.form.beschreibungEN":"Description (Englisch)","Organisationseinheit.form.kostenstelle":"Cost Unit","Organisationseinheit.form.inPubfob":"Visible in leuris:Portal","Organisationseinheit.form.obsolet":"Is obsolete/inactive","Organisationseinheit.form.ueberOrganisationseinheit":"Super organisational unit","Organisationseinheit.form.unterOrganisationseinheiten":"Sub organisational units","Organisationseinheit.list.column.name":"Name","Organisationseinheit.list.column.beginn":"Since","Organisationseinheit.list.column.ende":"Until","Organisationseinheit.list.column.kostenstelle":"Cost Unit","Organisationseinheit.list.column.inPubfob":"Public?","Organisationseinheit.list.column.obsolet":"Obsolete?","Organisationseinheit.list.column.ueberOrganisationseinheit":"Super organisational unit","Organisationseinheit.list.column.unterOrganisationseinheiten":"Sub organisational units","Organisationseinheit.list.filter.ueberOrganisationseinheit":"Super organisational unit","Organisationseinheit.list.filter.name":"Name","Organisationseinheit.list.filter.kostenstelle":"Cost Unit","Organisationseinheit.list.filter.inPubfob":"Visibility in public FOB","Organisationseinheit.inPubfob.TRUE":"Visible","Organisationseinheit.inPubfob.FALSE":"Not visible","Pagination.jumpToPage":"Jump to page","Pagination.pageNotAvailable":"Page not available","Person":"Person","PersonIdent":"Person Identifiers","PersonIdent.form.personIdentTyp":"Type of Person Identifier","PersonIdent.form.wert":"Identifier","Person.form.vorname":"First name","Person.form.name":"Last name","Person.form.nachname":"Last name","Person.form.titel":"Title","Person.form.fisPersid":"FIS identifier","Person.form.personIdent":"Person Identifier","Person.form.organisationseinheiten":"Organisational unit","Person.list.column.titel":"Title","Person.list.column.fisPersid":"FIS identifier","Person.list.column.vorname":"First name","Person.list.column.name":"Last name","Person.list.column.personIdent":"Person Identifiers","Person.list.filter.titel":"Title","Person.list.filter.fisPersid":"FIS identifier","Person.list.filter.vorname":"First name","Person.list.filter.name":"Last name","Person.list.filter.personIdentWert":"Search in Person Identifiers","Preis":"Award/Prize","Preise":"Awards/Prizes","Preis.hatPreisgeld.TRUE":"Yes","Preis.hatPreisgeld.FALSE":"No","Preis.hatPreisgeld.NULL":"No information","Preis.compact.verliehenIn":"awarded in","Preis.compact.vergebenDurch":"by","Preis.form.hatPreisgeld":"Award is endowed","Preis.form.hinweistext":"<b>Please record only those awards, prizes and honours that are not listed in the Research Report yet!</b><br>Use the search under <i>List activities</i> to see which events are already listed.","Preis.form.namePreis":"Name of Award, Prize or Honour","Preis.form.organisationseinheit":"Organisational Unit of Awardee","Preis.form.preisBezeichnung":"Type of Award","Preis.form.preisTraeger":"Awardee","Preis.form.preisTraeger.plusbutton":"Create Awardee","Preis.form.vergebenDurch":"Award, prize or honour awarded by","Preis.form.verleihungsJahr":"Awarding Year","Preis.list.column._createDate":"Created on","Preis.list.column._updateDate":"Updated on","Preis.list.column.hatPreisgeld":"Award is endowed","Preis.list.column.namePreis":"Name of Award","Preis.list.column.organisationseinheit":"Organisational Unit of Awardee","Preis.list.column.preisBezeichnung":"Type of Award","Preis.list.column.preisTraeger":"Awardee","Preis.list.column.verleihungsJahr":"Awarding Year","Preis.list.filter.namePreis":"Name of Award","Preis.list.filter.organisationseinheit":"Organisational Unit","Preis.list.filter.kumuliert":"Include subordinate units","Preis.list.filter.preisBezeichnung":"Type of Award","Preis.list.filter.preisTraeger":"Awardee","Preis.list.filter.verleihungsJahr":"Awarding Year","Preis.list.filter.hatPreisgeld":"Award is endowed","Public.person":"Person(s)","Public.noselection":"No selection made","Public.loading":"Loading Data for the selected","Public.toast.clipboard.success":"Link successfully copied to clipboard","Public.toast.clipboard.error":"Link could not be copied to clipboard","Public.filter.jahr":"Year","Public.filter.status":"Status","Public.filter.mittelgeber":"Funding agency","Public.filter.inProject":"Result of a project","Public.filter.fundedBy":" funded by: ","Public.filter.fundedByPrintLabel":"Funding","Public.filter.awardsTypePrintLabel":"Award","Public.filter.beliebigerMittelgeber":"Any funding body","Public.filter.funded_by.DFG":"German Research Foundation (DFG)","Public.filter.funded_by.EU":"EU","Public.filter.funded_by.BMBF":"Federal Ministry of Education and Research (BMBF)","Public.filter.funded_by.ANDERE_BM":"Other Federal Ministries (without BMBF)","Public.filter.funded_by.SMWK":"Saxon State Ministry of Science, Culture and Tourism (SMWK)","Public.filter.funded_by.ANDERE_SAECHSISCHE_MINISTERIEN":"Other Saxon State Ministries (without SMWK)","Public.filter.funded_by.DAAD":"German Academic Exchange Service (DAAD)","Public.filter.funded_by.UNI_LE":"Leipzig University","Public.filter.funded_by.WIRTSCHAFT":"Industry","Public.filter.funded_by.STIFTUNGEN_DE":"Foundations in Germany","Public.filter.funded_by.ANDERE":"Other","Public.filter.person":"Person","Public.filter.suche":"Search","Public.filter.externalPartner":"Partner","Public.filter.publikationstypen":"Type of Publication","Public.filter.beliebigerPreis":"Any award","Public.filter.typeIds.preis_2":"Gottfried Wilhelm Leibniz-Preis","Public.filter.typeIds.preis_3":"Max-Planck-Humboldt-Forschungspreis","Public.filter.typeIds.preis_4":"Heinz Maier-Leibnitz-Preis","Public.filter.typeIds.preis_29":"Akademiepreis der Berlin-Brandenburgischen Akademie der Wissenschaften","Public.filter.typeIds.preis_30":"Alfried Krupp-Förderpreis für junge Hochschullehrer","Public.filter.typeIds.preis_31":"Greve-Preis der Leopoldina","Public.filter.typeIds.preis_32":"Hector Wissenschaftspreis","Public.filter.typeIds.preis_33":"Carl-Friedrich-von-Weizsäcker-Preis","Public.filter.typeIds.preis_34":"Deutscher Umweltpreis","Public.filter.typeIds.preis_35":"Deutscher Zukunftspreis","Public.filter.typeIds.preis_36":"DFG Communicator-Preis","Public.filter.typeIds.preis_37":"Leipziger Wissenschaftspreis","Public.filter.typeIds.weiterePreise":"Other","Public.filter.typeIds.weitere_preise":"Other","Public.sort.changeOrder":"Change sort order","Public.sort.order.ASC":"Ascending","Public.sort.order.DESC":"Descending","Public.sort.by":"Sort by","Public.sort.titel":"Title","Public.sort.beginn":"Start date","Public.sort.typ":"Type","Public.sort.jahr":"Year","Public.sort.name":"Name","Public.sort.preisTraeger":"Awardee","Public.action.share":"Share link","Public.action.share.default":"Default view","Public.action.share.defaultWithSearchOptions":"Default view with search option","Public.action.share.compact":"Compact view","Public.action.share.compactWithSearchOptions":"Compact view with search option","Public.action.print":"Print","Public.action.export":"Export","Public.action.export.disabled":"Please log in to request your PDF Export.","Public.select.reset":"No selection","Public.headline.organisationalUnit":"Structure of Leipzig University","Public.headline.person":"Persons at Leipzig University","Public.switch.ou.person":"Toggle between","Public.person.search":"Person search","Public.person.search.limit":"100 of %{staffTotalEntries} persons shown.","Public.person.search.match":"%{staffTotalEntries} person(s) found.","Public.person.search.nomatch":"No person(s) found.","Public.person.list.limit":"Please refine your search.<br>Too many persons.","Public.filter.category.article":"Article","Public.filter.category.monography":"Monography","Public.filter.category.editorship":"Editorship","Public.filter.category.contribution":"Contribution","Public.filter.category.report":"Report","Public.filter.status.ongoing":"Ongoing","Public.filter.status.terminated":"Terminated","Public.entity.backToList":"Back to list","Public.placeholder.ousearch":"Search for organisational unit...","Export.header":"Request Data Export","Export.infotext":"Here you can export the research activities of an organisational unit to PDF. The file will be sent to you by email.","Export.currentOrga":"Current unit","Export.close":"Close","Export.continue":"Continue","Export.success":"Your export will generated and sent to you shortly.","Export.error":"An error occured. Please try again later.","Export.list.filter.jahr":"Year","Export.list.filter.format":"File format","Export.list.filter.email":"Email","Export.list.filter.organisationseinheit":"Organisational Unit","Publikation":"Publication","Publikationen":"Publications","Publikation.compact.dissertation":"Doctoral thesis","Publikation.compact.habilitationsschrift":"Habilitation thesis","Publikation.compact.Abkuerzung.Seite":"p","Publikation.compact.Abkuerzung.SeitePlural":"pp","Publikation.compact.Abkuerzung.Herausgeber":"Ed","Publikation.compact.Abkuerzung.HerausgeberPlural":"Eds","Publikation.form.author":"Author/s","Publikation.form.band":"Volume","Publikation.form.buchtitel":"Book title","Publikation.form.foerderer":"Agency funding publication costs","Publikation.form.forschungsprojekt":"Related project","Publikation.form.herausgeber":"Editor/s","Publikation.form.hinweistext":"<b>Please record only those publications that are not listed in the Research Report yet!</b><br>Your colleagues or co-authors may have already entered joint publications. We have prefilled the Research Report for you with all publications published in 2017 with relation to Leipzig University in the Web of Science. Use the search under <i>List activities</i> to see which publications are already present for your organizational unit.","Publikation.form.inProjekt":"Publication resulted from a project at Leipzig University","Publikation.form.institution":"Publishing Organisation","Publikation.form.istFinal":"Data input is finalised","Publikation.form.journal":"Journal / Media Title","Publikation.form.journalNummer":"Issue","Publikation.form.organisationseinheit":"Organisational Unit of Author / Editor","Publikation.form.pubIdent":"Publication-ID","Publikation.form.pubIdentTyp":"Type of Publication-ID","Publikation.form.publicPubIdent":"Publication-ID","Publikation.form.publicPubIdent.pubIdentTyp":"Type of Publication-ID","Publikation.form.publicPubIdent.wert":"ID","Publikation.form.publikationsTyp":"Type of Publication","Publikation.form.relevantFuerWeitere":"Other organisational units of Leipzig University participate in this publication","Publikation.form.seiteEnde":"Last Page of Article","Publikation.form.seiteStart":"First Page of Article","Publikation.form.serientitel":"Series title","Publikation.form.sprache":"Language","Publikation.form.titelPublikation":"Title of Publication","Publikation.form.validiert":"Publication data is validated by UBL.","Publikation.form.verlagsort":"Place of Publisher","Publikation.form.verleger":"Publisher","Publikation.form.veroeffentlichungsJahr":"Year of Publication","Publikation.form.weitereOrganisationseinheiten":"Other Participating Organisational Units of Leipzig University","Publikation.list.column._createDate":"Created on","Publikation.list.column._updateDate":"Updated on","Publikation.list.column.author":"Author/s","Publikation.list.column.herausgeber":"Editor/s","Publikation.list.column.istFinal":"Data entry final","Publikation.list.column.organisationseinheit":"Organisational Unit","Publikation.list.column.publicPubIdent":"Publication-ID","Publikation.list.column.publikationsTyp":"Type","Publikation.list.column.titelPublikation":"Title","Publikation.list.column.validiert":"UBL validated","Publikation.list.column.veroeffentlichungsJahr":"Year","Publikation.list.column.weitereOrganisationseinheiten":"Other Organisational Units","Publikation.list.filter.author":"Author/s","Publikation.list.filter.beteiligte":"Participating Author or Editor","Publikation.list.filter.freieID":"Search in Publication-Identifier (DOI, ISBN)","Publikation.list.filter.herausgeber":"Editor/s","Publikation.list.filter.organisationseinheit":"Organisational Unit of author/s or editor/s","Publikation.list.filter.kumuliert":"Include subordinate units","Publikation.list.filter.titelPublikation":"Title of Publication","Publikation.list.filter.validiert":"Publication data input is validated by UBL","Publikation.list.filter.veroeffentlichungsJahr":"Year of Publication","PublikationValidiert.TRUE":"Yes","PublikationValidiert.FALSE":"Not yet","PublikationsTyp.ARTIKEL":"Article","PublikationsTyp.BEITRAGINNICHTWISSENSCHAFTLICHENMEDIEN":"Chapter / Article in Non-Academic Media","PublikationsTyp.BERICHT":"Research Report","PublikationsTyp.BUCHBEITRAG":"Chapter in Book","PublikationsTyp.DISSERTATION":"Doctoral thesis","PublikationsTyp.HABILITATIONSSCHRIFT":"Habilitation thesis","PublikationsTyp.MONOGRAPHIE":"Book, Whole","PublikationsTyp.QUELLENEDITION":"Source Edition (Editorship)","PublikationsTyp.SAMMELBAND":"Edited Volume / Collection of Articels (Editorship)","PublikationsTyp.SAMMELBANDBEITRAG":"Chapter in Edited Volume / Collection of Articels","PublikationsTyp.SONDERHEFT":"Special Issue of Journal (Editorship)","PublikationsTyp.SONSTIGE":"Miscellaneous","PublikationsTyp.TAGUNGSBAND":"Conference Proceedings (Editorship)","PublikationsTyp.TAGUNGSBEITRAG":"Chapter in Conference Proceedings","PublikationsTyp.WORKINGPAPER":"Working Paper","Veranstaltung":"Scientific Event","Veranstaltungen":"Scientific Events","Veranstaltung.virtuell.TRUE":"Yes","Veranstaltung.virtuell.FALSE":"No","Veranstaltung.form.hinweistext":"<b>Please record only those scientific events that are not listed in the Research Report yet!</b><br>Use the search under <i>List activities</i> to see which events are already listed.<br><br>Please be aware that only scientific events (co-)organized by researchers or institutions of Leipzig University should be reported in leuris:Forschungsbericht.","Veranstaltung.form.name":"Event Title","Veranstaltung.form.organisationseinheit":"Hosting Organisational Unit","Veranstaltung.form.relevantFuerWeitere":"Other organisational units of Leipzig University participated in this event","Veranstaltung.form.veranstalter":"Event Organiser","Veranstaltung.form.veranstaltungEnde":"End Date of Event","Veranstaltung.form.veranstaltungStart":"Start Date of Event","Veranstaltung.form.veranstaltungsTyp":"Event Type","Veranstaltung.form.weitereOrganisationseinheiten":"Further Organisational Units of Leipzig University","Veranstaltung.list.column._createDate":"Created on","Veranstaltung.list.column._updateDate":"Updated on","Veranstaltung.list.column.name":"Event Title","Veranstaltung.list.column.organisationseinheit":"Hosting Organisational Unit","Veranstaltung.list.column.veranstalter":"Event Organiser","Veranstaltung.list.column.veranstaltungEnde":"End Date","Veranstaltung.list.column.veranstaltungStart":"Start Date","Veranstaltung.list.column.veranstaltungsTyp":"Event Type","Veranstaltung.list.column.weitereOrganisationseinheiten":"Further Organisational Units","Veranstaltung.list.column.stadt":"City","Veranstaltung.list.column.land":"Country","Veranstaltung.list.column.virtuell":"virtual","Veranstaltung.list.filter.name":"Event Title","Veranstaltung.list.filter.organisationseinheit":"Hosting Organisational Unit","Veranstaltung.list.filter.kumuliert":"Include subordinate units","Veranstaltung.list.filter.berichtsjahr":"Reporting year","Veranstaltung.list.filter.veranstalter":"Event Organiser","Veranstaltung.list.filter.veranstaltungsTyp":"Event Type","Veranstaltung.list.filter.stadt":"City","Veranstaltung.list.filter.land":"Country","Veranstaltung.list.filter.virtuell":"\"Virtual or online event","Veranstaltung.form.externeWebsite":"External Event Website","Veranstaltung.form.beschreibungDE":"Description in German","Veranstaltung.form.beschreibungEN":"Description in English","Veranstaltung.form.stadt":"City","Veranstaltung.form.land":"Country","Veranstaltung.form.virtuell":"Virtual or online event","Patent":"Patent","Patente":"Patents","Patent.form.hinweistext":"<b>Please record only those patents that are not listed in the Research Report yet!</b><br>Use the search under <i>List activities</i> to see which patents are already listed.","Patent.form.organisationseinheit":"Organisational Unit of Main Inventor at Leipzig University","Patent.form.titel":"Title of Parent Application","Patent.form.veroeffentlichungsnummer":"Publication Number","Patent.form.datumDerPrioritaetsbegruendendenErstanmeldung":"Priority Date of Patent Application","Patent.form.haupterfinder":"Main Inventor","Patent.form.anmelderExtern":"External Organisation Filing Patent","Patent.form.anmelderIntern":"Internal Organisation Filing Patent","Patent.form.lizenzen":"Transfer of Rights / Licenses","Patent.form.link":"Hyperlink to Application","Patent.form.forschungsgebiet":"Research Area / Object of Research","Patent.form.kurzbeschreibung":"Description / Abstract of Patent Application","Patent.form.ansprechpartner":"Contact Person for Transfer Area","Patent.form.land":"Countries of Application","Patent.form.ansprechpartner.plusbutton":"Add","Patent.list.column.titel":"Title","Patent.list.column.haupterfinder":"Main Inventor","Patent.list.column.veroeffentlichungsnummer":"Publication Number","Patent.list.column.datumDerPrioritaetsbegruendendenErstanmeldung":"Patent Application on","Patent.list.column.lizenzen":"Licenses","Patent.list.column.forschungsgebiet":"Research Area","Patent.list.column.anmelderExtern":"External Organisation Filing Patent","Patent.list.column.anmelderIntern":"Internal Organisation Filing Patent","Patent.list.column.ansprechpartner":"Contact Person for Transfer Area","Patent.list.column.land":"Countries of Application","Patent.list.filter.organisationseinheit":"Organisational Unit of Main Inventor at Leipzig University","Patent.list.filter.kumuliert":"Include subordinate units","Patent.list.filter.jahrDerPrioritaetsbegruendendenErstanmeldung":"Priority Year of Patent Application","Patent.list.filter.haupterfinder":"Main Inventor","Patent.list.filter.titel":"Title of Parent Application","Patent.list.filter.veroeffentlichungsnummer":"Publication Number","Patent.list.filter.lizenzen":"Transfer of Rights / Licenses","Patent.list.filter.link":"Hyperlink to Application","Patent.list.filter.forschungsgebiet":"Research Area / Object of Research","Patent.list.filter.kurzbeschreibung":"Description / Abstract of Patent Application","Patent.list.filter.anmelderExtern":"External Organisation Filing Patent","Patent.list.filter.anmelderIntern":"Internal Organisation Filing Patent","Patent.list.filter.ansprechpartner":"Contact Person for Transfer Area","Patent.list.filter.land":"Countries of Application","Patent.compact.datumDerPrioritaetsbegruendendenErstanmeldung":"Priority Date","Land":"Country","Länder":"Countries","Land.list.filter.alpha2code":"Alpha-2 Code","Land.list.filter.alpha3code":"Alpha-3 Code","Land.list.filter.nameDE":"Country (DE)","Land.list.filter.nameEN":"Country (EN)","Land.list.filter.numericCode":"Numeric Country Code","Land.list.column.alpha2code":"Alpha-2 Code","Land.list.column.alpha3code":"Alpha-3 Code","Land.list.column.nameDE":"Country (DE)","Land.list.column.nameEN":"Country (EN)","Land.list.column.numericCode":"Numeric Country Code","Land.form.alpha2code":"Alpha-2 Code","Land.form.alpha3code":"Alpha-3 Code","Land.form.nameDE":"Country (DE)","Land.form.nameEN":"Country (EN)","Land.form.numericCode":"Numeric Country Code","Land.form.tableSelect.nameDE":"Country (DE)","Land.form.tableSelect.nameEN":"Country (EN)","Land.form.tableSelect.alpha2code":"Alpha-2 Code","Land.form.tableSelect.alpha3code":"Alpha-3 Code","Land.form.tableSelect.numericCode":"Numeric Country Code","tableSelect.header.haupterfinder":"Selection of main inventor/s","tableSelect.header.anmelderExtern":"Selection of external organisation/s filling patent","tableSelect.header.anmelderIntern":"Selection of internal organisation/s filling patent","tableSelect.header.ansprechpartner":"Selection of Contact Persons","tableSelect.header.land":"Selection of application countries","form.xbutton.remove.multiSelect.anmelderExtern":"Remove external organisation","form.xbutton.remove.multiSelect.anmelderIntern":"Remove internal organisation","form.xbutton.remove.multiSelect.haupterfinder":"Remove main investor","form.xbutton.remove.multiSelect.land":"Remove country","createModal.header.ansprechpartner":"Contact Person for Transfer Area","embedded.button.add.foerderung":"Add funding agency","embedded.button.add.personIdent":"Add Person-Identifier","embedded.button.remove.personIdent":"Remove Person-Identifier","embedded.button.add.publicPubIdent":"Add Publication-ID","embedded.button.remove.foerderung":"Remove funding agency","embedded.button.remove.publicPubIdent":"Remove Publication-ID","form.editlink":"Edit selection","form.xbutton":"Empty field","form.xbutton.remove.multiSelect.author":"Remove author","form.xbutton.remove.multiSelect.herausgeber":"Remove editor","form.xbutton.remove.multiSelect.beteiligteOrganisationen":"Remove organisation","form.xbutton.remove.multiSelect.beteiligtePersonen":"Remove Person","form.xbutton.remove.multiSelect.weitereOrganisationseinheiten":"Remove Organisational Unit","form.xbutton.remove.multiSelect.mitarbeiter":"Remove collaborator","form.xbutton.remove.multiSelect.antragsteller":"Remove applicant","form.xbutton.remove.multiSelect.veranstalter":"Remove organiser","form.xbutton.remove.multiSelect.foerderer":"Remove funding agency","form.heading.choose_activity":"Please choose an activity type","list.spaltensichtbarkeit":"Columns","menu.aboutme":"My activities","menu.create":"Record activity","menu.create*":"Record activity*","menu.details":"Details","menu.editor":"Editor","menu.list":"List activities","menu.login":"Login","menu.loggedInAs":"Logged in as %{username}","menu.logout":"Logout","menu.report":"Manage Report","menu.start":"Home","menu.imprint":"Legal notice","menu.privacyPolicy":"Privacy","menu.list.public":"Research Activities","menu.list.public.internal":"leuris:Forschungsbericht","menu.list.public.internal.desc":"Insert and edit research activities","menu.list.public.external":"leuris:Portal","menu.list.public.external.desc":"Browse the public research portal","menu.list.public.profile":"My page within the leuris:Portal","menu.list.public.profile.desc":"Show your public research activities","menu.help":"Help","menu.help.faq":"FAQ","menu.help.knownBugs":"Known Bugs","menu.help.videoTutorials":"View leuris video tutorials","menu.help.mostImportantInANutshell":"The Most Important In A Nutshell","menu.language":"Language","menu.language.DE":"German","menu.language.EN":"English","preisBezeichnung.beschreibung.Preis.Kategorie1":"Research Awards","preisBezeichnung.beschreibung.Preis.Kategorie2":"Innovation Awards","preisBezeichnung.beschreibung.Preis.Kategorie3":"Communication Awards","preisBezeichnung.beschreibung.Preis.Kategorie4":"Regional Awards","preisBezeichnung.beschreibung.Preis.Kategorie5":"other Awards / Honours","savedViews.heading":"In Browser saved Searches","savedViews.noneSaved":"No Searches saved yet.","tableSelect.button.close":"Confirm selection","tableSelect.button.create":"Create new","tableSelect.emptyTablePlaceholder.isFetching":"Loading...","tableSelect.emptyTablePlaceholder.noInput":"Start typing to search.","tableSelect.emptyTablePlaceholder.minLength":"Please enter at least three characters.","tableSelect.emptyTablePlaceholder.noResults":"No match found. Please adjust your search.","tableSelect.header.weitereOrganisationseinheiten":"Selection of other Organisational Units","tableSelect.header.veranstalter":"Selection of event organisers","tableSelect.header.author":"Selection of author/s","tableSelect.header.antragsteller":"Select project applicants","tableSelect.header.beteiligtePersonen":"Selection of persons","tableSelect.header.beteiligteOrganisationen":"Selection of external Organisations","tableSelect.header.foerderer":"Selection of types of funding agencies","tableSelect.header.herausgeber":"Selection of editor/s","tableSelect.header.mitarbeiter":"Selection of project collaborator/s","tableSelect.queryString":"Search","tableSelect.selected":"Selection","tag.static.researchActivity":"Research activity","tag.static.printedPageOfPagesLabel":"Printed table page","tag.static.printedPageOfPagesValue":"%{page} of %{totalTablePages}","tag.static.resultCount":"Search results found","tag.static.entriesPerPage":"Max entries per page","toast.login.failed":"Login failed","toast.delete.record":"Record deleted successfully","toast.delete.record.error":"Delete failed due to a conflict","toast.savedView.save":"List settings saved","toast.validation.failed":"Validation failed","toast.session.expired":"Session expired. Please sign in again.","toast.session.will.expired.soon":"Your session will expire soon","tree.loading":"Loading","tree.loading.error":"Failed to fetch organizational units","tree.open":"Open","tree.collapse":"Collapse","warnung.create.abbrechen":"Attention: You discard a recording of an activity.<br><br>If you want to discard this activity, click <b>Continue</b>.","warnung.create.cancel":"Cancel","warnung.create.confirm":"Continue","warnung.create.nachricht":"Attention: You like to change the activity type although your edits are not saved yet. <br><br>If you want to finish editing them, click on <b>Cancel</b>.<br><br>If you want to discard changes to the activity in the editor and record a new activity, click <b>Continue</b>.","warnung.edit.cancel":"Cancel","warnung.edit.confirm":"Continue","warnung.edit.nachricht":"Attention: You are working on an activity.<br><br>If you want to finish editing it, click on <b>Cancel</b>.<br><br>If you want to discard changes to the activity in the editor and edit the selected activity, click <b>Continue</b>.","repeat":"Repeat","upload.heading":"Publication upload","upload.infotext":"<p>\n  Here you can send one or more publication lists for an organisational\n  unit by email. Please note that publication lists will not appear\n  right away in leuris:Forschungsbericht or leuris:Portal. The\n  University Library will first collect and validate all publications\n  before they will be transfered in packages to leuris:Forschungsbericht.\n  Further information, such as the association with a research project,\n  can only be added after the validation.\n</p>\n\n<p>\n  Should you decide to send publications lists please keep in mind\n  the following guidelines:\n</p>\n\n<ul>\n  <li>\n    The library staff can only work with structured format as produced\n    by literature management software (i.e. BibTeX, EndNote, Citavi).\n    Word oder PDF documents will not be accepted.\n  </li>\n  <li>\n    Lists must only contain publications that are not yet available\n    in leuris:Forschungsbericht.\n  </li>\n  <li>\n    Lists must only contain publications that are the result of research\n    at the Leipzig University.\n  </li>\n  <li>\n    At the moment, please allow at least two months for processing,\n    validating, and availability in leuris:Forschungsbericht. We are\n    working on an improved workflow.\n  </li>\n</ul>","upload.linktext":"Send a publication list by e-mail now","Person.list.column.organisationseinheiten":"Organisational units","Person.list.filter.organisationseinheiten":"Organisational units","Person.list.filter.kumuliert":"Include subordinate units","menu.upload":"Publication upload","Forschungsprojekt.form.verbundprpjekt":"Collaborative Research Project","start.headline":"<strong>Welcome to the website of the \"Forschungsbericht\" (Research Report) of Leipzig University.</strong>","start.intro":"In the research report ('Forschungsbericht') you can continually report new research activities or edit existing ones. Data that has already been entered will continue to be accessible and can be updated. The web interface is continually enhanced and the leuris team looks forward to your feedback to <a href=\"mailto:leuris@uni-leipzig.de\">leuris@uni-leipzig.de</a>.","start.help.heading":"Getting Help","start.help":"<span class=\"has-text-weight-bold\">Help</span> to enter research activities and to use our web interface is found in our <a href=\"https://home.uni-leipzig.de/~leuriswiki/doku.php\" target=\"_blank\">Wiki</a> (German):","start.help.intro":"The most important in brief","start.help.faq":"Frequently Asked Questions","start.video.tutorials.text":"You can find out all about how to use leuris at any time in the virtual classroom. Video tutorials in German introduce the different features of leuris: ","start.video.tutorials.link":"leuris video tutorials","start.firstSteps.heading":"First Steps","start.firstSteps":"<p>To avoid unnecessary duplicate work, note, that many details of research activities are already stored in the database. Please use the %{renderedRouterLinkListActivities} function.</p><p>To make it easier for you to search again, you can save the search, filter and table display settings of an activity type and then directly call it from this start page.</p>","start.listSavedViews":"List existing activities","start.addActivity":"Add new activities","start.shortcuts":"Fast access to saved search, filter and table display settings","start.noOU":"Your account has not been assigned to a cost center. Please send an e-mail to the","LeurisProfile.abstract.empty":"Short profile not available.","LeurisProfile.abstract.edit":"Edit short profile","AboutMe.loading":"Loading Data for the selected","AboutMe.toast.clipboard.success":"Link successfully copied to clipboard","AboutMe.toast.clipboard.error":"Link could not be copied to clipboard","AboutMe.filter.jahr":"Year","AboutMe.filter.status":"Status","AboutMe.filter.mittelgeber":"Funding agency","AboutMe.filter.person":"Person","AboutMe.filter.suche":"Search","AboutMe.filter.externalPartner":"Partner","AboutMe.filter.publikationstypen":"Type of Publication","AboutMe.sort.changeOrder":"Change sort order","AboutMe.sort.order.ASC":"Ascending","AboutMe.sort.order.DESC":"Descending","AboutMe.sort.by":"Sort by","AboutMe.sort.titel":"Title","AboutMe.sort.beginn":"Start date","AboutMe.sort.typ":"Type","AboutMe.sort.jahr":"Year","AboutMe.sort.name":"Name","AboutMe.sort.preisTraeger":"Awardee","AboutMe.action.share":"Share link","AboutMe.action.share.default":"Default view","AboutMe.action.share.compact":"Compact view","AboutMe.action.print":"Print","AboutMe.select.reset":"No selection","AboutMe.filter.category.article":"Article","AboutMe.filter.category.monography":"Monography","AboutMe.filter.category.editorship":"Editorship","AboutMe.filter.category.contribution":"Contribution","AboutMe.filter.category.report":"Report","AboutMe.filter.status.ongoing":"Ongoing","AboutMe.filter.status.terminated":"Terminated","AboutMe.toast.select":"Research activity selected as favourite in the leuris profile page","AboutMe.toast.deselect":"Research activity deselected as favourite in the leuris profile page","AboutMe.toast.researchSelectionLimit":"Research selection limit reached on current activity (5/5)","EntityCreateForm.invalid.date.isAtLeastFrom":"The end date can't be earlier than the start date.","Mittelgeber.form.name":"Name","Mittelgeber.form.finSchluessel":"Financing Key","Mittelgeber.list.column.name":"Name","Mittelgeber.list.column.finSchluessel":"Financing Key","Mittelgeber.list.filter.name":"Name","Mittelgeber.list.filter.finSchluessel":"Financing Key","UL Profile Link":"Profile on the Leipzig University Website","Forschungsprojekt.list.column.sdg":"SDGs","tableSelect.header.sdg":"Select project Sustainable Development Goals (SDGs)","Forschungsprojekt.form.sdg":"Sustainable Development Goals (SDGs)","form.xbutton.remove.multiSelect.sdg":"Remove SDG","Sdg.form.tableSelect._id":"ID","Sdg.form.tableSelect._stringRep":"Name","Sdg.Placeholder":"Sustainable Development Goals","Sdg.NoSelection":"No selection","Sdg.Category":"Category","Sdg.Any":"Any goal","Sdg.Biosphere":"Biosphere","Sdg.Society":"Society","Sdg.Economy":"Economy","Sdg.SingleSelection":"Single selection","Sdg.SDG1":"No Poverty","Sdg.SDG2":"Zero hunger","Sdg.SDG3":"Good health and well-being","Sdg.SDG4":"Quality education","Sdg.SDG5":"Gender equality","Sdg.SDG6":"Clean water and sanitation","Sdg.SDG7":"Affordable and clean energy","Sdg.SDG8":"Decent work and economic growth","Sdg.SDG9":"Industry, Innovation, Technology and Infrastructure","Sdg.SDG10":"Reduced inequality","Sdg.SDG11":"Sustainable cities and communities","Sdg.SDG12":"Responsible consumption and production","Sdg.SDG13":"Climate action","Sdg.SDG14":"Life below water","Sdg.SDG15":"Life on land","Sdg.SDG16":"Peace, justice and strong institutions","Sdg.SDG17":"Partnerships for the goals","Public.filter.sdg":"SDG","Public.filter.sdg.any":"Any goal","Public.filter.sdg.biosphere":"Biosphere","Public.filter.sdg.society":"Society","Public.filter.sdg.economy":"Economy","Public.filter.sdg.sdg1":"No Poverty","Public.filter.sdg.sdg2":"Zero hunger","Public.filter.sdg.sdg3":"Good health and well-being","Public.filter.sdg.sdg4":"Quality education","Public.filter.sdg.sdg5":"Gender equality","Public.filter.sdg.sdg6":"Clean water and sanitation","Public.filter.sdg.sdg7":"Affordable and clean energy","Public.filter.sdg.sdg8":"Decent work and economic growth","Public.filter.sdg.sdg9":"Industry, Innovation, Technology and Infrastructure","Public.filter.sdg.sdg10":"Reduced inequality","Public.filter.sdg.sdg11":"Sustainable cities and communities","Public.filter.sdg.sdg12":"Responsible consumption and production","Public.filter.sdg.sdg13":"Climate action","Public.filter.sdg.sdg14":"Life below water","Public.filter.sdg.sdg15":"Life on land","Public.filter.sdg.sdg16":"Peace, justice and strong institutions","Public.filter.sdg.sdg17":"Partnerships for the goals","iso639-2b::aar":"Afar","iso639-2b::abk":"Abkhazian","iso639-2b::ace":"Achinese","iso639-2b::ach":"Acoli","iso639-2b::ada":"Adangme","iso639-2b::ady":"Adyghe","iso639-2b::afa":"Afro-Asiatic languages","iso639-2b::afh":"Afrihili","iso639-2b::afr":"Afrikaans","iso639-2b::ain":"Ainu","iso639-2b::aka":"Akan","iso639-2b::akk":"Akkadian","iso639-2b::alb":"Albanian","iso639-2b::ale":"Aleut","iso639-2b::alg":"Algonquian languages","iso639-2b::alt":"Southern Altai","iso639-2b::amh":"Amharic","iso639-2b::ang":"English, Old","iso639-2b::anp":"Angika","iso639-2b::apa":"Apache languages","iso639-2b::ara":"Arabic","iso639-2b::arc":"Imperial Aramaic","iso639-2b::arg":"Aragonese","iso639-2b::arm":"Armenian","iso639-2b::arn":"Mapuche","iso639-2b::arp":"Arapaho","iso639-2b::art":"Artificial languages","iso639-2b::arw":"Arawak","iso639-2b::asm":"Assamese","iso639-2b::ast":"Asturian","iso639-2b::ath":"Athapascan languages","iso639-2b::aus":"Australian languages","iso639-2b::ava":"Avaric","iso639-2b::ave":"Avestan","iso639-2b::awa":"Awadhi","iso639-2b::aym":"Aymara","iso639-2b::aze":"Azerbaijani","iso639-2b::bad":"Banda languages","iso639-2b::bai":"Bamileke languages","iso639-2b::bak":"Bashkir","iso639-2b::bal":"Baluchi","iso639-2b::bam":"Bambara","iso639-2b::ban":"Balinese","iso639-2b::baq":"Basque","iso639-2b::bas":"Basa","iso639-2b::bat":"Baltic languages","iso639-2b::bej":"Bedawiyet","iso639-2b::bel":"Belarusian","iso639-2b::bem":"Bemba","iso639-2b::ben":"Bengali","iso639-2b::ber":"Berber languages","iso639-2b::bho":"Bhojpuri","iso639-2b::bih":"Bihari languages","iso639-2b::bik":"Bikol","iso639-2b::bin":"Edo","iso639-2b::bis":"Bislama","iso639-2b::bla":"Siksika","iso639-2b::bnt":"Bantu languages","iso639-2b::tib":"Tibetan","iso639-2b::bos":"Bosnian","iso639-2b::bra":"Braj","iso639-2b::bre":"Breton","iso639-2b::btk":"Batak languages","iso639-2b::bua":"Buriat","iso639-2b::bug":"Buginese","iso639-2b::bul":"Bulgarian","iso639-2b::bur":"Burmese","iso639-2b::byn":"Bilin","iso639-2b::cad":"Caddo","iso639-2b::cai":"Central American Indian languages","iso639-2b::car":"Galibi Carib","iso639-2b::cat":"Catalan","iso639-2b::cau":"Caucasian languages","iso639-2b::ceb":"Cebuano","iso639-2b::cel":"Celtic languages","iso639-2b::cze":"Czech","iso639-2b::cha":"Chamorro","iso639-2b::chb":"Chibcha","iso639-2b::che":"Chechen","iso639-2b::chg":"Chagatai","iso639-2b::chi":"Chinese","iso639-2b::chk":"Chuukese","iso639-2b::chm":"Mari","iso639-2b::chn":"Chinook jargon","iso639-2b::cho":"Choctaw","iso639-2b::chp":"Chipewyan","iso639-2b::chr":"Cherokee","iso639-2b::chu":"Church Slavic","iso639-2b::chv":"Chuvash","iso639-2b::chy":"Cheyenne","iso639-2b::cmc":"Chamic languages","iso639-2b::cop":"Coptic","iso639-2b::cor":"Cornish","iso639-2b::cos":"Corsican","iso639-2b::cpe":"English Creoles","iso639-2b::cpf":"French Creoles","iso639-2b::cpp":"Portuguese Creoles","iso639-2b::cre":"Cree","iso639-2b::crh":"Crimean Tatar","iso639-2b::crp":"Creoles and pidgins","iso639-2b::csb":"Kashubian","iso639-2b::cus":"Cushitic languages","iso639-2b::wel":"Welsh","iso639-2b::dak":"Dakota","iso639-2b::dan":"Danish","iso639-2b::dar":"Dargwa","iso639-2b::day":"Land Dayak languages","iso639-2b::del":"Delaware","iso639-2b::den":"Slave (Athapascan)","iso639-2b::ger":"German","iso639-2b::dgr":"Dogrib","iso639-2b::din":"Dinka","iso639-2b::div":"Maldivian","iso639-2b::doi":"Dogri","iso639-2b::dra":"Dravidian languages","iso639-2b::dsb":"Lower Sorbian","iso639-2b::dua":"Duala","iso639-2b::dum":"Dutch, Middle","iso639-2b::dut":"Dutch","iso639-2b::dyu":"Dyula","iso639-2b::dzo":"Dzongkha","iso639-2b::efi":"Efik","iso639-2b::egy":"Egyptian, Ancient","iso639-2b::eka":"Ekajuk","iso639-2b::gre":"Greek, Modern","iso639-2b::elx":"Elamite","iso639-2b::eng":"English","iso639-2b::enm":"English, Middle","iso639-2b::epo":"Esperanto","iso639-2b::est":"Estonian","iso639-2b::ewe":"Ewe","iso639-2b::ewo":"Ewondo","iso639-2b::fan":"Fang","iso639-2b::fao":"Faroese","iso639-2b::per":"Persian","iso639-2b::fat":"Fanti","iso639-2b::fij":"Fijian","iso639-2b::fil":"Filipino","iso639-2b::fin":"Finnish","iso639-2b::fiu":"Finno-Ugrian languages","iso639-2b::fon":"Fon","iso639-2b::fre":"French","iso639-2b::frm":"French, Middle","iso639-2b::fro":"French, Old","iso639-2b::frr":"Northern Frisian","iso639-2b::frs":"Eastern Frisian","iso639-2b::fry":"Western Frisian","iso639-2b::ful":"Fulah","iso639-2b::fur":"Friulian","iso639-2b::gaa":"Ga","iso639-2b::gay":"Gayo","iso639-2b::gba":"Gbaya","iso639-2b::gem":"Germanic languages","iso639-2b::geo":"Georgian","iso639-2b::gez":"Geez","iso639-2b::gil":"Gilbertese","iso639-2b::gla":"Scottish Gaelic","iso639-2b::gle":"Irish","iso639-2b::glg":"Galician","iso639-2b::glv":"Manx","iso639-2b::gmh":"German, Middle High","iso639-2b::goh":"German, Old High","iso639-2b::gon":"Gondi","iso639-2b::gor":"Gorontalo","iso639-2b::got":"Gothic","iso639-2b::grb":"Grebo","iso639-2b::grc":"Greek, Ancient","iso639-2b::grn":"Guarani","iso639-2b::gsw":"Swiss German","iso639-2b::guj":"Gujarati","iso639-2b::gwi":"Gwich'in","iso639-2b::hai":"Haida","iso639-2b::hat":"Haitian Creole","iso639-2b::hau":"Hausa","iso639-2b::haw":"Hawaiian","iso639-2b::heb":"Hebrew","iso639-2b::her":"Herero","iso639-2b::hil":"Hiligaynon","iso639-2b::him":"Himachali languages","iso639-2b::hin":"Hindi","iso639-2b::hit":"Hittite","iso639-2b::hmn":"Hmong","iso639-2b::hmo":"Hiri Motu","iso639-2b::hrv":"Croatian","iso639-2b::hsb":"Upper Sorbian","iso639-2b::hun":"Hungarian","iso639-2b::hup":"Hupa","iso639-2b::iba":"Iban","iso639-2b::ibo":"Igbo","iso639-2b::ice":"Icelandic","iso639-2b::ido":"Ido","iso639-2b::iii":"Sichuan Yi","iso639-2b::ijo":"Ijo languages","iso639-2b::iku":"Inuktitut","iso639-2b::ile":"Interlingue","iso639-2b::ilo":"Iloko","iso639-2b::ina":"Interlingua","iso639-2b::inc":"Indic languages","iso639-2b::ind":"Indonesian","iso639-2b::ine":"Indo-European languages","iso639-2b::inh":"Ingush","iso639-2b::ipk":"Inupiaq","iso639-2b::ira":"Iranian languages","iso639-2b::iro":"Iroquoian languages","iso639-2b::ita":"Italian","iso639-2b::jav":"Javanese","iso639-2b::jbo":"Lojban","iso639-2b::jpn":"Japanese","iso639-2b::jpr":"Judeo-Persian","iso639-2b::jrb":"Judeo-Arabic","iso639-2b::kaa":"Kara-Kalpak","iso639-2b::kab":"Kabyle","iso639-2b::kac":"Kachin","iso639-2b::kal":"Greenlandic","iso639-2b::kam":"Kamba","iso639-2b::kan":"Kannada","iso639-2b::kar":"Karen languages","iso639-2b::kas":"Kashmiri","iso639-2b::kau":"Kanuri","iso639-2b::kaw":"Kawi","iso639-2b::kaz":"Kazakh","iso639-2b::kbd":"Kabardian","iso639-2b::kha":"Khasi","iso639-2b::khi":"Khoisan languages","iso639-2b::khm":"Central Khmer","iso639-2b::kho":"Sakan","iso639-2b::kik":"Kikuyu","iso639-2b::kin":"Kinyarwanda","iso639-2b::kir":"Kyrgyz","iso639-2b::kmb":"Kimbundu","iso639-2b::kok":"Konkani","iso639-2b::kom":"Komi","iso639-2b::kon":"Kongo","iso639-2b::kor":"Korean","iso639-2b::kos":"Kosraean","iso639-2b::kpe":"Kpelle","iso639-2b::krc":"Karachay-Balkar","iso639-2b::krl":"Karelian","iso639-2b::kro":"Kru languages","iso639-2b::kru":"Kurukh","iso639-2b::kua":"Kwanyama","iso639-2b::kum":"Kumyk","iso639-2b::kur":"Kurdish","iso639-2b::kut":"Kutenai","iso639-2b::lad":"Ladino","iso639-2b::lah":"Lahnda","iso639-2b::lam":"Lamba","iso639-2b::lao":"Lao","iso639-2b::lat":"Latin","iso639-2b::lav":"Latvian","iso639-2b::lez":"Lezghian","iso639-2b::lim":"Limburgish","iso639-2b::lin":"Lingala","iso639-2b::lit":"Lithuanian","iso639-2b::lol":"Mongo","iso639-2b::loz":"Lozi","iso639-2b::ltz":"Luxembourgish","iso639-2b::lua":"Luba-Lulua","iso639-2b::lub":"Luba-Katanga","iso639-2b::lug":"Ganda","iso639-2b::lui":"Luiseno","iso639-2b::lun":"Lunda","iso639-2b::luo":"Luo","iso639-2b::lus":"Lushai","iso639-2b::mac":"Macedonian","iso639-2b::mad":"Madurese","iso639-2b::mag":"Magahi","iso639-2b::mah":"Marshallese","iso639-2b::mai":"Maithili","iso639-2b::mak":"Makasar","iso639-2b::mal":"Malayalam","iso639-2b::man":"Mandingo","iso639-2b::mao":"Maori","iso639-2b::map":"Austronesian languages","iso639-2b::mar":"Marathi","iso639-2b::mas":"Masai","iso639-2b::may":"Malay","iso639-2b::mdf":"Moksha","iso639-2b::mdr":"Mandar","iso639-2b::men":"Mende","iso639-2b::mga":"Irish, Middle","iso639-2b::mic":"Micmac","iso639-2b::min":"Minangkabau","iso639-2b::mis":"Uncoded languages","iso639-2b::mkh":"Mon-Khmer languages","iso639-2b::mlg":"Malagasy","iso639-2b::mlt":"Maltese","iso639-2b::mnc":"Manchu","iso639-2b::mni":"Manipuri","iso639-2b::mno":"Manobo languages","iso639-2b::moh":"Mohawk","iso639-2b::mon":"Mongolian","iso639-2b::mos":"Mossi","iso639-2b::mul":"Multiple languages","iso639-2b::mun":"Munda languages","iso639-2b::mus":"Creek","iso639-2b::mwl":"Mirandese","iso639-2b::mwr":"Marwari","iso639-2b::myn":"Mayan languages","iso639-2b::myv":"Erzya","iso639-2b::nah":"Nahuatl languages","iso639-2b::nai":"North American Indian languages","iso639-2b::nap":"Neapolitan","iso639-2b::nau":"Nauru","iso639-2b::nav":"Navajo","iso639-2b::nbl":"South Ndebele","iso639-2b::nde":"North Ndebele","iso639-2b::ndo":"Ndonga","iso639-2b::nds":"Low German","iso639-2b::nep":"Nepali","iso639-2b::new":"Newari","iso639-2b::nia":"Nias","iso639-2b::nic":"Niger-Kordofanian languages","iso639-2b::niu":"Niuean","iso639-2b::nno":"Norwegian Nynorsk","iso639-2b::nob":"Norwegian Bokmål","iso639-2b::nog":"Nogai","iso639-2b::non":"Norse, Old","iso639-2b::nor":"Norwegian","iso639-2b::nqo":"N'Ko","iso639-2b::nso":"Pedi","iso639-2b::nub":"Nubian languages","iso639-2b::nwc":"Old Newari","iso639-2b::nya":"Nyanja","iso639-2b::nym":"Nyamwezi","iso639-2b::nyn":"Nyankole","iso639-2b::nyo":"Nyoro","iso639-2b::nzi":"Nzima","iso639-2b::oci":"Occitan","iso639-2b::oji":"Ojibwa","iso639-2b::ori":"Oriya","iso639-2b::orm":"Oromo","iso639-2b::osa":"Osage","iso639-2b::oss":"Ossetian","iso639-2b::ota":"Ottoman","iso639-2b::oto":"Otomian languages","iso639-2b::paa":"Papuan languages","iso639-2b::pag":"Pangasinan","iso639-2b::pal":"Pahlavi","iso639-2b::pam":"Pampanga","iso639-2b::pan":"Panjabi","iso639-2b::pap":"Papiamento","iso639-2b::pau":"Palauan","iso639-2b::peo":"Persian, Old","iso639-2b::phi":"Philippine languages","iso639-2b::phn":"Phoenician","iso639-2b::pli":"Pali","iso639-2b::pol":"Polish","iso639-2b::pon":"Pohnpeian","iso639-2b::por":"Portuguese","iso639-2b::pra":"Prakrit languages","iso639-2b::pro":"Occitan, Old","iso639-2b::pus":"Pashto","iso639-2b::que":"Quechua","iso639-2b::raj":"Rajasthani","iso639-2b::rap":"Rapanui","iso639-2b::rar":"Rarotongan","iso639-2b::roa":"Romance languages","iso639-2b::roh":"Romansh","iso639-2b::rom":"Romany","iso639-2b::rum":"Romanian","iso639-2b::run":"Rundi","iso639-2b::rup":"Arumanian","iso639-2b::rus":"Russian","iso639-2b::sad":"Sandawe","iso639-2b::sag":"Sango","iso639-2b::sah":"Yakut","iso639-2b::sai":"South American Indian languages","iso639-2b::sal":"Salishan languages","iso639-2b::sam":"Samaritan Aramaic","iso639-2b::san":"Sanskrit","iso639-2b::sas":"Sasak","iso639-2b::sat":"Santali","iso639-2b::scn":"Sicilian","iso639-2b::sco":"Scots","iso639-2b::sel":"Selkup","iso639-2b::sem":"Semitic languages","iso639-2b::sga":"Irish, Old","iso639-2b::sgn":"Sign Languages","iso639-2b::shn":"Shan","iso639-2b::sid":"Sidamo","iso639-2b::sin":"Sinhalese","iso639-2b::sio":"Siouan languages","iso639-2b::sit":"Sino-Tibetan languages","iso639-2b::sla":"Slavic languages","iso639-2b::slo":"Slovak","iso639-2b::slv":"Slovenian","iso639-2b::sma":"Southern Sami","iso639-2b::sme":"Northern Sami","iso639-2b::smi":"Sami languages","iso639-2b::smj":"Lule Sami","iso639-2b::smn":"Inari Sami","iso639-2b::smo":"Samoan","iso639-2b::sms":"Skolt Sami","iso639-2b::sna":"Shona","iso639-2b::snd":"Sindhi","iso639-2b::snk":"Soninke","iso639-2b::sog":"Sogdian","iso639-2b::som":"Somali","iso639-2b::son":"Songhai languages","iso639-2b::sot":"Sotho, Southern","iso639-2b::spa":"Spanish","iso639-2b::srd":"Sardinian","iso639-2b::srn":"Sranan Tongo","iso639-2b::srp":"Serbian","iso639-2b::srr":"Serer","iso639-2b::ssa":"Nilo-Saharan languages","iso639-2b::ssw":"Swati","iso639-2b::suk":"Sukuma","iso639-2b::sun":"Sundanese","iso639-2b::sus":"Susu","iso639-2b::sux":"Sumerian","iso639-2b::swa":"Swahili","iso639-2b::swe":"Swedish","iso639-2b::syc":"Classical Syriac","iso639-2b::syr":"Syriac","iso639-2b::tah":"Tahitian","iso639-2b::tai":"Tai languages","iso639-2b::tam":"Tamil","iso639-2b::tat":"Tatar","iso639-2b::tel":"Telugu","iso639-2b::tem":"Timne","iso639-2b::ter":"Tereno","iso639-2b::tet":"Tetum","iso639-2b::tgk":"Tajik","iso639-2b::tgl":"Tagalog","iso639-2b::tha":"Thai","iso639-2b::tig":"Tigre","iso639-2b::tir":"Tigrinya","iso639-2b::tiv":"Tiv","iso639-2b::tkl":"Tokelau","iso639-2b::tlh":"Klingon","iso639-2b::tli":"Tlingit","iso639-2b::tmh":"Tamashek","iso639-2b::tog":"Tonga (Nyasa)","iso639-2b::ton":"Tongan","iso639-2b::tpi":"Tok Pisin","iso639-2b::tsi":"Tsimshian","iso639-2b::tsn":"Tswana","iso639-2b::tso":"Tsonga","iso639-2b::tuk":"Turkmen","iso639-2b::tum":"Tumbuka","iso639-2b::tup":"Tupi languages","iso639-2b::tur":"Turkish","iso639-2b::tut":"Altaic languages","iso639-2b::tvl":"Tuvalu","iso639-2b::twi":"Twi","iso639-2b::tyv":"Tuvinian","iso639-2b::udm":"Udmurt","iso639-2b::uga":"Ugaritic","iso639-2b::uig":"Uighur","iso639-2b::ukr":"Ukrainian","iso639-2b::umb":"Umbundu","iso639-2b::und":"Undetermined","iso639-2b::urd":"Urdu","iso639-2b::uzb":"Uzbek","iso639-2b::vai":"Vai","iso639-2b::ven":"Venda","iso639-2b::vie":"Vietnamese","iso639-2b::vol":"Volapük","iso639-2b::vot":"Votic","iso639-2b::wak":"Wakashan languages","iso639-2b::wal":"Wolaitta","iso639-2b::war":"Waray","iso639-2b::was":"Washo","iso639-2b::wen":"Sorbian languages","iso639-2b::wln":"Walloon","iso639-2b::wol":"Wolof","iso639-2b::xal":"Kalmyk","iso639-2b::xho":"Xhosa","iso639-2b::yao":"Yao","iso639-2b::yap":"Yapese","iso639-2b::yid":"Yiddish","iso639-2b::yor":"Yoruba","iso639-2b::ypk":"Yupik languages","iso639-2b::zap":"Zapotec","iso639-2b::zbl":"Blissymbols","iso639-2b::zen":"Zenaga","iso639-2b::zgh":"Tamazight","iso639-2b::zha":"Zhuang","iso639-2b::znd":"Zande languages","iso639-2b::zul":"Zulu","iso639-2b::zun":"Zuni","iso639-2b::zxx":"No linguistic content","iso639-2b::zza":"Zazaki"}}

/***/ }),

/***/ "FBWx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree"},[(_vm.isLoading && !_vm.error)?_c('div',[_c('translate',[_vm._v("tree.loading")]),_vm._v("...")],1):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"columns is-multiline is-centered"},[_c('b-icon',{staticClass:"column",staticStyle:{"max-width":"0.5rem"},attrs:{"pack":"fa","icon":"exclamation"}}),_vm._v(" "),_c('translate',{staticClass:"column is-italic",staticStyle:{"flex":"none"}},[_vm._v("tree.loading.error")]),_vm._v(" "),_c('b-tooltip',{attrs:{"label":_vm.$gettext('repeat'),"position":"is-top"}},[_c('a',{staticClass:"button column",staticStyle:{"border":"0px","background-color":"transparent"},on:{"click":_vm.loadAsyncData}},[_c('b-icon',{attrs:{"pack":"fa","icon":"repeat"}})],1)])],1):_vm._e(),_vm._v(" "),(!_vm.isLoading && !_vm.error)?_c('div',[_c('ul',{attrs:{"id":"demo"}},[_c('fob-tree-item',{staticClass:"item",attrs:{"isOpen":true,"model":_vm.rootData}})],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FJN/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Welcome_vue__ = __webpack_require__("XbJz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03d08ccd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Welcome_vue__ = __webpack_require__("QVvY");
function injectStyle (ssrContext) {
  __webpack_require__("YFGe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Welcome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03d08ccd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Welcome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FKis":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAuthorized && _vm.userActiveViewState !== 1)?_c('aside',{staticClass:"menu",staticStyle:{"width":"230px"}},[_c('ul',{staticClass:"menu-list",class:{ 'fob-menu-is-disabled': !_vm.userHasOrga }},[_c('li',{staticClass:"orga-select",on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"escape",undefined,$event.key,undefined)){ return null; }return _vm.closeOrgaSelect($event)}}},[(_vm.userIsAuthorized && _vm.userOrgas.length > 0)?_c('b-dropdown',{ref:"orgaselect",model:{value:(_vm.activeOrga),callback:function ($$v) {_vm.activeOrga=$$v},expression:"activeOrga"}},[_c('button',{staticClass:"button is-basalt",attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',[_c('div',[_vm._v("\n                  "+_vm._s(_vm.userOrgas[_vm.activeOrga].name)+"\n                ")])]),_vm._v(" "),_c('b-icon',{attrs:{"type":"is-small","icon":"angle-right"}})],1),_vm._v(" "),_vm._l((_vm.userOrgas),function(orga,i){return _c('b-dropdown-item',{key:orga.kst,attrs:{"value":i}},[_c('div',{staticClass:"media",attrs:{"tabindex":"0"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return (function () { return _vm.selectOrga(i); })($event)}}},[_c('div',{staticClass:"media-content"},[_c('h3',[_vm._v(_vm._s(orga.name))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(orga.parentName))])])])])})],2):_vm._e()],1),_vm._v(" "),_vm._l((_vm.menu),function(item,i){return _c('li',{key:i,class:{ 'fob-menu-item-is-disabled': item.disabled }},[_c('router-link',{class:item.classes || [],attrs:{"exact":item.exact,"to":item.link}},[(item.icon)?_c('span',{staticClass:"icon"},[_c('i',{class:item.icon})]):_vm._e(),_vm._v(" "),_c('translate',[_vm._v(_vm._s(item.name))]),_vm._v(_vm._s(item.marked ? '*' : '')+"\n        ")],1)],1)})],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FXe8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fob-about-me"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"level"},[_c('div',{staticClass:"level-left"},[(_vm.isLoading)?_c('div',{staticClass:"is-size-5",staticStyle:{"margin-bottom":"10px","font-style":"italic","font-variant":"small-caps"}},[_c('translate',[_vm._v("AboutMe.loading")])],1):_c('div',{staticClass:"fob-aboutme-heading is-size-5",staticStyle:{"max-width":"840px"}},[_c('div',[_c('span',{staticClass:"fob-aboutme-heading-label",staticStyle:{"font-weight":"bold","font-variant":"small-caps","margin-bottom":"10px"}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('span',[_vm._v("("+_vm._s(_vm.leurisProfileFisPersid)+")")])]),_vm._v(" "),_c('span',{staticClass:"fob-only-for-print-view is-size-7"},[_c('translate',[_vm._v(_vm._s(_vm.activeResource.label))])],1)])]),_vm._v(" "),_c('div',{staticClass:"level-right fob-hide-in-print"},[_c('fob-aboutme-list-quick-actions',{attrs:{"qa-share":true,"qa-share-compact-view":true,"qa-print":true}})],1)]),_vm._v(" "),(_vm.leurisProfile || _vm.leurisProfileFisPersid)?_c('div',{staticClass:"leurisProfile fob-hide-in-print",staticStyle:{"margin-bottom":"2rem","padding":"0 8rem 0 2rem","border-left":"3px solid rgb(138, 193, 208)"}},[(_vm.leurisProfile)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.leurisProfile.abstract[_vm.currentLocale])}}):_vm._e(),_vm._v(" "),(_vm.userIsLoggedIn && (_vm.leurisProfileFisPersid === _vm.userFisPersid))?[(_vm.leurisProfile == null || (_vm.leurisProfile && !_vm.leurisProfile.abstract[_vm.currentLocale]))?_c('div',[_c('em',[_c('translate',[_vm._v("LeurisProfile.abstract.empty")])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"1rem 0 1rem 0"}},[_c('b-icon',{staticStyle:{"margin-right":"0.25rem"},attrs:{"icon":"pencil","size":"is-small"}}),_vm._v(" "),_c('a',{attrs:{"href":(_vm.leurisProfileBaseUrl + "/" + _vm.leurisProfileFisPersid + "/drafts/abstract")}},[_c('translate',[_vm._v("LeurisProfile.abstract.edit")])],1)],1)]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card",staticStyle:{"opacity":"0.95"}},[_c('b-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},_vm._l((_vm.resourceTypes),function(resourceType){return _c('b-tab-item',{key:resourceType.type,staticStyle:{"flex":"0 0 auto"},attrs:{"disabled":resourceType.disabled}},[_c('template',{slot:"header"},[_c('span',{class:{'fob-is-filtered': _vm.hasActiveFilter(resourceType.type)}},[_c('translate',[_vm._v(_vm._s(resourceType.label))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(("(" + (_vm.total[resourceType.type]) + ")")))])],1)]),_vm._v(" "),(!resourceType.disabled)?_c('div',[_c('fob-aboutme-list-view',{staticStyle:{"height":"100%"},attrs:{"resource-type":resourceType.type}})],1):_vm._e()],2)}))],1)])]),_vm._v(" "),_c('div',{staticClass:"print-footer"},[_c('span',[_c('translate',{attrs:{"translate-params":{printDate: _vm.printDate}}},[_vm._v("details.printedOn")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FYuD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fq9t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FxIa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FyeQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityCompact_vue__ = __webpack_require__("4Dw1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bfd81eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityCompact_vue__ = __webpack_require__("0BjP");
function injectStyle (ssrContext) {
  __webpack_require__("eM7q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityCompact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bfd81eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityCompact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G9OK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showLabel)?_c('fob-label',{attrs:{"label":_vm.schema.label,"asterisk":_vm.asterisk}},[(!_vm.schema.onlyCreate && !_vm.deactivated)?_c('button',{staticClass:"multi-select-edit-btn",on:{"click":_vm.showTableSelect}},[_c('translate',[_vm._v("form.editlink")])],1):_vm._e(),_vm._v(" "),(_vm.type === 'is-danger')?_c('b-icon',{attrs:{"icon":"exclamation-circle","type":"is-danger"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.resourceData && _vm.resourceData.length > 0)?_c('div',[(_vm.draggable && !_vm.deactivated)?_c('div',[_c('draggable',{attrs:{"options":{ draggable: '.fob-tag', filter: 'button'}},model:{value:(_vm.resourceData),callback:function ($$v) {_vm.resourceData=$$v},expression:"resourceData"}},[_vm._l((_vm.resourceData),function(item,i){return [_c('div',{key:i,staticClass:"fob-tag"},[_c('b-field',[_c('div',{staticClass:"box control fob-tag-text fob-draggable",attrs:{"expanded":""}},[_c('b-icon',{attrs:{"type":"is-lightgray","icon":_vm.schema.icon}}),_vm._v(" "),_c('fob-entity-decorator',{attrs:{"resourceData":item}},[_vm._v("\n                  "+_vm._s(item._stringRep)+"\n                ")])],1),_vm._v(" "),_c('b-tooltip',{attrs:{"square":"","position":"is-top","label":_vm.$gettext(("form.xbutton.remove.multiSelect." + (_vm.schema.field)))}},[_c('button',{staticClass:"control button is-aquamarine",staticStyle:{"margin-left":"12px","margin-top":"0px"},attrs:{"control":""},on:{"click":function($event){_vm.dropRow(item._id)}}},[_c('b-icon',{attrs:{"icon":"times","size":"is-small"}})],1)])],1)],1)]})],2)],1):_c('div',[_vm._l((_vm.resourceData),function(item,i){return [_c('div',{key:i,staticClass:"fob-tag",class:{'fob-tag-deactivated': _vm.deactivated}},[_c('b-field',[_c('div',{staticClass:"box control fob-tag-text fob-undraggable",attrs:{"expanded":""}},[_c('b-icon',{attrs:{"type":"is-lightgray","icon":_vm.schema.icon}}),_vm._v(" "),_c('fob-entity-decorator',{attrs:{"resourceData":item}},[_vm._v("\n                "+_vm._s(item._stringRep)+"\n              ")])],1),_vm._v(" "),(!_vm.deactivated)?_c('b-tooltip',{attrs:{"square":"","position":"is-top","label":_vm.$gettext(("form.xbutton.remove.multiSelect." + (_vm.schema.field)))}},[_c('button',{staticClass:"control button is-aquamarine",staticStyle:{"margin-left":"12px","margin-top":"0px"},attrs:{"control":""},on:{"click":function($event){_vm.dropRow(item._id)}}},[_c('b-icon',{attrs:{"icon":"times","size":"is-small"}})],1)]):_vm._e()],1)],1)]})],2)]):_vm._e(),_vm._v(" "),(!_vm.deactivated)?_c('b-modal',{attrs:{"active":_vm.tableSelectVisible,"canCancel":true,"width":"1440","has-modal-card":""},on:{"update:active":function($event){_vm.tableSelectVisible=$event}}},[_c('fob-entity-table-select',{attrs:{"route":_vm.schema.schema.className,"method":_vm.schema.finder,"field":_vm.schema.field,"icon":_vm.schema.icon,"schema":_vm.schema.schema,"allowCreate":_vm.schema.allowCreate},model:{value:(_vm.resourceData),callback:function ($$v) {_vm.resourceData=$$v},expression:"resourceData"}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GKHd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFieldsGeneric__ = __webpack_require__("K13K");

var ListFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ListFieldsGeneric__["a" /* default */])('Veranstaltung');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Veranstaltung',
  route: 'veranstaltung',
  className: 'veranstaltung',
  fields: [ListFields.SortableTimestamp('_updateDate', false, 'updateDate', true), ListFields.SortableTimestamp('_createDate', false, 'createDate', true), ListFields.SortableReference('organisationseinheit', true), ListFields.UnsortableReference('weitereOrganisationseinheiten', false), ListFields.SortableField('name', true), ListFields.SortableField('veranstaltungsTyp', true), ListFields.UnsortableReference('veranstalter', false), ListFields.SortableDate('veranstaltungStart', true), ListFields.SortableDate('veranstaltungEnde', true), ListFields.SortableField('stadt', false), ListFields.SortableReference('land', false), ListFields.SortableBoolean('virtuell', false)]
});

/***/ }),

/***/ "GcbJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchStaffQuery; });
function fetchStaffQuery(_ref) {
  var startsWith = _ref.startsWith,
      pageSize = _ref.pageSize,
      page = _ref.page,
      filter = _ref.filter;

  var variables = {
    pageSize: Number(pageSize) || 100,
    page: Number(page) || 1,
    startsWith: startsWith || '',
    filterFullName: filter.fullName || ''
  };

  if (filter && filter.organisationalUnit && Number(filter.organisationalUnit)) {
    variables['filterOrganisationalUnit'] = Number(filter.organisationalUnit);
  }

  return {
    operationName: 'fetchStaffQuery',
    query: '\n      query fetchStaffQuery($startsWith:String!, $filterFullName:String, $filterOrganisationalUnit:Int, $pageSize:Int, $page:Int) {\n        staff(filter: {organisationalUnit: $filterOrganisationalUnit, fullName: $filterFullName}, startsWith: $startsWith, pageSize: $pageSize, page: $page, sortOrder: ASC, orderBy: SURNAME) {\n          meta {\n            totalEntries\n            decompositions {\n              letterCount:groups {\n                count\n                name\n              }\n            }\n          }\n          entries {\n            ... on Person {\n              id:fisPersid\n              label:_stringRep\n              titel:title\n              vorname:givenName\n              name:surname\n              organisationseinheiten:organisationalUnits {\n                titelDe:titleDe\n              }\n            }\n          }\n        }\n      }\n    ',
    variables: variables
  };
}



/***/ }),

/***/ "GfOp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__("0xDb");


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isInvalid: true,
      showErrors: false
    };
  },

  methods: {
    requestSave: function requestSave() {
      if (this.isInvalid) {
        this.showErrors = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* ToastError */])(this.$gettext('toast.validation.failed'));
      } else {
        this.save();
      }
    },
    saveAndDispatch: function saveAndDispatch(action) {
      var _this = this;

      return this.$store.dispatch(action).then(function (data) {
        var type = data._entityName.split('.').splice(-1)[0].toLowerCase();
        var id = data._id;
        _this.$router.push({
          name: 'anzeigen_einzeln',
          params: {
            resourceType: type,
            resourceId: id
          }
        });
      });
    }
  }
});

/***/ }),

/***/ "Gnij":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',{staticClass:"fob-hide-in-print",staticStyle:{"padding":"1rem"},attrs:{"grouped":""}},[_c('b-field',{attrs:{"expanded":""}},[_c('b-pagination',{staticClass:"control fob-hide-in-print",staticStyle:{"padding-right":"1rem"},attrs:{"per-page":_vm.perPage,"current":_vm.page,"total":_vm.total},on:{"update:current":_vm.onChangePageByPagination}})],1),_vm._v(" "),_c('b-tooltip',{staticClass:"setCurrentPageManually",attrs:{"label":_vm.$gettext('Pagination.jumpToPage')}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentPage),expression:"currentPage"}],staticClass:"input is-primary",style:({ 'margin-right': !_vm.disableSwitch ? '1rem' : '' }),attrs:{"placeholder":_vm.$gettext('page'),"autocomplete":"off","type":"text"},domProps:{"value":(_vm.currentPage)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.currentPage=$event.target.value},_vm.onChangePageManually]}})]),_vm._v(" "),(!_vm.disableSwitch)?_c('b-tooltip',{attrs:{"label":_vm.$gettext('list.button.compactView')}},[_c('b-switch',{staticClass:"fob-hide-in-print control",staticStyle:{"margin-bottom":"0.7rem"},model:{value:(_vm.isCompact),callback:function ($$v) {_vm.isCompact=$$v},expression:"isCompact"}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Go2m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__ = __webpack_require__("cigy");

var Filter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__["a" /* default */])('Preis');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Preis',
  route: 'preis',
  fields: [Filter.ReferenceByMultiValueSearchRep('organisationseinheit', 'sitemap', 'organisationseinheit'), Filter.kumuliert(), Filter.Number('verleihungsJahr', 'calendar-o'), Filter.ReferenceByMultiValueSearchRep('preisTraeger', 'user', 'abstractPerson'), Filter.String('namePreis'), Filter.ReferenceBySearchRep('preisBezeichnung', 'folder-open'), {
    label: 'Preis.list.filter.hatPreisgeld',
    field: 'hatPreisgeld',
    type: 'select',
    translatable: true,
    values: [{
      value: 'TRUE',
      label: 'Preis.hatPreisgeld.TRUE'
    }, {
      value: 'FALSE',
      label: 'Preis.hatPreisgeld.FALSE'
    }, {
      value: null,
      label: ''
    }]
  }]
});

/***/ }),

/***/ "H7Yy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schema_Selection__ = __webpack_require__("0r7M");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value'],
  computed: {
    resourceType: {
      get: function get() {
        return this.value;
      },
      set: function set(v) {
        this.$emit('input', v);
      }
    },
    selection: function selection() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__schema_Selection__["a" /* default */])(this.$store.getters['user/getUser']);
    },
    hasSelectionGroups: function hasSelectionGroups() {
      return this.selection.filter(function (x) {
        return x.entities.length > 0;
      }).filter(function (x) {
        return x.label !== '__editable';
      }).length > 1;
    },
    nonEmptySelectionGroups: function nonEmptySelectionGroups() {
      return this.selection.filter(function (x) {
        return x.entities.length > 0;
      }).filter(function (x) {
        return x.label !== '__editable';
      });
    }
  },
  methods: {
    setSelection: function setSelection(v) {
      if (this.hasSelectionGroups) {
        this.$refs.groupSelector.selected = v;
      } else {
        this.$refs.plainSelector.selected = v;
      }
    }
  }
});

/***/ }),

/***/ "H80q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-card",staticStyle:{"width":"960px"}},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_c('translate',[_vm._v("tableSelect.header."+_vm._s(_vm.field))])],1)]),_vm._v(" "),_c('section',{staticClass:"modal-card-body"},[_c('b-field',{attrs:{"label":_vm.$gettext('tableSelect.queryString')}},[_c('b-input',{ref:"input",attrs:{"icon":_vm.icon,"value":"","placeholder":"Start typing..."},on:{"input":_vm.queryForTable},model:{value:(_vm.tableQuery),callback:function ($$v) {_vm.tableQuery=$$v},expression:"tableQuery"}})],1),_vm._v(" "),_c('b-table',{attrs:{"narrowed":"","paginated":true,"per-page":5,"loading":_vm.isFetching,"data":_vm.filteredTableContent},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b-table-column',{attrs:{"label":"","width":"40"}},[_c('a',{staticClass:"is-primary",on:{"click":function($event){_vm.selectRow(props.row._id)}}},[_c('b-icon',{attrs:{"size":"is-small","icon":"plus"}})],1)]),_vm._v(" "),_vm._l((_vm.tableColumns),function(col,i){return _c('b-table-column',{key:i,attrs:{"label":_vm.$gettext((_vm.entityName + ".form.tableSelect." + (col.label))),"width":col.width}},[(col.field === '_stringRep')?[_c('fob-entity-decorator',{attrs:{"resourceData":props.row}},[_vm._v("\n              "+_vm._s(props.row[col.field])+"\n            ")])]:[_vm._v("\n            "+_vm._s(props.row[col.field])+"\n          ")]],2)})]}}])},[_c('template',{slot:"empty"},[_c('section',{staticClass:"section"},[_c('div',{staticClass:"content has-text-grey has-text-centered"},[_c('p',[_c('b-icon',{attrs:{"icon":"exclamation","size":"is-large"}})],1),_vm._v(" "),(_vm.isFetching)?[_c('translate',[_vm._v("tableSelect.emptyTablePlaceholder.isFetching")])]:(_vm.tableQuery.length === 0)?[_c('translate',[_vm._v("tableSelect.emptyTablePlaceholder.noInput")])]:(_vm.tableQuery.length > 0 && _vm.tableQuery.length < _vm.method.minLength)?[_c('translate',[_vm._v("tableSelect.emptyTablePlaceholder.minLength")])]:(_vm.tableQuery.length >= _vm.method.minLength)?[_c('p',[_c('translate',[_vm._v("tableSelect.emptyTablePlaceholder.noResults")])],1)]:_vm._e()],2)])])],2),_vm._v(" "),_c('h3',{staticClass:"is-size-6",staticStyle:{"margin-top":"20px"}},[_c('strong',[_c('translate',[_vm._v("tableSelect.selected")])],1)]),_vm._v(" "),_c('div',{staticStyle:{"height":"300px","overflow-y":"scroll","overflow-x":"hidden"}},[_c('table',{staticClass:"table is-narrow has-mobile-cards",staticStyle:{"width":"100%"}},[_c('thead',[_c('tr',{staticClass:"is-unselectable"},[_c('th',{staticStyle:{"width":"40px"}}),_vm._v(" "),_vm._l((_vm.tableColumns),function(col,i){return _c('th',{key:i,style:({ width: col.width + 'px' })},[_c('translate',[_vm._v(_vm._s((_vm.entityName + ".form.tableSelect." + (col.label))))])],1)})],2)]),_vm._v(" "),_c('draggable',{attrs:{"element":'tbody',"options":{
            draggable: 'tr',
            filter: '.delete-icon'
          }},on:{"change":function($event){_vm.$emit('input', _vm.selectedContent)}},model:{value:(_vm.selectedContent),callback:function ($$v) {_vm.selectedContent=$$v},expression:"selectedContent"}},_vm._l((_vm.selectedContent),function(line,i){return _c('tr',{key:i},[_c('td',{staticClass:"delete-icon",staticStyle:{"width":"40px"}},[_c('a',{staticClass:"is-primary",on:{"click":function($event){_vm.dropRow(line._id)}}},[_c('b-icon',{attrs:{"type":"is-carnelian","size":"is-small","icon":"minus"}})],1)]),_vm._v(" "),_vm._l((_vm.tableColumns),function(col,i){return _c('td',{key:i,staticStyle:{"cursor":"move"}},[(col.field === '_stringRep')?[_c('fob-entity-decorator',{attrs:{"resourceData":line}},[_vm._v("\n                    "+_vm._s(line[col.field])+"\n                  ")])]:[_vm._v("\n                  "+_vm._s(line[col.field])+"\n                ")]],2)})],2)}))],1)])],1),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('button',{staticClass:"button is-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.$parent.close()}}},[_c('translate',[_vm._v("tableSelect.button.close")])],1),_vm._v(" "),(_vm.allowCreate)?_c('button',{staticClass:"button",attrs:{"type":"button"},on:{"click":_vm.prepareCreation}},[_c('translate',[_vm._v("tableSelect.button.create")])],1):_vm._e()]),_vm._v(" "),_c('fob-entity-create-modal',{attrs:{"active":_vm.showCreateModal,"schema":_vm.schema,"field":_vm.field},on:{"update:active":function($event){_vm.showCreateModal=$event},"submit":_vm.submitCreated},model:{value:(_vm.created),callback:function ($$v) {_vm.created=$$v},expression:"created"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HCTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mixins_DateTimeHelper__ = __webpack_require__("5W2G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mixins_PublicViewHelper__ = __webpack_require__("VlMm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_ExternalLinkProvider__ = __webpack_require__("1/AK");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-header',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_mixins_DateTimeHelper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__components_mixins_PublicViewHelper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__components_mixins_ExternalLinkProvider__["a" /* default */]],
  data: function data() {
    return {
      userAction: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    'userLogout': 'user/logout'
  }), {
    triggerUserLogout: function triggerUserLogout() {
      var _this = this;

      this.userLogout().then(function () {
        return _this.$router.push('/login');
      });
    },
    onActiveViewChange: function onActiveViewChange(activeViewItem) {
      if (activeViewItem.id === 'profile') {
        activeViewItem.route.params.id = this.userFisPersid;
      } else if (activeViewItem.id === 'external') {
        activeViewItem.route.params = this.toCurrentRoute.params;
      }
      this.$router.replace(activeViewItem.route);
    },
    showActiveViewItem: function showActiveViewItem(activeViewItem) {
      // show by default all view items
      // expection: profile -> check if user is a researcher then show view item else not
      return activeViewItem.id !== 'profile' || this.userResearcher;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    userOrgas: 'user/orgas',
    username: 'user/name',
    userFisPersid: 'user/fisPersid',
    userIsAuthorized: 'user/isAuthorized',
    userResearcher: 'user/researcher',
    userActiveViewStates: 'user/activeViewStates',
    publicViewSelected: 'publicView/getSelected',
    version: 'getVersion'
  }), {
    activeOrga: {
      get: function get() {
        return this.$store.getters['user/activeOrga'];
      },
      set: function set(value) {
        this.$store.dispatch('user/changeOrga', value);
        this.$router.push({ name: 'start' });
      }
    },
    userActiveViewState: {
      get: function get() {
        return this.$store.getters['user/activeViewState'];
      },
      set: function set(id) {
        this.$store.dispatch('user/activeViewState', id);
      }
    },
    onLoginPage: function onLoginPage() {
      return this.$route.name === 'login';
    }
  })
});

/***/ }),

/***/ "HJ35":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",staticStyle:{"width":"600px"}},[_c('div',[_c('p',{staticClass:"is-size-5 has-text-weight-bold"},[_c('translate',[_vm._v("savedViews.heading")])],1)]),_vm._v(" "),(_vm.savedViews.length > 0)?_vm._l((_vm.allGroups),function(group){return _c('div',{key:group,staticStyle:{"margin-top":"20px"}},[(_vm.savedViewsForGroup(group).length > 0)?[_c('strong',[_c('translate',[_vm._v("\n          "+_vm._s(group[0].toUpperCase() + group.slice(1))+"\n        ")])],1),_vm._v(" "),_vm._l((_vm.savedViewsForGroup(group)),function(view,i){return _c('div',{key:i,staticClass:"saved-view"},[_c('div',{staticClass:"level",staticStyle:{"margin-left":"1rem"}},[_c('span',{staticClass:"level-left",staticStyle:{"width":"280px","text-overflow":"ellipsis","overflow":"hidden"}},[_vm._v(_vm._s(view.name))]),_vm._v(" "),_c('div',{staticClass:"level-right"},[_c('b-tooltip',{attrs:{"square":"","position":"is-top","label":_vm.$gettext('savedView.button.activate.toolTip')}},[_c('button',{staticClass:"button is-aquamarine",on:{"click":function($event){_vm.switchView(view.id)}}},[_c('translate',[_vm._v("\n                savedView.button.activate\n              ")])],1)]),_vm._v(" "),_c('b-tooltip',{attrs:{"square":"","position":"is-top","type":"is-danger","label":_vm.$gettext('savedView.button.delete.toolTip')}},[_c('button',{staticClass:"button is-danger",staticStyle:{"margin":"0 0 0 10px"},attrs:{"tabindex":"-1"},on:{"click":function($event){_vm.deleteView(view.id)}}},[_c('b-icon',{attrs:{"icon":"times","size":"is-small"}})],1)])],1)])])})]:_vm._e()],2)}):[_c('div',{staticClass:"section"},[_c('i',[_c('translate',[_vm._v("savedViews.noneSaved")])],1)])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HKCH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HMSu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fob-label',{attrs:{"label":_vm.label,"asterisk":_vm.asterisk}}),_vm._v(" "),_c('b-field',{staticClass:"fob-select",attrs:{"type":_vm.derivedType,"grouped":""}},[_c('b-autocomplete',{ref:"select",attrs:{"expanded":"","max-results":"100","placeholder":"Tippen oder klicken um zu suchen","data":_vm.selectModel.data,"loading":_vm.selectModel.isFetching,"icon":_vm.icon,"field":"_stringRep"},on:{"input":_vm.getAsyncData,"select":_vm.emitChange},nativeOn:{"click":function($event){return _vm.clicked($event)}},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('h3',[_c('fob-entity-decorator',{attrs:{"resourceData":props.option}},[_vm._v("\n              "+_vm._s(props.option._stringRep)+"\n            ")])],1),_vm._v(" "),_c('small',{staticClass:"has-text-basalt"},[_vm._v(_vm._s(props.option.parentOrgaName))])]}}]),model:{value:(_vm.selectModel.displayName),callback:function ($$v) {_vm.$set(_vm.selectModel, "displayName", $$v)},expression:"selectModel.displayName"}}),_vm._v(" "),(_vm.extraButton)?_c('p',{staticClass:"control"},[_c('b-tooltip',{attrs:{"square":"","position":"is-top","label":_vm.$gettext(_vm.extraButton.tooltip)}},[_c('button',{staticClass:"button is-aquamarine",attrs:{"tabindex":"-1"},on:{"click":function($event){_vm.$emit('custom', {name: _vm.extraButton.event})}}},[_c('b-icon',{attrs:{"icon":_vm.extraButton.icon,"size":"is-small"}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.allowCreate)?_c('p',{staticClass:"control",staticStyle:{"margin-left":"3px"}},[_c('b-tooltip',{attrs:{"square":"","position":"is-top","label":_vm.$gettext((_vm.label + ".plusbutton"))}},[_c('button',{staticClass:"button is-aquamarine",attrs:{"tabindex":"-1"},on:{"click":_vm.prepareCreation}},[_c('b-icon',{attrs:{"icon":"plus","size":"is-small"}})],1)])],1):_vm._e(),_vm._v(" "),_c('p',{staticClass:"control"},[_c('b-tooltip',{attrs:{"square":"","position":"is-top","label":_vm.$gettext('form.xbutton')}},[_c('button',{staticClass:"button is-aquamarine",attrs:{"tabindex":"-1"},on:{"click":_vm.emptyField}},[_c('b-icon',{attrs:{"icon":"times","size":"is-small"}})],1)])],1)],1),_vm._v(" "),_c('fob-entity-create-modal',{attrs:{"active":_vm.showCreateModal,"schema":_vm.schema,"field":_vm.label.split('.').splice(-1)[0]},on:{"update:active":function($event){_vm.showCreateModal=$event},"submit":_vm.submitCreated},model:{value:(_vm.created),callback:function ($$v) {_vm.created=$$v},expression:"created"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HfQr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-width":"1200px"}},[_c('div',{staticClass:"section upload",staticStyle:{"margin-top":"-50px"}},[_c('h1',{staticClass:"is-size-4",staticStyle:{"margin-bottom":"20px"}},[_c('translate',[_vm._v("\n        upload.heading\n      ")])],1),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$gettext('upload.infotext'))}}),_vm._v(" "),_c('a',{attrs:{"href":'mailto:fob@uni-leipzig.de?subject='+_vm.subject+'&body='+_vm.text}},[_c('b-icon',{attrs:{"icon":"envelope","size":"is-small"}}),_vm._v(" "),_c('translate',[_vm._v("upload.linktext")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HiFQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findClosestPublicOU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchOrganisationalUnits; });
function findClosestPublicOU(id) {
  return {
    operationName: 'findClosestPublicOU',
    variables: {
      id: id
    },
    query: '\n      query findClosestPublicOU($id:ID!) {\n        closestPublicOrganisationalUnit(id: $id) {\n          id\n          titleDe\n        }\n      }\n    '
  };
}

function fetchOrganisationalUnits(_ref) {
  var pageSize = _ref.pageSize,
      page = _ref.page,
      sortField = _ref.sortField,
      sortOrder = _ref.sortOrder,
      filter = _ref.filter;

  var variables = {
    pageSize: Number(pageSize) || 100,
    page: Number(page) || 1
  };

  if (sortOrder) {
    variables['sortOrder'] = sortOrder;
  }

  if (sortField) {
    variables['sortField'] = sortField;
  }

  if (filter && filter.text && filter.text.length > 0) {
    variables['filterText'] = filter.text;
  }

  return {
    operationName: 'fetchOrganisationalUnits',
    variables: variables,
    query: '\n      query fetchOrganisationalUnits ($pageSize:Int!, $page:Int!, $sortOrder:SortOrder, $sortField:OrganisationalUnitSortKeys, $filterText:String!) {\n        organisationalUnits(pageSize:$pageSize, page: $page, sortOrder:$sortOrder, orderBy:$sortField, filter: { text: $filterText }) {\n          entries {\n            ... on OrganisationalUnit {\n              id\n              name: titleDe\n              title:_stringRep\n              begin\n              end\n            }\n          }\n        }\n      }\n    '
  };
}



/***/ }),

/***/ "Hmcf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      searchOpen: false,
      visibilityOpen: false
    };
  },

  props: ['value'],
  methods: {
    emitChange: function emitChange() {
      this.$emit('input', this.value);
    },
    hideOnMouseLeave: function hideOnMouseLeave() {
      var el = this.$refs['column-dropdown'];
      if (el.isActive) {
        el.toggle();
      }
    }
  }
});

/***/ }),

/***/ "HqXh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var QueryParameter = {
  whitelist: ['lang', 'fis_persid', 'ou', 'compact', 'year', 'status', 'funding', 'person', 'freetext', 'externalPartner', 'category', 'sdg', 'sortOrder', 'sortField'],
  clean: function clean(toQuery) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(toQuery).forEach(function (param) {
      if (!_this.whitelist.includes(param)) {
        delete toQuery[param];
      }
    });
    return toQuery;
  },
  hasBlacklistedParam: function hasBlacklistedParam(toQuery) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(toQuery).some(function (param) {
      return !_this2.whitelist.includes(param);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (QueryParameter);

/***/ }),

/***/ "Hqjx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NullableDate_vue__ = __webpack_require__("csRy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3eed6c05_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NullableDate_vue__ = __webpack_require__("okCn");
function injectStyle (ssrContext) {
  __webpack_require__("FxIa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NullableDate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3eed6c05_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NullableDate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I1Xi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityListOptions_vue__ = __webpack_require__("Y37L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42cb4868_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityListOptions_vue__ = __webpack_require__("PKt+");
function injectStyle (ssrContext) {
  __webpack_require__("+QKV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityListOptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42cb4868_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityListOptions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I22p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchList", function() { return fetchList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "find", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchResource", function() { return fetchResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveResource", function() { return saveResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updaveResource", function() { return updaveResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "autocomplete", function() { return autocomplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteEntity", function() { return deleteEntity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_es6_promise_debounce__ = __webpack_require__("91kW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_es6_promise_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_es6_promise_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fobclient__ = __webpack_require__("hs9L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__("IcnI");





var _this = this;






var fetchList = function fetchList(route, page, size, sort, sortOrder, filter) {
  var sortString = void 0;
  if (sort) {
    sortString = sort + ',' + sortOrder;
  } else {
    sortString = 'id,desc';
  }
  var params = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    projection: 'list',
    page: page,
    size: size,
    sort: sortString
  }, filter);

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5__fobclient__["a" /* default */].find[route].withGenericAnd(params).then(function (_ref) {
      var data = _ref.data,
          meta = _ref.meta;

      resolve({ data: data, meta: meta });
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch('resetLoading');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* ToastError */])(error, 5000, {
        route: route,
        page: page,
        size: size,
        sort: sort,
        sortOrder: sortOrder,
        sortString: sortString,
        filter: filter
      });
      reject();
    });
  });
};

var find = function find(entity, searchMethod, orderBy) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var params = { size: 500 };
    if (orderBy != null) {
      params.sort = orderBy;
    }
    __WEBPACK_IMPORTED_MODULE_5__fobclient__["a" /* default */].find[entity].bySearchRepLike('', params).then(function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref3) {
        var data = _ref3.data,
            meta = _ref3.meta;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                resolve({ data: data, meta: meta });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }()).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch('resetLoading');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* ToastError */])(error, 5000, {
        entity: entity,
        searchMethod: searchMethod
      });
      reject();
    });
  });
};

var fetchResource = function fetchResource(entity, id) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5__fobclient__["a" /* default */].find[entity].byID(id).then(function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(entity) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return entity.fetchResource();

              case 2:
                resolve(entity);

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }()).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch('resetLoading');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* ToastError */])(error, 5000, {
        entity: entity,
        id: id
      });
      reject();
    });
  });
};

// TODO: What returns genricSave
var saveResource = function saveResource(route, data) {
  return __WEBPACK_IMPORTED_MODULE_5__fobclient__["a" /* default */].genericSave(route)(data);
};

var updaveResource = function updaveResource(entity) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5__fobclient__["a" /* default */].updaveEntity(entity).then(function (data) {
      resolve(data);
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch('resetLoading');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* ToastError */])(error, 5000, {
        entity: entity
      });
      reject();
    });
  });
};

var autocompleteUnbounced = function autocompleteUnbounced(route, method) {
  return function (query) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5__fobclient__["a" /* default */].find[route][method](__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, query, { size: 200, page: 0 })).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch('resetLoading');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* ToastError */])(error, 10000, {
          method: method,
          route: route,
          query: query,
          error: error.response.data.error,
          status: error.response.data.status,
          path: error.response.data.path,
          timestamp: error.response.data.timestamp,
          exception: error.response.data.exception
        });
        reject();
      });
    });
  };
};

var autocomplete = function autocomplete(route, method) {
  return __WEBPACK_IMPORTED_MODULE_4_es6_promise_debounce___default()(autocompleteUnbounced(route, method), 500);
};

var deleteEntity = function deleteEntity(entity) {
  return __WEBPACK_IMPORTED_MODULE_5__fobclient__["a" /* default */].deleteEntity(entity);
};

/***/ }),

/***/ "I5KR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__ = __webpack_require__("9fz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AbstractPerson__ = __webpack_require__("BP7K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FieldsGeneric__ = __webpack_require__("WWW9");





var Fields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__FieldsGeneric__["a" /* default */])('Veranstaltung');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Veranstaltung',
  route: 'veranstaltung',
  className: 'veranstaltung',
  class: __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__["Veranstaltung"],
  fields: [Fields.organisationseinheit, Fields.relevantFuerWeitere, Fields.weitereOrganisationseinheiten, Fields.String('name'), Fields.String('veranstaltungsTyp'), Fields.Date('veranstaltungStart'), Fields.Date('veranstaltungEnde'), Fields.MultiReference('veranstalter', 'user', __WEBPACK_IMPORTED_MODULE_2__AbstractPerson__["a" /* default */]), Fields.URL('externeWebsite'), {
    label: 'Veranstaltung.form.beschreibungDE',
    field: 'beschreibungDE',
    type: 'html-text',
    render: 'html',
    maxLength: 6000
  }, {
    label: 'Veranstaltung.form.beschreibungEN',
    field: 'beschreibungEN',
    type: 'html-text',
    render: 'html',
    maxLength: 6000
  }, Fields.Boolean('virtuell'), {
    label: 'Veranstaltung.form.stadt',
    field: 'stadt',
    type: 'string',
    table: true,
    view: function view(data) {
      return !data.virtuell;
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.PrefetchedSingleReference('land', 'land', 'globe'), {
    preselect: function preselect(land) {
      return land.nameDE === 'Deutschland';
    },
    prefilter: function prefilter(land) {
      return land.alpha2code !== 'EP';
    },
    orderBy: 'nameDE',
    view: function view(data) {
      return !data.virtuell;
    }
  })]
});

/***/ }),

/***/ "IADm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchEventDetailsQuery; });
function fetchEventDetailsQuery(id) {
  var variables = { id: id };

  return {
    operationName: 'fetchEventDetailsQuery',
    query: '\n      query fetchEventDetailsQuery($id: Int!) {\n        veranstaltung:event(id: $id) {\n          _entityName\n          _stringRep\n          name\n          veranstaltungsTyp:type\n          veranstaltungStart:startDate\n          veranstaltungEnde:endDate\n          beschreibungDE:descriptionDe\n          beschreibungEN:descriptionEn\n          externeWebsite:externalEventWebsite\n          organisationseinheit:organisationalUnit {\n            _id:id\n            _entityName\n            _stringRep\n            parentOrgaName\n          }\n          relevantFuerWeitere:hasMultipleOus\n          weitereOrganisationseinheiten:additionalOrganisationalUnits {\n            _id:id\n            _entityName\n            _stringRep\n            parentOrgaName\n          }\n          veranstalter:organisers {\n            _stringRep: fullName\n            _entityName\n            fisPersid\n            orcid\n          }\n          stadt:city\n          land:country {\n            _stringRep\n            _entityName\n          }\n          virtuell:virtual\n        }\n      }\n    ',
    variables: variables
  };
}



/***/ }),

/***/ "IKL4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOADING_START", function() { return LOADING_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOADING_DONE", function() { return LOADING_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DATA", function() { return SET_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ID", function() { return SET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SCHEMA", function() { return SET_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_VIEW_ENTITY_TYPE", function() { return SET_VIEW_ENTITY_TYPE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var LOADING_START = function LOADING_START(state) {
  state.loading = true;
};

var LOADING_DONE = function LOADING_DONE(state) {
  state.loading = false;
};

var SET_DATA = function SET_DATA(state, data) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'data', data);
};

var SET_ID = function SET_ID(state, id) {
  state.id = id;
};

var SET_SCHEMA = function SET_SCHEMA(state, schema) {
  state.schema = schema;
};

var SET_VIEW_ENTITY_TYPE = function SET_VIEW_ENTITY_TYPE(state, type) {
  state.viewEntityType = type;
};

/***/ }),

/***/ "IOX+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttons"},[(_vm.qaShare)?_c('b-tooltip',{attrs:{"label":_vm.$gettext('AboutMe.action.share'),"position":"is-top"}},[_c('b-dropdown',{attrs:{"position":"is-bottom-left"}},[_c('button',{staticClass:"button",staticStyle:{"border":"0px","background-color":"transparent"},attrs:{"slot":"trigger"},slot:"trigger"},[_c('b-icon',{attrs:{"pack":"fa","icon":"link"}})],1),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.share({ compact: false })}}},[_c('translate',[_vm._v("AboutMe.action.share.default")])],1),_vm._v(" "),(_vm.qaShareCompactView)?_c('b-dropdown-item',{on:{"click":function($event){_vm.share({ compact: true })}}},[_c('translate',[_vm._v("AboutMe.action.share.compact")])],1):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.qaPrint)?_c('b-tooltip',{attrs:{"label":_vm.$gettext('AboutMe.action.print'),"position":"is-top"}},[_c('button',{staticClass:"button",staticStyle:{"border":"0px","background-color":"transparent"},on:{"click":_vm.print}},[_c('b-icon',{attrs:{"pack":"fa","icon":"print"}})],1)]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__("qQWK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__("lwq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_creator__ = __webpack_require__("2/cz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_editor__ = __webpack_require__("/+mb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_list__ = __webpack_require__("xEeK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_publicView__ = __webpack_require__("ZkOl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_resource__ = __webpack_require__("Ej7L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_tomaner__ = __webpack_require__("6zwT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_tree__ = __webpack_require__("LYu5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_user__ = __webpack_require__("LWU+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_aboutme__ = __webpack_require__("bHuR");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);
















/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  plugins: [__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate___default()({
    key: 'de.ul.fob',
    paths: ['confirmPrivacyPolicy', 'lastVersion', 'user.name', 'user.roles', 'user.orgas', 'user.token', 'user.savedViews', 'user.selectedOrgaID', 'user.fisPersid', 'user.email', 'user.forscher', 'user.activeViewState', 'tomaner.maco', 'aboutme.name', 'aboutme.fisPersid', 'aboutme.leurisProfile',
    // disable the list attributes for debugging
    'list.resourceType', 'list.listSchema', 'list.filterSchema', 'list.filter', 'list.config', 'creator.schema', 'creator.data']
  })],
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_5__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_6__actions__,
  modules: {
    creator: __WEBPACK_IMPORTED_MODULE_7__modules_creator__["a" /* default */],
    editor: __WEBPACK_IMPORTED_MODULE_8__modules_editor__["a" /* default */],
    list: __WEBPACK_IMPORTED_MODULE_9__modules_list__["a" /* default */],
    publicView: __WEBPACK_IMPORTED_MODULE_10__modules_publicView__["a" /* default */],
    resource: __WEBPACK_IMPORTED_MODULE_11__modules_resource__["a" /* default */],
    tomaner: __WEBPACK_IMPORTED_MODULE_12__modules_tomaner__["a" /* default */],
    tree: __WEBPACK_IMPORTED_MODULE_13__modules_tree__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_14__modules_user__["a" /* default */],
    aboutme: __WEBPACK_IMPORTED_MODULE_15__modules_aboutme__["a" /* default */]
  }
}));

/***/ }),

/***/ "Ie2l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);


/* harmony default export */ __webpack_exports__["a"] = ({
  personIdentTyp: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] },
  wert: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] }
});

/***/ }),

/***/ "If87":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_aboutme_AboutMeListSort__ = __webpack_require__("oOhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_aboutme_AboutMeListFilter__ = __webpack_require__("jJC0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_AboutMeHelper__ = __webpack_require__("oE11");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-aboutme-list-options',
  props: ['resourceType'],
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_mixins_AboutMeHelper__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    config: 'aboutme/getConfig',
    total: 'aboutme/getTotal',
    filter: 'aboutme/getFilter'
  }), {
    activeFilter: function activeFilter() {
      return this.filter[this.activeResourceType].filter;
    },
    page: function page() {
      return this.config[this.activeResourceType].page;
    },
    totalTablePages: function totalTablePages() {
      return Math.ceil(this.total[this.activeResourceType] / this.config[this.activeResourceType].perPage);
    }
  }),
  methods: {
    onPerPageChange: function onPerPageChange(perPage) {
      var _this = this;

      this.$store.dispatch('aboutme/changePerPage', {
        resourceType: this.activeResourceType,
        perPage: perPage
      }).then(function () {
        _this.loadAsyncData();
      });
    },
    labelForActiveFilterField: function labelForActiveFilterField(filterField) {
      return this.filter[this.activeResourceType].filters.find(function (filter) {
        return filter.value === filterField;
      }).label;
    },
    labelForActiveFilterValue: function labelForActiveFilterValue(filterField, filterValue) {
      var filterConfig = this.filter[this.activeResourceType].filters.find(function (filter) {
        return filter.value === filterField;
      });
      if (filterConfig.type === 'select') {
        return 'AboutMe.filter.' + filterField + '.' + filterValue.toLowerCase();
      } else {
        return filterValue;
      }
    },
    onUpdateSortField: function onUpdateSortField(sortField) {
      var _this2 = this;

      this.$store.dispatch('aboutme/setSortField', {
        resourceType: this.resourceType,
        sortField: sortField
      }).then(function () {
        _this2.loadAsyncData();
      });
    },
    onUpdateSortOrder: function onUpdateSortOrder(sortOrder) {
      var _this3 = this;

      this.$store.dispatch('aboutme/setSortOrder', {
        resourceType: this.resourceType,
        sortOrder: sortOrder
      }).then(function () {
        _this3.loadAsyncData();
      });
    }
  },
  components: {
    'fob-aboutme-list-sort': __WEBPACK_IMPORTED_MODULE_2__components_aboutme_AboutMeListSort__["a" /* default */],
    'fob-aboutme-list-filter': __WEBPACK_IMPORTED_MODULE_3__components_aboutme_AboutMeListFilter__["a" /* default */]
  }
});

/***/ }),

/***/ "IhzH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Publikation.form.publikationsTyp',
  field: 'publikationsTyp',
  type: 'select',
  translatable: true,
  values: [{
    value: 'ARTIKEL',
    label: 'PublikationsTyp.ARTIKEL'
  }, {
    value: 'SAMMELBANDBEITRAG',
    label: 'PublikationsTyp.SAMMELBANDBEITRAG'
  }, {
    value: 'TAGUNGSBEITRAG',
    label: 'PublikationsTyp.TAGUNGSBEITRAG'
  }, {
    value: 'BUCHBEITRAG',
    label: 'PublikationsTyp.BUCHBEITRAG'
  }, {
    value: 'SAMMELBAND',
    label: 'PublikationsTyp.SAMMELBAND'
  }, {
    value: 'TAGUNGSBAND',
    label: 'PublikationsTyp.TAGUNGSBAND'
  }, {
    value: 'SONDERHEFT',
    label: 'PublikationsTyp.SONDERHEFT'
  }, {
    value: 'MONOGRAPHIE',
    label: 'PublikationsTyp.MONOGRAPHIE'
  }, {
    value: 'QUELLENEDITION',
    label: 'PublikationsTyp.QUELLENEDITION'
  }, {
    value: 'BERICHT',
    label: 'PublikationsTyp.BERICHT'
  }, {
    value: 'WORKINGPAPER',
    label: 'PublikationsTyp.WORKINGPAPER'
  }, {
    value: 'BEITRAGINNICHTWISSENSCHAFTLICHENMEDIEN',
    label: 'PublikationsTyp.BEITRAGINNICHTWISSENSCHAFTLICHENMEDIEN'
  }, {
    value: 'DISSERTATION',
    label: 'PublikationsTyp.DISSERTATION'
  }, {
    value: 'HABILITATIONSSCHRIFT',
    label: 'PublikationsTyp.HABILITATIONSSCHRIFT'
  }, {
    value: 'SONSTIGE',
    label: 'PublikationsTyp.SONSTIGE'
  }]
});

/***/ }),

/***/ "IqS5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_DateTimeHelper__ = __webpack_require__("5W2G");



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_mixins_DateTimeHelper__["a" /* default */]],
  head: {
    title: function title() {
      if (this.leurisHead) {
        return {
          inner: this.leurisHead.inner,
          separator: '|',
          complement: this.complement
        };
      } else {
        /* should no longer be used, but keep as fallback */
        return {
          inner: 'leuris',
          separator: '|',
          complement: this.title
        };
      }
    }
  },
  computed: {
    title: function title() {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.complementTitle) === 'object') {
        return this.$gettext(this.complementTitle.inner) + ' ' + (this.complementTitle.separator || '') + ' ' + this.$gettext(this.complementTitle.complement);
      } else {
        return this.$gettext(this.complementTitle);
      }
    },
    complement: function complement() {
      var _this = this;

      var complement = this.leurisHead.complement;
      var separator = this.leurisHead.separator || '';
      if ((typeof complement === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(complement)) === 'object') {
        return complement.map(function (c) {
          return _this.$gettext(c);
        }).join(' ' + separator + ' ');
      } else {
        return this.$gettext(complement);
      }
    }
  },
  watch: {
    currentLocale: function currentLocale() {
      this.$emit('updateHead');
    }
  }
});

/***/ }),

/***/ "IsdL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicListSort_vue__ = __webpack_require__("KeKz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_437b6594_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicListSort_vue__ = __webpack_require__("Zvhw");
function injectStyle (ssrContext) {
  __webpack_require__("yCdw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicListSort_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_437b6594_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicListSort_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Iy+K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J3Fq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J5Ry":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PersonIdent__ = __webpack_require__("Ie2l");



/* harmony default export */ __webpack_exports__["a"] = ({
  vorname: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] },
  name: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] },
  personIdent: {
    $each: __WEBPACK_IMPORTED_MODULE_1__PersonIdent__["a" /* default */]
  }
});

/***/ }),

/***/ "JAcS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_DynamicTitle__ = __webpack_require__("IqS5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_ExternalLinkProvider__ = __webpack_require__("1/AK");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'help',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_DynamicTitle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__components_mixins_ExternalLinkProvider__["a" /* default */]],
  data: function data() {
    return {
      msg: 'UL Forschungsbericht',
      leurisHead: {
        inner: 'leuris:Forschungsbericht',
        complement: 'menu.help'
      }
    };
  },

  computed: {
    renderedRouterLinkListActivities: function renderedRouterLinkListActivities() {
      var route = this.$router.resolve({ name: 'auflisten' }, this.$route);
      var linkText = this.$gettext('menu.list');
      return '<a href="' + route.href + '">' + linkText + '</a>';
    }
  }
});

/***/ }),

/***/ "JK/4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoading", function() { return isLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSchema", function() { return getSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFilterSchema", function() { return getFilterSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getResourceType", function() { return getResourceType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPage", function() { return getPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPerPage", function() { return getPerPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSortField", function() { return getSortField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSortOrder", function() { return getSortOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getId", function() { return getId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFilter", function() { return getFilter; });
var isLoading = function isLoading(state) {
  return state.loading;
};

var getSchema = function getSchema(state) {
  return state.listSchema[state.resourceType];
};

var getFilterSchema = function getFilterSchema(state) {
  return state.filterSchema[state.resourceType];
};

var getResourceType = function getResourceType(state) {
  return state.resourceType;
};

var getPage = function getPage(state) {
  return state.config[state.resourceType].page;
};

var getPerPage = function getPerPage(state) {
  return state.config[state.resourceType].perPage;
};

var getSortField = function getSortField(state) {
  return state.config[state.resourceType].sortField;
};

var getSortOrder = function getSortOrder(state) {
  return state.config[state.resourceType].sortOrder;
};

var getId = function getId(state) {
  return state.id;
};

var getFilter = function getFilter(state) {
  return state.filter[state.resourceType];
};

/***/ }),

/***/ "Jocs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__("eOoE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql__ = __webpack_require__("lwCg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_PublicViewHelper__ = __webpack_require__("VlMm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mixins_OrgaDurationHelper__ = __webpack_require__("oSjT");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ('treeItem', {
  name: 'fob-tree-item',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_mixins_PublicViewHelper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__components_mixins_OrgaDurationHelper__["a" /* default */]],
  props: ['root', 'model', 'parent', 'isOpen'],
  data: function data() {
    return {
      childData: {},
      id: this.model.id,
      open: false,
      openBranch: -1,
      loading: false,
      isSelected: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    selectedOrganisationalUnit: 'tree/selected'
  }), {
    isFolder: function isFolder() {
      return this.model.children && this.model.children.length;
    },
    newParent: function newParent() {
      var path = [];
      if (Array.isArray(this.parent)) {
        path = this.parent.concat([this.id]);
      } else {
        path = [this.id];
      }
      return path;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    'saveBranchData': 'tree/saveBranchData',
    'saveOpenBranch': 'tree/saveOpenBranch',
    'removeOpenBranch': 'tree/removeOpenBranch',
    'selectBranch': 'tree/selectBranch'
  }), {
    loadAsyncData: function loadAsyncData() {
      var _this = this;

      this.loading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__axios__["a" /* graphql */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__graphql__["j" /* fetchOuQuery */])(this.id)).then(function (response) {
        _this.childData = response.data.data.organisationalUnit;
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },

    toggle: function toggle() {
      // only collapse tree if children are available
      if (this.isFolder) {
        // dont refetch
        if (!this.childData.name) {
          // query via axios
          this.loading = true;
          this.loadAsyncData();
        }
        this.open = !this.open; // open branch
        if (this.open) {
          this.saveOpenBranch(this.id);
        } else {
          this.removeOpenBranch(this.id);
        }
        this.saveBranchData(this);
      }
    },
    openParent: function openParent() {
      if (!this.open) {
        this.toggle();
      }
    },
    select: function select(model) {
      this.openParent();
      this.selectBranch(model);
    },
    handleOpenEvent: function handleOpenEvent(eventData) {
      this.openBranch = eventData;
      this.saveBranchData(this);
    }
  }),
  mounted: function mounted() {
    // if root element fetch query and open branches
    if (this.root) {
      this.open = true;
    }
    // read store data
    var treeItemData = this.$store.state.tree.branch[this.id];
    if (treeItemData) {
      this.childData = treeItemData.childData;
      this.id = treeItemData.id;
      this.open = this.root || this.isOpen || this.open || false;
      this.openBranch = treeItemData.openBranch;
    }
  },

  watch: {
    isOpen: function isOpen() {
      this.open = this.isOpen;
    }
  }
});

/***/ }),

/***/ "JqIW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mixins_ExternalLinkProvider__ = __webpack_require__("1/AK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mixins_UserCanEditByKostenstelle__ = __webpack_require__("jh8f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_FavourResearchActivity__ = __webpack_require__("LwcP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mixins_DateTimeHelper__ = __webpack_require__("5W2G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mixins_PublicRouteBuilder__ = __webpack_require__("+ueH");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-entity-compact-cyan',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_mixins_DateTimeHelper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__components_mixins_ExternalLinkProvider__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__components_mixins_FavourResearchActivity__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__components_mixins_PublicRouteBuilder__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__components_mixins_UserCanEditByKostenstelle__["a" /* default */]],
  props: ['data', 'entityDetailsRoute', 'entityEditRoute', 'showPublicationsCount', 'showPublicationType', 'showStar'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    maco: 'tomaner/maco'
  }), {
    resourceType: function resourceType() {
      return this.data._entityName.split('.').splice(-1)[0].toLowerCase();
    },
    resourceId: function resourceId() {
      if (this.entityDetailsRoute === 'anzeigen_einzeln') {
        return this.data._id;
      } else {
        return this.data.primaryPublicIdent || this.data._id;
      }
    },
    internalId: function internalId() {
      return this.data._id;
    }
  }),
  methods: {
    sdgLink: function sdgLink(id) {
      var lpad = ('0' + id).slice(-2);
      return '/static/sdg/E_WEB_' + lpad + '.png';
    }
  }
});

/***/ }),

/***/ "JrBN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('div',{staticStyle:{"padding":"0 1rem 0 1rem"}},[_c('translate',[_vm._v("AboutMe.sort.by")])],1),_vm._v(" "),_c('b-select',{staticStyle:{"padding":"0 1rem 0 1rem"},model:{value:(_vm.localSortField),callback:function ($$v) {_vm.localSortField=$$v},expression:"localSortField"}},_vm._l((_vm.sortFields),function(value){return _c('option',{key:(_vm.resourceType + "." + (value.field)),domProps:{"value":value.field}},[_c('translate',[_vm._v(_vm._s(value.label))])],1)})),_vm._v(" "),_c('b-select',{model:{value:(_vm.localSortOrder),callback:function ($$v) {_vm.localSortOrder=$$v},expression:"localSortOrder"}},[_c('option',{attrs:{"value":"ASC"}},[_c('translate',[_vm._v("AboutMe.sort.order.ASC")])],1),_vm._v(" "),_c('option',{attrs:{"translate":"","value":"DESC"}},[_c('translate',[_vm._v("AboutMe.sort.order.DESC")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "K13K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (base) {
  return {
    SortableReference: function SortableReference(field, visible) {
      var sortField = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : field + 'SearchRep';
      var plain = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      return {
        label: base + '.list.column.' + field,
        field: field,
        sortField: sortField,
        render: 'stringRep',
        tableVisible: visible,
        sortable: true,
        plain: plain
      };
    },
    UnsortableReference: function UnsortableReference(field, visible) {
      var plain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      return {
        label: base + '.list.column.' + field,
        field: field,
        render: 'stringRep',
        tableVisible: visible,
        plain: plain
      };
    },
    SortableField: function SortableField(field, visible) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'string';
      var sortField = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : field;

      return {
        label: base + '.list.column.' + field,
        field: field,
        tableVisible: visible,
        sortable: true,
        sortField: sortField,
        type: type
      };
    },
    SortableBoolean: function SortableBoolean(field, visible) {
      return {
        label: base + '.list.column.' + field,
        field: field,
        tableVisible: visible,
        sortable: true,
        type: Boolean
      };
    },
    SortableDate: function SortableDate(field, visible) {
      return {
        label: base + '.list.column.' + field,
        field: field,
        tableVisible: visible,
        sortable: true,
        type: Date
      };
    },
    SortableTimestamp: function SortableTimestamp(field, visible) {
      var sortField = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : field;
      var asDate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      return {
        label: base + '.list.column.' + field,
        field: field,
        tableVisible: visible,
        sortable: true,
        sortField: sortField,
        type: asDate ? 'timestampAsDate' : 'timestamp'
      };
    }
  };
});

/***/ }),

/***/ "K8Lz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchEventQuery; });
function fetchEventQuery(rootQueryType, id, pageSize, page, sortField, sortOrder, filter) {
  rootQueryType = ['organisationalUnit', 'person'].includes(rootQueryType) ? rootQueryType : null;
  id = rootQueryType === 'organisationalUnit' ? Number(id) : '' + id;

  // if the rootQueryType does not match for organisational unit or person then return nulls
  if (!rootQueryType) {
    return null;
  }

  var variables = {
    id: id || null,
    pageSize: Number(pageSize) || 20,
    page: Number(page) || 1
  };

  if (sortOrder) {
    variables['sortOrder'] = sortOrder;
  }

  if (sortField) {
    variables['sortField'] = sortField;
  }

  if (filter && filter.year && Number(filter.year)) {
    variables['filterYear'] = Number(filter.year);
  }

  if (filter && filter.freetext && filter.freetext.length > 0) {
    variables['filterFreetext'] = filter.freetext;
  }

  if (filter && filter.person && filter.person.length > 0) {
    variables['filterPerson'] = filter.person;
  }

  return {
    operationName: 'fetchEventQuery',
    query: '\n      query fetchEventQuery($id: ID!, $pageSize:Int!, $page:Int!, $sortOrder:SortOrder, $sortField:EventSortKeys, $filterYear:Int, $filterFreetext:String, $filterPerson:String) {\n        ' + rootQueryType + '(id: $id) {\n          veranstaltung:events(pageSize: $pageSize, page: $page, sortOrder: $sortOrder, orderBy:$sortField, filter: {year: $filterYear freeText: $filterFreetext person:$filterPerson }) {\n            meta {\n              pageNumber\n              pageSize\n              totalEntries\n              totalPages\n            }\n            entries {\n              ... on Event {\n                _id:id\n                _entityName\n                html {\n                  de\n                  en\n                }\n              }\n            }\n          }\n        }\n      }\n    ',
    variables: variables
  };
}



/***/ }),

/***/ "KeKz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-public-list-sort',
  props: ['resourceType', 'sortField', 'sortFields', 'sortOrder'],
  computed: {
    localSortField: {
      get: function get() {
        return this.sortField;
      },
      set: function set(newSortField) {
        this.onSortFieldChange(newSortField);
        return newSortField;
      }
    },
    localSortOrder: {
      get: function get() {
        return this.sortOrder;
      },
      set: function set(newSortOrder) {
        this.onSortOrderChange(newSortOrder);
        return newSortOrder;
      }
    }
  },
  methods: {
    onSortFieldChange: function onSortFieldChange(sortField) {
      this.$emit('update:sortFieldPublicView', sortField);
    },
    onSortOrderChange: function onSortOrderChange(sortOrder) {
      this.$emit('update:sortOrderPublicView', sortOrder);
    }
  }
});

/***/ }),

/***/ "KnrV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__ = __webpack_require__("cigy");

var Filter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__["a" /* default */])('Forschungsprojekt');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Forschungsprojekt',
  route: 'forschungsprojekt',
  fields: [Filter.ReferenceByMultiValueSearchRep('organisationseinheit', 'sitemap', 'organisationseinheit'), Filter.kumuliert(), Filter.Number('berichtsjahr', 'calendar-o'), Filter.ReferenceByMultiValueSearchRep('beteiligte', 'user', 'abstractPerson'), Filter.String('titelDE'), Filter.String('titelEN'), Filter.ReferenceByMultiValueSearchRep('antragsteller', 'user', 'abstractPerson'), Filter.ReferenceByMultiValueSearchRep('projektleiter', 'user', 'abstractPerson'), Filter.ReferenceBySearchRep('mittelgeber', 'credit-card', 'mittelgeber'), Filter.String('uebergeordnetesProjekt')]
});

/***/ }),

/***/ "KxDk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_public_PublicListExport__ = __webpack_require__("9R/T");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// COMPONENTS


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-public-list-quick-actions',
  data: function data() {
    return {
      showExportModal: false
    };
  },

  props: {
    'qa-share': {
      type: [Boolean, Object],
      default: false
    },
    'qa-print': {
      type: Boolean,
      default: false
    },
    'qa-export': {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isCompact: function isCompact() {
      return this.qaShare && this.qaShare.hasOwnProperty('compact') ? this.qaShare.compact : false;
    },
    hasQueryParams: function hasQueryParams() {
      return this.qaShare && this.qaShare.hasOwnProperty('queryParams');
    },
    urlPath: function urlPath() {
      return window.location.origin + '/portal' + this.$route.path;
    },
    urlQueryParams: function urlQueryParams() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.qaShare.queryParams).filter(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            _ = _ref2[0],
            filterValue = _ref2[1];

        return filterValue != null;
      }).map(function (_ref3) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
            filterName = _ref4[0],
            filterValue = _ref4[1];

        return filterName + '=' + encodeURIComponent(filterValue);
      }).join('&');
    },
    copyToClipboard: function copyToClipboard(text) {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["g" /* CopyToClipboard */])(text).then(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* ToastSuccess */])(_this.$gettext('Public.toast.clipboard.success'));
      }, function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* ToastError */])(_this.$gettext('Public.toast.clipboard.error'));
      });
    },
    print: function print() {
      window.print();
    },
    shareAsSimple: function shareAsSimple() {
      var url = this.urlPath();
      this.copyToClipboard(url);
    },
    shareAsSimpleWithQueryParams: function shareAsSimpleWithQueryParams() {
      var url = this.urlPath() + '?' + this.urlQueryParams();
      this.copyToClipboard(url);
    },
    shareAsCompact: function shareAsCompact() {
      var url = this.urlPath() + '?compact=true';
      this.copyToClipboard(url);
    },
    shareAsCompactWithQueryParams: function shareAsCompactWithQueryParams() {
      var url = this.urlPath() + '?compact=true&' + this.urlQueryParams();
      this.copyToClipboard(url);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
    userIsLoggedIn: 'user/isAuthorized',
    rootQueryType: 'publicView/getRootQueryType'
  }), {
    userIsAdmin: function userIsAdmin() {
      return this.userIsLoggedIn && this.$store.getters['user/roles'].ADMIN === true;
    },
    exportButtonDisabled: function exportButtonDisabled() {
      return this.qaExport && !this.userIsLoggedIn && this.rootQueryType === 'organisationalUnit';
    },
    exportButtonActive: function exportButtonActive() {
      return this.qaExport && this.userIsLoggedIn && this.rootQueryType === 'organisationalUnit';
    }
  }),
  components: {
    'fob-public-list-export': __WEBPACK_IMPORTED_MODULE_5__components_public_PublicListExport__["a" /* default */]
  }
});

/***/ }),

/***/ "L4RB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityListColumnVisibility_vue__ = __webpack_require__("Hmcf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63d897ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityListColumnVisibility_vue__ = __webpack_require__("Dz6P");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityListColumnVisibility_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63d897ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityListColumnVisibility_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LWU+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("glhi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__("ANWq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__("VKxC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("nDDf");





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__
});

/***/ }),

/***/ "LXsN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityListPagination_vue__ = __webpack_require__("EU3M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b2bf9c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityListPagination_vue__ = __webpack_require__("Gnij");
function injectStyle (ssrContext) {
  __webpack_require__("3hk8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityListPagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b2bf9c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityListPagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LYu5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("+n61");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__("XQT5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__("xHvv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("QOdh");





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__
});

/***/ }),

/***/ "LgZK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Publikation_vue__ = __webpack_require__("2hmK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a91897ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Publikation_vue__ = __webpack_require__("fCOC");
function injectStyle (ssrContext) {
  __webpack_require__("BO1V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Publikation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a91897ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Publikation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Lh/Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFieldsGeneric__ = __webpack_require__("K13K");

var ListFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ListFieldsGeneric__["a" /* default */])('Preis');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Preis',
  route: 'preis',
  className: 'preis',
  fields: [ListFields.SortableTimestamp('_updateDate', false, 'updateDate', true), ListFields.SortableTimestamp('_createDate', false, 'createDate', true), ListFields.SortableReference('organisationseinheit', false), ListFields.SortableReference('preisTraeger', true), ListFields.SortableField('verleihungsJahr', true), ListFields.SortableField('namePreis', true), ListFields.SortableReference('preisBezeichnung', false, 'preisBezeichnungSearchRep', true), ListFields.SortableField('hatPreisgeld', true, Boolean)]
});

/***/ }),

/***/ "LwcP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("gyMJ");



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    favourResearchActivity: function favourResearchActivity(_ref) {
      var _this = this;

      var resourceType = _ref.resourceType,
          resourceId = _ref.resourceId;

      var fisPersid = this.$store.getters['user/fisPersid'];
      var isAuthorized = this.$store.getters['user/isAuthorized'];
      if (isAuthorized) {
        if (this.isFavouredResearchActivity({ resourceType: resourceType, resourceId: resourceId })) {
          // DELETE
          __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].maco.researchSelection('delete', fisPersid, resourceType, resourceId).then(function (data) {
            _this.$store.dispatch('aboutme/setResearchActivityAsFavourite', data);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* ToastSuccess */])(_this.$gettext('AboutMe.toast.deselect'), 1500);
          }).catch(function () {
            /* error handling in api.maco */
          });
        } else {
          // POST
          __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].maco.researchSelection('post', fisPersid, resourceType, resourceId).then(function (data) {
            _this.$store.dispatch('aboutme/setResearchActivityAsFavourite', data);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* ToastSuccess */])(_this.$gettext('AboutMe.toast.select'), 1500);
          }).catch(function (error) {
            /* error handling in api.maco */
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* ToastError */])(_this.$gettext(error));
          });
        }
      }
    },
    isFavouredResearchActivity: function isFavouredResearchActivity(_ref2) {
      var resourceType = _ref2.resourceType,
          resourceId = _ref2.resourceId;

      return this.$store.getters['aboutme/favouredResearchActivity'][resourceType].includes(Number(resourceId));
    }
  }
});

/***/ }),

/***/ "M8Iu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mixins_CompactViewHelper__ = __webpack_require__("TGNV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debounce__ = __webpack_require__("HhAh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_EntityHeader__ = __webpack_require__("sGAB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_public_PublicSelectTag__ = __webpack_require__("ZNs5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mixins_PublicViewHelper__ = __webpack_require__("VlMm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_mixins_TooltipHelper__ = __webpack_require__("Aa4s");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-public-select-person',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_mixins_CompactViewHelper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__components_mixins_PublicViewHelper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__components_mixins_TooltipHelper__["a" /* default */]],
  data: function data() {
    return {
      maxLengthOfTags: 46, // will also set by TooltipHelper - default: 30
      searchStr: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    isLoadingStaff: 'publicView/isLoadingStaff',
    selectedOrganisationalUnit: 'tree/selected',
    staff: 'publicView/getStaffStartsWithData',
    staffLetterCount: 'publicView/getStaffLetterCount',
    staffStartsWith: 'publicView/getStaffStartsWith',
    staffTotalEntries: 'publicView/getStaffTotalEntries'
  }), {
    staffFullName: {
      get: function get() {
        return this.$store.getters['publicView/getStaffFullName'];
      },
      set: function set(fullName) {
        return this.$store.dispatch('publicView/setStaffFullName', fullName);
      }
    },
    alphabet: function alphabet() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(Array(26))).map(function (a, idx) {
        return String.fromCharCode(97 + idx).toUpperCase();
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    resetSelectedTreeItem: 'tree/reset'
  }), {
    getTitleForLetter: function getTitleForLetter(letter) {
      var count = 0;
      if (letter === 'AZ') {
        for (var _letter in this.staffLetterCount) {
          count += this.staffLetterCount[_letter];
        }
      } else {
        count = this.staffLetterCount[letter];
      }
      return count > 0 ? count + ' ' + this.$gettext('Public.person') : '';
    },
    loadAsyncStaff: function loadAsyncStaff(_ref) {
      var startsWith = _ref.startsWith,
          filters = _ref.filters;

      var options = {
        startsWith: this.staffLetterCount[startsWith] || startsWith === '' ? startsWith : this.staffStartsWith,
        filter: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          organisationalUnit: this.selectedOrganisationalUnit.id,
          fullName: this.searchStr != null ? this.searchStr : this.staffFullName
        }, filters)
      };
      this.$store.dispatch('publicView/loadAsyncStaff', options);
    },
    loadStaffStartsWith: function loadStaffStartsWith(startsWith) {
      if (this.staffLetterCount[startsWith] || startsWith === '') {
        this.loadAsyncStaff({ startsWith: startsWith });
      }
    },

    onFullName: __WEBPACK_IMPORTED_MODULE_4_debounce___default()(function () {
      this.loadAsyncStaff({});
    }, 500),
    resetSelectedOrga: function resetSelectedOrga() {
      this.resetSelectedTreeItem();
      this.loadAsyncStaff({});
    }
  }),
  beforeMount: function beforeMount() {
    // clear input fullname search
    this.staffFullName = '';
  },
  mounted: function mounted() {
    // reset all inputs on init and fetch persons
    this.loadAsyncStaff({
      startsWith: '',
      filters: {
        fullName: ''
      }
    });
  },

  components: {
    'fob-entity-header': __WEBPACK_IMPORTED_MODULE_5__components_EntityHeader__["a" /* default */],
    'fob-public-select-tag': __WEBPACK_IMPORTED_MODULE_6__components_public_PublicSelectTag__["a" /* default */]
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0263782d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("eJzL");
function injectStyle (ssrContext) {
  __webpack_require__("E5fF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0263782d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MH+L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-card",staticStyle:{"width":"900px"}},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_c('translate',[_vm._v("Export.header")])],1)]),_vm._v(" "),_c('section',{staticClass:"modal-card-body"},[_c('b-loading',{attrs:{"is-full-page":false,"active":_vm.loading},on:{"update:active":function($event){_vm.loading=$event}}}),_vm._v(" "),_c('translate',[_vm._v("Export.infotext")]),_vm._v(" "),(!_vm.loading && !_vm.sent)?_c('fob-entity-create-form',{ref:"fobEntityCreateForm",attrs:{"schema":_vm.schema,"showErrors":_vm.showErrors},on:{"custom":function (val) { return _vm.customEvent(_vm.currentOrga, val); },"update:invalid":function (value) { return _vm.isInvalid = value; }},model:{value:(_vm.resourceData),callback:function ($$v) {_vm.resourceData=$$v},expression:"resourceData"}}):_vm._e(),_vm._v(" "),(_vm.sent)?_c('div',{staticStyle:{"margin-top":"1em"}},[_vm._v("\n      "+_vm._s(_vm.message)+"\n      "),_c('br'),_vm._v(" "),(_vm.error)?_c('b-input',{staticStyle:{"margin":"30px 0px","width":"300px"},attrs:{"type":"text","value":_vm.error,"readonly":""}}):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[(!_vm.sent)?_c('button',{staticClass:"button",attrs:{"type":"button"},on:{"click":function($event){_vm.$parent.close()}}},[_c('translate',[_vm._v("\n        Export.close\n      ")])],1):_vm._e(),_vm._v(" "),(!_vm.sent)?_c('button',{staticClass:"button is-primary",on:{"click":_vm.requestExport}},[_c('translate',[_vm._v("\n          Export.continue\n      ")])],1):_vm._e(),_vm._v(" "),(_vm.sent)?_c('button',{staticClass:"button",attrs:{"type":"button"},on:{"click":function($event){_vm.$parent.close()}}},[_c('translate',[_vm._v("\n        Export.close\n      ")])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MZuF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityPalette_vue__ = __webpack_require__("H7Yy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c42b1d7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityPalette_vue__ = __webpack_require__("6Yhf");
function injectStyle (ssrContext) {
  __webpack_require__("fNnQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityPalette_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c42b1d7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityPalette_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MjnN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MwCT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_buefy__ = __webpack_require__("MMSg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_buefy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_gettext__ = __webpack_require__("Zoqe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_gettext___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_gettext__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_head__ = __webpack_require__("RZCy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__translations_translations_json__ = __webpack_require__("FA/a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__translations_translations_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__translations_translations_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_EntityDetails__ = __webpack_require__("iBzs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_form_EntityCreateForm__ = __webpack_require__("B6Sg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils__ = __webpack_require__("0xDb");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



















__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_5_moment___default.a.locale('de');

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_head___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_buefy___default.a, {
  defaultIconPack: 'fa',
  defaultDateFormatter: __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* dateFormatter */],
  defaultDateParser: function defaultDateParser(date) {
    var m = __WEBPACK_IMPORTED_MODULE_5_moment___default()(date, 'DD.MM.YYYY');
    return m.isValid() ? m.toDate() : null;
  },
  defaultMonthNames: __WEBPACK_IMPORTED_MODULE_5_moment___default.a.months(),
  defaultDayNames: __WEBPACK_IMPORTED_MODULE_5_moment___default.a.weekdaysMin(),
  defaultFirstDayOfWeek: 1
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_gettext___default.a, {
  translations: __WEBPACK_IMPORTED_MODULE_12__translations_translations_json___default.a,
  availableLanguages: {
    de_DE: 'DE',
    en_150: 'EN'
  },
  defaultLanguage: 'de_DE'
});

var leurisConfig = window.LEURIS_CONFIG || { MODE: 'FOB' };
var leurisMode = leurisConfig.MODE;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$leurisMode = leurisMode;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('fob-entity-details', __WEBPACK_IMPORTED_MODULE_13__components_EntityDetails__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('fob-entity-create-form', __WEBPACK_IMPORTED_MODULE_14__components_form_EntityCreateForm__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */])(leurisMode),
  store: __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]
  },
  methods: {
    checkUserToken: function checkUserToken() {
      if (__WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].getters['user/isAuthorized']) {
        if (__WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].getters['user/remainingSessionLength'] <= 0) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils__["b" /* ToastError */])(this.$gettext('toast.session.expired'));
          __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].dispatch('user/logout');
          this.$router.replace({ name: 'welcome' });
        } else if (__WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].getters['user/remainingSessionLength'] < 10 * 60 * 1000) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils__["b" /* ToastError */])(this.$gettext('toast.session.will.expired.soon'));
        }
      }
    },
    checkForUpdate: function checkForUpdate() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('/static/data/version.json').then(function (response) {
        var clientVersion = __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].getters['getVersion'];
        var serverVersion = response.data.version;
        if (clientVersion !== serverVersion) {
          __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].dispatch('setServerVersion', serverVersion);
          _this.$snackbar.open({
            indefinite: false,
            duration: 10000,
            message: _this.$gettext('UpdateAvailable'),
            type: 'is-info',
            position: 'is-bottom-right',
            actionText: _this.$gettext('ReloadPage'),
            queue: false,
            onAction: function onAction() {
              console.log('ok');
              // reload page
              window.location.reload(true);
            }
          });
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    // set language on start
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.language = __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].getters['language'];

    __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].dispatch('start');
    // this.checkUserToken()
    this.checkForUpdate();
    /*
    // user token
    setInterval(() => {
      this.checkUserToken()
    }, 60 * 1000) // every 60 seconds
    */

    // version
    setInterval(function () {
      _this2.checkForUpdate();
    }, 60 * 60 * 1000); // every hour

    if (__WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].state.lastVersion === '') {
      __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].dispatch('updateLastVersion', __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].state.version);
    }

    // this triggers deletion of the local storage when a schema change has
    // occured. the version number in the if condition below represents the
    // version number of the latest schema change.
    // for every user with a version number below that version the local
    // storage needs to be deleted
    if (__WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].state.lastVersion !== __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].state.version && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils__["c" /* isLowerVersion */])(__WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].state.lastVersion, 'v0.43.0')) {
      console.log('Dropping browser cache');
      var fobStorage = window.localStorage.getItem('de.ul.fob');
      var fobJSON = JSON.parse(fobStorage);
      delete fobJSON.list;
      fobJSON.lastVersion = __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].state.version;
      __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].dispatch('updateLastVersion', __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].state.version);
      __WEBPACK_IMPORTED_MODULE_9_js_cookie__["remove"](__webpack_require__.i({"NODE_ENV":"production","FOB_BACKEND_URL":"","FOB_BACKEND_PATH":"/fob","FOB_BACKEND_PORT":"","ANCHOR_WHEEL_URL":"","ANCHOR_WHEEL_PATH":"/anchorwheel/api","ANCHOR_WHEEL_PORT":"","LEURIS_WIKI_URL":"https://home.uni-leipzig.de/~leuriswiki/doku.php","MACO_URL":"/profilseite","MACO_PORT":"","MACO_BACKEND_URL":"","MACO_BACKEND_PATH":"/profilseite/api","MACO_BACKEND_PORT":"","ALT_LOGIN_URL":"","ALT_LOGIN_PORT":"","ALT_LOGIN_PATH":"/tomaner/login/","ALT_LOGIN_TRANSFORMATOR":(function transformator(x) { return x.fob.body }),"ORCID_BASE_URL":"https://orcid.org","EXPORT_SERVER_URL":"","EXPORT_SERVER_PORT":"","EXPORT_SERVER_PATH":"/fob/export/","LEURIS_BASE_URI":"https://leuris.uni-leipzig.de"}).COOKIE_KEY_MACO, {
        path: '',
        domain: __webpack_require__.i({"NODE_ENV":"production","FOB_BACKEND_URL":"","FOB_BACKEND_PATH":"/fob","FOB_BACKEND_PORT":"","ANCHOR_WHEEL_URL":"","ANCHOR_WHEEL_PATH":"/anchorwheel/api","ANCHOR_WHEEL_PORT":"","LEURIS_WIKI_URL":"https://home.uni-leipzig.de/~leuriswiki/doku.php","MACO_URL":"/profilseite","MACO_PORT":"","MACO_BACKEND_URL":"","MACO_BACKEND_PATH":"/profilseite/api","MACO_BACKEND_PORT":"","ALT_LOGIN_URL":"","ALT_LOGIN_PORT":"","ALT_LOGIN_PATH":"/tomaner/login/","ALT_LOGIN_TRANSFORMATOR":(function transformator(x) { return x.fob.body }),"ORCID_BASE_URL":"https://orcid.org","EXPORT_SERVER_URL":"","EXPORT_SERVER_PORT":"","EXPORT_SERVER_PATH":"/fob/export/","LEURIS_BASE_URI":"https://leuris.uni-leipzig.de"}).COOKIE_DOMAIN
      });
      window.localStorage.removeItem('de.ul.fob');
      window.localStorage.setItem('de.ul.fob', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(fobJSON));
      // store.dispatch('user/logout').then(() => this.$router.push('/login'))
      location.reload();
    }
  }
});

/***/ }),

/***/ "NJ16":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGIN_MACO", function() { return LOGIN_MACO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET", function() { return RESET; });
var LOGIN_MACO = function LOGIN_MACO(state, _ref) {
  var loggedIn = _ref.loggedIn,
      token = _ref.token,
      validUntil = _ref.validUntil;

  state.maco.loggedIn = loggedIn || false;
  state.maco.token = token || null;
  state.maco.validUntil = validUntil || null;
};

var RESET = function RESET(state) {
  state.maco.loggedIn = false;
  state.maco.token = null;
  state.maco.validUntil = null;
};

/***/ }),

/***/ "NKc/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NOQi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Public_vue__ = __webpack_require__("nVE5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8830fb64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Public_vue__ = __webpack_require__("q+oM");
function injectStyle (ssrContext) {
  __webpack_require__("DEzH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Public_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8830fb64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Public_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NUk6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity__ = __webpack_require__("9fz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FieldsGeneric__ = __webpack_require__("WWW9");



var Fields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__FieldsGeneric__["a" /* default */])('PubIdent');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'PubIdent',
  route: 'pubident',
  class: __WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity__["PubIdent"],
  className: 'pubIdent',
  fields: [Fields.String('wert'), Fields.PrefetchedSingleReference('pubIdentTyp', 'pubIdentTyp', 'folder-open')]
});

/***/ }),

/***/ "NWfb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__ = __webpack_require__("9fz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AbstractPerson__ = __webpack_require__("BP7K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ExterneOrganisation__ = __webpack_require__("Vu0z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FieldsGeneric__ = __webpack_require__("WWW9");






var Fields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__FieldsGeneric__["a" /* default */])('Kooperation');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Kooperation',
  route: 'kooperation',
  className: 'kooperation',
  class: __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__["Kooperation"],
  fields: [Fields.organisationseinheit, Fields.relevantFuerWeitere, Fields.weitereOrganisationseinheiten, Fields.String('titelKooperation'), Fields.Text('kurzbeschreibung', 6000), Fields.MultiReference('ansprechpartner', 'user', __WEBPACK_IMPORTED_MODULE_2__AbstractPerson__["a" /* default */]), Fields.Date('beginn'), Fields.Boolean('endeGeplant'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.Date('ende'), {
    view: function view(data, user) {
      return data.endeGeplant === true;
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.Label('kooperationsarten'), { inPublicView: false }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.Boolean('gemeinsameThemen'), { narrow: true, inPublicView: false }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.Boolean('gegenseiteHilfe'), { narrow: true, inPublicView: false }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.Boolean('gastaufenthalte'), { narrow: true, inPublicView: false }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.Boolean('gemeinsameTagungen'), { narrow: true, inPublicView: false }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.Boolean('gemeinsamePublikationen'), { narrow: true, inPublicView: false }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.Boolean('doktorandenProgramm'), { narrow: true, inPublicView: false }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.Boolean('andereKooperation'), { narrow: true, inPublicView: false }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.Text('kooperationsartFreitext', 6000), {
    view: function view(data, user) {
      return data.andereKooperation === true;
    }
  }), Fields.MultiReference('beteiligtePersonen', 'user', __WEBPACK_IMPORTED_MODULE_2__AbstractPerson__["a" /* default */]), Fields.SimpleMultiReference('beteiligteOrganisationen', 'sitemap', __WEBPACK_IMPORTED_MODULE_3__ExterneOrganisation__["a" /* default */])]
});

/***/ }),

/***/ "Noxu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchResearchProjectDetailsQuery; });
function fetchResearchProjectDetailsQuery(id) {
  var variables = { id: id };

  return {
    operationName: 'fetchResearchProjectDetailsQuery',
    query: '\n      query fetchResearchProjectDetailsQuery($id: ID!) {\n        forschungsprojekt: project(id: $id) {\n          organisationseinheit: organisationalUnit {\n            _id:id\n            _entityName\n            _stringRep\n            parentOrgaName\n          }\n          relevantFuerWeitere: hasMultipleOus\n          weitereOrganisationseinheiten: additionalOrganisationalUnits {\n            _id:id\n            _entityName\n            _stringRep\n            parentOrgaName\n          }\n          _id: id\n          _entityName\n          _stringRep\n          primaryPublicIdent\n          titelDE: titleDe\n          titelEN: titleEn\n          beschreibungDE: descriptionDe\n          beschreibungEN: descriptionEn\n          uebergeordnetesProjekt: superordinateProject\n          antragsteller: applicants {\n            _entityName\n            _stringRep: fullName\n            fisPersid\n            orcid\n          }\n          sdg {\n            _id: id\n            _entityName\n            _stringRep\n            nameDe\n            nameEn\n          }\n          projektleiter: managers {\n            startdatum: startDate\n            enddatum: endDate\n            person {\n              _entityName\n              _stringRep: fullName\n              fisPersid\n              orcid\n            }\n          }\n          mitarbeiter: collaborators {\n            _entityName\n            _stringRep: fullName\n            fisPersid\n            orcid\n          }\n          projektBeginn: startDate\n          projektEnde: endDate\n          externeProjektwebsite: externalProjectWebsite\n          foerderung: funding {\n            mittelgeber: fundingAgency {\n              _stringRep\n              _entityName\n              finSchluessel: financingKey\n            }\n            foerderkennzeichen: fundingCode\n          }\n          publikation: publications {\n            _id:id\n            _entityName\n            _stringRep\n            titelPublikation:title\n            publikationsTyp:typeDe\n            author:authors {\n              _stringRep\n              _entityName\n              name:surname\n              vorname:givenName\n            }\n            herausgeber:editors {\n              _stringRep\n              _entityName\n              name:surname\n              vorname:givenName\n            }\n            verlagsort:place\n            veroeffentlichungsJahr:year\n            organisationseinheit:organisationalUnit {\n              name:titleDe\n            }\n            weitereOrganisationseinheiten:additionalOrganisationalUnits {\n              name:titleDe\n            }\n            publicPubIdent:identifiers {\n              pubIdentTyp:type {\n                anmerkung:comment\n                kennung:key\n              }\n              wert:value\n            }\n            institution:issuingOrganisation\n            journal\n            verleger:publisher\n            journalNummer:issue\n            band:volume\n            istFinal:validated\n            seiteEnde:pageEnd\n            seiteStart:pageStart\n            serientitel:seriesTitle\n            sprache:language\n            buchtitel:bookTitle\n            validiert:validated\n            foerderer:fundingAgencies {\n              _entityName\n              _stringRep\n              name\n            }\n          }\n          verbundprojekt: isJointProject\n          sprecherhochschule: spokesperson_ou {\n            _entityName\n            _stringRep\n          }\n        }\n      }\n    ',
    variables: variables
  };
}



/***/ }),

/***/ "OEr8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "requestExport", function() { return requestExport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__("eOoE");



var requestExport = function requestExport(year, orgaId, email, format) {
  var payload = {
    jahr: year,
    orgaId: orgaId,
    email: email,
    format: format
  };
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__axios__["b" /* leurisExportAxios */])('post', payload).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      if (error && error.response && error.response.data && error.response.status) {
        reject('Error ' + error.response.status + ': ' + error.response.data.error);
      } else {
        reject('Error: Server down');
      }
    });
  });
};

/***/ }),

/***/ "ObY8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OdqC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicEntity_vue__ = __webpack_require__("SRFI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8790f5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicEntity_vue__ = __webpack_require__("YVNy");
function injectStyle (ssrContext) {
  __webpack_require__("Rn3h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicEntity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8790f5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicEntity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P1X8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__ = __webpack_require__("cigy");

var Filter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__["a" /* default */])('Patent');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Patent',
  route: 'patent',
  fields: [Filter.ReferenceByMultiValueSearchRep('organisationseinheit', 'sitemap', 'organisationseinheit'), Filter.kumuliert(), Filter.Number('jahrDerPrioritaetsbegruendendenErstanmeldung', 'calendar-o'), Filter.ReferenceByMultiValueSearchRep('haupterfinder', 'user', 'abstractPerson'), Filter.String('titel'), Filter.String('veroeffentlichungsnummer'), Filter.String('lizenzen'), Filter.String('link'), Filter.String('forschungsgebiet'), Filter.String('kurzbeschreibung'), Filter.ReferenceByMultiValueSearchRep('anmelderExtern', 'sitemap', 'externeOrganisation'), Filter.ReferenceByMultiValueSearchRep('anmelderIntern', 'sitemap', 'organisationseinheit'), Filter.ReferenceByMultiValueSearchRep('ansprechpartner', 'user', 'abstractPerson'), Filter.ReferenceBySearchRep('land', 'globe', 'land')]
});

/***/ }),

/***/ "PB4+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadAsyncData", function() { return loadAsyncData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadAsyncStaff", function() { return loadAsyncStaff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStaffFullName", function() { return setStaffFullName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setShowOrgaTree", function() { return setShowOrgaTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setConfig", function() { return setConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setResourceType", function() { return setResourceType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changePage", function() { return changePage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setActiveTab", function() { return setActiveTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setData", function() { return setData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changePerPage", function() { return changePerPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSortField", function() { return setSortField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSortOrder", function() { return setSortOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSelected", function() { return setSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTotal", function() { return setTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateFilter", function() { return updateFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateListSchemaFields", function() { return updateListSchemaFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setOrganisationalUnitName", function() { return setOrganisationalUnitName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoading", function() { return isLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reset", function() { return reset; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__("eOoE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphql_ouDetails__ = __webpack_require__("8IlM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql__ = __webpack_require__("lwCg");






function runQuery(state, resourceType, query) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__axios__["a" /* graphql */])(query(state.selected.rootQueryType, state.selected.id, state.config[resourceType].perPage, state.config[resourceType].page, state.config[resourceType].sortField, state.config[resourceType].sortOrder, state.filter[resourceType].filter));
}

var loadAsyncData = function loadAsyncData(_ref, resourceType) {
  var state = _ref.state,
      commit = _ref.commit;

  commit('IS_LOADING', true);
  var fetchData = [];
  if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.data).includes(resourceType)) {
    var resource = state.resourceTypes.filter(function (resource) {
      return resource.type === resourceType;
    })[0];
    fetchData = [runQuery(state, resource.type, resource.query)];
  } else {
    state.resourceTypes.forEach(function (resource) {
      fetchData.push(runQuery(state, resource.type, resource.query));
    });
    /* these promise is pushed to fetchData in order to control the 'loading state' attribute */
    if (state.selected.rootQueryType === 'organisationalUnit' && state.selected.id != null) {
      fetchData.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__axios__["a" /* graphql */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__graphql_ouDetails__["a" /* fetchOuDetailsQuery */])(Number(state.selected.id))).then(function (response) {
        commit('SET_LABEL', response.data.data.organisationalUnit.stringRep);
        commit('SET_OU_DETAILS', response.data.data.organisationalUnit);
      }));
    } else if (state.selected.rootQueryType === 'person' && state.selected.id != null) {
      fetchData.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__axios__["a" /* graphql */])(state.leurisProfile.query({ fisPersid: state.selected.id })).then(function (response) {
        commit('SET_LABEL', response.data.data.person.name);
        commit('SET_LEURIS_PROFILE', response.data.data.person);
      }));
    }
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(fetchData).then(function (responses) {
    responses.forEach(function (response) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.data).forEach(function (resourceType) {
        if (response) {
          var data = response.data.data[state.selected.rootQueryType];
          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).includes(resourceType)) {
            commit('SET_DATA', {
              resourceType: resourceType,
              data: data[resourceType].entries
            });
            commit('SET_TOTAL', {
              resourceType: resourceType,
              total: data[resourceType].meta.totalEntries
            });
          }
        }
      });

      commit('IS_LOADING', false);
    });
  });
};

var loadAsyncStaff = function loadAsyncStaff(_ref2, _ref3) {
  var state = _ref2.state,
      commit = _ref2.commit;
  var startsWith = _ref3.startsWith,
      filter = _ref3.filter;

  commit('IS_LOADING_STAFF', true);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__axios__["a" /* graphql */])(state.staff.query({ startsWith: startsWith, filter: filter })).then(function (response) {
    var letterCount = response.data.data.staff.meta.decompositions[0].letterCount;
    var totalEntries = response.data.data.staff.meta.totalEntries;
    var data = response.data.data.staff.entries;

    commit('SET_STAFF_LETTER_COUNT', letterCount);
    commit('SET_STAFF_FULLNAME', filter.fullName);
    commit('SET_STAFF_TOTAL_ENTRIES', totalEntries);
    commit('SET_STAFF_STARTSWITH', startsWith);
    commit('SET_STAFF_DATA', data);
    commit('IS_LOADING_STAFF', false);
  });
};

var setStaffFullName = function setStaffFullName(_ref4, fullName) {
  var state = _ref4.state,
      commit = _ref4.commit;

  commit('SET_STAFF_FULLNAME', fullName);
};

var setShowOrgaTree = function setShowOrgaTree(_ref5, show) {
  var state = _ref5.state,
      commit = _ref5.commit;

  commit('SET_SHOW_ORGATREE', show);
};

var setConfig = function setConfig(_ref6, _ref7) {
  var state = _ref6.state,
      commit = _ref6.commit;
  var resourceType = _ref7.resourceType,
      property = _ref7.property,
      value = _ref7.value;

  commit('SET_CONFIG', { resourceType: resourceType, property: property, value: value });
};

var setResourceType = function setResourceType(_ref8, type) {
  var state = _ref8.state,
      commit = _ref8.commit;

  commit('SET_RESOURCE_TYPE', type);
};

var changePage = function changePage(_ref9, _ref10) {
  var state = _ref9.state,
      commit = _ref9.commit;
  var resourceType = _ref10.resourceType,
      page = _ref10.page;

  commit('CHANGE_PAGE', { resourceType: resourceType, page: page });
};

var setActiveTab = function setActiveTab(_ref11, activeTab) {
  var state = _ref11.state,
      commit = _ref11.commit;

  commit('SET_ACTIVE_TAB', activeTab);
  commit('SET_RESOURCE_TYPE', state.resourceTypes[activeTab].type);
};

var setData = function setData(_ref12, _ref13) {
  var state = _ref12.state,
      commit = _ref12.commit;
  var resourceType = _ref13.resourceType,
      data = _ref13.data;

  commit('SET_DATA', { resourceType: resourceType, data: data });
};

var changePerPage = function changePerPage(_ref14, _ref15) {
  var state = _ref14.state,
      commit = _ref14.commit;
  var resourceType = _ref15.resourceType,
      perPage = _ref15.perPage;

  commit('CHANGE_PER_PAGE', { resourceType: resourceType, perPage: perPage });
  // show first on perPage change
  commit('SET_CONFIG', { resourceType: resourceType, property: 'page', value: 1 });
};

var setSortField = function setSortField(_ref16, _ref17) {
  var state = _ref16.state,
      commit = _ref16.commit;
  var resourceType = _ref17.resourceType,
      sortField = _ref17.sortField;

  commit('SET_SORT_FIELD', { resourceType: resourceType, sortField: sortField });
  // show first on perPage change
  commit('SET_CONFIG', { resourceType: resourceType, property: 'page', value: 1 });
};

var setSortOrder = function setSortOrder(_ref18, _ref19) {
  var state = _ref18.state,
      commit = _ref18.commit;
  var resourceType = _ref19.resourceType,
      sortOrder = _ref19.sortOrder;

  commit('SET_SORT_ORDER', { resourceType: resourceType, sortOrder: sortOrder });
  // show first on perPage change
  commit('SET_CONFIG', { resourceType: resourceType, property: 'page', value: 1 });
};

var setSelected = function setSelected(_ref20, selected) {
  var state = _ref20.state,
      commit = _ref20.commit;

  if (selected.type === 'ou') {
    var redirect = false;
    var fromOU = state.selected.id;
    var toOU = selected.id || '1';

    if (fromOU !== toOU) {
      // Using `await` does not work at all, sadly. It transforms the whole
      // block into some weird Promise and toOU ends up being undefined
      // I don't even...
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__axios__["a" /* graphql */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__graphql__["g" /* findClosestPublicOU */])(toOU)).then(function (response) {
        var closestPublicOU = response.data.data.closestPublicOrganisationalUnit.id;
        if (closestPublicOU !== toOU) {
          console.warn('Requested OU ' + toOU + ' is not public, redirecting to ' + closestPublicOU);
          redirect = true;
        }
        selected.id = closestPublicOU;
        commit('SET_SELECTED', selected);
        return { redirect: redirect, orgaID: closestPublicOU };
      });
    } else {
      commit('SET_SELECTED', selected);
      return { redirect: redirect, orgaID: toOU };
    }
  } else {
    commit('SET_SELECTED', selected);
  }
};

var setTotal = function setTotal(_ref21, _ref22) {
  var state = _ref21.state,
      commit = _ref21.commit;
  var resourceType = _ref22.resourceType,
      total = _ref22.total;

  commit('SET_TOTAL', { resourceType: resourceType, total: total });
};

var updateFilter = function updateFilter(_ref23, _ref24) {
  var state = _ref23.state,
      commit = _ref23.commit;
  var resourceType = _ref24.resourceType,
      updateFilter = _ref24.updateFilter;

  if ('inProject' in updateFilter) {
    if (updateFilter.inProject === 'true' || updateFilter.inProject === null) {
      updateFilter.inProject = true;
    } else {
      updateFilter.inProject = false;
    }
  }
  if ('fundedByCategory' in updateFilter && updateFilter.fundedByCategory === 'null') {
    updateFilter.fundedByCategory = null;
  }
  commit('UPDATE_FILTER', { resourceType: resourceType, updateFilter: updateFilter });
};

var updateListSchemaFields = function updateListSchemaFields(_ref25, resourceType, updatedListSchemaFields) {
  var state = _ref25.state,
      commit = _ref25.commit;

  commit('UPDATE_LIST_SCHEMA_FIELDS', { resourceType: resourceType, updatedListSchemaFields: updatedListSchemaFields });
};

var setOrganisationalUnitName = function setOrganisationalUnitName(_ref26, name) {
  var state = _ref26.state,
      commit = _ref26.commit;

  commit('SET_ORGANISATIONAL_UNIT_NAME', name);
};

var isLoading = function isLoading(_ref27, loadingState) {
  var state = _ref27.state,
      commit = _ref27.commit;
  return commit('IS_LOADING', loadingState);
};

var reset = function reset(_ref28) {
  var state = _ref28.state,
      commit = _ref28.commit;
  return commit('RESET');
};

/***/ }),

/***/ "PKt+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-collapse',{staticClass:"card",staticStyle:{"margin-bottom":"2rem"},attrs:{"open":_vm.searchOpen},on:{"update:open":function($event){_vm.searchOpen=$event}}},[_c('div',{staticClass:"card-header",attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"card-header-title"},[_c('a',[_c('b-icon',{attrs:{"icon":_vm.searchOpen ? 'angle-down' : 'angle-right'}})],1),_vm._v(" "),_c('translate',[_vm._v("list.options.adjust.searchparameters")])],1),_vm._v(" "),_c('div',{staticClass:"card-header-icon"},[_c('span',{staticClass:"has-text-basalt"},[_vm._v("\n          "+_vm._s(_vm.total)+" "+_vm._s(_vm.total === 1 ? _vm.$gettext('list.total') : _vm.$gettext('list.total.plural'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"card-content",staticStyle:{"padding-top":"0","padding-bottom":"3rem"}},[_c('div',{key:_vm.filterSchema.label},[_c('fob-entity-create-form',{ref:"fobEntityCreateForm",attrs:{"schema":_vm.filterSchema},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"fob-only-for-print-view"},[_c('div',{staticClass:"print-metadata-box"},[_c('div',{staticClass:"print-metadata-columns"},[_c('div',{staticClass:"print-metadata-label"},[_c('translate',[_vm._v("tag.static.researchActivity")])],1),_vm._v(" "),_c('div',{staticClass:"print-metadata-value"},[_c('translate',[_vm._v(_vm._s(this.filterSchema.label))])],1)]),_vm._v(" "),_c('div',{staticClass:"print-metadata-columns"},[_c('div',{staticClass:"print-metadata-label"},[_c('translate',[_vm._v("tag.static.printedPageOfPagesLabel")])],1),_vm._v(" "),_c('div',{staticClass:"print-metadata-value"},[_c('translate',{attrs:{"translate-params":{page: _vm.page, totalTablePages: _vm.totalTablePages}}},[_vm._v("tag.static.printedPageOfPagesValue")])],1)]),_vm._v(" "),_c('div',{staticClass:"print-metadata-columns"},[_c('div',{staticClass:"print-metadata-label"},[_c('translate',[_vm._v("tag.static.resultCount")])],1),_vm._v(" "),_c('div',{staticClass:"print-metadata-value"},[_vm._v(_vm._s(this.total))])]),_vm._v(" "),_c('div',{staticClass:"print-metadata-columns"},[_c('div',{staticClass:"print-metadata-label"},[_c('translate',[_vm._v("tag.static.entriesPerPage")])],1),_vm._v(" "),_c('div',{staticClass:"print-metadata-value"},[_vm._v(_vm._s(this.perPage))])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"tags"}},[_c('b-field',{directives:[{name:"show",rawName:"v-show",value:(!_vm.searchOpen && _vm.hasActiveFilters),expression:"!searchOpen && hasActiveFilters"}],staticClass:"fob-entity-list-filter-tags",attrs:{"grouped":"","group-multiline":""}},[_c('transition-group',{staticClass:"fob-entity-list-options-tag-list-dynamic",attrs:{"name":"tag-list"}},_vm._l((_vm.activeFilter),function(value,field){return _c('div',{key:field},[_c('b-taglist',{attrs:{"attached":""}},[_c('b-tag',{attrs:{"type":"is-aquamarine"}},[_vm._v("\n              "+_vm._s(_vm.$gettext(_vm.schemaBitForField(field).label))+"\n            ")]),_vm._v(" "),_c('b-tag',{attrs:{"type":"is-basalt","closable":""},on:{"close":function($event){_vm.removeTag(field)}}},[_c('fob-entity-value',{attrs:{"plain":true,"bit":_vm.schemaBitForField(field),"resourceData":value,"maxLength":30}})],1)],1)],1)}))],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PVM7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityListCompact_vue__ = __webpack_require__("DSDm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25c4326d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityListCompact_vue__ = __webpack_require__("84oZ");
function injectStyle (ssrContext) {
  __webpack_require__("Xkiq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityListCompact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25c4326d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityListCompact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PdFZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pn/Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PxRq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{ 'entity-decoration': _vm.decorate },style:(_vm.decorationStyle)},[_vm._t("default"),_vm._v(" "),(_vm.hasOrcid)?_c('span',[_c('a',{attrs:{"target":"_blank","href":("https://orcid.org/" + (_vm.resourceData.orcid))}},[_c('img',{attrs:{"width":"16","height":"16","src":__webpack_require__("tNDU")}})])]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Pxwp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__("eOoE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphql__ = __webpack_require__("lwCg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_es6_promise_debounce__ = __webpack_require__("91kW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_es6_promise_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_es6_promise_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_EntityHeader__ = __webpack_require__("sGAB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_public_PublicSelectTag__ = __webpack_require__("ZNs5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mixins_PublicViewHelper__ = __webpack_require__("VlMm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_mixins_TooltipHelper__ = __webpack_require__("Aa4s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_tree_Tree__ = __webpack_require__("vXi7");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-public-select-organisational-unit',
  mixins: [__WEBPACK_IMPORTED_MODULE_7__components_mixins_PublicViewHelper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__components_mixins_TooltipHelper__["a" /* default */]],
  data: function data() {
    return {
      data: [],
      isFetching: false,
      maxLengthOfTags: 46, // will also set by TooltipHelper - default: 30
      searchStr: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    selectedOrganisationalUnit: 'tree/selected'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    resetSelectedTreeItem: 'tree/reset',
    selectBranch: 'tree/selectBranch'
  }), {
    loadAsyncOrganisationalUnits: __WEBPACK_IMPORTED_MODULE_4_es6_promise_debounce___default()(function (text) {
      var _this = this;

      if (text && text.length > 0) {
        this.isFetching = true;
        // clear previous results
        this.data = [];
        // graphql options
        var opts = {
          sortOrder: 'ASC',
          orderBy: 'TITLE_DE',
          filter: {
            text: text
          }
          // start fetching ous
        };__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__axios__["a" /* graphql */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__graphql__["i" /* fetchOrganisationalUnits */])(opts)).then(function (response) {
          _this.data = response.data.data.organisationalUnits.entries;
          _this.isFetching = false;
        }).catch(function () {
          _this.isFetching = false;
        });
      }
    }, 500),
    selectOrganisationalUnit: function selectOrganisationalUnit(ou) {
      this.setRoute('ou', ou.id);
      this.selectBranch({ id: ou.id, name: ou.name });
    },
    setRoute: function setRoute(type, id) {
      var to = {
        name: 'public',
        params: {
          type: type,
          id: id,
          resourceType: this.activeResourceType
        }
      };
      this.$router.replace(to);
    }
  }),
  components: {
    'fob-tree': __WEBPACK_IMPORTED_MODULE_9__components_tree_Tree__["a" /* default */],
    'fob-entity-header': __WEBPACK_IMPORTED_MODULE_5__components_EntityHeader__["a" /* default */],
    'fob-public-select-tag': __WEBPACK_IMPORTED_MODULE_6__components_public_PublicSelectTag__["a" /* default */]
  }
});

/***/ }),

/***/ "Q3mG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q9ro":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchPublicationDetailsQuery; });
function fetchPublicationDetailsQuery(id) {
  var variables = { id: id };

  return {
    operationName: 'fetchPublicationDetailsQuery',
    query: '\n      query fetchPublicationDetailsQuery($id: Int!) {\n        publikation: publication(id: $id) {\n          _id: id\n          _stringRep\n          _entityName\n          titelPublikation: title\n          publikationsTyp: typeDe\n          author: authors {\n            _stringRep: fullName\n            _entityName\n            fisPersid\n            orcid\n          }\n          herausgeber: editors {\n            _stringRep: fullName\n            _entityName\n            fisPersid\n            orcid\n          }\n          verlagsort: place\n          veroeffentlichungsJahr: year\n          organisationseinheit: organisationalUnit {\n            _id:id\n            _stringRep\n            _entityName\n            parentOrgaName\n          }\n          relevantFuerWeitere: hasMultipleOus\n          weitereOrganisationseinheiten: additionalOrganisationalUnits {\n            _id:id\n            _stringRep\n            _entityName\n            parentOrgaName\n          }\n          publicPubIdent: identifiers {\n            pubIdentTyp: type {\n              _entityName\n              _stringRep\n              kennung: key\n            }\n            wert: value\n          }\n          institution: issuingOrganisation\n          journal\n          verleger: publisher\n          journalNummer: issue\n          band: volume\n          istFinal: validated\n          seiteEnde: pageEnd\n          seiteStart: pageStart\n          serientitel: seriesTitle\n          sprache: language\n          buchtitel: bookTitle\n          validiert: validated\n          inProjekt: inProject\n          forschungsprojekt: project {\n            _id:id\n            _entityName\n            _stringRep\n          }\n          foerderer: fundingAgencies {\n            _entityName\n            _stringRep\n            name\n          }\n        }\n      }\n    ',
    variables: variables
  };
}



/***/ }),

/***/ "QGv4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchResearchProjectQuery; });
function fetchResearchProjectQuery(rootQueryType, id, pageSize, page, sortField, sortOrder, filter) {
  rootQueryType = ['organisationalUnit', 'person'].includes(rootQueryType) ? rootQueryType : null;
  id = rootQueryType === 'organisationalUnit' ? Number(id) : '' + id;

  // if the rootQueryType does not match for organisational unit or person then return nulls
  if (!rootQueryType) {
    return null;
  }

  var variables = {
    id: id || null,
    pageSize: Number(pageSize) || 20,
    page: Number(page) || 1
  };

  if (sortOrder) {
    variables['sortOrder'] = sortOrder;
  }

  if (sortField) {
    variables['sortField'] = sortField;
  }

  if (filter && filter.year && Number(filter.year)) {
    variables['filterYear'] = Number(filter.year);
  }

  if (filter && filter.freetext && filter.freetext.length > 0) {
    variables['filterFreetext'] = filter.freetext;
  }

  if (filter && filter.funding && filter.funding.length > 0) {
    variables['filterFunding'] = filter.funding;
  }

  if (filter && filter.sdg && filter.sdg.length !== '') {
    var value = filter.sdg;
    if (value.startsWith('SDG')) {
      var _id = parseInt(value.slice(3));
      variables['filterSdgIds'] = [_id];
    } else {
      variables['filterSdgCategory'] = value;
    }
  }

  if (filter && filter.person && filter.person.length > 0) {
    variables['filterPerson'] = filter.person;
  }

  if (filter && filter.status && filter.status.length > 0) {
    variables['filterStatus'] = filter.status;
  }

  return {
    operationName: 'fetchResearchProjectQuery',
    query: '\n      query fetchResearchProjectQuery(\n        $id: ID!,\n        $pageSize:Int!,\n        $page:Int!,\n        $sortOrder:SortOrder,\n        $sortField:ProjectSortKeys,\n        $filterYear:Int,\n        $filterFreetext:String,\n        $filterFunding:String,\n        $filterSdgCategory:SdgCategory,\n        $filterSdgIds:[Int],\n        $filterPerson:String,\n        $filterStatus:String\n      ) {\n        ' + rootQueryType + '(id: $id) {\n          forschungsprojekt:projects(\n            pageSize: $pageSize, page: $page, sortOrder: $sortOrder, orderBy:$sortField,\n            filter: {\n              year: $filterYear\n              freeText: $filterFreetext\n              funding: $filterFunding\n              person: $filterPerson\n              sdgCategory: $filterSdgCategory\n              sdgIds: $filterSdgIds\n              status: $filterStatus\n            }\n          ) {\n            meta {\n              totalPages\n              totalEntries\n              pageNumber\n              pageSize\n            }\n            entries {\n              ... on Project {\n                _id:id\n                _entityName\n                primaryPublicIdent\n                sdg {\n                  _id:id\n                  _stringRep\n                }\n                html {\n                  de\n                  en\n                }\n                publications_count\n              }\n            }\n          }\n        }\n      }\n    ',
    variables: variables
  };
}



/***/ }),

/***/ "QLxO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QOdh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reset", function() { return reset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveBranchData", function() { return saveBranchData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveOpenBranch", function() { return saveOpenBranch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveRootData", function() { return saveRootData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeOpenBranch", function() { return removeOpenBranch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectBranch", function() { return selectBranch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startLoading", function() { return startLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stopLoading", function() { return stopLoading; });
var reset = function reset(_ref) {
  var dispatch = _ref.dispatch,
      commit = _ref.commit;

  commit('RESET');
};

var saveBranchData = function saveBranchData(_ref2, treeItemData) {
  var dispatch = _ref2.dispatch,
      commit = _ref2.commit;

  commit('SAVE_BRANCH_DATA', treeItemData);
};

var saveOpenBranch = function saveOpenBranch(_ref3, id) {
  var dispatch = _ref3.dispatch,
      commit = _ref3.commit;

  commit('SAVE_OPEN_BRANCH', id);
};

var saveRootData = function saveRootData(_ref4, rootData) {
  var dispatch = _ref4.dispatch,
      commit = _ref4.commit;

  commit('SAVE_ROOT_DATA', rootData);
};

var removeOpenBranch = function removeOpenBranch(_ref5, id) {
  var dispatch = _ref5.dispatch,
      commit = _ref5.commit;

  commit('REMOVE_OPEN_BRANCH', id);
};

var selectBranch = function selectBranch(_ref6, branch) {
  var dispatch = _ref6.dispatch,
      commit = _ref6.commit;

  commit('SELECT_BRANCH', branch);
};

var startLoading = function startLoading(_ref7) {
  var dispatch = _ref7.dispatch,
      commit = _ref7.commit;

  commit('SET_LOADING', true);
};

var stopLoading = function stopLoading(_ref8) {
  var dispatch = _ref8.dispatch,
      commit = _ref8.commit;

  commit('SET_LOADING', false);
};

/***/ }),

/***/ "QQXh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__schema__ = __webpack_require__("uDTM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fobclient_lib_entity__ = __webpack_require__("9fz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fobclient_lib_entity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_fobclient_lib_entity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mixins_ValidateAndSave__ = __webpack_require__("GfOp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mixins_DynamicTitle__ = __webpack_require__("IqS5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_EntityPalette__ = __webpack_require__("MZuF");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-entity-create',
  mixins: [__WEBPACK_IMPORTED_MODULE_6__components_mixins_ValidateAndSave__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__components_mixins_DynamicTitle__["a" /* default */]],
  data: function data() {
    return {
      resourceTypes: __WEBPACK_IMPORTED_MODULE_3__schema__["a" /* default */].baseTypes,
      leurisHead: {
        inner: 'leuris:Forschungsbericht',
        complement: 'menu.create'
      },
      showErrors: false
    };
  },

  components: {
    'fob-entity-palette': __WEBPACK_IMPORTED_MODULE_8__components_EntityPalette__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    isDirty: 'creator/isDirty',
    loading: 'creator/isLoading',
    resourceType: 'creator/getResourceType',
    schema: 'creator/getSchema'
  }), {
    resourceData: {
      get: function get() {
        return this.$store.getters['creator/getData'];
      },
      set: function set(value) {
        this.$store.dispatch('creator/setData', value);
      }
    },
    selectedSchema: function selectedSchema() {
      return this.$store.getters['creator/getSchema'];
    },
    selectedEntity: function selectedEntity() {
      var _this = this;

      var resource = this.resourceTypes.find(function (x) {
        return x.schema.route === _this.resourceType;
      });
      if (resource != null) {
        var className = resource.schema.className;
        return className.charAt(0).toUpperCase() + className.slice(1);
      } else {
        return '';
      }
    },

    selectedType: {
      get: function get() {
        return this.resourceType;
        // if (this.resourceType === null) {
        //   return null
        // } else {
        //   const sel = this.resourceTypes.findIndex(x => x.schema.route === this.resourceType)
        //   if (sel === -1) {
        //     this.$router.replace({
        //       name: 'eintragen'
        //     })
        //     return null
        //   }
        //   return sel
        // }
      },
      set: function set(v) {
        var _this2 = this;

        // the test v !== this.selectedType is necessary because when reverting
        // the dropdown state back to the current value on cancel, a new update
        // to the the selectedModel is triggered. we want neither show a warning
        // nor reset the resource to a blank state
        if (v !== this.selectedType) {
          if (this.resourceData != null && this.resourceData._dirty) {
            this.$dialog.confirm({
              message: this.$gettext(v != null ? 'warnung.create.nachricht' : 'warnung.create.abbrechen'),
              confirmText: this.$gettext('warnung.create.confirm'),
              cancelText: this.$gettext('warnung.create.cancel'),
              onConfirm: function onConfirm() {
                if (v != null) {
                  _this2.resourceData._dirty = false;
                  _this2.$router.push({
                    name: 'eintragen',
                    params: {
                      resourceType: v
                    }
                  });
                  _this2.$store.dispatch('creator/newEntity');
                } else {
                  _this2.$store.dispatch('creator/closeEditor');
                  _this2.$router.push({ name: 'eintragen' });
                }
              },
              onCancel: function onCancel() {
                _this2.$refs.palette.setSelection(_this2.selectedType);
              }
            });
          } else {
            // TODO: Refactor to DRY
            if (v !== null) {
              var orga = this.$store.getters['user/selectedOrga'];
              var Constructor = __WEBPACK_IMPORTED_MODULE_3__schema__["a" /* default */][v].class;
              var blankEntity = new Constructor({ organisationseinheit: orga });
              this.$store.dispatch('creator/setData', blankEntity);
              this.$router.push({
                name: 'eintragen',
                params: {
                  resourceType: v
                }
              });
            } else {
              this.$store.dispatch('creator/closeEditor');
              this.$router.push({ name: 'eintragen' });
            }
          }
        }
      }
    }
  }),
  beforeMount: function beforeMount() {
    if (this.resourceData != null && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.resourceData).length !== 0 && !(this.resourceData instanceof __WEBPACK_IMPORTED_MODULE_5_fobclient_lib_entity__["BaseEntity"])) {
      var Constructor = this.schema.class;
      var reconstructedEntity = new Constructor(this.resourceData);
      this.resourceData = reconstructedEntity;
    }
  },

  methods: {
    save: function save() {
      this.saveAndDispatch('creator/saveEntity');
      // .then(() => this.$store.dispatch('creator/newEntity'))
      this.$store.dispatch('creator/closeEditor');
    },
    close: function close() {
      this.$refs.palette.setSelection(null);
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var resourceType = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['creator/getResourceType'];
    var isDirty = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['creator/isDirty'];
    if (resourceType != null && to.params.resourceType !== resourceType) {
      if (isDirty && to.params.resourceType != null) {
        // IMPROVEMENT: warning here and optionally start new resource
        // BUT: beforeRouteEnter has not access to the Vue vm and thus can't
        //      translate the dialog. postponed and just silently redirect
        next({
          name: 'eintragen',
          params: {
            resourceType: resourceType
          }
        });
      } else {
        next({
          name: 'eintragen',
          params: {
            resourceType: resourceType
          }
        });
      }
    } else {
      if (to.params.resourceType != null) {
        var type = to.params.resourceType;
        if (__WEBPACK_IMPORTED_MODULE_3__schema__["a" /* default */][type] != null) {
          if (isDirty) {
            __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('creator/setSchema', __WEBPACK_IMPORTED_MODULE_3__schema__["a" /* default */][type]).then(function () {
              return next();
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('creator/setSchema', __WEBPACK_IMPORTED_MODULE_3__schema__["a" /* default */][type]).then(function () {
              return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('creator/newEntity');
            }).then(function () {
              return next();
            });
          }
        } else {
          next('/erstellen');
        }
      } else {
        next();
      }
    }
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.showErrors = false;
    var type = to.params.resourceType;
    var resourceType = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['creator/getResourceType'];
    var isDirty = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['creator/isDirty'];
    if (__WEBPACK_IMPORTED_MODULE_3__schema__["a" /* default */][type] != null) {
      if (isDirty) {
        next(false);
      } else {
        this.$refs.palette.setSelection(type);
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('creator/setSchema', __WEBPACK_IMPORTED_MODULE_3__schema__["a" /* default */][type]).then(function () {
          return next();
        });
      }
    } else if (resourceType != null && to.params.resourceType !== resourceType) {
      next({
        name: 'eintragen',
        params: {
          resourceType: resourceType
        }
      });
    } else {
      next();
    }
    // TODO: Move logic from selectedType setter here
  }
});

/***/ }),

/***/ "QVvY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"container",staticStyle:{"max-width":"1000px"}},[_c('div',{staticClass:"container has-text-centered",staticStyle:{"max-width":"900px","margin-bottom":"4rem"}},[_c('div',{staticClass:"is-size-3 welcome-text-heading is-uppercase",staticStyle:{"margin-bottom":"20px"},domProps:{"innerHTML":_vm._s(_vm.$gettext('welcome.heading'))}}),_vm._v(" "),_c('div',{directives:[{name:"translate",rawName:"v-translate"}],staticClass:"has-text-left welcome-text-above",staticStyle:{"margin-bottom":"2rem","text-align":"justify !important"},attrs:{"v-translate-params":{ renderedRouterLinkPublicActivities: _vm.renderedRouterLinkPublicActivities }}},[_vm._v("welcome.text.above")])]),_vm._v(" "),_c('div',{staticClass:"level box",staticStyle:{"font-variant":"small-caps"}},_vm._l((_vm.resourceTypes),function(rtype){return _c('div',{key:rtype.type,staticClass:"level-item has-text-centered"},[_c('div',[_c('router-link',{staticClass:"has-text-garnet",attrs:{"to":{
              name: 'public',
              params: {
                type: 'ou',
                id: 1,
                resourceType: rtype.type
              }
            }}},[_c('p',[_c('translate',{staticClass:"is-size-5"},[_vm._v(_vm._s(rtype.label))])],1),_vm._v(" "),_c('div',{staticClass:"has-text-basalt is-size-3"},[(_vm.stats != null)?_c('p',[_vm._v("\n                "+_vm._s(_vm.stats[rtype.type].meta.totalEntries.toLocaleString(_vm.$language.current.substring(0, 2)))+"\n              ")]):_c('p',[_vm._v("\n                …\n              ")])])])],1)])})),_vm._v(" "),_c('div',{staticClass:"has-text-centered",staticStyle:{"margin-bottom":"2rem"}},[_c('router-link',{staticClass:"has-text-garnet",attrs:{"to":{
          name: 'public',
          params: {
            type: 'ou',
            id: 1,
            resourceType: 'forschungsprojekt'
          }
        }}},[_c('translate',{staticClass:"is-size-6",staticStyle:{"text-transform":"uppercase","letter-spacing":"1px","padding-right":"0.5rem"}},[_vm._v("welcome.btn.readmore")]),_vm._v(" "),_c('i',{staticClass:"fa fa-chevron-right",attrs:{"aria-hidden":"true"}})],1)],1),_vm._v(" "),_c('div',[_c('h1',{staticClass:"has-text-centered is-size-4 is-uppercase",staticStyle:{"padding":"2rem"}},[_c('translate',[_vm._v("welcome.text.like")])],1),_vm._v(" "),_c('div',{staticClass:"tile is-ancestor"},[_c('div',{staticClass:"tile is-parent"},[_c('article',{staticClass:"tile is-child box"},[_c('p',{staticClass:"title is-size-5"},[_c('translate',[_vm._v("welcome.tile.researchprofile.title")])],1),_vm._v(" "),_c('div',{attrs:{"stlye":"content"},domProps:{"innerHTML":_vm._s(_vm.$gettext('welcome.tile.researchprofile.content'))}})])]),_vm._v(" "),_c('div',{staticClass:"tile is-parent is-5"},[_c('article',{staticClass:"tile is-child box"},[_c('p',{staticClass:"title is-size-5"},[_c('translate',[_vm._v("welcome.tile.techtransfer.title")])],1),_vm._v(" "),_c('div',{attrs:{"stlye":"content"},domProps:{"innerHTML":_vm._s(_vm.$gettext('welcome.tile.techtransfer.content'))}})])]),_vm._v(" "),_c('div',{staticClass:"tile is-parent"},[_c('article',{staticClass:"tile is-child box"},[_c('p',{staticClass:"title is-size-5"},[_c('translate',[_vm._v("welcome.tile.researchservice.title")])],1),_vm._v(" "),_c('div',{attrs:{"stlye":"content"},domProps:{"innerHTML":_vm._s(_vm.$gettext('welcome.tile.researchservice.content'))}})])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QaL/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SavedViews_vue__ = __webpack_require__("cnyR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c96ca8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SavedViews_vue__ = __webpack_require__("HJ35");
function injectStyle (ssrContext) {
  __webpack_require__("mlar")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SavedViews_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c96ca8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SavedViews_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ql6K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchAwardDetailsQuery; });
function fetchAwardDetailsQuery(id) {
  var variables = { id: id };

  return {
    operationName: 'fetchAwardDetailsQuery',
    query: '\n      query fetchAwardDetailsQuery($id: Int!) {\n        preis: award(id: $id) {\n          _entityName\n          _id: id\n          _stringRep\n          hatPreisgeld: endowed\n          namePreis: name\n          vergebenDurch: awardedBy\n          verleihungsJahr: year\n          organisationseinheit: organisationalUnit {\n            _entityName\n            _stringRep\n            _id:id\n            parentOrgaName\n          }\n          preisBezeichnung: type {\n            _entityName\n            _stringRep\n          }\n          preisTraeger: awardee {\n            _entityName\n            _stringRep: fullName\n            fisPersid\n            orcid\n          }\n        }\n      }\n    ',
    variables: variables
  };
}



/***/ }),

/***/ "R0D5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-entity-decorator',
  props: {
    isPublic: {
      type: Boolean,
      default: false
    },
    resourceData: {
      type: [String, Boolean, Number, Object, Array, Date],
      default: null
    }
  },
  computed: {
    hasOrcid: function hasOrcid() {
      if (!this.resourceData._entityName) {
        return false;
      }
      if (!this.resourceData._entityName === 'de.ul.fob.domain.Person') {
        return false;
      }
      if (!this.resourceData.orcid) {
        return false;
      }

      return true;
    },
    decorate: function decorate() {
      return !this.isPublic && this.resourceData._entityName === 'de.ul.fob.domain.AbstractPerson';
    },
    decorationStyle: function decorationStyle() {
      return {
        '--decorator': '"' + this.$gettext('extern') + '"'
      };
    }
  }
});

/***/ }),

/***/ "R2wm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_form_EntityCreateForm__ = __webpack_require__("B6Sg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__schema_list_Export__ = __webpack_require__("xNE7");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-public-list-export',
  data: function data() {
    return {
      data: null,
      loading: true,
      showErrors: false,
      isInvalid: false,
      currentOrga: null,
      resourceData: {
        jahr: null,
        email: null,
        organisationseinheit: null
      },
      sent: false,
      message: '',
      error: null,
      schema: __WEBPACK_IMPORTED_MODULE_5__schema_list_Export__["a" /* default */]
    };
  },

  methods: {
    customEvent: function customEvent(orga, val) {
      if (val.name === 'current-orga') {
        this.resourceData['organisationseinheit'] = orga;
      }
    },
    requestExport: function requestExport() {
      var _this = this;

      if (this.isInvalid) {
        this.showErrors = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* ToastError */])(this.$gettext('toast.validation.failed'));
      } else {
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].leurisExport.requestExport(parseInt(this.resourceData['jahr']), this.resourceData['organisationseinheit']._id, this.resourceData['email'], this.resourceData['format']).then(function () {
          _this.message = _this.$gettext('Export.success');
          _this.sent = true;
        }).catch(function (error) {
          _this.message = _this.$gettext('Export.error');
          _this.error = error;
          _this.sent = true;
        });
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    selectedOrganisationalUnit: 'tree/selected',
    email: 'user/email'
  })),
  components: {
    'fob-entity-create-form': __WEBPACK_IMPORTED_MODULE_2__components_form_EntityCreateForm__["a" /* default */]
  },
  mounted: function mounted() {
    var _this2 = this;

    this.resourceData['jahr'] = new Date().getFullYear();
    this.resourceData['email'] = this.email;
    this.resourceData['format'] = 'PDF';

    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].methods.fetchResource('organisationseinheit', this.selectedOrganisationalUnit.id).then(function (data) {
      _this2.currentOrga = data;
      _this2.loading = false;
    });
  }
});

/***/ }),

/***/ "RVzl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchPublicationQuery; });
function fetchPublicationQuery(rootQueryType, id, pageSize, page, sortField, sortOrder, filter) {
  rootQueryType = ['organisationalUnit', 'person'].includes(rootQueryType) ? rootQueryType : null;
  id = rootQueryType === 'organisationalUnit' ? Number(id) : '' + id;

  // if the rootQueryType does not match for organisational unit or person then return nulls
  if (!rootQueryType) {
    return null;
  }

  var variables = {
    id: id || null,
    pageSize: Number(pageSize) || 20,
    page: Number(page) || 1
  };

  if (sortOrder) {
    variables['sortOrder'] = sortOrder;
  }

  if (sortField) {
    variables['sortField'] = sortField;
  }

  if (filter && filter.year && Number(filter.year)) {
    variables['filterYear'] = Number(filter.year);
  }

  if (filter && filter.freetext && filter.freetext.length > 0) {
    variables['filterFreetext'] = filter.freetext;
  }

  if (filter && filter.person && filter.person.length > 0) {
    variables['filterPerson'] = filter.person;
  }

  if (filter && filter.category && filter.category.length > 0) {
    variables['filterCategory'] = filter.category;
  }

  if (filter && filter.inProject) {
    variables['filterInProject'] = filter.inProject;
  }

  if (filter && filter.inProject && filter.fundedByCategory) {
    variables['filterFundedByCategory'] = filter.fundedByCategory;
  }

  return {
    operationName: 'fetchPublicationQuery',
    query: '\n      query fetchPublicationQuery(\n        $id: ID!,\n        $pageSize: Int!,\n        $page: Int!,\n        $sortOrder: SortOrder,\n        $sortField: PublicationSortKeys,\n        $filterYear: Int,\n        $filterFreetext: String,\n        $filterPerson: String,\n        $filterCategory: String,\n        $filterInProject: Boolean,\n        $filterFundedByCategory: FundingAgencyCategory,\n      ) {\n        ' + rootQueryType + '(id: $id) {\n          publikation:publications(\n            pageSize: $pageSize, page: $page, sortOrder: $sortOrder, orderBy:$sortField,\n            filter: {\n              year: $filterYear\n              freeText: $filterFreetext\n              person: $filterPerson\n              category: $filterCategory\n              inProject: $filterInProject\n              fundedByCategory: $filterFundedByCategory\n            }\n          ) {\n            meta {\n              pageNumber\n              pageSize\n              totalEntries\n              totalPages\n            }\n            entries {\n              ... on Publication {\n                _id:id\n                _entityName\n                publikationsTyp:typeDe\n                html {\n                  de\n                  en\n                }\n              }\n            }\n          }\n        }\n      }\n    ',
    variables: variables
  };
}



/***/ }),

/***/ "Rn3h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S8QC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SRFI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__("eOoE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql__ = __webpack_require__("lwCg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__schema__ = __webpack_require__("uDTM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_EntityDetails__ = __webpack_require__("iBzs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_EntityHeader__ = __webpack_require__("sGAB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_public_PublicListQuickActions__ = __webpack_require__("BF6l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mixins_UserCanEditByKostenstelle__ = __webpack_require__("jh8f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_mixins_ExternalLinkProvider__ = __webpack_require__("1/AK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_mixins_PublicRouteBuilder__ = __webpack_require__("+ueH");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__components_mixins_ExternalLinkProvider__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__components_mixins_PublicRouteBuilder__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__components_mixins_UserCanEditByKostenstelle__["a" /* default */]],
  data: function data() {
    return {
      resourceTypes: __WEBPACK_IMPORTED_MODULE_3__schema__["a" /* default */].baseTypes,
      resourceData: null,
      linkProvider: function linkProvider(data) {
        if (data._entityName != null) {
          var type = data._entityName.split('.').splice(-1)[0].toLowerCase();
          if (type === 'organisationseinheit') {
            if (data._id !== '1' && data.hasOwnProperty('parentOrgaName') && data.parentOrgaName == null) {
              return null;
            } else {
              return {
                name: 'public',
                params: {
                  type: 'ou',
                  id: data._id,
                  resourceType: 'forschungsprojekt'
                }
              };
            }
          } else if (type === 'person' && data.fisPersid != null) {
            return {
              name: 'public',
              params: {
                type: 'person',
                id: data.fisPersid,
                resourceType: 'forschungsprojekt'
              }
            };
          } else if (type === 'publikation' || type === 'forschungsprojekt') {
            return {
              name: 'public_details',
              params: {
                resourceType: type,
                resourceId: data._id
              }
            };
          }
        }
      }
    };
  },

  props: ['resourceType', 'resourceId'],
  components: {
    'fob-entity-details': __WEBPACK_IMPORTED_MODULE_4__components_EntityDetails__["a" /* default */],
    'fob-entity-header': __WEBPACK_IMPORTED_MODULE_5__components_EntityHeader__["a" /* default */],
    'fob-public-list-quick-actions': __WEBPACK_IMPORTED_MODULE_6__components_public_PublicListQuickActions__["a" /* default */]
  },
  computed: {
    resourceSchema: function resourceSchema() {
      var _this = this;

      return this.resourceTypes.find(function (x) {
        return _this.resourceType === x.schema.route;
      }).schema;
    },
    internalId: function internalId() {
      return this.resourceData._id;
    }
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var _this2 = this;

    var resourceId = Number(to.params.resourceId) || to.params.resourceId;
    var query = __WEBPACK_IMPORTED_MODULE_2__graphql__["k" /* detailsQuery */][to.params.resourceType](resourceId);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__axios__["a" /* graphql */])(query).then(function (response) {
      _this2.resourceData = response.data.data[to.params.resourceType];
      next();
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    var resourceId = Number(this.resourceId) || this.resourceId;
    var query = __WEBPACK_IMPORTED_MODULE_2__graphql__["k" /* detailsQuery */][this.resourceType](resourceId);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__axios__["a" /* graphql */])(query).then(function (response) {
      _this3.resourceData = response.data.data[_this3.resourceType];
      if (_this3.resourceData.primaryPublicIdent && _this3.$route.params.resourceId !== _this3.resourceData.primaryPublicIdent) {
        var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this3.$route.params, {
          resourceId: _this3.resourceData.primaryPublicIdent
        });
        var newRoute = {
          name: _this3.$route.name,
          params: params
        };
        _this3.$router.replace(newRoute);
      }
    });
  }
});

/***/ }),

/***/ "SdEH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TFk4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__ = __webpack_require__("9fz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldsGeneric__ = __webpack_require__("WWW9");




var Fields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__FieldsGeneric__["a" /* default */])('Mittelgeber');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Mittelgeber',
  route: 'mittelgeber',
  class: __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__["Mittelgeber"],
  className: 'mittelgeber',
  fields: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.String('name'), {
    table: true
  }), Fields.String('finSchluessel')]
});

/***/ }),

/***/ "TGNV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    fullName: function fullName(person) {
      if (person) {
        var parts = [person.name, person.vorname].filter(function (x) {
          return x != null;
        });
        return parts.join(', ');
      } else {
        return '';
      }
    },
    fullNameWithTitle: function fullNameWithTitle(person) {
      if (person) {
        var givenName = [person.titel, person.vorname].filter(function (x) {
          return x != null;
        }).join(' ');
        var parts = [person.name, givenName].filter(function (x) {
          return x != null;
        });
        return parts.join(', ');
      } else {
        return '';
      }
    },
    shortNameWithIntial: function shortNameWithIntial(person) {
      if (person.vorname != null && person.vorname !== '') {
        if (person.vorname.indexOf('-') > -1) {
          var initials = person.vorname.split('-').map(function (v) {
            return v.charAt(0).toUpperCase() + '.';
          }).join('-');
          return person.name + ', ' + initials;
        } else {
          return person.name + ', ' + person.vorname.charAt(0).toUpperCase() + '.';
        }
      } else {
        return person.name;
      }
    }
  }
});

/***/ }),

/***/ "TJVf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TVmP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("UthT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1e0c700_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("gxd1");
function injectStyle (ssrContext) {
  __webpack_require__("myh2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1e0c700_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Togc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TzBH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntitySelect_vue__ = __webpack_require__("scTh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_295a2815_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntitySelect_vue__ = __webpack_require__("HMSu");
function injectStyle (ssrContext) {
  __webpack_require__("S8QC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntitySelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_295a2815_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntitySelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "confirmPrivacyPolicy", function() { return confirmPrivacyPolicy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserOrgas", function() { return getUserOrgas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getActiveOrga", function() { return getActiveOrga; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVersion", function() { return getVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getServerVersion", function() { return getServerVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "now", function() { return now; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "language", function() { return language; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoading", function() { return isLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMainMenu", function() { return getMainMenu; });
var confirmPrivacyPolicy = function confirmPrivacyPolicy(state) {
  return state.confirmPrivacyPolicy;
};

var getUserOrgas = function getUserOrgas(state) {
  return state.userOrgas;
};

var getActiveOrga = function getActiveOrga(state) {
  return state.activeOrga;
};

var getVersion = function getVersion(state) {
  return state.version;
};

var getServerVersion = function getServerVersion(state) {
  return state.serverVersion;
};

var now = function now(state) {
  return state.now;
};

var language = function language(state) {
  return state.language;
};

var isLoading = function isLoading(state, getters) {
  return getters['resource/isLoading'] || getters['list/isLoading'] || getters['editor/isLoading'] || getters['user/isLoading'] || getters['publicView/isLoading'] || getters['publicView/isLoadingStaff'] || getters['tree/isLoading'] || getters['aboutme/isLoading'];
};

var getMainMenu = function getMainMenu(state, getters, rootState) {
  return [{
    name: 'menu.start',
    icon: 'fa fa-home',
    link: '/',
    exact: true
  }, {
    name: 'menu.aboutme',
    icon: 'fa fa-user',
    link: { name: 'aboutme' },
    auth: true,
    exact: true,
    disabled: !rootState.user.forscher
  }, {
    name: 'menu.login',
    icon: 'fa fa-key',
    link: { name: 'login' },
    auth: false,
    exact: true
  }, {
    name: 'menu.list',
    link: { name: 'auflisten' },
    icon: 'fa fa-table',
    auth: true
  }, {
    name: 'menu.details',
    link: { name: 'anzeigen' },
    icon: 'fa fa-search',
    auth: true
  }, {
    name: 'menu.editor',
    marked: getters['editor/isDirty'],
    link: '/bearbeiten',
    icon: 'fa fa-pencil-square-o',
    classes: getters['editor/isDirty'] ? ['fob-text-italic'] : [],
    auth: true
  }, {
    name: 'menu.create',
    marked: getters['creator/isDirty'],
    link: { name: 'eintragen' },
    icon: 'fa fa-file-o',
    classes: getters['creator/isDirty'] ? ['fob-text-italic'] : [],
    auth: true
  }, {
    name: 'menu.upload',
    link: '/upload',
    icon: 'fa fa-upload',
    auth: true
  }, {
    name: 'menu.help',
    link: '/help',
    icon: 'fa fa-question-circle',
    auth: true
    // Deactivated until further notice
    // {
    //   name: 'menu.report',
    //   link: '/berichte',
    //   icon: 'fa fa-list-ul',
    //   auth: true
    // }
  }].filter(function (item) {
    return typeof item.auth === 'undefined' || item.auth === getters['user/isAuthorized'];
  });
};

/***/ }),

/***/ "Ur8k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fob-public-list-options',{attrs:{"resourceType":_vm.resourceType}}),_vm._v(" "),_c('fob-public-list-compact',{attrs:{"resourceType":_vm.resourceType}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UthT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-footer',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    isAuthorized: 'user/isAuthorized',
    version: 'getVersion',
    serverVersion: 'getServerVersion'
  }), {
    hasUpdateAvailable: function hasUpdateAvailable() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* isLowerVersion */])(this.version, this.serverVersion);
    }
  }),
  methods: {
    dropLocalStorage: function dropLocalStorage() {
      var _this = this;

      this.$dialog.confirm({
        title: 'Browserspeicher löschen',
        message: 'Sind Sie sicher, dass Sie alle im Browser gespeicherten FOB-relevanten Einstellungen <b>löschen</b> möchten? Diese Aktion kann nicht rückgängig gemacht werden!',
        cancelText: 'Abbrechen',
        confirmText: 'Speicher leeren',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: function onConfirm() {
          // remove cookie data
          __WEBPACK_IMPORTED_MODULE_3_js_cookie__["remove"](__webpack_require__.i({"NODE_ENV":"production","FOB_BACKEND_URL":"","FOB_BACKEND_PATH":"/fob","FOB_BACKEND_PORT":"","ANCHOR_WHEEL_URL":"","ANCHOR_WHEEL_PATH":"/anchorwheel/api","ANCHOR_WHEEL_PORT":"","LEURIS_WIKI_URL":"https://home.uni-leipzig.de/~leuriswiki/doku.php","MACO_URL":"/profilseite","MACO_PORT":"","MACO_BACKEND_URL":"","MACO_BACKEND_PATH":"/profilseite/api","MACO_BACKEND_PORT":"","ALT_LOGIN_URL":"","ALT_LOGIN_PORT":"","ALT_LOGIN_PATH":"/tomaner/login/","ALT_LOGIN_TRANSFORMATOR":(function transformator(x) { return x.fob.body }),"ORCID_BASE_URL":"https://orcid.org","EXPORT_SERVER_URL":"","EXPORT_SERVER_PORT":"","EXPORT_SERVER_PATH":"/fob/export/","LEURIS_BASE_URI":"https://leuris.uni-leipzig.de"}).COOKIE_KEY_MACO, {
            path: '',
            domain: __webpack_require__.i({"NODE_ENV":"production","FOB_BACKEND_URL":"","FOB_BACKEND_PATH":"/fob","FOB_BACKEND_PORT":"","ANCHOR_WHEEL_URL":"","ANCHOR_WHEEL_PATH":"/anchorwheel/api","ANCHOR_WHEEL_PORT":"","LEURIS_WIKI_URL":"https://home.uni-leipzig.de/~leuriswiki/doku.php","MACO_URL":"/profilseite","MACO_PORT":"","MACO_BACKEND_URL":"","MACO_BACKEND_PATH":"/profilseite/api","MACO_BACKEND_PORT":"","ALT_LOGIN_URL":"","ALT_LOGIN_PORT":"","ALT_LOGIN_PATH":"/tomaner/login/","ALT_LOGIN_TRANSFORMATOR":(function transformator(x) { return x.fob.body }),"ORCID_BASE_URL":"https://orcid.org","EXPORT_SERVER_URL":"","EXPORT_SERVER_PORT":"","EXPORT_SERVER_PATH":"/fob/export/","LEURIS_BASE_URI":"https://leuris.uni-leipzig.de"}).COOKIE_DOMAIN
          });
          // remove localstorage
          window.localStorage.removeItem('de.ul.fob');
          _this.$dialog.alert({
            message: 'Speicher geleert! Seite wird neu geladen.',
            type: 'is-danger',
            onConfirm: function onConfirm() {
              return location.reload();
            }
          });
        }
      });
    },
    reloadPage: function reloadPage() {
      window.location.reload(true);
    }
  }
});

/***/ }),

/***/ "UtpS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HTMLEditor_vue__ = __webpack_require__("+34z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d7b212e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HTMLEditor_vue__ = __webpack_require__("i0wJ");
function injectStyle (ssrContext) {
  __webpack_require__("HKCH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d7b212e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HTMLEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d7b212e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HTMLEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VKxC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USER_LOGIN", function() { return USER_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USER_LOGOUT", function() { return USER_LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE_ORGA", function() { return CHANGE_ORGA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOADING_START", function() { return LOADING_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOADING_DONE", function() { return LOADING_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAVE_VIEW", function() { return SAVE_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE_VIEW", function() { return DELETE_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ACTIVE_VIEW_STATE", function() { return ACTIVE_VIEW_STATE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var USER_LOGIN = function USER_LOGIN(state, data) {
  state.name = data.name;
  state.roles = data.roles;
  state.token = data.token;
  state.orgas = data.organisationseinheiten;
  state.fisPersid = data.fisPersid;
  state.email = data.email;
  state.forscher = data.forscher;

  // set fisPersid for profileViewState
  var profileViewState = state.activeViewStates.find(function (activeViewState) {
    return activeViewState.id === 'profile';
  });
  if (profileViewState) {
    profileViewState.route.params.id = data.fisPersid;
  }
};

var USER_LOGOUT = function USER_LOGOUT(state) {
  state.name = null;
  state.roles = [];
  state.token = null;
  state.orgas = null;
  state.fisPersid = null;
  state.email = null;
  state.forscher = null;
  state.selectedOrgaID = null;
};

var CHANGE_ORGA = function CHANGE_ORGA(state, data) {
  state.activeOrga = data;
  state.selectedOrgaID = state.orgas[state.activeOrga]._id;
};

var LOADING_START = function LOADING_START(state) {
  state.loading = true;
};

var LOADING_DONE = function LOADING_DONE(state) {
  state.loading = false;
};

var SAVE_VIEW = function SAVE_VIEW(state, viewConfiguration) {
  var id = 1;
  if (state.savedViews.length > 0) {
    id = state.savedViews.slice(-1)[0].id + 1;
  }
  state.savedViews.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ id: id }, viewConfiguration));
};

var DELETE_VIEW = function DELETE_VIEW(state, id) {
  var index = state.savedViews.findIndex(function (x) {
    return x.id === id;
  });
  state.savedViews.splice(index, 1);
};

var ACTIVE_VIEW_STATE = function ACTIVE_VIEW_STATE(state, id) {
  state.activeViewState = id;
};

/***/ }),

/***/ "VlMm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    activeTab: 'publicView/getActiveTab',
    resourceTypes: 'publicView/resourceTypes',
    publicViewLabel: 'publicView/getLabel',
    selected: 'publicView/getSelected',
    selectedTree: 'tree/selected'
  }), {
    activeResourceType: function activeResourceType() {
      return this.resourceTypes[this.activeTab].type;
    },
    organisationalUnitName: function organisationalUnitName() {
      if (this.selectedTree && !this.selectedTree.name) {
        return this.publicViewLabel;
      } else {
        return this.selectedTree.name;
      }
    },
    toCurrentRoute: function toCurrentRoute() {
      var to = {
        name: 'public',
        params: {
          type: this.selected.type || 'ou',
          id: this.selected.id || 1,
          resourceType: this.activeResourceType || 'forschungsprojekt'
        }
      };

      if (this.isCompactView) {
        to.query = {
          compact: true
        };
      }

      return to;
    }
  }),
  methods: {
    loadAsyncData: function loadAsyncData() {
      this.$store.dispatch('publicView/loadAsyncData', this.activeResourceType);
    },
    setFirstPage: function setFirstPage() {
      this.$store.dispatch('publicView/setConfig', {
        resourceType: this.activeResourceType,
        property: 'page',
        value: 1
      });
    },
    toPublicRoute: function toPublicRoute() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ou';
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var resourceType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'forschungsprojekt';

      var to = {
        name: 'public',
        params: {
          type: type,
          id: id,
          resourceType: resourceType
        }
      };

      if (this.isCompactView) {
        to.query = {
          compact: true
        };
      }

      return to;
    }
  }
});

/***/ }),

/***/ "Vr8j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VtBz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE_PAGE", function() { return CHANGE_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ACTIVE_TAB", function() { return SET_ACTIVE_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CONFIG", function() { return SET_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_LEURIS_PROFILE", function() { return SET_LEURIS_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DATA", function() { return SET_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SELECTED", function() { return SET_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TOTAL", function() { return SET_TOTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE_PER_PAGE", function() { return CHANGE_PER_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_LABEL", function() { return SET_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_RESOURCE_TYPE", function() { return SET_RESOURCE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SORT_FIELD", function() { return SET_SORT_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SORT_ORDER", function() { return SET_SORT_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_FILTER", function() { return UPDATE_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_STAFF_STARTSWITH", function() { return SET_STAFF_STARTSWITH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_STAFF_FULLNAME", function() { return SET_STAFF_FULLNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_STAFF_LETTER_COUNT", function() { return SET_STAFF_LETTER_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_STAFF_TOTAL_ENTRIES", function() { return SET_STAFF_TOTAL_ENTRIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_STAFF_DATA", function() { return SET_STAFF_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IS_LOADING", function() { return IS_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IS_LOADING_STAFF", function() { return IS_LOADING_STAFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOADING_DONE", function() { return LOADING_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOADING_DONE_STAFF", function() { return LOADING_DONE_STAFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SHOW_ORGATREE", function() { return SET_SHOW_ORGATREE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_OU_DETAILS", function() { return SET_OU_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET", function() { return RESET; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var CHANGE_PAGE = function CHANGE_PAGE(state, _ref) {
  var resourceType = _ref.resourceType,
      page = _ref.page;

  state.config[resourceType].page = page;
};

var SET_ACTIVE_TAB = function SET_ACTIVE_TAB(state, activeTab) {
  state.activeTab = activeTab;
};

var SET_CONFIG = function SET_CONFIG(state, _ref2) {
  var resourceType = _ref2.resourceType,
      property = _ref2.property,
      value = _ref2.value;

  state.config[resourceType][property] = value;
};

var SET_LEURIS_PROFILE = function SET_LEURIS_PROFILE(state, person) {
  state.leurisProfile = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.leurisProfile, {
    fisPersid: state.selected.id,
    orcid: person.orcid,
    ulWebsiteProfile: {
      de: person.ulWebsiteProfileDe,
      en: person.ulWebsiteProfileEn
    },
    data: person.leurisProfile
  });
};

var SET_DATA = function SET_DATA(state, _ref3) {
  var resourceType = _ref3.resourceType,
      data = _ref3.data;

  state.data[resourceType] = data;
};

var SET_SELECTED = function SET_SELECTED(state, selected) {
  state.selected = selected;
};

var SET_TOTAL = function SET_TOTAL(state, _ref4) {
  var resourceType = _ref4.resourceType,
      total = _ref4.total;

  state.total[resourceType] = total;
};

var CHANGE_PER_PAGE = function CHANGE_PER_PAGE(state, _ref5) {
  var resourceType = _ref5.resourceType,
      perPage = _ref5.perPage;

  state.config[resourceType].perPage = perPage;
};

var SET_LABEL = function SET_LABEL(state, label) {
  state.label = label;
};

var SET_RESOURCE_TYPE = function SET_RESOURCE_TYPE(state, type) {
  state.resourceType = type;
};

var SET_SORT_FIELD = function SET_SORT_FIELD(state, _ref6) {
  var resourceType = _ref6.resourceType,
      sortField = _ref6.sortField;

  state.config[resourceType].sortField = sortField;
};

var SET_SORT_ORDER = function SET_SORT_ORDER(state, _ref7) {
  var resourceType = _ref7.resourceType,
      sortOrder = _ref7.sortOrder;

  state.config[resourceType].sortOrder = sortOrder;
};

var UPDATE_FILTER = function UPDATE_FILTER(state, _ref8) {
  var resourceType = _ref8.resourceType,
      updateFilter = _ref8.updateFilter;

  state.filter[resourceType].filter = updateFilter;
};

var SET_STAFF_STARTSWITH = function SET_STAFF_STARTSWITH(state, startsWith) {
  state.staff.startsWith = startsWith;
};

var SET_STAFF_FULLNAME = function SET_STAFF_FULLNAME(state, fullName) {
  state.staff.fullName = fullName;
};

var SET_STAFF_LETTER_COUNT = function SET_STAFF_LETTER_COUNT(state, letterCount) {
  var count = {};
  letterCount = letterCount.forEach(function (letter) {
    count[letter.name] = letter.count;
  });
  state.staff.letterCount = count;
};

var SET_STAFF_TOTAL_ENTRIES = function SET_STAFF_TOTAL_ENTRIES(state, totalEntries) {
  state.staff.totalEntries = totalEntries;
};

var SET_STAFF_DATA = function SET_STAFF_DATA(state, data) {
  state.staff.data = data;
};

var IS_LOADING = function IS_LOADING(state, loadingState) {
  state.loading = loadingState || false;
};

var IS_LOADING_STAFF = function IS_LOADING_STAFF(state, loadingState) {
  state.staff.loading = loadingState || false;
};

var LOADING_DONE = function LOADING_DONE(state) {
  state.loading = false;
};

var LOADING_DONE_STAFF = function LOADING_DONE_STAFF(state) {
  state.staff.loading = false;
};

var SET_SHOW_ORGATREE = function SET_SHOW_ORGATREE(state, show) {
  state.showOrgaTree = show || false;
};

var SET_OU_DETAILS = function SET_OU_DETAILS(state, ouDetails) {
  state.ouDetails = ouDetails;
};

var RESET = function RESET(state) {
  state.leurisProfile = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.leurisProfile, {
    data: null,
    fisPersid: null,
    orcid: null,
    ulWebsiteProfile: {
      de: null,
      en: null
    }
  });
  state.ouDetails = {
    stringRep: null,
    begin: null,
    end: null,
    description: null
    // reset total
  };state.total = {
    forschungsprojekt: 0,
    kooperation: 0,
    publikation: 0,
    veranstaltung: 0,
    preis: 0
    // reset data
  };state.data = {
    forschungsprojekt: [],
    kooperation: [],
    publikation: [],
    veranstaltung: [],
    preis: []
    // reset config
  };state.filter = {
    forschungsprojekt: {
      filter: {},
      filters: [{ type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } }, { type: 'select', value: 'status', label: 'Public.filter.status', options: ['ONGOING', 'TERMINATED'] }, { type: 'input', value: 'funding', label: 'Public.filter.mittelgeber', icon: 'credit-card' }, { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' }, { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }, { type: 'select', value: 'sdg', label: 'Public.filter.sdg', icon: 'bullseye', hidden: true }]
    },
    kooperation: {
      filter: {},
      filters: [{ type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } }, { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' }, { type: 'input', value: 'externalPartner', label: 'Public.filter.externalPartner', icon: 'globe' }, { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }]
    },
    publikation: {
      filter: {},
      filters: [{ type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } }, { type: 'select', value: 'category', label: 'Public.filter.publikationstypen', options: ['ARTICLE', 'MONOGRAPHY', 'EDITORSHIP', 'CONTRIBUTION', 'REPORT'] }, { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' }, { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' },
      // this is only here to get a translation for the print view (see PublicListOptions)
      { type: 'other', value: 'fundedByCategory', label: 'Public.filter.fundedByPrintLabel', icon: 'credit-card' }]
    },
    veranstaltung: {
      filter: {},
      filters: [{ type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } }, { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' }, { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }]
    },
    preis: {
      filter: {},
      filters: [{ type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } }, { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' }, { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' },
      // this is only here to get a translation for the print view (see PublicListOptions)
      { type: 'select', value: 'typeIds', label: 'Public.filter.awardsTypePrintLabel', icon: 'graduation-cap', hidden: true }]
    }
    // reset config
  };state.config = {
    forschungsprojekt: {
      page: 1,
      perPage: 10,
      sortField: 'START_DATE',
      sortFields: [
      // { field: 'TITLE_DE', label: 'Public.sort.titel', locale: 'de' },
      // { field: 'TITLE_EN', label: 'Public.sort.titel', locale: 'en' },
      { field: 'START_DATE', label: 'Public.sort.beginn' }],
      sortOrder: 'DESC'
    },
    kooperation: {
      page: 1,
      perPage: 10,
      sortField: 'START_DATE',
      sortFields: [
      // { field: 'TITLE', label: 'Public.sort.titel' },
      { field: 'START_DATE', label: 'Public.sort.beginn' }],
      sortOrder: 'DESC'
    },
    publikation: {
      page: 1,
      perPage: 10,
      sortField: 'YEAR',
      sortFields: [{ field: 'TYPE', label: 'Public.sort.typ' },
      // { field: 'TITLE', label: 'Public.sort.titel' },
      { field: 'YEAR', label: 'Public.sort.jahr' }],
      sortOrder: 'DESC'
    },
    veranstaltung: {
      page: 1,
      perPage: 10,
      sortField: 'START_DATE',
      sortFields: [{ field: 'TYPE', label: 'Public.sort.typ' }, { field: 'START_DATE', label: 'Public.sort.beginn'
        // { field: 'NAME', label: 'Public.sort.name' }
      }],
      sortOrder: 'DESC'
    },
    preis: {
      page: 1,
      perPage: 10,
      sortField: 'YEAR',
      sortFields: [{ field: 'TYPE', label: 'Public.sort.typ' }, { field: 'YEAR', label: 'Public.sort.jahr' }, { field: 'AWARDEE', label: 'Public.sort.preisTraeger'
        // { field: 'NAME', label: 'Public.sort.name' }
      }],
      sortOrder: 'DESC'
    }
  };
};

/***/ }),

/***/ "VtdD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setData", function() { return setData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSchema", function() { return setSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "newEntity", function() { return newEntity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closeEditor", function() { return closeEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveEntity", function() { return saveEntity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("gyMJ");



var setData = function setData(_ref, data) {
  var state = _ref.state,
      commit = _ref.commit;

  commit('SET_DATA', data);
};

var setSchema = function setSchema(_ref2, schema) {
  var state = _ref2.state,
      commit = _ref2.commit;

  commit('SET_SCHEMA', schema);
};

var newEntity = function newEntity(_ref3) {
  var state = _ref3.state,
      commit = _ref3.commit,
      dispatch = _ref3.dispatch,
      rootGetters = _ref3.rootGetters;

  var orga = rootGetters['user/selectedOrga'];
  var Constructor = state.schema.class;
  var blankEntity = new Constructor({ organisationseinheit: orga });
  dispatch('setData', blankEntity);
};

var closeEditor = function closeEditor(_ref4) {
  var state = _ref4.state,
      commit = _ref4.commit;

  commit('SET_SCHEMA', null);
  commit('SET_DATA', null);
};

var saveEntity = function saveEntity(_ref5) {
  var state = _ref5.state,
      commit = _ref5.commit,
      dispatch = _ref5.dispatch,
      rootGetters = _ref5.rootGetters;

  commit('LOADING_START');

  // set fields that were not visible to null
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(state.schema.fields), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var bit = _step.value;

      if (!(bit.view === undefined || bit.view(state.data, rootGetters['user/getUser']))) {
        if (state.data[bit.field] != null) {
          state.data[bit.field] = null;
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].methods.updaveResource(state.data).then(function (data) {
    commit('LOADING_DONE');
    return data;
  });
};

/***/ }),

/***/ "Vu0z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__ = __webpack_require__("9fz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldsGeneric__ = __webpack_require__("WWW9");



var Fields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__FieldsGeneric__["a" /* default */])('ExterneOrganisation');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Externe Organisation',
  route: 'externeorganisation',
  class: __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__["ExterneOrganisation"],
  className: 'externeOrganisation',
  preliminaryStringRep: function preliminaryStringRep(data) {
    return data.name + ', ' + data.stadt;
  },

  fields: [{
    label: 'ExterneOrganisation.form.name',
    field: 'name',
    type: 'string',
    table: true
  }, {
    label: 'ExterneOrganisation.form.stadt',
    field: 'stadt',
    type: 'string',
    table: true
  }, {
    label: 'ExterneOrganisation.form.beschreibung',
    field: 'beschreibung',
    type: 'string'
  }, {
    label: 'ExterneOrganisation.form.kurzname',
    field: 'kurzname',
    type: 'string'
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.PrefetchedSingleReference('land', 'land', 'globe'), {
    preselect: function preselect(land) {
      return land.nameDE === 'Deutschland';
    },
    prefilter: function prefilter(land) {
      return land.alpha2code !== 'EP';
    },
    orderBy: 'nameDE'
  })]
});

/***/ }),

/***/ "W+k1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity__ = __webpack_require__("9fz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity__);


/* harmony default export */ __webpack_exports__["a"] = ({
  route: 'orgaIdent',
  class: __WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity__["OrgaIdent"],
  className: 'orgaIdent',
  entityName: 'de.ul.fob.domain.OrgaIdent',
  fields: [{
    label: 'OrgaIdent.form.typ',
    field: 'typ'
  }, {
    label: 'OrgaIdent.form.wert',
    field: 'wert'
  }]
});

/***/ }),

/***/ "WWW9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Organisationseinheit__ = __webpack_require__("tTX3");


/* harmony default export */ __webpack_exports__["a"] = (function (base) {
  return {
    String: function String(field) {
      return {
        label: base + '.form.' + field,
        field: field,
        type: 'string'
      };
    },
    Text: function Text(field) {
      var maxlength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;

      return {
        label: base + '.form.' + field,
        field: field,
        maxlength: maxlength,
        type: 'text'
      };
    },
    Number: function (_Number) {
      function Number(_x2) {
        return _Number.apply(this, arguments);
      }

      Number.toString = function () {
        return _Number.toString();
      };

      return Number;
    }(function (field) {
      return {
        label: base + '.form.' + field,
        field: field,
        type: Number
      };
    }),
    Boolean: function (_Boolean) {
      function Boolean(_x3) {
        return _Boolean.apply(this, arguments);
      }

      Boolean.toString = function () {
        return _Boolean.toString();
      };

      return Boolean;
    }(function (field) {
      return {
        label: base + '.form.' + field,
        field: field,
        type: Boolean
      };
    }),
    Date: function (_Date) {
      function Date(_x4) {
        return _Date.apply(this, arguments);
      }

      Date.toString = function () {
        return _Date.toString();
      };

      return Date;
    }(function (field) {
      return {
        label: base + '.form.' + field,
        field: field,
        type: Date
      };
    }),
    UneditableDate: function UneditableDate(field) {
      return {
        label: base + '.form.' + field,
        field: field,
        type: Date,
        editable: false
      };
    },
    URL: function URL(field, text) {
      return {
        label: base + '.form.' + field,
        field: field,
        type: 'link',
        icon: 'link',
        computed: function computed(data) {
          if (data && data[field]) {
            return {
              href: data[field],
              text: text || data[field]
            };
          }
          return null;
        }
      };
    },
    PrefetchedSingleReference: function PrefetchedSingleReference(field, entity, icon) {
      var groupBy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var plain = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      return {
        label: base + '.form.' + field,
        type: 'prefetchedObject',
        field: field,
        entity: entity,
        icon: icon,
        groupBy: groupBy,
        plain: plain
      };
    },
    SingleReference: function SingleReference(field, icon, schema) {
      var allowCreate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var plain = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      return {
        label: base + '.form.' + field,
        field: field,
        render: 'stringRep',
        type: 'object',
        schema: schema,
        icon: icon,
        cardinality: 'single',
        finder: {
          name: 'bySearchRepLike',
          multiValue: false,
          minLength: 0
        },
        allowCreate: allowCreate,
        plain: plain
      };
    },
    SimpleMultiReference: function SimpleMultiReference(field, icon, schema) {
      var allowCreate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var plain = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      return {
        label: base + '.form.' + field,
        field: field,
        render: 'stringRep',
        type: 'object',
        schema: schema,
        icon: icon,
        cardinality: 'many',
        finder: {
          name: 'bySearchRepLike',
          multiValue: false,
          minLength: 0
        },
        allowCreate: allowCreate,
        plain: plain
      };
    },
    UneditableSimpleMultiReference: function UneditableSimpleMultiReference(field, icon, schema) {
      var allowCreate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var plain = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      return {
        label: base + '.form.' + field,
        field: field,
        render: 'stringRep',
        type: 'object',
        schema: schema,
        icon: icon,
        cardinality: 'many',
        finder: {
          name: 'bySearchRepLike',
          multiValue: false,
          minLength: 0
        },
        allowCreate: allowCreate,
        editable: false,
        plain: plain
      };
    },
    Label: function Label(name) {
      return {
        label: base + '.form.' + name,
        type: 'label'
      };
    },
    MultiReference: function MultiReference(field, icon, schema) {
      var allowCreate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var plain = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      return {
        label: base + '.form.' + field,
        field: field,
        render: 'stringRep',
        type: 'object',
        schema: schema,
        icon: icon,
        cardinality: 'many',
        finder: {
          name: 'byMultiValueSearchRep',
          multiValue: true,
          minLength: 4
        },
        allowCreate: allowCreate,
        plain: plain
      };
    },
    SingleReferenceByMultiValueSearchRep: function SingleReferenceByMultiValueSearchRep(field, icon, schema) {
      var allowCreate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var plain = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      return {
        label: base + '.form.' + field,
        field: field,
        render: 'stringRep',
        type: 'object',
        schema: schema,
        icon: icon,
        cardinality: 'single',
        finder: {
          name: 'byMultiValueSearchRep',
          multiValue: true,
          minLength: 4
        },
        allowCreate: allowCreate,
        plain: plain
      };
    },


    organisationseinheit: {
      label: base + '.form.organisationseinheit',
      field: 'organisationseinheit',
      type: 'object',
      icon: 'sitemap',
      cardinality: 'single',
      render: 'stringRep',
      schema: __WEBPACK_IMPORTED_MODULE_0__Organisationseinheit__["a" /* default */],
      finder: {
        name: 'bySearchRepLike',
        multiValue: false,
        minLength: 0
      }
    },

    relevantFuerWeitere: {
      label: base + '.form.relevantFuerWeitere',
      field: 'relevantFuerWeitere',
      type: Boolean
    },

    weitereOrganisationseinheiten: {
      label: base + '.form.weitereOrganisationseinheiten',
      singularLabel: 'Organisationseinheit',
      field: 'weitereOrganisationseinheiten',
      type: 'object',
      render: 'stringRep',
      icon: 'sitemap',
      cardinality: 'many',
      method: 'bySearchRepLike',
      schema: __WEBPACK_IMPORTED_MODULE_0__Organisationseinheit__["a" /* default */],
      finder: {
        name: 'byMultiValueSearchRep',
        multiValue: true,
        minLength: 3,
        opts: {
          sort: ['inPubfob,desc', 'name,asc']
        }
      },
      allowCreate: false,
      view: function view(data, user) {
        return data.relevantFuerWeitere;
      }
    }
  };
});

/***/ }),

/***/ "WdLZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"has-text-weight-bold leuris-heading"},[_vm._v("\n    leuris:Forschungsbericht\n  ")]),_vm._v(" "),_c('div',{staticClass:"columns section",staticStyle:{"max-width":"1200px","margin":"auto","padding-top":"0"}},[_c('div',{staticClass:"section has-text-centered",staticStyle:{"max-width":"1200px","width":"100%","padding-top":"0","margin":"auto"}},[_c('div',{staticClass:"has-text-centered",staticStyle:{"max-width":"600px","margin":"auto"}},[_c('translate',[_vm._v("Login Description")])],1)])]),_vm._v(" "),_c('div',{staticClass:"columns section",staticStyle:{"max-width":"1200px","margin":"auto","margin-top":"-50px"}},[_c('div',{staticClass:"column"},[_c('div',[_c('b-message',{attrs:{"type":"is-aquamarine","title":_vm.$gettext('Login Systemrequirements Heading'),"closable":false}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$gettext('Login Systemrequirements Text'))}})])],1)]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('b-message',{attrs:{"type":"is-lightgray","title":_vm.$gettext('Login Not Working Heading'),"closable":false}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$gettext('Login Not Working Text'))}})])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WoGI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_DynamicTitle__ = __webpack_require__("IqS5");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NotFound',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_DynamicTitle__["a" /* default */]],
  data: function data() {
    return {
      msg: 'UL Forschungsbericht',
      leurisHead: {
        inner: 'leuris:Forschungsportal',
        complement: 'notFound'
      }
    };
  }
});

/***/ }),

/***/ "XECV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TreeItem_vue__ = __webpack_require__("Jocs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_542182e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TreeItem_vue__ = __webpack_require__("tJdp");
function injectStyle (ssrContext) {
  __webpack_require__("1jLr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TreeItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_542182e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TreeItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XQT5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rootData", function() { return rootData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selected", function() { return selected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoading", function() { return isLoading; });
var rootData = function rootData(state) {
  return state.rootData;
};

var selected = function selected(state) {
  return state.selected;
};

var isLoading = function isLoading(state) {
  return state.loading;
};

/***/ }),

/***/ "XbJz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_DynamicTitle__ = __webpack_require__("IqS5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql__ = __webpack_require__("lwCg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axios__ = __webpack_require__("eOoE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'welcome',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_mixins_DynamicTitle__["a" /* default */]],
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      leurisHead: {
        inner: 'leuris:Portal',
        complement: 'menu.start'
      },
      stats: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
    userIsAuthorized: 'user/isAuthorized',
    resourceTypes: 'publicView/resourceTypes'
  }), {
    renderedRouterLinkPublicActivities: function renderedRouterLinkPublicActivities() {
      var route = this.$router.resolve({
        name: 'public',
        params: {
          type: 'ou',
          id: 1,
          resourceType: 'forschungsprojekt'
        }
      }, this.$route);
      var linkText = this.$gettext('welcome.researchActivities');
      return '<a href="' + route.href + '">' + linkText + '</a>';
    }
  }),
  mounted: function mounted() {
    var _this = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__axios__["a" /* graphql */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__graphql__["l" /* fetchStatsQuery */])(1)).then(function (response) {
      _this.stats = response.data.data.organisationalUnit;
    });
  }
});

/***/ }),

/***/ "Xcjk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xkiq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XsV+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fob-aboutme-list-options',{attrs:{"resourceType":_vm.resourceType}}),_vm._v(" "),_c('fob-aboutme-list-compact',{attrs:{"resourceType":_vm.resourceType}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y37L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_form_EntitySelect__ = __webpack_require__("TzBH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_form_EntityCreateForm__ = __webpack_require__("B6Sg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_EntityValue__ = __webpack_require__("YRcE");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// COMPONENTS




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      searchOpen: false,
      visibilityOpen: false
    };
  },

  props: ['filterSchema', 'page', 'perPage', 'tableFields', 'total', 'value'],
  computed: {
    filter: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.$emit('input', newValue);
      }
    },
    activeFilter: function activeFilter() {
      var activeFilter = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.filterSchema.fields), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var fieldSchema = _step.value;

          var key = fieldSchema.field;
          var value = this.filter[key];
          if (value != null && value !== '' && value !== false && (value.name !== '' || false)) {
            activeFilter[key] = value;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return activeFilter;
    },
    hasActiveFilters: function hasActiveFilters() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.activeFilter).length > 0;
    },
    totalTablePages: function totalTablePages() {
      return Math.ceil(this.total / this.perPage);
    }
  },
  methods: {
    emitChange: function emitChange() {
      this.$emit('input', this.filter);
    },
    schemaBitForField: function schemaBitForField(field) {
      return this.filterSchema.fields.find(function (x) {
        return x.field === field;
      });
    },
    removeTag: function removeTag(field) {
      var schemaBit = this.filterSchema.fields.find(function (x) {
        return x.field === field;
      });
      if (schemaBit.type === 'object') {
        /*
        Call emptyField() von createForm which in turn calls emptyField() on the
        entitySelect component. This is needed to remove not only the value in
        the filter object but to reset the enitySelect field as well.
        */
        this.$refs.fobEntityCreateForm.emptyField(field);
      } else {
        this.filter[field] = null;
      }
    }
  },
  components: {
    'fob-entity-select': __WEBPACK_IMPORTED_MODULE_2__components_form_EntitySelect__["a" /* default */],
    'fob-entity-value': __WEBPACK_IMPORTED_MODULE_4__components_EntityValue__["a" /* default */],
    'fob-entity-create-form': __WEBPACK_IMPORTED_MODULE_3__components_form_EntityCreateForm__["a" /* default */]
  }
});

/***/ }),

/***/ "YCNd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_CompactViewHelper__ = __webpack_require__("TGNV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-auszeichnung-compact',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_CompactViewHelper__["a" /* default */]],
  props: ['schema', 'data'],
  computed: {
    title: function title() {
      return this.data.namePreis;
    },
    awardee: function awardee() {
      return this.fullName(this.data.preisTraeger);
    },
    awardedBy: function awardedBy() {
      return this.data.vergebenDurch;
    },
    organizationalUnit: function organizationalUnit() {
      return this.data.organisationseinheit.name;
    },
    type: function type() {
      return '' + this.data.preisBezeichnung.name.charAt(0).toUpperCase() + this.data.preisBezeichnung.name.slice(1);
    },
    year: function year() {
      return this.data.verleihungsJahr;
    }
  }
});

/***/ }),

/***/ "YCyQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin-bottom":"1rem"}},[_c('fob-entity-header',{staticStyle:{"margin-bottom":"0rem","font-weight":"bold"},attrs:{"type":"Public.headline.person"}}),_vm._v(" "),_c('fob-public-select-tag',{attrs:{"view":"person"},on:{"reset-selected-orga":_vm.resetSelectedOrga}})],1),_vm._v(" "),_c('div',{staticClass:"fob-abc-list"},[_c('div',{staticStyle:{"margin-bottom":"1rem"}},[_c('b-field',{attrs:{"grouped":""}},[_c('b-field',{staticStyle:{"margin":"0 1rem 0 0","min-width":"300px","display":"block"}},[_c('b-input',{staticStyle:{"width":"300px"},attrs:{"placeholder":_vm.$gettext('Public.person.search'),"icon":"search"},on:{"input":_vm.onFullName},model:{value:(_vm.searchStr),callback:function ($$v) {_vm.searchStr=$$v},expression:"searchStr"}})],1),_vm._v(" "),_c('b-tooltip',{staticStyle:{"min-width":"35px"},attrs:{"square":"","position":"is-top","label":_vm.$gettext("form.xbutton")}},[_c('button',{staticClass:"button contol is-aquamarine",attrs:{"tabindex":"-1"},on:{"click":function($event){_vm.searchStr = ''}}},[_c('b-icon',{attrs:{"icon":"times","size":"is-small"}})],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"height":"20px"}},[(_vm.staffTotalEntries > _vm.staff.length)?_c('p',{staticClass:"help is-error is-italic"},[_c('translate',{attrs:{"translate-params":{staffTotalEntries: _vm.staffTotalEntries}}},[_vm._v("Public.person.search.limit")])],1):(_vm.staffTotalEntries)?_c('p',{staticClass:"help is-italic"},[_c('translate',{attrs:{"translate-params":{staffTotalEntries: _vm.staffTotalEntries}}},[_vm._v("Public.person.search.match")])],1):_c('p',{staticClass:"help is-italic"},[_c('translate',[_vm._v("Public.person.search.nomatch")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"columns is-multiline",staticStyle:{"position":"relative"}},[_vm._l((_vm.alphabet),function(letter){return _c('div',{key:letter,staticClass:"column is-narrow",staticStyle:{"padding-bottom":"0px","width":"calc(97%/7)"}},[_c('a',{staticClass:"button",class:{ 'is-aquamarine': letter === _vm.staffStartsWith },staticStyle:{"width":"2.5rem","height":"2.5rem"},attrs:{"disabled":!_vm.staffLetterCount[letter],"title":_vm.getTitleForLetter(letter)},on:{"click":function($event){_vm.loadStaffStartsWith(letter)}}},[_vm._v("\n          "+_vm._s(letter)+"\n        ")])])}),_vm._v(" "),_c('div',{staticClass:"column"},[_c('a',{staticClass:"button",class:{ 'is-aquamarine': _vm.staffStartsWith === ''},staticStyle:{"width":"2.5rem","height":"2.5rem","padding":"0rem"},attrs:{"title":_vm.getTitleForLetter('AZ')},on:{"click":function($event){_vm.loadStaffStartsWith('')}}},[_vm._v("\n          A…Z\n        ")])]),_vm._v(" "),_c('b-loading',{attrs:{"is-full-page":false,"active":_vm.isLoadingStaff},on:{"update:active":function($event){_vm.isLoadingStaff=$event}}})],2),_vm._v(" "),(!_vm.isLoadingStaff && _vm.staff && _vm.staff.length > 0)?_c('div',{staticClass:"fob-person-search-results",staticStyle:{"min-width":"450px","margin-top":"1rem"}},[_c('hr',{staticClass:"fob-public-select-divider",attrs:{"align":"left"}}),_vm._v(" "),_c('ul',_vm._l((_vm.staff),function(person){return _c('router-link',{key:("person-" + (person.id) + "-" + _vm.activeResourceType),staticClass:"control",staticStyle:{"padding":"2px 0 2px 0"},attrs:{"title":person.organisationseinheiten.map(function (x) { return ("" + (x.titelDe)); }).join('\n'),"tag":"li","to":_vm.toPublicRoute('person', person.id, _vm.activeResourceType)}},[_c('b-icon',{attrs:{"pack":"fa","icon":"user"}}),_vm._v(" "),_c('a',[_vm._v(_vm._s(_vm.fullNameWithTitle(person)))])],1)})),_vm._v(" "),(_vm.staffTotalEntries > _vm.staff.length)?_c('div',{staticClass:"fadeout"},[_c('span',{staticClass:"help is-italic has-text-centered",staticStyle:{"padding-top":"6em","width":"300px"},domProps:{"innerHTML":_vm._s(_vm.$gettext('Public.person.list.limit'))}})]):_vm._e()]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YFGe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YRcE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityValue_vue__ = __webpack_require__("kU3t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b22a58e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityValue_vue__ = __webpack_require__("Zzr5");
function injectStyle (ssrContext) {
  __webpack_require__("J3Fq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b22a58e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityValue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b22a58e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityValue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YVNy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.resourceData != null)?_c('div',{staticStyle:{"max-width":"1000px","margin":"0 auto"}},[_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column fob-hide-in-print"},[_c('div',{staticClass:"level"},[_c('div',{staticClass:"level-left"}),_vm._v(" "),_c('div',{staticClass:"level-right"},[_c('fob-public-list-quick-actions',{attrs:{"qa-share":true,"qa-print":true}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column"},[_c('fob-entity-header',{staticClass:"fob-entity-header",attrs:{"type":_vm.resourceSchema.className,"title":_vm.resourceData._stringRep}}),_vm._v(" "),_c('fob-entity-details',{staticClass:"fob-entity-details",attrs:{"resourceData":_vm.resourceData,"resourceSchema":_vm.resourceSchema,"resourceId":_vm.resourceId,"linkProvider":_vm.linkProvider,"useCompactComponents":true,"isPublic":true}}),_vm._v(" "),_c('div',{staticClass:"fob-hide-in-print",staticStyle:{"margin-top":"3rem"}},[_c('router-link',{attrs:{"to":_vm.currentPublicRoute()}},[_c('div',{staticClass:"button is-primary"},[_c('b-icon',{attrs:{"icon":"arrow-left","size":"is-small"}}),_vm._v(" "),_c('translate',[_vm._v("Public.entity.backToList")])],1)]),_vm._v(" "),(_vm.userCanEditByKostenstelle(_vm.resourceData))?_c('a',{attrs:{"href":_vm.portalEditLink}},[_c('div',{staticClass:"button is-garnet"},[_c('b-icon',{attrs:{"icon":"edit","size":"is-small"}}),_vm._v(" "),_c('translate',[_vm._v("component.entity.compact.edit")])],1)]):_vm._e()],1)],1)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_QueryParameter__ = __webpack_require__("HqXh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Hello__ = __webpack_require__("qSdX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Welcome__ = __webpack_require__("FJN/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AboutMe__ = __webpack_require__("2kkt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Entity__ = __webpack_require__("Z0aV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_EntityCreate__ = __webpack_require__("4tOy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_EntityEdit__ = __webpack_require__("sCuL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_EntityListView__ = __webpack_require__("DVHc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Public__ = __webpack_require__("NOQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_PublicEntity__ = __webpack_require__("OdqC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Upload__ = __webpack_require__("jd+X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Help__ = __webpack_require__("9YsO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_NotFound__ = __webpack_require__("YcJa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__schema__ = __webpack_require__("uDTM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_buefy__ = __webpack_require__("MMSg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_buefy__);
























__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]);

function createRoutes(leurisMode) {
  var routes = [];

  if (leurisMode === 'FOB') {
    routes.push({
      path: '/',
      name: 'start',
      component: __WEBPACK_IMPORTED_MODULE_7__components_Hello__["a" /* default */]
    });
    routes.push({
      path: '/login',
      name: 'login',
      component: __WEBPACK_IMPORTED_MODULE_10__components_Login__["a" /* default */]
    });
    routes.push({
      path: '/meine-aktivitaeten',
      name: 'aboutme',
      component: __WEBPACK_IMPORTED_MODULE_9__components_AboutMe__["a" /* default */],
      meta: { auth: true, viewState: 0 }
    });
    routes.push({
      path: '/eintragen/:resourceType?',
      name: 'eintragen',
      component: __WEBPACK_IMPORTED_MODULE_12__components_EntityCreate__["a" /* default */],
      props: true,
      meta: { auth: true, viewState: 0 }
    });
    routes.push({
      path: '/bearbeiten/:resourceType?/:resourceId?',
      name: 'editieren',
      component: __WEBPACK_IMPORTED_MODULE_13__components_EntityEdit__["a" /* default */],
      meta: { auth: true, viewState: 0 }
    });
    routes.push({
      path: '/upload',
      name: 'upload',
      component: __WEBPACK_IMPORTED_MODULE_17__components_Upload__["a" /* default */],
      meta: { auth: true, viewState: 0 }
    });
    routes.push({
      path: '/zeige',
      name: 'anzeigen',
      component: __WEBPACK_IMPORTED_MODULE_11__components_Entity__["a" /* default */],
      meta: { auth: true, viewState: 0 }
    });
    routes.push({
      path: '/zeige/:resourceType/:resourceId',
      name: 'anzeigen_einzeln',
      component: __WEBPACK_IMPORTED_MODULE_11__components_Entity__["a" /* default */],
      meta: { auth: true, viewState: 0 }
    });
    routes.push({
      path: '/auflisten',
      name: 'auflisten',
      component: __WEBPACK_IMPORTED_MODULE_14__components_EntityListView__["a" /* default */],
      meta: { auth: true, viewState: 0 }
    });
    routes.push({
      path: '/auflisten/:resourceType',
      name: 'auflisten_resource',
      component: __WEBPACK_IMPORTED_MODULE_14__components_EntityListView__["a" /* default */],
      meta: { auth: true, viewState: 0 }
    });
    routes.push({
      path: '/berichte',
      name: 'media-projekt',
      component: __WEBPACK_IMPORTED_MODULE_7__components_Hello__["a" /* default */],
      meta: { auth: true, viewState: 0 }
    });
    routes.push({
      path: '/help',
      name: 'help',
      component: __WEBPACK_IMPORTED_MODULE_18__components_Help__["a" /* default */],
      meta: { auth: true, viewState: 0 }
    });
  }
  // will match before /public/:type?/:id?/:resourceType?
  // in case type === 'details'
  if (leurisMode === 'PORTAL') {
    routes.push({
      path: '/',
      name: 'welcome',
      component: __WEBPACK_IMPORTED_MODULE_8__components_Welcome__["a" /* default */]
    });
    routes.push({
      path: '/welcome',
      name: 'welcome',
      component: __WEBPACK_IMPORTED_MODULE_8__components_Welcome__["a" /* default */]
    });
    routes.push({
      path: '/details/:resourceType(forschungsprojekt|publikation|preis|kooperation|veranstaltung)/:resourceId',
      name: 'public_details',
      component: __WEBPACK_IMPORTED_MODULE_16__components_PublicEntity__["a" /* default */],
      props: true
    });
    routes.push({
      path: '/:type(ou|person)?/:id?/:resourceType?',
      name: 'public',
      component: __WEBPACK_IMPORTED_MODULE_15__components_Public__["a" /* default */],
      props: true
    });
  }

  // generic routes
  routes.push({
    path: '/404',
    name: '404',
    component: __WEBPACK_IMPORTED_MODULE_19__components_NotFound__["a" /* default */]
  });
  routes.push({
    path: '*',
    name: 'notFound'
  });

  return routes;
}

function activityFromPath(path) {
  var parts = path.split('/');
  return parts[parts.length - 1];
}

function createRouter(leurisMode) {
  var router = new __WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]({
    base: '/' + leurisMode.toLowerCase() + '/',
    // https://router.vuejs.org/guide/essentials/history-mode.html
    mode: 'history',
    routes: createRoutes(leurisMode),
    linkActiveClass: 'is-active'
  });

  router.afterEach(function (to, from) {
    if (from.name) {
      var behavior = 'smooth';
      var top = 223;

      // when user logs out they are redirected to login page
      if (to.name === 'login') {
        top = 0;
      }

      if (from.name === 'public' && to.name === 'public') {
        var fromActivity = activityFromPath(from.path);
        var toActivity = activityFromPath(to.path);
        // don't adjust viewport when switch tabs
        if (fromActivity !== toActivity) {
          return;
        }
        top = 223;
        behavior = 'smooth';
      }
      setTimeout(function () {
        window.scrollTo({
          top: top,
          left: 0,
          behavior: behavior
        });
      }, 300);
    }
  });

  router.beforeEach(function (to, from, next) {
    // removeQueryParams is false by default
    var removeQueryParams = __WEBPACK_IMPORTED_MODULE_6__router_QueryParameter__["a" /* default */].hasBlacklistedParam(to.query);
    // process passed query parameters
    if (to.query.lang) {
      // set language by query param
      switch (to.query.lang) {
        case 'de':
          __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('setLanguage', 'de_DE');
          break;
        case 'en':
          __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('setLanguage', 'en_150');
          break;
      }
      // delete lang query param
      delete to.query.lang;
      // trigger route replace
      removeQueryParams = true;
    }

    if (to.query.fis_persid) {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('publicView/setSelected', {
        id: to.query.fis_persid,
        type: 'person',
        rootQueryType: 'person',
        typeLabel: 'Person'
      }).then(function (result) {
        if (result && result.redirect) {
          router.replace(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, to, { params: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, to.params, { id: result.orgaID }) }));
        }
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('publicView/reset');
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('publicView/loadAsyncData');
      });
      // delete fis_persid query param
      delete to.query.fis_persid;
      // trigger route replace
      removeQueryParams = true;
    }

    if (to.query.ou) {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('publicView/setSelected', {
        id: to.query.ou,
        type: 'ou',
        rootQueryType: 'organisationalUnit',
        typeLabel: 'Organisationseinheit'
      }).then(function (result) {
        if (result && result.redirect) {
          router.replace(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, to, { params: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, to.params, { id: result.orgaID }) }));
        }
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('publicView/reset');
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('publicView/loadAsyncData');
      });
      // delete ou query param
      delete to.query.ou;
      // trigger route replace
      removeQueryParams = true;
    }

    var queryFilter = {};
    var availabeFilters = ['year', 'status', 'funding', 'fundedByCategory', 'inProject', 'person', 'freetext', 'externalPartner', 'category', 'sdg'];

    availabeFilters.forEach(function (filter) {
      if (to.params.resourceType && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(to.query).includes(filter)) {
        queryFilter[filter] = to.query[filter];
        delete to.query[filter];
        removeQueryParams = true;
      }
    });

    // TODO: Review, might be better that queryPerPage is not passed (also since the selected is not passed)
    // let queryPerPage = null
    // if (to.params.resourceType && to.query.perPage) {
    //   queryPerPage = Number(to.query.perPage)
    //   delete to.query.perPage
    //   removeQueryParams = true
    // }

    var querySortOrder = null;
    if (to.params.resourceType && to.query.sortOrder) {
      querySortOrder = to.query.sortOrder.toUpperCase();
      delete to.query.sortOrder;
      removeQueryParams = true;
    }

    var querySortField = null;
    if (to.params.resourceType && to.query.sortField) {
      querySortField = to.query.sortField.toUpperCase();
      delete to.query.sortField;
      removeQueryParams = true;
    }

    if (removeQueryParams) {
      // reload without query params
      router.replace(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, to, {
        query: __WEBPACK_IMPORTED_MODULE_6__router_QueryParameter__["a" /* default */].clean(to.query)
      }));
    }

    var authRequired = to.matched.some(function (route) {
      return route.meta.auth;
    });
    var authed = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['user/isAuthorized'];

    // set active view state 'internal view', 'public view' and 'public personal view'
    if (to.meta && to.query.profile) {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('user/activeViewState', 2);
    } else if (to.name === 'start' && authed) {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('user/activeViewState', 0);
    } else if (to.meta && to.meta.hasOwnProperty('viewState')) {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('user/activeViewState', to.meta.viewState);
    } else {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('user/activeViewState', 1);
    }

    if (to.hash.startsWith('#')) {
      console.log('Redirecting to hash-less URI');
      next({
        path: to.hash.slice(1)
      });
    } else if (!authed && to.name === 'start') {
      if (leurisMode === 'FOB') {
        next('/login');
      } else {
        next('/welcome');
      }
    } else if (authRequired && !authed) {
      next('/login');
    } else if (authed && to.name === 'login') {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('user/activeViewState', 0);
      next({
        path: '/',
        replace: true
      });
    } else if (to.name === 'anzeigen_einzeln') {
      // TODO: Refactor to optional parameter
      var resourceSchema = __WEBPACK_IMPORTED_MODULE_20__schema__["a" /* default */][to.params.resourceType];
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('resource/setResource', {
        id: to.params.resourceId,
        type: to.params.resourceType,
        schema: resourceSchema
      }).then(function (data) {
        next();
      });
    } else if (to.name === 'editieren') {
      // first check if a resource is being edited
      if (to.params.resourceType != null) {
        var _resourceSchema = __WEBPACK_IMPORTED_MODULE_20__schema__["a" /* default */][to.params.resourceType];
        var resourceId = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['editor/getId'];
        var resourceType = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['editor/getViewEntityType'];
        var resourceData = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['editor/getData'];
        var resourceDataEmpty = resourceData == null || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(resourceData).length === 0 && resourceData.constructor === Object;
        // only reload when actually changing route in order to keep current changes
        // BUT reload data if page is reloaded
        if (to.params.resourceType !== resourceType || to.params.resourceId !== resourceId || resourceDataEmpty) {
          if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['editor/isDirty']) {
            __WEBPACK_IMPORTED_MODULE_21_buefy__["Dialog"].confirm({
              message: router.app.$gettext('warnung.edit.nachricht'),
              confirmText: router.app.$gettext('warnung.edit.confirm'),
              cancelText: router.app.$gettext('warnung.edit.cancel'),
              onConfirm: function onConfirm() {
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('editor/setResource', {
                  id: to.params.resourceId,
                  type: to.params.resourceType,
                  schema: _resourceSchema
                }).then(function () {
                  next();
                });
              },
              onCancel: function onCancel() {
                next(false);
              }
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('editor/setResource', {
              id: to.params.resourceId,
              type: to.params.resourceType,
              schema: _resourceSchema
            }).then(function () {
              next();
            });
          }
        } else {
          next();
        }
      } else {
        next();
      }
    } else if (to.name === 'auflisten_resource') {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('list/setResourceType', to.params.resourceType);
      next();
    } else if (to.name === 'welcome') {
      next({
        path: 'ou/1/forschungsprojekt',
        replace: true
      });
    } else if (to.name === 'public') {
      var fromSelected = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['publicView/getSelected'];
      // As default: id === 1 reset tree (this also set the name to "Universität Leipzig")
      // let treeSelected = store.getters['publicView/selected']
      if (to.params.id && Number(to.params.id) === 1 && to.params.type === 'ou') {
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('tree/reset');
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('tree/selectBranch', { id: to.params.id, name: 'Universität Leipzig' });
      } else {
        // set selected for tree component
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('tree/selectBranch', { id: to.params.id });
      }
      var validResourceType = false;
      if (to.params.resourceType) {
        var resourceTypes = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['publicView/resourceTypes'];
        var tabIdx = resourceTypes.findIndex(function (resourceType) {
          return resourceType.type === to.params.resourceType;
        });
        if (tabIdx !== -1) {
          __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('publicView/setActiveTab', tabIdx);
          validResourceType = true;
        }
      }
      if (from.params !== 'public' || fromSelected.type !== to.params.type || fromSelected.id !== to.params.id) {
        // show orga tree on organ view and the person search on person view
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('publicView/setShowOrgaTree', to.params.type === 'ou');

        if (to.params && to.params.id && to.params.type && validResourceType) {
          __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('publicView/setSelected', {
            id: to.params.id || 1, // if null load Universität as default
            type: to.params.type === 'person' ? 'person' : 'ou',
            rootQueryType: to.params.type === 'person' ? 'person' : 'organisationalUnit',
            typeLabel: to.params.type === 'person' ? 'Person' : 'Organisationseinheit'
          }).then(function (result) {
            if (result && result.redirect) {
              router.replace(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, to, { params: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, to.params, { id: result.orgaID }) }));
            }
            var dispatched = [];
            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(queryFilter).length > 0 || querySortField != null || querySortOrder != null) {
              if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(queryFilter).length > 0) {
                dispatched.push(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('publicView/updateFilter', {
                  resourceType: to.params.resourceType,
                  updateFilter: queryFilter
                }));
              }
              if (querySortField != null) {
                dispatched.push(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('publicView/setSortField', {
                  resourceType: to.params.resourceType,
                  sortField: querySortField
                }));
              }
              if (querySortOrder != null) {
                dispatched.push(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('publicView/setSortOrder', {
                  resourceType: to.params.resourceType,
                  sortOrder: querySortOrder
                }));
              }
              // if (queryPerPage != null) {
              //   dispatched.push(store.dispatch('publicView/changePerPage', {
              //     resourceType: to.params.resourceType,
              //     perPage: Number(queryPerPage)
              //   }))
              // }

              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(dispatched).then(function () {
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('publicView/loadAsyncData').then(function () {
                  next();
                }).catch(function () {
                  next({
                    name: 'public',
                    params: {
                      type: 'ou',
                      id: 1,
                      resourceType: 'forschungsprojekt'
                    }
                  });
                });
              });
            } else if (fromSelected.type !== to.params.type || fromSelected.id !== to.params.id) {
              // do not query the same data
              __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('publicView/reset').then(function () {
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('publicView/loadAsyncData').then(function () {
                  next();
                }).catch(function () {
                  next({
                    name: 'public',
                    params: {
                      type: 'ou',
                      id: 1,
                      resourceType: 'forschungsprojekt'
                    }
                  });
                });
              });
              next();
            } else {
              next();
            }
          });
        } else if (!validResourceType) {
          console.error('404: Invalid Resource Type');
          // if given resource type is not one of available resourceTypes (getter),
          // display error page
          router.replace({ name: '404' });
        } else if (!fromSelected.id) {
          // if no id was set query data
          __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('publicView/setSelected', {
            id: to.params.id || 1, // if null load Universität as default
            type: to.params.type === 'person' ? 'person' : 'ou',
            rootQueryType: to.params.type === 'person' ? 'person' : 'organisationalUnit',
            typeLabel: to.params.type === 'person' ? 'Person' : 'Organisationseinheit'
          }).then(function () {
            __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('publicView/reset');
            __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('publicView/loadAsyncData');
            next();
          });
        } else {
          next();
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('publicView/reset');
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('publicView/loadAsyncData');
        next();
      }
    } else if (to.name === 'notFound') {
      console.error('404: Route does not exist');
      router.replace({ name: '404' });
    } else {
      next();
    }
  });
  return router;
}

/* harmony default export */ __webpack_exports__["a"] = (createRouter);

/***/ }),

/***/ "YcJa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__ = __webpack_require__("WoGI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc3c33d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__("AN2u");
function injectStyle (ssrContext) {
  __webpack_require__("tLDE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dc3c33d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc3c33d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z/xC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "researchSelection", function() { return researchSelection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__axios__ = __webpack_require__("eOoE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__("0xDb");







var researchSelection = function researchSelection(method, fisPersid, resourceType, resourceId) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    // map 'resourceType' from FOB to types from MACO
    var macoActivity = {
      forschungsprojekt: 'projects',
      kooperation: 'cooperations',
      publikation: 'publications',
      veranstaltung: 'events',
      preis: 'awards'
      // convert number as string to number from type Number
    };var id = Number(resourceId);
    // set a payload in axios differs between http methods
    var payload = {};
    if (method && ['get', 'post', 'put', 'patch'].includes(method) && !__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(id)) {
      payload = { id: id };
    } else if (method && method === 'delete' && !__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(id)) {
      payload = { data: { id: id } };
    }
    // only fetch research selection if fisPersid is given
    if (fisPersid) {
      // set endpoint url for http method (default: fetch all)
      var endpoint = '/research_selection/' + fisPersid;
      if (method && ['post', 'delete'].includes(method) && macoActivity[resourceType]) {
        endpoint += '/' + macoActivity[resourceType];
      }
      // fetch research selection
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__axios__["c" /* macoAxios */])(method, endpoint, payload).then(function (response) {
        var data = {};
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(macoActivity).forEach(function (_ref) {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
              fobActivityName = _ref2[0],
              macoActivityName = _ref2[1];

          data[fobActivityName] = response.data[macoActivityName];
        });
        resolve(data);
      }).catch(function (error) {
        // identify error from maco, 403: max favourites reached
        if (error.response.status === 403 && error.response.data && error.response.data.error && error.response.data.error.research_selection) {
          reject('AboutMe.toast.researchSelectionLimit');
        } else {
          // default error handling
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* ToastError */])(error, 5000, {
            method: method,
            fisPersid: fisPersid,
            resourceId: resourceId,
            resourceType: resourceType,
            macoActivity: macoActivity[resourceType]
          });
        }
        reject(error);
      });
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* ToastError */])('Could not favour research activitiy', 5000, {
        method: method,
        fisPersid: fisPersid,
        resourceId: resourceId,
        resourceType: resourceType,
        macoActivity: macoActivity[resourceType]
      });
      reject();
    }
  });
};

/***/ }),

/***/ "Z0aV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Entity_vue__ = __webpack_require__("2q6c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c033270_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Entity_vue__ = __webpack_require__("suVi");
function injectStyle (ssrContext) {
  __webpack_require__("ObY8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Entity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c033270_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Entity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZCKo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchAwardQuery; });
function fetchAwardQuery(rootQueryType, id, pageSize, page, sortField, sortOrder, filter) {
  rootQueryType = ['organisationalUnit', 'person'].includes(rootQueryType) ? rootQueryType : null;
  id = rootQueryType === 'organisationalUnit' ? Number(id) : '' + id;

  // if the rootQueryType does not match for organisational unit or person then return nulls
  if (!rootQueryType) {
    return null;
  }

  var variables = {
    id: id || null,
    pageSize: Number(pageSize) || 20,
    page: Number(page) || 1
  };

  if (sortOrder) {
    variables['sortOrder'] = sortOrder;
  }

  if (sortField) {
    variables['sortField'] = sortField;
  }

  if (filter && filter.typeIds) {
    if (filter.typeIds.startsWith('PREIS_')) {
      var _id = filter.typeIds.slice('PREIS_'.length);
      variables['filterTypeIds'] = [Number(_id)];
    } else if (filter.typeIds === 'WEITERE_PREISE') {
      variables['filterTypeIds'] = [1, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28];
    }
  }

  if (filter && filter.year && Number(filter.year)) {
    variables['filterYear'] = Number(filter.year);
  }

  if (filter && filter.freetext && filter.freetext.length > 0) {
    variables['filterFreetext'] = filter.freetext;
  }

  if (filter && filter.person && filter.person.length > 0) {
    variables['filterPerson'] = filter.person;
  }

  return {
    operationName: 'fetchAwardQuery',
    query: '\n      query fetchAwardQuery(\n        $id: ID!,\n        $pageSize:Int!,\n        $page:Int!,\n        $sortOrder:SortOrder,\n        $sortField:AwardSortKeys,\n        $filterYear:Int,\n        $filterTypeIds:[Int],\n        $filterFreetext:String,\n        $filterPerson:String,\n      ) {\n        ' + rootQueryType + '(id: $id) {\n          preis:awards(\n            pageSize: $pageSize,\n            page: $page,\n            sortOrder: $sortOrder,\n            orderBy:$sortField,\n            filter: {\n              year: $filterYear,\n              freeText: $filterFreetext,\n              person: $filterPerson,\n              typeIds: $filterTypeIds,\n            }\n          ) {\n            meta {\n              pageNumber\n              pageSize\n              totalEntries\n              totalPages\n            }\n            entries {\n              ... on Award {\n                _entityName\n                _id:id\n                html {\n                  de\n                  en\n                }\n              }\n            }\n          }\n        }\n      }\n    ',
    variables: variables
  };
}



/***/ }),

/***/ "ZMCW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchLeurisProfileQuery; });
function fetchLeurisProfileQuery(_ref) {
  var fisPersid = _ref.fisPersid;

  var variables = { fisPersid: fisPersid };

  return {
    operationName: 'fetchLeurisProfileQuery',
    query: '\n      query fetchLeurisProfileQuery($fisPersid: ID!) {\n        person(id: $fisPersid) {\n          name: _stringRep\n          orcid\n          ulWebsiteProfileDe\n          ulWebsiteProfileEn\n          leurisProfile {\n            abstract {\n              de\n              en\n            }\n          }\n        }\n      }\n    ',
    variables: variables
  };
}



/***/ }),

/***/ "ZNs5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicSelectTag_vue__ = __webpack_require__("cIus");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ce080d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicSelectTag_vue__ = __webpack_require__("e6/N");
function injectStyle (ssrContext) {
  __webpack_require__("dAR2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicSelectTag_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ce080d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicSelectTag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZaTp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_CompactViewHelper__ = __webpack_require__("TGNV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_DateTimeHelper__ = __webpack_require__("5W2G");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-patent-compact',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_CompactViewHelper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__components_mixins_DateTimeHelper__["a" /* default */]],
  props: ['schema', 'data'],
  computed: {
    title: function title() {
      return this.data.titel;
    },
    mainInventor: function mainInventor() {
      return this.fullName(this.data.haupterfinder && this.data.haupterfinder[0] || {});
    },
    organizationalUnit: function organizationalUnit() {
      return this.data.organisationseinheit.name;
    },
    priorityDate: function priorityDate() {
      return this.asDate(this.data.datumDerPrioritaetsbegruendendenErstanmeldung);
    },
    publicationNumber: function publicationNumber() {
      return this.data.veroeffentlichungsnummer;
    }
  }
});

/***/ }),

/***/ "ZkOl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("BCQj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__("Ev9m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__("VtBz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("PB4+");





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__
});

/***/ }),

/***/ "ZmL6":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "NksN",
	"./af.js": "NksN",
	"./ar": "s1DA",
	"./ar-dz": "u9qe",
	"./ar-dz.js": "u9qe",
	"./ar-kw": "GWSX",
	"./ar-kw.js": "GWSX",
	"./ar-ly": "3d56",
	"./ar-ly.js": "3d56",
	"./ar-ma": "51T7",
	"./ar-ma.js": "51T7",
	"./ar-sa": "QX/g",
	"./ar-sa.js": "QX/g",
	"./ar-tn": "YyyS",
	"./ar-tn.js": "YyyS",
	"./ar.js": "s1DA",
	"./az": "QcUs",
	"./az.js": "QcUs",
	"./be": "Ovp9",
	"./be.js": "Ovp9",
	"./bg": "ZIpD",
	"./bg.js": "ZIpD",
	"./bm": "HfHs",
	"./bm.js": "HfHs",
	"./bn": "wVAL",
	"./bn.js": "wVAL",
	"./bo": "0JFG",
	"./bo.js": "0JFG",
	"./br": "kjQ0",
	"./br.js": "kjQ0",
	"./bs": "jceK",
	"./bs.js": "jceK",
	"./ca": "wqDk",
	"./ca.js": "wqDk",
	"./cs": "Eeel",
	"./cs.js": "Eeel",
	"./cv": "A/FZ",
	"./cv.js": "A/FZ",
	"./cy": "j537",
	"./cy.js": "j537",
	"./da": "c2jm",
	"./da.js": "c2jm",
	"./de": "SiL6",
	"./de-at": "FBeO",
	"./de-at.js": "FBeO",
	"./de-ch": "WPku",
	"./de-ch.js": "WPku",
	"./de.js": "SiL6",
	"./dv": "Kk4k",
	"./dv.js": "Kk4k",
	"./el": "9jdc",
	"./el.js": "9jdc",
	"./en-au": "LMQY",
	"./en-au.js": "LMQY",
	"./en-ca": "QdkW",
	"./en-ca.js": "QdkW",
	"./en-gb": "+Qcl",
	"./en-gb.js": "+Qcl",
	"./en-ie": "CQ3a",
	"./en-ie.js": "CQ3a",
	"./en-il": "lkAw",
	"./en-il.js": "lkAw",
	"./en-in": "an//",
	"./en-in.js": "an//",
	"./en-nz": "0f8q",
	"./en-nz.js": "0f8q",
	"./en-sg": "KeC4",
	"./en-sg.js": "KeC4",
	"./eo": "sxX8",
	"./eo.js": "sxX8",
	"./es": "xbPA",
	"./es-do": "gKpp",
	"./es-do.js": "gKpp",
	"./es-us": "SEgU",
	"./es-us.js": "SEgU",
	"./es.js": "xbPA",
	"./et": "um5+",
	"./et.js": "um5+",
	"./eu": "Rxbj",
	"./eu.js": "Rxbj",
	"./fa": "YBex",
	"./fa.js": "YBex",
	"./fi": "iWfJ",
	"./fi.js": "iWfJ",
	"./fil": "5cDL",
	"./fil.js": "5cDL",
	"./fo": "Dlyg",
	"./fo.js": "Dlyg",
	"./fr": "ZzA1",
	"./fr-ca": "Gq0W",
	"./fr-ca.js": "Gq0W",
	"./fr-ch": "ru/r",
	"./fr-ch.js": "ru/r",
	"./fr.js": "ZzA1",
	"./fy": "L7gE",
	"./fy.js": "L7gE",
	"./ga": "fTs2",
	"./ga.js": "fTs2",
	"./gd": "6kDW",
	"./gd.js": "6kDW",
	"./gl": "bYNZ",
	"./gl.js": "bYNZ",
	"./gom-deva": "Tbz0",
	"./gom-deva.js": "Tbz0",
	"./gom-latn": "js8X",
	"./gom-latn.js": "js8X",
	"./gu": "xIZ/",
	"./gu.js": "xIZ/",
	"./he": "R1xH",
	"./he.js": "R1xH",
	"./hi": "4H0D",
	"./hi.js": "4H0D",
	"./hr": "cuVS",
	"./hr.js": "cuVS",
	"./hu": "9QLk",
	"./hu.js": "9QLk",
	"./hy-am": "wN5z",
	"./hy-am.js": "wN5z",
	"./id": "kwJa",
	"./id.js": "kwJa",
	"./is": "NVnF",
	"./is.js": "NVnF",
	"./it": "6cc6",
	"./it-ch": "tBGD",
	"./it-ch.js": "tBGD",
	"./it.js": "6cc6",
	"./ja": "NC7d",
	"./ja.js": "NC7d",
	"./jv": "Z5rS",
	"./jv.js": "Z5rS",
	"./ka": "oZ+8",
	"./ka.js": "oZ+8",
	"./kk": "JJrU",
	"./kk.js": "JJrU",
	"./km": "JsaR",
	"./km.js": "JsaR",
	"./kn": "wzoo",
	"./kn.js": "wzoo",
	"./ko": "eS4q",
	"./ko.js": "eS4q",
	"./ku": "TPtF",
	"./ku.js": "TPtF",
	"./ky": "tJO/",
	"./ky.js": "tJO/",
	"./lb": "Q8Xi",
	"./lb.js": "Q8Xi",
	"./lo": "i/4P",
	"./lo.js": "i/4P",
	"./lt": "Kr6r",
	"./lt.js": "Kr6r",
	"./lv": "Stc5",
	"./lv.js": "Stc5",
	"./me": "yl7X",
	"./me.js": "yl7X",
	"./mi": "U2Om",
	"./mi.js": "U2Om",
	"./mk": "Ujuy",
	"./mk.js": "Ujuy",
	"./ml": "i/l/",
	"./ml.js": "i/l/",
	"./mn": "sxoT",
	"./mn.js": "sxoT",
	"./mr": "FGR4",
	"./mr.js": "FGR4",
	"./ms": "YUJq",
	"./ms-my": "mzSP",
	"./ms-my.js": "mzSP",
	"./ms.js": "YUJq",
	"./mt": "ND0v",
	"./mt.js": "ND0v",
	"./my": "V9pQ",
	"./my.js": "V9pQ",
	"./nb": "3sl7",
	"./nb.js": "3sl7",
	"./ne": "kuza",
	"./ne.js": "kuza",
	"./nl": "KTp2",
	"./nl-be": "4tZK",
	"./nl-be.js": "4tZK",
	"./nl.js": "KTp2",
	"./nn": "fuOv",
	"./nn.js": "fuOv",
	"./oc-lnc": "feuU",
	"./oc-lnc.js": "feuU",
	"./pa-in": "vpMg",
	"./pa-in.js": "vpMg",
	"./pl": "ACl7",
	"./pl.js": "ACl7",
	"./pt": "v+kn",
	"./pt-br": "Q4iG",
	"./pt-br.js": "Q4iG",
	"./pt.js": "v+kn",
	"./ro": "y5Yt",
	"./ro.js": "y5Yt",
	"./ru": "4aSe",
	"./ru.js": "4aSe",
	"./sd": "xyC3",
	"./sd.js": "xyC3",
	"./se": "ld11",
	"./se.js": "ld11",
	"./si": "Ckki",
	"./si.js": "Ckki",
	"./sk": "QdPB",
	"./sk.js": "QdPB",
	"./sl": "QxcE",
	"./sl.js": "QxcE",
	"./sq": "Ntyb",
	"./sq.js": "Ntyb",
	"./sr": "RjrL",
	"./sr-cyrl": "NBnY",
	"./sr-cyrl.js": "NBnY",
	"./sr.js": "RjrL",
	"./ss": "wDoN",
	"./ss.js": "wDoN",
	"./sv": "k922",
	"./sv.js": "k922",
	"./sw": "j/q6",
	"./sw.js": "j/q6",
	"./ta": "MWLD",
	"./ta.js": "MWLD",
	"./te": "vOLw",
	"./te.js": "vOLw",
	"./tet": "uAHB",
	"./tet.js": "uAHB",
	"./tg": "+1fw",
	"./tg.js": "+1fw",
	"./th": "YA5y",
	"./th.js": "YA5y",
	"./tk": "AdzU",
	"./tk.js": "AdzU",
	"./tl-ph": "AI1X",
	"./tl-ph.js": "AI1X",
	"./tlh": "6y5R",
	"./tlh.js": "6y5R",
	"./tr": "n2Mj",
	"./tr.js": "n2Mj",
	"./tzl": "EITO",
	"./tzl.js": "EITO",
	"./tzm": "NTEK",
	"./tzm-latn": "gxfV",
	"./tzm-latn.js": "gxfV",
	"./tzm.js": "NTEK",
	"./ug-cn": "OMuo",
	"./ug-cn.js": "OMuo",
	"./uk": "Xnfh",
	"./uk.js": "Xnfh",
	"./ur": "NwAM",
	"./ur.js": "NwAM",
	"./uz": "4goc",
	"./uz-latn": "wtRA",
	"./uz-latn.js": "wtRA",
	"./uz.js": "4goc",
	"./vi": "jVvH",
	"./vi.js": "jVvH",
	"./x-pseudo": "Dui3",
	"./x-pseudo.js": "Dui3",
	"./yo": "Mj19",
	"./yo.js": "Mj19",
	"./zh-cn": "3ISc",
	"./zh-cn.js": "3ISc",
	"./zh-hk": "1oBQ",
	"./zh-hk.js": "1oBQ",
	"./zh-mo": "q/Y5",
	"./zh-mo.js": "q/Y5",
	"./zh-tw": "o/qB",
	"./zh-tw.js": "o/qB"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZmL6";

/***/ }),

/***/ "Zqee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("gyMJ");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-entity-select-prefetched',
  data: function data() {
    return {
      values: [],
      selected: null,
      loading: true,
      groupLabels: null,
      groups: {}
    };
  },

  props: ['entity', 'searchMethod', 'icon', 'value', 'groupBy', 'type', 'preselect', 'prefilter', 'orderBy', 'reorder'],
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].methods.find(this.entity, this.searchMethod, this.orderBy).then(function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
        var data = _ref2.data,
            meta = _ref2.meta;

        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, g;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.prefilter instanceof Function) {
                  _this.values = data.filter(_this.prefilter);
                } else {
                  _this.values = data;
                }

                if (_this.reorder) {
                  data = _this.reorder.map(function (i) {
                    return data.find(function (x) {
                      return x._id === i;
                    });
                  });
                }

                if (!(_this.groupBy != null)) {
                  _context.next = 23;
                  break;
                }

                _this.groupLabels = data.map(function (x) {
                  return x[_this.groupBy];
                }).reduce(function (x, y) {
                  return x.includes(y) ? x : [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(x), [y]);
                }, []).sort();
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 7;
                for (_iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  item = _step.value;
                  g = item[_this.groupBy];

                  if (_this.groups[g] == null) {
                    _this.groups[g] = [];
                  }
                  _this.groups[item[_this.groupBy]].push(item);
                }
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](7);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 15:
                _context.prev = 15;
                _context.prev = 16;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 18:
                _context.prev = 18;

                if (!_didIteratorError) {
                  _context.next = 21;
                  break;
                }

                throw _iteratorError;

              case 21:
                return _context.finish(18);

              case 22:
                return _context.finish(15);

              case 23:

                if (_this.value != null) {
                  _this.selected = _this.values.find(function (x) {
                    return x._id === _this.value._id;
                  })._id;
                } else if (_this.preselect instanceof Function) {
                  _this.selected = _this.values.find(_this.preselect)._id;
                }
                _this.loading = false;

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[7, 11, 15, 23], [16,, 18, 22]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  },

  methods: {
    selectValue: function selectValue() {
      var _this2 = this;

      var selectedEntity = this.values.find(function (x) {
        return x._id === _this2.selected;
      });
      this.$emit('input', selectedEntity);
    }
  }
});

/***/ }),

/***/ "Zvhw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('div',{staticStyle:{"padding":"0 1rem 0 1rem"}},[_c('translate',[_vm._v("Public.sort.by")])],1),_vm._v(" "),_c('b-select',{staticStyle:{"padding":"0 1rem 0 1rem"},model:{value:(_vm.localSortField),callback:function ($$v) {_vm.localSortField=$$v},expression:"localSortField"}},_vm._l((_vm.sortFields),function(value){return _c('option',{key:(_vm.resourceType + "." + (value.field)),domProps:{"value":value.field}},[_c('translate',[_vm._v(_vm._s(value.label))])],1)})),_vm._v(" "),_c('b-select',{model:{value:(_vm.localSortOrder),callback:function ($$v) {_vm.localSortOrder=$$v},expression:"localSortOrder"}},[_c('option',{attrs:{"value":"ASC"}},[_c('translate',[_vm._v("Public.sort.order.ASC")])],1),_vm._v(" "),_c('option',{attrs:{"translate":"","value":"DESC"}},[_c('translate',[_vm._v("Public.sort.order.DESC")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zzr5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.resourceData || _vm.bit.type === Boolean || _vm.bit.type === 'select')?_c('div',[(_vm.isFOBObject || _vm.isArray)?_c('span',[(!_vm.isArray)?_c('span',[(_vm.bit.render === 'embedded')?[_c('fob-entity-details',{attrs:{"resourceSchema":_vm.bit.schema,"resourceData":_vm.resourceData,"linkProvider":_vm.linkProvider,"isPublic":_vm.isPublic}})]:[(_vm.resourceData && !_vm.plain && _vm.constructLink(_vm.resourceData) != null)?[_c('fob-entity-decorator',{attrs:{"isPublic":_vm.isPublic,"resourceData":_vm.resourceData}},[_c('router-link',{staticClass:"has-text-garnet",attrs:{"to":_vm.constructLink(_vm.resourceData)}},[_c('b-tooltip',{attrs:{"active":_vm.showTooltip(_vm.stringRep(_vm.resourceData)),"label":_vm.stringRep(_vm.resourceData),"type":"is-basalt","position":"is-top","size":"is-small","square":true}},[_vm._v("\n                  "+_vm._s(_vm.labelFormatter(_vm.stringRep(_vm.resourceData)))+"\n              ")])],1)],1)]:_c('div',[_c('b-tooltip',{attrs:{"active":_vm.showTooltip(_vm.stringRep(_vm.resourceData)),"label":_vm.stringRep(_vm.resourceData),"type":"is-basalt","position":"is-top","size":"is-small","square":true}},[_c('fob-entity-decorator',{attrs:{"isPublic":_vm.isPublic,"resourceData":_vm.resourceData}},[_vm._v("\n              "+_vm._s(_vm.labelFormatter(_vm.stringRep(_vm.resourceData)))+"\n            ")])],1)],1)]],2):_c('span',[_c('ul',_vm._l((_vm.sortedResourceData()),function(item,index){return _c('li',{key:index},[(_vm.bit.render==='embedded')?[_c('fob-entity-details',{attrs:{"resourceSchema":_vm.bit.schema,"resourceData":item,"linkProvider":_vm.linkProvider,"isPublic":_vm.isPublic}})]:[(_vm.resourceData && !_vm.plain && _vm.constructLink(item) != null)?_c('div',[(_vm.useCompactComponents && _vm.hasCompactComponent(_vm.bit.schema))?_c('b-field',[_c('router-link',{staticClass:"has-text-aquamarine fob-hide-in-print",attrs:{"to":_vm.constructLink(item)}},[_c('b-icon',{staticStyle:{"margin-right":"1.5rem"},attrs:{"icon":"search","type":"is-aquamarine"}})],1),_vm._v(" "),_c('div',{staticClass:"fob-only-for-print-view",staticStyle:{"margin-right":"0.5rem"}},[_vm._v("—")]),_vm._v(" "),_c(_vm.compactComponentName(_vm.bit.schema),{tag:"component",staticClass:"fob-entity-compact-component",attrs:{"schema":_vm.getFullSchema(_vm.bit.schema.className),"data":item}})],1):[_c('fob-entity-decorator',{attrs:{"isPublic":_vm.isPublic,"resourceData":item}},[_c('router-link',{staticClass:"has-text-garnet",attrs:{"to":_vm.constructLink(item)}},[_c('b-tooltip',{attrs:{"active":_vm.showTooltip(_vm.stringRep(item)),"label":_vm.stringRep(item),"type":"is-aquamarine","position":"is-top","size":"is-small","square":true}},[_vm._v("\n                        "+_vm._s(_vm.labelFormatter(_vm.stringRep(item)))+"\n                    ")])],1)],1)]],2):_c('div',[_c('fob-entity-decorator',{attrs:{"isPublic":_vm.isPublic,"resourceData":item}},[_vm._v("\n                "+_vm._s(_vm.stringRep(item))+"\n              ")])],1)]],2)}))])]):(_vm.bit.type === Date)?_c('span',[_vm._v("\n    "+_vm._s(_vm.asDate(_vm.resourceData))+"\n  ")]):(_vm.bit.type === 'timestamp')?_c('span',[_vm._v("\n    "+_vm._s(_vm.asTimestamp(_vm.resourceData))+"\n  ")]):(_vm.bit.type === 'timestampAsDate')?_c('span',[_c('b-tooltip',{attrs:{"label":_vm.asTimestamp(_vm.resourceData)}},[_vm._v("\n      "+_vm._s(_vm.timestampAsDate(_vm.resourceData))+"\n    ")])],1):(_vm.bit.type === 'select')?_c('span',[(_vm.bit.translatable)?_c('span',[_c('b-tooltip',{attrs:{"active":_vm.showTooltip(_vm.$gettext(_vm.extractSelectLabelFromValue())),"label":_vm.$gettext(_vm.extractSelectLabelFromValue()),"type":"is-aquamarine","position":"is-top","size":"is-small","square":true}},[_vm._v("\n        "+_vm._s(_vm.labelFormatter(_vm.$gettext(_vm.extractSelectLabelFromValue())))+"\n      ")])],1):_c('span',[_c('b-tooltip',{attrs:{"active":_vm.showTooltip(_vm.resourceData),"label":String(_vm.resourceData),"type":"is-aquamarine","position":"is-top","size":"is-small","square":true}},[_vm._v("\n        "+_vm._s(_vm.labelFormatter(_vm.resourceData))+"\n      ")])],1)]):(_vm.bit.type === Boolean)?_c('span',[(_vm.plain)?_c('span',[_c('translate',[_vm._v(_vm._s(_vm.resourceData ? 'boolean.yes' : 'boolean.no'))])],1):_c('b-icon',{attrs:{"icon":_vm.resourceData ? 'check-square-o' : 'square-o'}})],1):(_vm.bit.type === 'link')?_c('span',[_c('div',{staticClass:"fob-hide-in-print"},[_c('a',{attrs:{"href":_vm.resourceData.href,"target":"_blank","rel":"noopener noreferrer"}},[(_vm.resourceData.href == _vm.resourceData.text)?[_vm._v("\n          "+_vm._s(decodeURIComponent(_vm.resourceData.text))+"\n        ")]:[_vm._v("\n          "+_vm._s(_vm.resourceData.text)+"\n        ")]],2),_vm._v(" "),_c('b-icon',{attrs:{"pack":"fa","icon":"external-link","size":"is-small"}})],1),_vm._v(" "),_c('div',{staticClass:"fob-only-for-print-view"},[_c('div',{staticClass:"fob-entity-value-link-title"},[(_vm.resourceData.href == _vm.resourceData.text)?[_vm._v("\n          "+_vm._s(decodeURIComponent(_vm.resourceData.text))+"\n        ")]:[_vm._v("\n          "+_vm._s(_vm.resourceData.text)+"\n        ")]],2),_vm._v(" "),(!_vm.isUri)?_c('div',{staticClass:"fob-entity-value-href"},[_vm._v("\n        ["),_c('span',[_vm._v(_vm._s(_vm.resourceData.href))]),_vm._v("]\n      ")]):_vm._e()])]):(_vm.bit.render === 'html')?_c('span',[_c('div',{staticClass:"html-value",domProps:{"innerHTML":_vm._s(_vm.resourceData)}})]):_c('span',[_c('b-tooltip',{attrs:{"active":_vm.showTooltip(_vm.resourceData),"label":String(_vm.resourceData),"type":"is-aquamarine","position":"is-top","size":"is-small","square":true}},[_vm._v("\n      "+_vm._s(_vm.labelFormatter(_vm.resourceData))+"\n    ")])],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a87m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aGWv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aQYl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Externe Organisation',
  route: 'externeorganisation',
  className: 'externeOrganisation',
  fields: [{
    label: 'Name',
    field: 'name',
    type: 'string'
  }, {
    label: 'Stadt',
    field: 'stadt',
    type: 'string'
  }, {
    label: 'Beschreibung',
    field: 'beschreibung',
    type: 'string'
  }, {
    label: 'Kurzname',
    field: 'kurzname',
    type: 'string'
  }, {
    label: 'Land',
    cardinality: 'single',
    icon: 'globe',
    field: 'land',
    type: 'object',
    render: 'stringRep'
  }]
});

/***/ }),

/***/ "afB/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFieldsGeneric__ = __webpack_require__("K13K");

var ListFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ListFieldsGeneric__["a" /* default */])('Person');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Person',
  route: 'person',
  className: 'person', // wird von fob-js-client benutzt
  fields: [ListFields.SortableField('titel', true), ListFields.SortableField('vorname', true), ListFields.SortableField('name', true), ListFields.SortableField('fisPersid', false), ListFields.UnsortableReference('organisationseinheiten', false), ListFields.UnsortableReference('personIdent', true, true)]
});

/***/ }),

/***/ "ambQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fobclient_lib_entity__ = __webpack_require__("9fz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fobclient_lib_entity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fobclient_lib_entity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__schema_AbstractPerson__ = __webpack_require__("BP7K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_Label__ = __webpack_require__("i8BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_form_NullableDate__ = __webpack_require__("Hqjx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_form_EntitySelect__ = __webpack_require__("TzBH");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-projektleiter-form',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default.a,
    'fob-label': __WEBPACK_IMPORTED_MODULE_6__components_form_Label__["a" /* default */],
    'fob-entity-select': __WEBPACK_IMPORTED_MODULE_8__components_form_EntitySelect__["a" /* default */],
    'fob-nullable-date': __WEBPACK_IMPORTED_MODULE_7__components_form_NullableDate__["a" /* default */]
  },
  data: function data() {
    return {
      finder: {
        name: 'byMultiValueSearchRep',
        multiValue: true,
        minLength: 3
      },
      roles: ['GESAMTLEITUNG', 'FACHLICHE_LEITUNG', 'TECHNISCHE_LEITUNG'],
      personSchema: __WEBPACK_IMPORTED_MODULE_5__schema_AbstractPerson__["a" /* default */],
      // This is only a shallow clone and will result in problems with reactivity.
      // To solve this, the EntityCreateForm has a `watch` method.
      data: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.value)),
      // Alternative: Use structuredClone, more modern but not consistently
      // used in FOB, since FOB inception predates structuredClone
      // data: this.value.map(v => window.structuredClone(v)),
      changing: false,
      containerHeight: 'auto'
    };
  },

  props: {
    label: String,
    asterisk: {
      type: Boolean,
      default: false
    },
    showErrors: {
      type: Boolean,
      default: false
    },
    validation: {
      type: Object,
      default: {}
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    errorMsg: function errorMsg(j) {
      if (this.data[j]) {
        if (this.validation.$each[j] == null) {
          return '';
        } else if (this.validation.$each[j].person == null || this.validation.$each[j].person.$invalid) {
          return 'projektleiter_no_person';
        } else if (!this.validation.$each[j].startdatum.withinProjectBounds) {
          return 'startdate_out_of_scope';
        } else if (!this.validation.$each[j].enddatum.withinProjectBounds) {
          return 'enddate_out_of_scope';
        } else if (!this.validation.$each[j].startdatum.beforeEnddatum) {
          return 'enddate_before_startdate';
        }
        return '';
      } else {
        // should not happen
        return 'state out of sync';
      }
    },
    addProjektleiter: function addProjektleiter() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var pls, total, neuerLeiter, input;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.changing = true;
                _context.next = 3;
                return _this.$nextTick();

              case 3:
                _this.data.push(new __WEBPACK_IMPORTED_MODULE_3_fobclient_lib_entity__["Projektleiter"]({}));

                // adjust height
                if (_this.containerHeight === 'auto') {
                  _this.containerHeight = document.getElementsByClassName('projektleiter-container')[0].offsetHeight;
                }
                _context.next = 7;
                return _this.$nextTick();

              case 7:
                pls = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(document.getElementsByClassName('projektleiter-item')));
                total = pls.reduce(function (acc, el) {
                  return acc + el.offsetHeight;
                }, 0);

                _this.containerHeight = total + 'px';

                // focus input field of new projektleiter
                // (somewhat hacky because frameworks kinda suck)
                neuerLeiter = document.getElementsByClassName('projektleiter-container')[0].firstElementChild.firstElementChild.lastChild;
                input = neuerLeiter.getElementsByClassName('autocomplete')[0].firstElementChild.firstElementChild;

                input.focus();

                _this.$emit('input', _this.data);

                setTimeout(function () {
                  _this.changing = false;
                }, 500);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    removeProjektleiter: function removeProjektleiter(id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var pls, total;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.changing = true;
                _context2.next = 3;
                return _this2.$nextTick();

              case 3:
                _this2.data = _this2.data.filter(function (leiter) {
                  return leiter._id !== id;
                });

                // adjust height
                pls = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(document.getElementsByClassName('projektleiter-item')));
                total = pls.reduce(function (acc, el) {
                  return acc + (el.id === 'projektleiter-' + id ? 0 : el.offsetHeight);
                }, 0);

                _this2.containerHeight = total + 'px';

                _this2.$emit('input', _this2.data);

                setTimeout(function () {
                  _this2.changing = false;
                }, 500);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    touch: function touch(id) {
      this.data.forEach(function (pl) {
        if (pl._id === id) {
          pl._dirty = true;
          // TODO: Is `this.$emit(input, this.data)` needed here?
          // Probably only if structuredClone is used in `data` above.
        }
      });
    }
  }
});

/***/ }),

/***/ "bAiX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_DateTimeHelper__ = __webpack_require__("5W2G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mixins_DynamicTitle__ = __webpack_require__("IqS5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_EntityHeader__ = __webpack_require__("sGAB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_aboutme_AboutMeListView__ = __webpack_require__("9Bhn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_aboutme_AboutMeListQuickActions__ = __webpack_require__("fHoA");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import BackToTop from 'vue-backtotop'






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-aboutme',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_mixins_DynamicTitle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__components_mixins_DateTimeHelper__["a" /* default */]],
  data: function data() {
    return {
      printDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* currentDateString */])(),
      leurisHead: {
        inner: 'leuris:Forschungsportal',
        complement: 'menu.aboutme'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    filter: 'aboutme/getFilter',
    isLoading: 'aboutme/isLoading',
    label: 'aboutme/name',
    resourceTypes: 'aboutme/resourceTypes',
    selectedOrganisationalUnit: 'tree/selected',
    selected: 'publicView/getSelected',
    total: 'aboutme/getTotal',
    leurisProfile: 'aboutme/leurisProfile',
    leurisProfileFisPersid: 'aboutme/fisPersid',
    userFisPersid: 'user/fisPersid',
    userIsLoggedIn: 'user/isAuthorized'
  }), {
    activeTab: {
      get: function get() {
        return this.$store.getters['aboutme/getActiveTab'];
      },
      set: function set(activeTab) {
        this.$store.dispatch('aboutme/setActiveTab', activeTab);
      }
    },
    leurisProfileBaseUrl: function leurisProfileBaseUrl() {
      return  false ? process.env.MACO_URL + ':' + process.env.MACO_PORT : '' + "/profilseite";
    },
    showOrgaTree: function showOrgaTree() {
      return false;
    },
    activeResource: function activeResource() {
      return this.resourceTypes[this.activeTab];
    },
    isCompactView: function isCompactView() {
      if (this.$route.meta.compact || this.$route.query.compact === true || this.$route.query.compact === 'true') {
        return true;
      } else if (this.$route.query.compact === null) {
        return false;
      } else {
        return false;
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    fetchLeurisProfile: 'aboutme/fetchLeurisProfile',
    fetchResearchActivities: 'aboutme/fetchResearchActivities',
    fetchResearchSelection: 'aboutme/fetchResearchSelection'
  }), {
    hasActiveFilter: function hasActiveFilter(resourceType) {
      var _this = this;

      var active = false;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filter[resourceType].filter).length > 0) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filter[resourceType].filter).some(function (filterKey) {
          var value = _this.filter[resourceType].filter[filterKey];
          if (value && value.length > 0) {
            active = true;
          }
        });
      }
      return active;
    },
    setRoute: function setRoute(type, id) {
      var to = {
        name: 'public',
        params: {
          type: type,
          id: id,
          resourceType: this.activeResource.type
        }
      };

      if (this.isCompactView) {
        to.query = {
          compact: true
        };
      }
      this.$router.replace(to);
    }
  }),
  watch: {
    selectedOrganisationalUnit: function selectedOrganisationalUnit() {
      // this.setRoute('ou', this.selectedOrganisationalUnit.id)
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    setInterval(function () {
      _this2.printDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* currentDateString */])();
    }, 30 * 1000);

    // load data
    this.fetchResearchSelection(this.userFisPersid);
    this.fetchLeurisProfile(this.userFisPersid);
    this.fetchResearchActivities();
  },

  components: {
    'fob-entity-header': __WEBPACK_IMPORTED_MODULE_6__components_EntityHeader__["a" /* default */],
    'fob-aboutme-list-view': __WEBPACK_IMPORTED_MODULE_7__components_aboutme_AboutMeListView__["a" /* default */],
    'fob-aboutme-list-quick-actions': __WEBPACK_IMPORTED_MODULE_8__components_aboutme_AboutMeListQuickActions__["a" /* default */]
    // BackToTop
  }
});

/***/ }),

/***/ "bBfD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bHuR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("mkhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__("bhWo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__("qDbP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("cKs/");





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__
});

/***/ }),

/***/ "bMTA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AbstractPerson__ = __webpack_require__("BP7K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fobclient_lib_entity__ = __webpack_require__("9fz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fobclient_lib_entity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fobclient_lib_entity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FieldsGeneric__ = __webpack_require__("WWW9");





var Fields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__FieldsGeneric__["a" /* default */])('Forschungsprojekt');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Forschungsprojekt',
  route: 'forschungsprojekt',
  class: __WEBPACK_IMPORTED_MODULE_2_fobclient_lib_entity__["Forschungsprojekt"],
  className: 'forschungsprojekt',
  fields: [Fields.organisationseinheit, Fields.relevantFuerWeitere, Fields.weitereOrganisationseinheiten, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.String('primaryPublicIdent'), {
    inEditView: false,
    editable: false,
    inPublicView: false,
    type: 'link',
    computed: function computed(data) {
      if (data.primaryPublicIdent) {
        return {
          href: "https://leuris.uni-leipzig.de" + '/portal/details/forschungsprojekt/' + data.primaryPublicIdent,
          text: data.primaryPublicIdent
        };
      }
      return null;
    }
  }), Fields.String('titelDE'), Fields.String('titelEN'), Fields.Text('beschreibungDE', 6000), Fields.Text('beschreibungEN', 6000), Fields.Date('projektBeginn'), Fields.Date('projektEnde'), {
    label: 'Forschungsprojekt.form.antragsteller',
    field: 'antragsteller',
    schema: __WEBPACK_IMPORTED_MODULE_1__AbstractPerson__["a" /* default */],
    finder: {
      name: 'byMultiValueSearchRep',
      multiValue: true,
      minLength: 3
    },
    icon: 'user',
    type: 'object',
    cardinality: 'many',
    render: 'stringRep'
  },
  // old projektLeiter, replaced by projektleiter
  /*
  {
    label: 'Forschungsprojekt.form.projektLeiter',
    field: 'projektLeiter',
    schema: AbstractPerson,
    icon: 'user',
    type: 'object',
    cardinality: 'single',
    render: 'stringRep',
    allowCreate: true,
    finder: {
      name: 'byMultiValueSearchRep',
      multiValue: true,
      minLength: 3
    }
  },
  */
  {
    label: 'Projektleitung',
    field: 'projektleiter',
    /*
      - a key `schema` is not needed since the projektleiter components
        come with their custom hard-coded layout of fields
      - a key `icon` is not needed, because there is no input field
      - render mode 'projektleiter' is a new custom-built mode
    */
    type: 'object',
    cardinality: 'many',
    render: 'projektleiter',
    allowCreate: true,
    onlyCreate: true
  }, Fields.URL('externeProjektwebsite'), Fields.String('uebergeordnetesProjekt'), {
    label: 'Forschungsprojekt.form.mitarbeiter',
    field: 'mitarbeiter',
    render: 'stringRep',
    type: 'object',
    schema: __WEBPACK_IMPORTED_MODULE_1__AbstractPerson__["a" /* default */],
    icon: 'user',
    cardinality: 'many',
    finder: {
      name: 'byMultiValueSearchRep',
      multiValue: true,
      minLength: 3
    }
  }, {
    label: 'Forschungsprojekt.form.finanzierung',
    field: 'foerderung',
    type: 'object',
    render: 'embedded',
    cardinality: 'many',
    nested: true,
    onlyCreate: true,
    schema: {
      route: 'foerderung',
      className: 'foerderung',
      entityName: 'de.ul.fob.domain.Foerderung',
      fields: [{
        label: 'Forschungsprojekt.form.foerderung.mittelgeber',
        field: 'mittelgeber',
        type: 'object',
        cardinality: 'single',
        nested: true,
        /*
        nested: take route 'foerderung' and nest 'mittelgeber' after that
        absolutely confusing! this has to be changed
        idea: 'nested' holds the path continuation, if any
         route is not relevant for nested! route is only for stand-alone
         main problem was:
        fetchResource is used to resolve 'embedded' references like book/author as
        well as direct resources ('person')
        */
        schema: {
          route: 'mittelgeber',
          className: 'mittelgeber',
          fields: [{
            label: 'Name',
            field: 'name'
          }]
        },
        finder: {
          name: 'bySearchRepLike',
          multiValue: false,
          minLength: 0,
          opts: {
            sort: 'finSchluessel'
          }
        }
      }, {
        field: 'logo',
        view: function view() {
          return false;
        },
        computed: function computed(data) {
          if (['000', '200', '300', '310', '320', '410', '420', '430'].includes(data.mittelgeber.finSchluessel)) {
            return '/static/logos/' + data.mittelgeber.finSchluessel + '.jpg';
          } else if (data.mittelgeber.finSchluessel === '110') {
            return '/static/logos/BMFTR_Logo_de.svg';
          } else if (data.mittelgeber.finSchluessel === '120') {
            return '/static/logos/BMWE_Logo_de.svg';
          } else {
            return null;
          }
        }
      }, {
        label: 'Forschungsprojekt.form.foerderung.foerderkennzeichen',
        field: 'foerderkennzeichen',
        inPublicView: false
      }]
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.MultiReference('sdg', 'bullseye'), {
    plain: true,
    view: function view(data, user, isPublic) {
      return !isPublic || data.sdg.length > 0;
    },

    schema: {
      route: 'sdg',
      className: 'sdg',
      fields: [{
        field: 'nameDe',
        table: true
      }, {
        field: 'nameEn',
        table: true
      }],
      tableSelectColumns: [{
        label: '_stringRep',
        field: '_stringRep'
      }]
    },
    finder: {
      name: 'byMultiValueSearchRep',
      multiValue: true,
      minLength: 0
    },
    widget: 'tableSelectVertical',
    allowCreate: false
  }), Fields.Boolean('verbundprojekt'), {
    label: 'Forschungsprojekt.form.sprecherhochschule',
    field: 'sprecherhochschule',
    render: 'stringRep',
    type: 'object',
    cardinality: 'single',
    schema: {
      route: 'externeorganisation',
      className: 'externeOrganisation'
    },
    finder: {
      name: 'bySearchRepLike',
      multiValue: false,
      minLength: 0
    },
    view: function view(data, user) {
      return data.verbundprojekt;
    }
  }, {
    label: 'Forschungsprojekt.form.publikation',
    field: 'publikation',
    schema: {
      className: 'publikation'
    },
    render: 'stringRep',
    type: 'object',
    cardinality: 'many',
    editable: false
  }, {
    label: 'Forschungsprojekt.form.istFinal',
    field: 'istFinal',
    inPublicView: false,
    type: Boolean
  }]
});

/***/ }),

/***/ "bhWo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoading", function() { return isLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "leurisProfile", function() { return leurisProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fisPersid", function() { return fisPersid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "favouredResearchActivity", function() { return favouredResearchActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "name", function() { return name; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getData", function() { return getData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSchema", function() { return getSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFilterSchema", function() { return getFilterSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getResourceType", function() { return getResourceType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getConfig", function() { return getConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTotal", function() { return getTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getActiveTab", function() { return getActiveTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getId", function() { return getId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFilter", function() { return getFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resourceTypes", function() { return resourceTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLabel", function() { return getLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPage", function() { return getPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPerPage", function() { return getPerPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSortField", function() { return getSortField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSortOrder", function() { return getSortOrder; });
var isLoading = function isLoading(state) {
  return state.loading;
};

var leurisProfile = function leurisProfile(state) {
  return state.leurisProfile;
};

var fisPersid = function fisPersid(state) {
  return state.fisPersid;
};

var favouredResearchActivity = function favouredResearchActivity(state) {
  return state.favouredResearchActivity;
};

var name = function name(state) {
  return state.name;
};

var getData = function getData(state) {
  return state.data;
};

var getSchema = function getSchema(state) {
  return state.listSchema;
};

var getFilterSchema = function getFilterSchema(state) {
  return state.filterSchema[state.resourceType];
};

var getResourceType = function getResourceType(state) {
  return state.resourceType;
};

var getConfig = function getConfig(state) {
  return state.config;
};

var getTotal = function getTotal(state) {
  return state.total;
};

var getActiveTab = function getActiveTab(state) {
  return state.activeTab;
};

var getId = function getId(state) {
  return state.id;
};

var getFilter = function getFilter(state) {
  return state.filter;
};

var resourceTypes = function resourceTypes(state) {
  return state.resourceTypes;
};

var getLabel = function getLabel(state) {
  return state.label;
};

var getPage = function getPage(state) {
  return state.config[state.resourceType].page;
};

var getPerPage = function getPerPage(state) {
  return state.config[state.resourceType].perPage;
};

var getSortField = function getSortField(state) {
  return state.config[state.resourceType].sortField;
};

var getSortOrder = function getSortOrder(state) {
  return state.config[state.resourceType].sortOrder;
};

/***/ }),

/***/ "blDO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PersonIdent__ = __webpack_require__("Ie2l");



/* harmony default export */ __webpack_exports__["a"] = ({
  vorname: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] },
  name: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] },
  personIdent: {
    $each: __WEBPACK_IMPORTED_MODULE_1__PersonIdent__["a" /* default */]
  }
});

/***/ }),

/***/ "bmqV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('b-icon',{staticClass:"has-text-aquamarine",staticStyle:{"margin-right":"10px"},attrs:{"pack":"fa","icon":"filter"}}),_vm._v(" "),_vm._l((_vm.filter[_vm.resourceType].filters),function(f){return _c('b-field',{key:f.value,staticStyle:{"margin-bottom":"0px","margin-right":"10px"}},[(f.type === 'input')?_c('b-input',{style:(f.style),attrs:{"placeholder":_vm.$gettext(f.label),"icon":f.icon},on:{"input":_vm.onFilter},model:{value:(_vm.filter[_vm.resourceType].filter[f.value]),callback:function ($$v) {_vm.$set(_vm.filter[_vm.resourceType].filter, f.value, $$v)},expression:"filter[resourceType].filter[f.value]"}}):_vm._e(),_vm._v(" "),(f.type === 'select')?_c('b-select',{attrs:{"placeholder":_vm.$gettext(f.label)},on:{"input":_vm.onFilter},model:{value:(_vm.filter[_vm.resourceType].filter[f.value]),callback:function ($$v) {_vm.$set(_vm.filter[_vm.resourceType].filter, f.value, $$v)},expression:"filter[resourceType].filter[f.value]"}},[_c('option',{staticClass:"is-italic",domProps:{"value":null}},[_c('translate',[_vm._v("AboutMe.select.reset")])],1),_vm._v(" "),_vm._l((f.options),function(filterOption){return _c('option',{key:filterOption,domProps:{"value":filterOption}},[_c('translate',[_vm._v("\n            "+_vm._s(("AboutMe.filter." + (f.value) + "." + (filterOption.toLowerCase())))+"\n          ")])],1)})],2):_vm._e()],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c1ol":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  loading: false,
  schema: null,
  data: {},
  id: null,
  viewEntityType: null
});

/***/ }),

/***/ "cIus":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mixins_PublicViewHelper__ = __webpack_require__("VlMm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mixins_TooltipHelper__ = __webpack_require__("Aa4s");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-public-select-tag',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_mixins_PublicViewHelper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__components_mixins_TooltipHelper__["a" /* default */]],
  data: function data() {
    return {
      maxLengthOfTags: 46
    };
  },

  props: {
    view: { default: 'ou' }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    publicViewSelected: 'publicView/getSelected'
  }), {
    isClosable: function isClosable() {
      if (this.organisationalUnitName !== 'Universität Leipzig') {
        return true;
      }
      return false;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    resetSelectedTreeItem: 'tree/reset',
    selectBranch: 'tree/selectBranch',
    loadAsyncStaff: 'publicView/loadAsyncStaff'
  }), {
    resetSelectedOrga: function resetSelectedOrga() {
      this.resetSelectedTreeItem();
      if (this.view === 'ou') {
        this.setRoute('ou', 1);
      } else if (this.view === 'person') {
        this.$emit('reset-selected-orga');
      }
    },
    selectOrganisationalUnit: function selectOrganisationalUnit(ou) {
      // this.selectBranch({ id: ou.id, name: ou.name })
      // TODO: set 'ou' or 'person' dynamically
      this.setRoute('ou', ou.id);
    },
    setRoute: function setRoute(type, id) {
      var to = {
        name: 'public',
        params: {
          type: type,
          id: id,
          resourceType: this.activeResourceType
        }
      };
      this.$router.replace(to);
    }
  })
});

/***/ }),

/***/ "cKs/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchLeurisProfile", function() { return fetchLeurisProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchResearchSelection", function() { return fetchResearchSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchResearchActivities", function() { return fetchResearchActivities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setResearchActivityAsFavourite", function() { return setResearchActivityAsFavourite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setConfig", function() { return setConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setResourceType", function() { return setResourceType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changePage", function() { return changePage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setActiveTab", function() { return setActiveTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setData", function() { return setData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changePerPage", function() { return changePerPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSortField", function() { return setSortField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSortOrder", function() { return setSortOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTotal", function() { return setTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateFilter", function() { return updateFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateListSchemaFields", function() { return updateListSchemaFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reset", function() { return reset; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axios__ = __webpack_require__("eOoE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql__ = __webpack_require__("lwCg");






function runQuery(state, resourceType, query) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__axios__["a" /* graphql */])(query('person', state.fisPersid, state.config[resourceType].perPage, state.config[resourceType].page, state.config[resourceType].sortField, state.config[resourceType].sortOrder, state.filter[resourceType].filter));
}

var fetchLeurisProfile = function fetchLeurisProfile(_ref, fisPersid) {
  var commit = _ref.commit;

  commit('IS_LOADING', true);
  commit('SET_FISPERSID', fisPersid);
  // leuris profile (maco graphql backend)
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__axios__["a" /* graphql */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__graphql__["a" /* fetchLeurisProfileQuery */])({ fisPersid: fisPersid })).then(function (response) {
    commit('SET_NAME', response.data.data.person.name);
    commit('SET_LEURIS_PROFILE', response.data.data.person.leurisProfile);
    commit('LOADING_DONE');
  });
};

var fetchResearchSelection = function fetchResearchSelection(_ref2, fisPersid) {
  var commit = _ref2.commit;

  // research selection (maco phoenix backend)
  __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].maco.researchSelection('get', fisPersid).then(function (data) {
    commit('SET_RESEARCH_ACTIVITY_AS_FAVOURITE', data);
    commit('LOADING_DONE');
  });
};

var fetchResearchActivities = function fetchResearchActivities(_ref3, resourceType) {
  var state = _ref3.state,
      commit = _ref3.commit;

  commit('IS_LOADING', true);

  var fetchData = [];
  if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.data).includes(resourceType)) {
    var resource = state.resourceTypes.filter(function (resource) {
      return resource.type === resourceType;
    })[0];
    fetchData = [runQuery(state, resource.type, resource.query)];
  } else {
    state.resourceTypes.forEach(function (resource) {
      fetchData.push(runQuery(state, resource.type, resource.query));
    });
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(fetchData).then(function (responses) {
    responses.forEach(function (response) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.data).forEach(function (resourceType) {
        if (response) {
          var data = response.data.data['person'];
          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).includes(resourceType)) {
            commit('SET_DATA', {
              resourceType: resourceType,
              data: data[resourceType].entries
            });
            commit('SET_TOTAL', {
              resourceType: resourceType,
              total: data[resourceType].meta.totalEntries
            });
          }
        }
      });

      commit('IS_LOADING', false);
    });
  });
};

var setResearchActivityAsFavourite = function setResearchActivityAsFavourite(_ref4, data) {
  var commit = _ref4.commit;

  commit('SET_RESEARCH_ACTIVITY_AS_FAVOURITE', data);
};

var setConfig = function setConfig(_ref5, _ref6) {
  var state = _ref5.state,
      commit = _ref5.commit;
  var resourceType = _ref6.resourceType,
      property = _ref6.property,
      value = _ref6.value;

  commit('SET_CONFIG', { resourceType: resourceType, property: property, value: value });
};

var setResourceType = function setResourceType(_ref7, type) {
  var state = _ref7.state,
      commit = _ref7.commit;

  commit('SET_RESOURCE_TYPE', type);
};

var changePage = function changePage(_ref8, _ref9) {
  var state = _ref8.state,
      commit = _ref8.commit;
  var resourceType = _ref9.resourceType,
      page = _ref9.page;

  commit('CHANGE_PAGE', { resourceType: resourceType, page: page });
};

var setActiveTab = function setActiveTab(_ref10, activeTab) {
  var state = _ref10.state,
      commit = _ref10.commit;

  commit('SET_ACTIVE_TAB', activeTab);
  commit('SET_RESOURCE_TYPE', state.resourceTypes[activeTab].type);
};

var setData = function setData(_ref11, _ref12) {
  var state = _ref11.state,
      commit = _ref11.commit;
  var resourceType = _ref12.resourceType,
      data = _ref12.data;

  commit('SET_DATA', { resourceType: resourceType, data: data });
};

var changePerPage = function changePerPage(_ref13, _ref14) {
  var state = _ref13.state,
      commit = _ref13.commit;
  var resourceType = _ref14.resourceType,
      perPage = _ref14.perPage;

  commit('CHANGE_PER_PAGE', { resourceType: resourceType, perPage: perPage });
  // show first on perPage change
  commit('SET_CONFIG', { resourceType: resourceType, property: 'page', value: 1 });
};

var setSortField = function setSortField(_ref15, _ref16) {
  var state = _ref15.state,
      commit = _ref15.commit;
  var resourceType = _ref16.resourceType,
      sortField = _ref16.sortField;

  commit('SET_SORT_FIELD', { resourceType: resourceType, sortField: sortField });
  // show first on perPage change
  commit('SET_CONFIG', { resourceType: resourceType, property: 'page', value: 1 });
};

var setSortOrder = function setSortOrder(_ref17, _ref18) {
  var state = _ref17.state,
      commit = _ref17.commit;
  var resourceType = _ref18.resourceType,
      sortOrder = _ref18.sortOrder;

  commit('SET_SORT_ORDER', { resourceType: resourceType, sortOrder: sortOrder });
  // show first on perPage change
  commit('SET_CONFIG', { resourceType: resourceType, property: 'page', value: 1 });
};

var setTotal = function setTotal(_ref19, _ref20) {
  var state = _ref19.state,
      commit = _ref19.commit;
  var resourceType = _ref20.resourceType,
      total = _ref20.total;

  commit('SET_TOTAL', { resourceType: resourceType, total: total });
};

var updateFilter = function updateFilter(_ref21, resourceType, updatedFilter) {
  var state = _ref21.state,
      commit = _ref21.commit;

  commit('UPDATE_FILTER', resourceType, updatedFilter);
};

var updateListSchemaFields = function updateListSchemaFields(_ref22, resourceType, updatedListSchemaFields) {
  var state = _ref22.state,
      commit = _ref22.commit;

  commit('UPDATE_LIST_SCHEMA_FIELDS', resourceType, updatedListSchemaFields);
};

var reset = function reset(_ref23) {
  var commit = _ref23.commit;

  commit('RESET');
};

/***/ }),

/***/ "ccZh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__ = __webpack_require__("gR1W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce36ecf8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__ = __webpack_require__("FKis");
function injectStyle (ssrContext) {
  __webpack_require__("BgBo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce36ecf8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ceHl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('b-icon',{staticClass:"has-text-aquamarine",staticStyle:{"margin-right":"10px"},attrs:{"pack":"fa","icon":"filter"}}),_vm._v(" "),_vm._l((_vm.filter[_vm.resourceType].filters.filter(function (f) { return f.hidden !== true; })),function(f){return _c('b-field',{key:f.value,staticStyle:{"margin-bottom":"0px","margin-right":"10px"}},[(f.type === 'input')?_c('b-input',{style:(f.style),attrs:{"placeholder":_vm.$gettext(f.label),"icon":f.icon},on:{"input":_vm.onFilter},model:{value:(_vm.filter[_vm.resourceType].filter[f.value]),callback:function ($$v) {_vm.$set(_vm.filter[_vm.resourceType].filter, f.value, $$v)},expression:"filter[resourceType].filter[f.value]"}}):_vm._e(),_vm._v(" "),(f.type === 'select')?_c('b-select',{attrs:{"placeholder":_vm.$gettext(f.label)},on:{"input":_vm.onFilter},model:{value:(_vm.filter[_vm.resourceType].filter[f.value]),callback:function ($$v) {_vm.$set(_vm.filter[_vm.resourceType].filter, f.value, $$v)},expression:"filter[resourceType].filter[f.value]"}},[_c('option',{staticClass:"is-italic",domProps:{"value":null}},[_c('translate',[_vm._v("Public.select.reset")])],1),_vm._v(" "),_vm._l((f.options),function(filterOption){return _c('option',{key:filterOption,domProps:{"value":filterOption}},[_c('translate',[_vm._v("\n              "+_vm._s(("Public.filter." + (f.value) + "." + (filterOption.toLowerCase())))+"\n            ")])],1)})],2):_vm._e()],1)})],2),_vm._v(" "),(_vm.resourceType === 'forschungsprojekt')?_c('div',{staticStyle:{"margin-top":"10px","margin-left":"34px","display":"flex","align-items":"center"}},[_c('b-field',{staticStyle:{"margin-bottom":"0px","margin-right":"10px"}},[_c('b-select',{attrs:{"icon":"bullseye","placeholder":_vm.$gettext('Sdg.Placeholder')},on:{"input":_vm.onFilter},model:{value:(_vm.filter[_vm.resourceType].filter.sdg),callback:function ($$v) {_vm.$set(_vm.filter[_vm.resourceType].filter, "sdg", $$v)},expression:"filter[resourceType].filter.sdg"}},[_c('option',{domProps:{"value":null}},[_c('translate',[_vm._v("Sdg.NoSelection")])],1),_vm._v(" "),_c('option',{attrs:{"value":"ANY"}},[_c('translate',[_vm._v("Sdg.Any")])],1),_vm._v(" "),_c('optgroup',{attrs:{"label":_vm.$gettext('Sdg.Category')}},[_c('option',{attrs:{"value":"BIOSPHERE"}},[_c('translate',[_vm._v("Sdg.Biosphere")])],1),_vm._v(" "),_c('option',{attrs:{"value":"SOCIETY"}},[_c('translate',[_vm._v("Sdg.Society")])],1),_vm._v(" "),_c('option',{attrs:{"value":"ECONOMY"}},[_c('translate',[_vm._v("Sdg.Economy")])],1)]),_vm._v(" "),_c('optgroup',{attrs:{"label":_vm.$gettext('Sdg.SingleSelection')}},[_c('option',{attrs:{"value":"SDG1"}},[_c('translate',[_vm._v("Sdg.SDG1")])],1),_vm._v(" "),_c('option',{attrs:{"value":"SDG2"}},[_c('translate',[_vm._v("Sdg.SDG2")])],1),_vm._v(" "),_c('option',{attrs:{"value":"SDG3"}},[_c('translate',[_vm._v("Sdg.SDG3")])],1),_vm._v(" "),_c('option',{attrs:{"value":"SDG4"}},[_c('translate',[_vm._v("Sdg.SDG4")])],1),_vm._v(" "),_c('option',{attrs:{"value":"SDG5"}},[_c('translate',[_vm._v("Sdg.SDG5")])],1),_vm._v(" "),_c('option',{attrs:{"value":"SDG6"}},[_c('translate',[_vm._v("Sdg.SDG6")])],1),_vm._v(" "),_c('option',{attrs:{"value":"SDG7"}},[_c('translate',[_vm._v("Sdg.SDG7")])],1),_vm._v(" "),_c('option',{attrs:{"value":"SDG8"}},[_c('translate',[_vm._v("Sdg.SDG8")])],1),_vm._v(" "),_c('option',{attrs:{"value":"SDG9"}},[_c('translate',[_vm._v("Sdg.SDG9")])],1),_vm._v(" "),_c('option',{attrs:{"value":"SDG10"}},[_c('translate',[_vm._v("Sdg.SDG10")])],1),_vm._v(" "),_c('option',{attrs:{"value":"SDG11"}},[_c('translate',[_vm._v("Sdg.SDG11")])],1),_vm._v(" "),_c('option',{attrs:{"value":"SDG12"}},[_c('translate',[_vm._v("Sdg.SDG12")])],1),_vm._v(" "),_c('option',{attrs:{"value":"SDG13"}},[_c('translate',[_vm._v("Sdg.SDG13")])],1),_vm._v(" "),_c('option',{attrs:{"value":"SDG14"}},[_c('translate',[_vm._v("Sdg.SDG14")])],1),_vm._v(" "),_c('option',{attrs:{"value":"SDG15"}},[_c('translate',[_vm._v("Sdg.SDG15")])],1),_vm._v(" "),_c('option',{attrs:{"value":"SDG16"}},[_c('translate',[_vm._v("Sdg.SDG16")])],1),_vm._v(" "),_c('option',{attrs:{"value":"SDG17"}},[_c('translate',[_vm._v("Sdg.SDG17")])],1)])])],1)],1):_vm._e(),_vm._v(" "),(_vm.resourceType === 'publikation')?_c('div',{staticStyle:{"margin-top":"10px","margin-left":"34px","display":"flex","align-items":"center"}},[_c('b-field',{staticStyle:{"padding-top":"5px","margin-bottom":"0px","margin-right":"10px"}},[_c('b-checkbox',{on:{"input":_vm.onFilter},model:{value:(_vm.filter[_vm.resourceType].filter.inProject),callback:function ($$v) {_vm.$set(_vm.filter[_vm.resourceType].filter, "inProject", $$v)},expression:"filter[resourceType].filter.inProject"}},[_c('translate',[_vm._v("Public.filter.inProject")]),(_vm.inProject)?_c('translate',[_vm._v("Public.filter.fundedBy")]):_vm._e()],1)],1),_vm._v(" "),_c('b-field',{staticStyle:{"margin-bottom":"0px","margin-right":"10px"}},[_c('b-select',{class:{ hiddenField: !_vm.inProject },attrs:{"icon":"credit-card","placeholder":_vm.$gettext('Public.filter.beliebigerMittelgeber')},on:{"input":_vm.onFilter},model:{value:(_vm.filter[_vm.resourceType].filter.fundedByCategory),callback:function ($$v) {_vm.$set(_vm.filter[_vm.resourceType].filter, "fundedByCategory", $$v)},expression:"filter[resourceType].filter.fundedByCategory"}},[_c('option',{domProps:{"value":null}},[_c('translate',[_vm._v("Public.filter.beliebigerMittelgeber")])],1),_vm._v(" "),_c('option',{attrs:{"value":"DFG"}},[_c('translate',[_vm._v("Public.filter.funded_by.DFG")])],1),_vm._v(" "),_c('option',{attrs:{"value":"EU"}},[_c('translate',[_vm._v("Public.filter.funded_by.EU")])],1),_vm._v(" "),_c('option',{attrs:{"value":"BMBF"}},[_c('translate',[_vm._v("Public.filter.funded_by.BMBF")])],1),_vm._v(" "),_c('option',{attrs:{"value":"ANDERE_BM"}},[_c('translate',[_vm._v("Public.filter.funded_by.ANDERE_BM")])],1),_vm._v(" "),_c('option',{attrs:{"value":"SMWK"}},[_c('translate',[_vm._v("Public.filter.funded_by.SMWK")])],1),_vm._v(" "),_c('option',{attrs:{"value":"ANDERE_SAECHSISCHE_MINISTERIEN"}},[_c('translate',[_vm._v("Public.filter.funded_by.ANDERE_SAECHSISCHE_MINISTERIEN")])],1),_vm._v(" "),_c('option',{attrs:{"value":"DAAD"}},[_c('translate',[_vm._v("Public.filter.funded_by.DAAD")])],1),_vm._v(" "),_c('option',{attrs:{"value":"UNI_LE"}},[_c('translate',[_vm._v("Public.filter.funded_by.UNI_LE")])],1),_vm._v(" "),_c('option',{attrs:{"value":"WIRTSCHAFT"}},[_c('translate',[_vm._v("Public.filter.funded_by.WIRTSCHAFT")])],1),_vm._v(" "),_c('option',{attrs:{"value":"STIFTUNGEN_DE"}},[_c('translate',[_vm._v("Public.filter.funded_by.STIFTUNGEN_DE")])],1),_vm._v(" "),_c('option',{attrs:{"value":"ANDERE"}},[_c('translate',[_vm._v("Public.filter.funded_by.ANDERE")])],1)])],1)],1):_vm._e(),_vm._v(" "),(_vm.resourceType === 'preis' && _vm.userIsLoggedIn)?_c('div',{staticStyle:{"margin-top":"10px","margin-left":"34px","display":"flex","align-items":"center"}},[_c('b-field',{staticStyle:{"margin-bottom":"0px","margin-right":"10px"}},[_c('b-select',{attrs:{"icon":"graduation-cap","placeholder":_vm.$gettext('Public.filter.beliebigerPreis')},on:{"input":_vm.onFilter},model:{value:(_vm.filter[_vm.resourceType].filter.typeIds),callback:function ($$v) {_vm.$set(_vm.filter[_vm.resourceType].filter, "typeIds", $$v)},expression:"filter[resourceType].filter.typeIds"}},[_c('option',{domProps:{"value":null}},[_c('translate',[_vm._v("Public.filter.beliebigerPreis")])],1),_vm._v(" "),_c('option',{attrs:{"value":"PREIS_3"}},[_c('translate',[_vm._v("Public.filter.typeIds.preis_3")])],1),_vm._v(" "),_c('option',{attrs:{"value":"PREIS_29"}},[_c('translate',[_vm._v("Public.filter.typeIds.preis_29")])],1),_vm._v(" "),_c('option',{attrs:{"value":"PREIS_30"}},[_c('translate',[_vm._v("Public.filter.typeIds.preis_30")])],1),_vm._v(" "),_c('option',{attrs:{"value":"PREIS_31"}},[_c('translate',[_vm._v("Public.filter.typeIds.preis_31")])],1),_vm._v(" "),_c('option',{attrs:{"value":"PREIS_32"}},[_c('translate',[_vm._v("Public.filter.typeIds.preis_32")])],1),_vm._v(" "),_c('option',{attrs:{"value":"PREIS_2"}},[_c('translate',[_vm._v("Public.filter.typeIds.preis_2")])],1),_vm._v(" "),_c('option',{attrs:{"value":"PREIS_33"}},[_c('translate',[_vm._v("Public.filter.typeIds.preis_33")])],1),_vm._v(" "),_c('option',{attrs:{"value":"PREIS_4"}},[_c('translate',[_vm._v("Public.filter.typeIds.preis_4")])],1),_vm._v(" "),_c('option',{attrs:{"value":"PREIS_34"}},[_c('translate',[_vm._v("Public.filter.typeIds.preis_34")])],1),_vm._v(" "),_c('option',{attrs:{"value":"PREIS_35"}},[_c('translate',[_vm._v("Public.filter.typeIds.preis_35")])],1),_vm._v(" "),_c('option',{attrs:{"value":"PREIS_36"}},[_c('translate',[_vm._v("Public.filter.typeIds.preis_36")])],1),_vm._v(" "),_c('option',{attrs:{"value":"PREIS_37"}},[_c('translate',[_vm._v("Public.filter.typeIds.preis_37")])],1),_vm._v(" "),_c('option',{attrs:{"value":"WEITERE_PREISE"}},[_c('translate',[_vm._v("Public.filter.typeIds.weiterePreise")])],1)])],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cfU0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_EntityValue__ = __webpack_require__("YRcE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mixins_DynamicTitle__ = __webpack_require__("IqS5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Projektleiter__ = __webpack_require__("yasp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mixins_PublicRouteBuilder__ = __webpack_require__("+ueH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mixins_ExternalLinkProvider__ = __webpack_require__("1/AK");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import api from '@/api'







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-entity-details',
  components: {
    'fob-entity-value': __WEBPACK_IMPORTED_MODULE_2__components_EntityValue__["a" /* default */],
    'fob-projektleiter': __WEBPACK_IMPORTED_MODULE_4__components_Projektleiter__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_mixins_DynamicTitle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__components_mixins_ExternalLinkProvider__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__components_mixins_PublicRouteBuilder__["a" /* default */]],
  created: function created() {
    var _this = this;

    // some schema fields have computed properties
    // e.g. creating links from pubIdent values
    // at first filter those items with "computed" function ...
    var schema = this.resourceSchema.fields.filter(function (bit) {
      return bit.computed;
    });
    // ... then use their "computed" function to calculate new values
    // and append them to resourceData.
    schema.forEach(function (bit) {
      var data = bit.computed(_this.resourceData);
      _this.resourceData[bit.field] = data;
    });
  },
  data: function data() {
    return {
      leurisHead: {
        inner: this.isPublic ? 'leuris:Portal' : 'leuris:Forschungsbericht',
        complement: 'menu.details'
      }
    };
  },

  props: ['resourceSchema', 'resourceData', 'resourceId', 'linkProvider', 'useCompactComponents', 'isPublic'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    loading: 'resource/isLoading',
    user: 'user/getUser'
  }), {
    displayFields: function displayFields() {
      if (this.isPublic) {
        return this.resourceSchema.fields.filter(function (x) {
          return x.inPublicView !== false;
        });
      } else {
        return this.resourceSchema.fields;
      }
    }
  }),
  methods: {
    sdgLink: function sdgLink(id) {
      var lpad = ('0' + id).slice(-2);
      return '/static/sdg/E_WEB_' + lpad + '.png';
    }
  }
});

/***/ }),

/***/ "cigy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (base) {
  return {
    Reference: function Reference(field, icon, className, finder) {
      return {
        label: base + '.list.filter.' + field,
        field: field,
        icon: icon,
        type: 'object',
        cardinality: 'single',
        render: 'stringRep',
        schema: {
          route: className.toLowerCase(),
          className: className
        },
        finder: finder
      };
    },
    ReferenceByMultiValueSearchRep: function ReferenceByMultiValueSearchRep(field, icon) {
      var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : field;

      return {
        label: base + '.list.filter.' + field,
        field: field,
        icon: icon,
        type: 'object',
        cardinality: 'single',
        render: 'stringRep',
        schema: {
          route: className.toLowerCase(),
          className: className
        },
        finder: {
          name: 'byMultiValueSearchRep',
          multiValue: true,
          minLength: 4
        }
      };
    },
    ReferenceBySearchRep: function ReferenceBySearchRep(field, icon) {
      var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : field;

      return {
        label: base + '.list.filter.' + field,
        field: field,
        icon: icon,
        type: 'object',
        cardinality: 'single',
        render: 'stringRep',
        schema: {
          route: className.toLowerCase(),
          className: className
        },
        finder: {
          name: 'bySearchRepLike',
          multiValue: false,
          minLength: 0
        }
      };
    },
    String: function String(field) {
      return {
        label: base + '.list.filter.' + field,
        field: field,
        type: 'string'
      };
    },
    Boolean: function (_Boolean) {
      function Boolean(_x3) {
        return _Boolean.apply(this, arguments);
      }

      Boolean.toString = function () {
        return _Boolean.toString();
      };

      return Boolean;
    }(function (field) {
      return {
        label: base + '.list.filter.' + field,
        field: field,
        type: Boolean
      };
    }),
    Number: function (_Number) {
      function Number(_x4, _x5) {
        return _Number.apply(this, arguments);
      }

      Number.toString = function () {
        return _Number.toString();
      };

      return Number;
    }(function (field, icon) {
      return {
        label: base + '.list.filter.' + field,
        type: Number,
        field: field,
        icon: icon
      };
    }),
    kumuliert: function kumuliert() {
      return {
        label: base + '.list.filter.kumuliert',
        field: 'kumuliert',
        type: Boolean,
        narrow: true,
        view: function view(data) {
          var visible = data.organisationseinheit != null && data.organisationseinheit.name !== '';
          visible = visible || data.organisationseinheiten != null && data.organisationseinheiten.name !== '';
          if (!visible) data.kumuliert = false;
          return visible;
        }
      };
    }
  };
});

/***/ }),

/***/ "cnyR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schema_Selection__ = __webpack_require__("0r7M");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    savedViews: function savedViews() {
      return this.$store.getters['user/getSavedViews'];
    },
    groups: function groups() {
      return this.savedViews.map(function (x) {
        return x.className;
      }).reduce(function (x, y) {
        return x.includes(y) ? x : [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(x), [y]);
      }, []);
    },
    allGroups: function allGroups() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__schema_Selection__["a" /* default */])(this.$store.getters['user/getUser']).map(function (x) {
        return x.entities.map(function (y) {
          return y.className;
        });
      }).reduce(function (x, y) {
        return x.concat(y);
      }, []);
    }
  },
  methods: {
    savedViewsForGroup: function savedViewsForGroup(group) {
      return this.savedViews.filter(function (x) {
        return x.className === group;
      });
    },
    switchView: function switchView(index) {
      this.$store.dispatch('list/switchView', index);
      this.$router.push({ name: 'auflisten' });
    },
    deleteView: function deleteView(index) {
      this.$store.dispatch('user/deleteView', index);
    }
  }
});

/***/ }),

/***/ "csRy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      date: this.value
    };
  },

  props: {
    value: Date,
    placeholder: String,
    invalid: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    // we need to listen to 'mousedown' because some(?) input fields
    // stop the click event propagation
    document.body.addEventListener('mousedown', this.mouseClicked);
  },
  beforeDestroy: function beforeDestroy() {
    document.body.removeEventListener('mousedown', this.mouseClicked);
  },

  methods: {
    nullDate: function nullDate() {
      // normally the date picker closes on it's own but not when the
      // date was null already
      this.closeDatePicker();
      this.date = null;
    },
    emitInput: function emitInput() {
      this.closeDatePicker();
      this.$emit('input', this.date);
    },
    mouseClicked: function mouseClicked(e) {
      var input = this.$refs.datewrapper.getElementsByTagName('input')[0];
      // clicking the input field (i.e. mouse down, then mouse up) will toggle the
      // date picker by default. we don't want to close it prematurely on
      // mousedown because then it will reopen on mouse up
      var clickedInput = e.target === input;

      // a nullClick happens when user selects something from a dropdown menu,
      // i.e. selects a year or a month. In this case, we don't want to close
      // the date picker just yet
      var nullClick = e.clientX === 0 && e.clientY === 0;

      var ddMenus = this.$refs.datewrapper.getElementsByClassName('dropdown-menu');
      if (ddMenus && ddMenus.length > 0) {
        var rect = ddMenus[0].getBoundingClientRect();
        var mx = e.clientX - rect.left;
        var my = e.clientY - rect.top;
        var inside = mx >= 0 && mx <= rect.width && my >= 0 && my <= rect.height;

        if (!inside && !nullClick && !clickedInput && this.$refs.nullableDate.$children[0].isActive) {
          this.$refs.nullableDate.$children[0].toggle();
        }
      }
    },
    closeDatePicker: function closeDatePicker() {
      if (this.$refs.nullableDate.$children[0].isActive) {
        this.$refs.nullableDate.$children[0].toggle();
      }
    }
  }
});

/***/ }),

/***/ "d2ya":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schema__ = __webpack_require__("uDTM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_EntityHeader__ = __webpack_require__("sGAB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mixins_ValidateAndSave__ = __webpack_require__("GfOp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mixins_DynamicTitle__ = __webpack_require__("IqS5");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-entity-edit',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_mixins_ValidateAndSave__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__components_mixins_DynamicTitle__["a" /* default */]],
  data: function data() {
    return {
      resourceTypes: __WEBPACK_IMPORTED_MODULE_2__schema__["a" /* default */].baseTypes,
      leurisHead: {
        inner: 'leuris:Forschungsbericht',
        complement: 'menu.editor'
      }
    };
  },

  methods: {
    save: function save() {
      this.saveAndDispatch('editor/saveEntity');
    },
    close: function close() {
      var _this = this;

      this.$store.dispatch('editor/closeEditor').then(function (data) {
        _this.$router.push({
          name: 'anzeigen_einzeln',
          params: {
            resourceType: data.type,
            resourceId: data.id
          }
        });
      });
    },
    updateData: function updateData() {
      this.$store.dispatch('editor/setData', this.resourceData);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    isDirty: 'editor/isDirty',
    resourceSchema: 'editor/getSchema',
    resourceId: 'editor/getId',
    resourceType: 'editor/getViewEntityType',
    loading: 'editor/isLoading'
  }), {
    resourceData: {
      get: function get() {
        return this.$store.getters['editor/getData'];
      },
      set: function set(value) {
        this.$store.dispatch('editor/setData', value);
      }
    },
    selectedType: {
      get: function get() {
        var _this2 = this;

        if (this.viewEntityType === null) {
          return null;
        } else {
          var sel = this.resourceTypes.findIndex(function (x) {
            return x.schema.route === _this2.viewEntityType;
          });
          if (sel === -1) {
            this.$router.replace({
              name: 'editieren'
            });
            return null;
          }
          return sel;
        }
      },
      set: function set(v) {
        if (v !== null) {
          this.$router.push({
            name: 'editieren',
            params: {
              resourceType: this.resourceTypes[v].schema.route,
              resourceId: 1
            }
          });
        }
      }
    },
    id: {
      get: function get() {
        return this.$store.getters['editor/getId'];
      },
      set: function set(value) {
        this.$router.push({
          name: 'editieren',
          params: {
            resourceType: this.resourceSchema.route,
            resourceId: value
          }
        });
      }
    }
  }),
  components: {
    'fob-entity-header': __WEBPACK_IMPORTED_MODULE_3__components_EntityHeader__["a" /* default */]
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var resourceId = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['editor/getId'];
    var resourceType = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['editor/getViewEntityType'];
    if (resourceType != null && (to.params.resourceType !== resourceType || to.params.resourceId !== resourceId)) {
      next({
        name: 'editieren',
        params: {
          resourceType: resourceType,
          resourceId: resourceId
        }
      });
    } else {
      next();
    }
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var resourceId = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['editor/getId'];
    var resourceType = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['editor/getViewEntityType'];
    if (to.params.resourceType !== resourceType || to.params.resourceId !== resourceId) {
      next({
        name: 'editieren',
        params: {
          resourceType: resourceType,
          resourceId: resourceId
        }
      });
    } else {
      next();
    }
  }
});

/***/ }),

/***/ "dAR2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e6/N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"0 2rem 0 0"}},[(_vm.organisationalUnitName)?_c('div',{staticStyle:{"margin":"0.5rem 0 1rem 0"}},[_c('b-tag',{attrs:{"type":"is-primary","closable":_vm.isClosable},on:{"close":_vm.resetSelectedOrga}},[_c('b-tooltip',{attrs:{"active":_vm.showTooltip(_vm.organisationalUnitName),"label":_vm.organisationalUnitName,"type":"is-basalt","position":"is-top","size":"is-small","square":true,"multilined":""}},[_vm._v("\n        "+_vm._s(_vm.labelFormatter(_vm.organisationalUnitName))+"\n      ")])],1)],1):_c('div',{staticStyle:{"margin":"0.5rem 0 1rem 0"}},[_c('b-tag',{attrs:{"type":"is-primary"}},[_vm._v("Lade...")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eFxi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity__ = __webpack_require__("9fz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FieldsGeneric__ = __webpack_require__("WWW9");



var Fields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__FieldsGeneric__["a" /* default */])('Land');

/* harmony default export */ __webpack_exports__["a"] = ({
  route: 'land',
  class: __WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity__["Land"],
  className: 'land',
  entityName: 'de.ul.fob.domain.land',
  tableSelectColumns: [{
    label: 'nameDE',
    field: 'nameDE'
  }, {
    label: 'nameEN',
    field: 'nameEN'
  }, {
    label: 'alpha2code',
    field: 'alpha2code'
  }, {
    label: 'alpha3code',
    field: 'alpha3code'
  }, {
    label: 'numericCode',
    field: 'numericCode'
  }],
  fields: [Fields.String('alpha2code'), Fields.String('alpha3code'), Fields.String('nameDE'), Fields.String('nameEN'), Fields.String('numericCode')]
});

/***/ }),

/***/ "eJzL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"app",attrs:{"id":"app"}},[(_vm.isLoading)?_c('div',{staticClass:"loadingBar"}):_vm._e(),_vm._v(" "),(_vm.isIE)?_c('b-notification',{staticClass:"fob-hide-in-print",staticStyle:{"margin":"0.5rem"},attrs:{"type":"is-danger","has-icon":"","closable":false}},[_c('translate',[_vm._v("browser.outdated")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"section",staticStyle:{"padding-top":"20px"},attrs:{"id":"fob-main-section"}},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-narrow"},[_c('fob-menu',{attrs:{"id":"fob-menu"}})],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('router-view')],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eM7q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eO8b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListFieldsGeneric__ = __webpack_require__("K13K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PublikationsTyp__ = __webpack_require__("IhzH");



var ListFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ListFieldsGeneric__["a" /* default */])('Publikation');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Publikation',
  route: 'publikation',
  className: 'publikation',
  fields: [ListFields.SortableTimestamp('_updateDate', false, 'updateDate', true), ListFields.SortableTimestamp('_createDate', false, 'createDate', true), ListFields.SortableReference('organisationseinheit', false), ListFields.UnsortableReference('weitereOrganisationseinheiten', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__PublikationsTyp__["a" /* default */], {
    label: 'Publikation.list.column.publikationsTyp',
    field: 'publikationsTyp',
    tableVisible: true,
    sortable: true,
    sortField: 'publikationsTyp',
    type: 'select',
    plain: true
  }), ListFields.UnsortableReference('author', true), ListFields.UnsortableReference('herausgeber', false), ListFields.SortableField('titelPublikation', true), ListFields.SortableField('veroeffentlichungsJahr', true), ListFields.UnsortableReference('publicPubIdent', false), ListFields.SortableBoolean('validiert', false), ListFields.SortableBoolean('istFinal', false)]
});

/***/ }),

/***/ "eOoE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return baseURL; });
/* unused harmony export anchorWheelURL */
/* unused harmony export macoURL */
/* unused harmony export macoBackendURL */
/* unused harmony export leurisPdfExportServerURL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return graphql; });
/* unused harmony export fobAxios */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return macoAxios; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return leurisExportAxios; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");





var buildURL = function buildURL(base, port, path) {
  return port ? base + ':' + port + path : '' + base + path;
};

var baseURL =  false ? process.env.FOB_BACKEND_URL + ':' + process.env.FOB_BACKEND_PORT + process.env.FOB_BACKEND_PATH : '' + "" + "/fob";

var anchorWheelURL =  false ? process.env.ANCHOR_WHEEL_URL + ':' + process.env.ANCHOR_WHEEL_PORT + process.env.ANCHOR_WHEEL_PATH : '' + "" + "/anchorwheel/api";

var macoURL =  false ? process.env.MACO_URL + ':' + process.env.MACO_PORT : '' + "/profilseite";

var macoBackendURL =  false ? process.env.MACO_BACKEND_URL + ':' + process.env.MACO_BACKEND_PORT + process.env.MACO_BACKEND_PATH : '' + "" + "/profilseite/api";

var leurisPdfExportServerURL = buildURL("", "", "/fob/export/");

var graphql = function graphql(request) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(anchorWheelURL, request).then(function (response) {
      if (response.data.errors) {
        // hide loading bar
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('resetLoading');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* ToastErrorGraphQL */])({
          errors: response.data.errors
        });
        reject();
      } else {
        resolve(response);
      }
    }).catch(function (error) {
      // hide loading bar
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('resetLoading');
      // distignuish between several types of errors
      if (error && error.response && error.response.data && error.response.data.errors) {
        // graphql errors
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* ToastErrorGraphQL */])({
          errors: error.response.data.errors
        });
      } else if (error && error.response && error.response.status === 500) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* ToastError */])('Internal Server Error from GraphQL backend');
      } else if (error && !error.response) {
        // network error
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* ToastError */])('GraphQL backed is not started or no internet connection (network error)');
      } else {
        // generic XHR error
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* ToastError */])(error);
      }
      reject(error);
    });
  });
};

var fobAxios = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: baseURL,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
});

var macoAxios = function macoAxios(method, endpoint, payload) {
  var token = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['tomaner/maco'].token;
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
    baseURL: macoBackendURL,
    timeout: 5000,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json;charset=UTF-8',
      'Cache-Control': 'no-cache, max-age=0, must-revalidate, no-store'
    }
  })[method](endpoint, payload);
};

var leurisExportAxios = function leurisExportAxios(method, payload) {
  var token = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['user/token'];

  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
    timeout: 5000,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json;charset=UTF-8',
      'Cache-Control': 'no-cache, max-age=0, must-revalidate, no-store'
    }
  })[method](leurisPdfExportServerURL, payload);
};



/***/ }),

/***/ "eoqk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setViewEntityType", function() { return setViewEntityType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setData", function() { return setData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closeEditor", function() { return closeEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveEntity", function() { return saveEntity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setResource", function() { return setResource; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_buefy__ = __webpack_require__("MMSg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_buefy__);




var setViewEntityType = function setViewEntityType(_ref, type) {
  var state = _ref.state,
      commit = _ref.commit;

  commit('SET_VIEW_ENTITY_TYPE', type);
};

var setData = function setData(_ref2, data) {
  var state = _ref2.state,
      commit = _ref2.commit;

  commit('SET_DATA', data);
};

var closeEditor = function closeEditor(_ref3) {
  var state = _ref3.state,
      commit = _ref3.commit;

  var type = state.viewEntityType;
  var id = state.id;
  commit('SET_DATA', null);
  commit('SET_SCHEMA', null);
  commit('SET_VIEW_ENTITY_TYPE', null);
  return { type: type, id: id };
};

var saveEntity = function saveEntity(_ref4) {
  var state = _ref4.state,
      commit = _ref4.commit,
      dispatch = _ref4.dispatch,
      rootGetters = _ref4.rootGetters;

  commit('LOADING_START');
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(state.schema.fields), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var bit = _step.value;

      if (!(bit.view === undefined || bit.view(state.data, rootGetters['user/getUser']))) {
        if (state.data[bit.field] != null) {
          state.data[bit.field] = null;
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].methods.updaveResource(state.data).then(function (data) {
    dispatch('closeEditor');
    commit('LOADING_DONE');
    return data;
  });
};

var setResource = function setResource(_ref5, _ref6) {
  var state = _ref5.state,
      commit = _ref5.commit;
  var id = _ref6.id,
      type = _ref6.type,
      schema = _ref6.schema;

  commit('LOADING_START');
  if (id != null) {
    commit('SET_ID', id);
  }
  if (schema != null) {
    commit('SET_SCHEMA', schema);
    commit('SET_VIEW_ENTITY_TYPE', type);
  }

  return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].methods.fetchResource(state.schema.className, state.id).then(function (data) {
    commit('SET_DATA', data);
    commit('LOADING_DONE');
  }).catch(function (error) {
    // Error
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log(error.response);
      // this.$snackbar.open(`Default, positioned bottom-right with a green 'OK' button`)
      __WEBPACK_IMPORTED_MODULE_2_buefy__["Toast"].open({
        duration: 5000,
        message: state.schema.route + ' ' + state.id + '<br />\n                    [' + error.response.status + '] ' + error.response.statusText,
        position: 'is-bottom',
        type: 'is-carnelian'
      });
      commit('SET_DATA', null);
      commit('LOADING_DONE');
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message);
    }
    console.log(error.config);
  });
};

/***/ }),

/***/ "f+Bj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFieldsGeneric__ = __webpack_require__("K13K");
 // Template für Listen-Elemente
var ListFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ListFieldsGeneric__["a" /* default */])('Mittelgeber'); // Initialisieren des Templates für eine bestimmte Entität

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Mittelgeber',
  route: 'mittelgeber',
  className: 'mittelgeber',
  fields: [ListFields.SortableField('name', true), ListFields.SortableField('finSchluessel', true)]
});

/***/ }),

/***/ "fCOC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fob-compact-publication"},[(_vm.type == 'artikel')?_c('div',[(_vm.authors)?_c('div',[_vm._v(_vm._s(_vm.authors))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"font-weight":"bolder"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',[(_vm.journal)?_c('span',{staticStyle:{"font-style":"italic"}},[_vm._v(_vm._s(_vm.journal)+".")]):_vm._e(),_vm._v(" "),(_vm.year)?_c('span',[_vm._v(_vm._s(_vm.year)+".")]):_vm._e(),_vm._v(" "),(_vm.band && _vm.journalNumber)?_c('span',[_vm._v("\n        "+_vm._s(_vm.band)+"("+_vm._s(_vm.journalNumber)+").\n      ")]):_vm._e(),_vm._v(" "),(_vm.seiteStart && _vm.seiteEnde)?_c('span',[_c('span',[_c('translate',[_vm._v("Publikation.compact.Abkuerzung.SeitePlural")]),_vm._v(".")],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.seiteStart)+"-"+_vm._s(_vm.seiteEnde))])]):(_vm.seiteStart && !_vm.seiteEnde)?_c('span',[_c('span',[_c('translate',[_vm._v("Publikation.compact.Abkuerzung.Seite")]),_vm._v(".")],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.seiteStart))])]):_vm._e()])]):(['sammelbandbeitrag', 'buchbeitrag', 'tagungsbeitrag'].indexOf(_vm.type) !== -1)?_c('div',[(_vm.authors)?_c('div',[_vm._v(_vm._s(_vm.authors))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"font-weight":"bolder"}},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),(_vm.herausgeber)?_c('div',[_c('span',[_vm._v("In:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.herausgeber))])]):_vm._e(),_vm._v(" "),_c('div',[(_vm.buchtitel)?_c('span',{staticStyle:{"font-style":"italic"}},[_vm._v(_vm._s(_vm.buchtitel)+".")]):_vm._e(),_vm._v(" "),(_vm.verlagsort)?_c('span',[_vm._v(_vm._s(_vm.verlagsort)+": ")]):_vm._e(),_vm._v(" "),(_vm.verleger)?_c('span',[_vm._v(_vm._s(_vm.verleger)+". ")]):_vm._e(),_vm._v(" "),(_vm.year)?_c('span',[_vm._v(_vm._s(_vm.year)+". ")]):_vm._e(),_vm._v(" "),(_vm.seiteStart && _vm.seiteEnde)?_c('span',[_c('span',[_c('translate',[_vm._v("Publikation.compact.Abkuerzung.SeitePlural")]),_vm._v(".")],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.seiteStart)+"-"+_vm._s(_vm.seiteEnde))])]):(_vm.seiteStart && !_vm.seiteEnde)?_c('span',[_c('span',[_c('translate',[_vm._v("Publikation.compact.Abkuerzung.Seite")]),_vm._v(".")],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.seiteStart))])]):_vm._e()])]):(_vm.type === 'monographie')?_c('div',[(_vm.authors)?_c('div',[_vm._v(_vm._s(_vm.authors))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"font-weight":"bolder"}},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',[(_vm.verlagsort)?_c('span',[_vm._v(_vm._s(_vm.verlagsort)+":")]):_vm._e(),_vm._v(" "),(_vm.verleger)?_c('span',[_vm._v(_vm._s(_vm.verleger)+". ")]):_vm._e(),(_vm.year)?_c('span',[_vm._v(_vm._s(_vm.year))]):_vm._e()])]):(_vm.type === 'sammelband')?_c('div',[(_vm.herausgeber)?_c('div',[_c('span',[_vm._v(_vm._s(_vm.herausgeber))])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"font-weight":"bolder"}},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),(_vm.institution)?_c('div',[_c('span',[_vm._v(_vm._s(_vm.institution))])]):_vm._e(),_vm._v(" "),_c('div',[(_vm.verlagsort)?_c('span',[_vm._v(_vm._s(_vm.verlagsort)+":")]):_vm._e(),_vm._v(" "),(_vm.verleger)?_c('span',[_vm._v(_vm._s(_vm.verleger)+". ")]):_vm._e(),(_vm.year)?_c('span',[_vm._v(_vm._s(_vm.year))]):_vm._e()])]):(['tagungsband', 'quellenedition'].indexOf(_vm.type) !== -1)?_c('div',[(_vm.herausgeber)?_c('div',[_c('span',[_vm._v(_vm._s(_vm.herausgeber))])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"font-weight":"bolder"}},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),(_vm.institution)?_c('div',[_c('span',[_vm._v(_vm._s(_vm.institution))])]):_vm._e(),_vm._v(" "),_c('div',[(_vm.verlagsort)?_c('span',[_vm._v(_vm._s(_vm.verlagsort)+":")]):_vm._e(),_vm._v(" "),(_vm.verleger)?_c('span',[_vm._v(_vm._s(_vm.verleger)+". ")]):_vm._e(),_vm._v(" "),(_vm.year)?_c('span',[_vm._v(_vm._s(_vm.year))]):_vm._e()])]):(_vm.type === 'sonderheft')?_c('div',[(_vm.herausgeber)?_c('div',[_c('span',[_vm._v(_vm._s(_vm.herausgeber))])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"font-weight":"bolder"}},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',[(_vm.journal)?_c('span',{staticStyle:{"font-style":"italic"}},[_vm._v(_vm._s(_vm.journal)+".")]):_vm._e(),_vm._v(" "),(_vm.year)?_c('span',[_vm._v(_vm._s(_vm.year)+".")]):_vm._e(),_vm._v(" "),(_vm.band)?_c('span',[_vm._v(" "+_vm._s(_vm.band))]):_vm._e(),_vm._v(" "),(_vm.journalNumber)?_c('span',[_vm._v(" ("+_vm._s(_vm.journalNumber)+")")]):_vm._e()])]):(['bericht', 'workingpaper'].indexOf(_vm.type) !== -1)?_c('div',[(_vm.authors)?_c('div',[_vm._v(_vm._s(_vm.authors))]):(_vm.herausgeber)?_c('div',[_vm._v(_vm._s(_vm.herausgeber))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"font-weight":"bolder"}},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',[(_vm.institution)?_c('span',[_vm._v(_vm._s(_vm.institution)+". ")]):_vm._e(),_vm._v(" "),(_vm.verlagsort)?_c('span',[_vm._v(_vm._s(_vm.verlagsort)+". ")]):_vm._e(),_vm._v(" "),(_vm.year)?_c('span',[_vm._v(_vm._s(_vm.year))]):_vm._e()])]):(['dissertation', 'habilitationsschrift'].indexOf(_vm.type) !== -1)?_c('div',[(_vm.authors)?_c('div',[_vm._v(_vm._s(_vm.authors))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"font-weight":"bolder"}},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',[_c('span',[_c('translate',[_vm._v(_vm._s(("Publikation.compact." + _vm.type)))]),_vm._v(". ")],1),_vm._v(" "),(_vm.institution)?_c('span',[_vm._v(_vm._s(_vm.institution)+". ")]):_vm._e(),_vm._v(" "),(_vm.year)?_c('span',[_vm._v(_vm._s(_vm.year))]):_vm._e()])]):(_vm.type === 'beitraginnichtwissenschaftlichenmedien')?_c('div',[(_vm.authors)?_c('div',[_vm._v(_vm._s(_vm.authors))]):(_vm.herausgeber)?_c('div',[_vm._v(_vm._s(_vm.herausgeber))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"font-weight":"bolder"}},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',[(_vm.journal)?_c('span',{staticStyle:{"font-style":"italic"}},[_vm._v(_vm._s(_vm.journal)+". ")]):_vm._e(),_vm._v(" "),(_vm.year)?_c('span',[_vm._v(_vm._s(_vm.year))]):_vm._e()])]):_c('div',[(_vm.authors)?_c('div',[_vm._v(_vm._s(_vm.authors))]):(_vm.herausgeber)?_c('div',[_vm._v(_vm._s(_vm.herausgeber))]):_vm._e(),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-weight":"bolder"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.year)?_c('span',[_vm._v(" ("+_vm._s(_vm.year)+")")]):_vm._e()])]),_vm._v(" "),(_vm.doi.id || _vm.isbn.id)?_c('div',{staticClass:"fob-publikation-compact-link"},[(_vm.doi.id)?_c('span',[_vm._v("DOI: "),_c('a',{attrs:{"href":_vm.doi.uri,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.doi.id))])]):_vm._e(),_vm._v(" "),(!_vm.doi.id && _vm.isbn.id)?_c('span',[_vm._v("ISBN: "),_c('a',{attrs:{"href":_vm.isbn.uri,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.isbn.id))])]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fHoA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMeListQuickActions_vue__ = __webpack_require__("BE/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_334100f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutMeListQuickActions_vue__ = __webpack_require__("IOX+");
function injectStyle (ssrContext) {
  __webpack_require__("Togc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMeListQuickActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_334100f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutMeListQuickActions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fLMI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  maco: {
    token: null,
    validUntil: null,
    loggedIn: false
  }
});

/***/ }),

/***/ "fNnQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fn+S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debounce_promise__ = __webpack_require__("OC31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debounce_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_debounce_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_EntityListColumnVisibility__ = __webpack_require__("L4RB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_EntityListOptions__ = __webpack_require__("I1Xi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_EntityListCompact__ = __webpack_require__("PVM7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_EntityListTable__ = __webpack_require__("t04V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_EntityPalette__ = __webpack_require__("MZuF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_EntityListPagination__ = __webpack_require__("LXsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_mixins_DynamicTitle__ = __webpack_require__("IqS5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_mixins_DateTimeHelper__ = __webpack_require__("5W2G");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// UTILS





// COMPONENTS






// MIXINS



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-entity-list-view',
  mixins: [__WEBPACK_IMPORTED_MODULE_15__components_mixins_DynamicTitle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__components_mixins_DateTimeHelper__["a" /* default */]],
  data: function data() {
    return {
      data: [],
      total: 0,
      loading: false,
      showConfig: false,
      isCompact: false,
      printDate: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])({
    page: 'list/getPage'
  }), {
    leurisHead: function leurisHead() {
      var msgid = this.resourceType.charAt(0).toUpperCase() + this.resourceType.slice(1);
      return {
        inner: 'leuris:Forschungsbericht',
        separator: '|',
        complement: ['menu.list', msgid]
      };
    },

    filter: {
      get: function get() {
        return this.$store.getters['list/getFilter'];
      },
      set: function set(newFilter) {
        this.$store.dispatch('list/updateFilter', newFilter);
        this.refreshTableAfterFilterUpdate();
      }
    },
    filterSchema: function filterSchema() {
      return this.$store.getters['list/getFilterSchema'];
    },
    schema: function schema() {
      return this.$store.getters['list/getSchema'];
    },

    tableFields: {
      get: function get() {
        return this.schema.fields;
      },
      set: function set(newListSchemaFields) {
        this.$store.dispatch('list/updateListSchemaFields', newListSchemaFields);
      }
    },
    resourceType: {
      get: function get() {
        return this.$store.getters['list/getResourceType'];
      },
      set: function set(newType) {
        this.data = [];
        this.$router.push({
          name: 'auflisten_resource',
          params: {
            resourceType: newType
          }
        });
        this.refreshTableAfterPaging();
      }
    },
    perPage: {
      get: function get() {
        return this.$store.getters['list/getPerPage'];
      },
      set: function set(perPage) {
        this.$store.dispatch('list/setPerPage', perPage).then(this.$nextTick(this.refreshTableAfterPaging));
      }
    },
    sortField: {
      get: function get() {
        return this.$store.getters['list/getSortField'];
      },
      set: function set(sortField) {
        this.$store.dispatch('list/setSortField', sortField);
      }
    },
    sortOrder: {
      get: function get() {
        return this.$store.getters['list/getSortOrder'];
      },
      set: function set(order) {
        this.$store.dispatch('list/setSortOrder', order);
      }
    },
    filterParams: function filterParams() {
      var _this = this;

      // value 'null' and empty strings as well as key '_dirty' will be removed,
      // but value 'false' is explicitly used for filtering
      // (necessary for e.g. filter 'hatPreisgeld' on awards)
      var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.filter).filter(function (x) {
        var blackListFilterParams = {
          keys: ['_dirty'],
          values: ['', null]
        };
        return !blackListFilterParams.keys.includes(x) && !blackListFilterParams.values.includes(_this.filter[x]);
      });
      // generate param object for query parameters
      var params = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var x = _step.value;

          var f = this.filter[x];
          if (f !== null && (typeof f === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(f)) === 'object') {
            params[x] = f._id;
          } else {
            params[x] = f;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return params;
    }
  }),
  methods: {
    updateCompact: function updateCompact(v) {
      this.isCompact = v;
    },
    saveView: function saveView() {
      var _this2 = this;

      this.$dialog.prompt({
        message: this.$gettext('savedView.dialog.message'),
        confirmText: this.$gettext('savedView.dialog.confirm'),
        cancelText: this.$gettext('savedView.dialog.cancel'),
        inputAttrs: {
          maxlength: 50
        },
        onConfirm: function onConfirm(value) {
          _this2.$store.dispatch('list/saveView', value);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["h" /* ToastSuccess */])(_this2.$gettext('toast.savedView.save'));
        }
      });
    },
    doRefreshTable: function doRefreshTable() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].methods.fetchList(this.schema.className, this.page - 1, this.perPage, this.sortField, this.sortOrder, this.filterParams).then(function (_ref) {
        var data = _ref.data,
            meta = _ref.meta;

        _this3.data = [];
        _this3.total = meta.totalElements;
        _this3.$store.dispatch('list/changePage', meta.number + 1);
        data.forEach(function (item) {
          return _this3.data.push(item);
        });
        _this3.loading = false;
      }, function (response) {
        _this3.data = [];
        _this3.total = 0;
        _this3.loading = false;
      });
    },

    refreshTableAfterPaging: __WEBPACK_IMPORTED_MODULE_8_debounce_promise___default()(function () {
      return this.doRefreshTable();
    }, 500, { leading: true }),
    refreshTableAfterFilterUpdate: __WEBPACK_IMPORTED_MODULE_8_debounce_promise___default()(function () {
      return this.doRefreshTable();
    }, 500, { leading: false }),
    onPageChange: function onPageChange(page) {
      this.loading = true;
      this.$store.dispatch('list/changePage', page).then(this.refreshTableAfterPaging);
    },
    updateSorting: function updateSorting(_ref2) {
      var field = _ref2.field,
          order = _ref2.order;

      this.sortField = field;
      this.sortOrder = order;
      this.refreshTableAfterPaging();
    },
    print: function print() {
      window.print();
    },
    updatePrintTimestamp: function updatePrintTimestamp() {
      this.printDate = this.currentDateString();
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var resourceType = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters['list/getResourceType'];
    if (to.params.resourceType == null && resourceType != null) {
      next({
        name: 'auflisten_resource',
        params: {
          resourceType: resourceType
        }
      });
    } else {
      next();
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.doRefreshTable();
    // init timestamp of print date
    this.updatePrintTimestamp();
    // update timestamp of print date after 30 sec
    setInterval(function () {
      _this4.updatePrintTimestamp();
    }, 30 * 1000);
  },

  watch: {
    resourceType: function resourceType() {
      this.$emit('updateHead');
    },
    currentLocale: function currentLocale() {
      this.updatePrintTimestamp();
    }
  },
  components: {
    'fob-entity-list-options': __WEBPACK_IMPORTED_MODULE_10__components_EntityListOptions__["a" /* default */],
    'fob-entity-list-compact': __WEBPACK_IMPORTED_MODULE_11__components_EntityListCompact__["a" /* default */],
    'fob-entity-list-table': __WEBPACK_IMPORTED_MODULE_12__components_EntityListTable__["a" /* default */],
    'fob-entity-list-column-visibility': __WEBPACK_IMPORTED_MODULE_9__components_EntityListColumnVisibility__["a" /* default */],
    'fob-entity-palette': __WEBPACK_IMPORTED_MODULE_13__components_EntityPalette__["a" /* default */],
    'fob-entity-list-pagination': __WEBPACK_IMPORTED_MODULE_14__components_EntityListPagination__["a" /* default */]
  }
});

/***/ }),

/***/ "foU5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gCeS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("\n      "+_vm._s(_vm.data.veranstaltungsTyp)+"\n    ")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("\n        "+_vm._s(_vm.data.name)+"\n      ")])]),_vm._v(" "),_c('div',[_vm._v("\n      "+_vm._s(_vm.data.organisationseinheit.name)),(_vm.hasAdditionalOUs)?_c('span',[_vm._v("; "+_vm._s(_vm.additionalOUs))]):_vm._e()]),_vm._v(" "),(_vm.data.veranstalter != null && _vm.data.veranstalter.length != 0)?_c('div',[_c('em',[_c('translate',[_vm._v("Veranstaltung.form.veranstalter")])],1),_vm._v(" :\n      "+_vm._s(_vm.veranstalter)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',[_vm._v("\n      "+_vm._s(_vm.dateRange)+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gR1W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mixins_DateTimeHelper__ = __webpack_require__("5W2G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mixins_ExternalLinkProvider__ = __webpack_require__("1/AK");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-menu',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_mixins_DateTimeHelper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__components_mixins_ExternalLinkProvider__["a" /* default */]],
  methods: {
    closeOrgaSelect: function closeOrgaSelect() {
      if (this.$refs.orgaselect.isActive) {
        this.$refs.orgaselect.toggle();
      }
    },
    selectOrga: function selectOrga(i) {
      this.$refs.orgaselect.toggle();
      this.activeOrga = i;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    menu: 'getMainMenu',
    version: 'getVersion',
    isAuthorized: 'user/isAuthorized',
    userActiveViewState: 'user/activeViewState',
    username: 'user/name',
    userHasOrga: 'user/hasOrga',
    userResearcher: 'user/researcher',
    userOrgas: 'user/orgas',
    userFisPersid: 'user/fisPersid',
    userIsAuthorized: 'user/isAuthorized'
  }), {
    activeOrga: {
      get: function get() {
        return this.$store.getters['user/activeOrga'];
      },
      set: function set(value) {
        this.$store.dispatch('user/changeOrga', value);
        this.$router.push({ name: 'start' });
      }
    },
    userActiveViewState: {
      get: function get() {
        return this.$store.getters['user/activeViewState'];
      },
      set: function set(id) {
        this.$store.dispatch('user/activeViewState', id);
      }
    },
    onLoginPage: function onLoginPage() {
      return this.$route.name === 'login';
    }
  })
});

/***/ }),

/***/ "glhi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: null,
  roles: [],
  fisPersid: null,
  email: null,
  forscher: null,
  token: null,
  orgas: null,
  activeOrga: 0,
  selectedOrgaID: null,
  loading: false,
  savedViews: [],
  activeViewState: 0,
  activeViewStates: [{
    id: 'internal',
    label: 'menu.list.public.internal',
    desc: 'menu.list.public.internal.desc',
    route: {
      name: 'start'
    }
  }, {
    id: 'external',
    label: 'menu.list.public.external',
    desc: 'menu.list.public.external.desc',
    route: {
      name: 'public',
      params: {
        type: 'ou',
        id: 1,
        resourceType: 'forschungsprojekt'
      }
    }
  }]
});

/***/ }),

/***/ "gnid":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicSelect_vue__ = __webpack_require__("vahH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aad7f56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicSelect_vue__ = __webpack_require__("AuJ+");
function injectStyle (ssrContext) {
  __webpack_require__("mJCd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aad7f56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gxd1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer fob-hide-in-print",staticStyle:{"background":"transparent","letter-spacing":"1px","line-height":"1.5rem"}},[_c('div',{staticClass:"content has-text-centered"},[_c('p',{staticClass:"is-size-7",domProps:{"innerHTML":_vm._s(_vm.$gettext('footer.main'))}}),_vm._v(" "),_c('p',{staticClass:"is-size-7 is-uppercase"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$gettext('footer.link.imprint'))}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$gettext('footer.link.privacyPolicy'))}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$gettext('footer.link.contact'))}})]),_vm._v(" "),_c('div',{staticClass:"is-size-7 has-text-grey-light"},[_c('span',{staticStyle:{"padding-right":"0.5rem"}},[_vm._v("FOBGUI "+_vm._s(_vm.version))]),_vm._v(" "),(this.hasUpdateAvailable)?_c('a',{staticClass:"has-text-grey-light",staticStyle:{"padding-right":"0.5rem"},attrs:{"title":_vm.$gettext('ReloadPage')},on:{"click":_vm.reloadPage}},[_c('translate',[_vm._v("UpdateAvailable")])],1):_vm._e(),_vm._v(" "),(this.isAuthorized)?_c('a',{staticClass:"has-text-grey-light",staticStyle:{"padding-right":"0.5rem"},on:{"click":_vm.dropLocalStorage}},[_vm._v("Browserspeicher löschen")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gyMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__methods__ = __webpack_require__("I22p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__maco__ = __webpack_require__("Z/xC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__leurisExport__ = __webpack_require__("OEr8");




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_0__methods__,
  maco: __WEBPACK_IMPORTED_MODULE_1__maco__,
  leurisExport: __WEBPACK_IMPORTED_MODULE_2__leurisExport__
});

/***/ }),

/***/ "h2RA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOADING_START", function() { return LOADING_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOADING_DONE", function() { return LOADING_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DATA", function() { return SET_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SCHEMA", function() { return SET_SCHEMA; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var LOADING_START = function LOADING_START(state) {
  state.loading = true;
};

var LOADING_DONE = function LOADING_DONE(state) {
  state.loading = false;
};

var SET_DATA = function SET_DATA(state, data) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'data', data);
};

var SET_SCHEMA = function SET_SCHEMA(state, schema) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'schema', schema);
};

/***/ }),

/***/ "hGmp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maco", function() { return maco; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reset", function() { return reset; });
var maco = function maco(_ref, data) {
  var dispatch = _ref.dispatch,
      commit = _ref.commit;

  commit('LOGIN_MACO', data);
};

var reset = function reset(_ref2) {
  var commit = _ref2.commit;

  commit('RESET');
};

/***/ }),

/***/ "hZZj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projektleiter_vue__ = __webpack_require__("ambQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdbe8b08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Projektleiter_vue__ = __webpack_require__("63V6");
function injectStyle (ssrContext) {
  __webpack_require__("m1CF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cdbe8b08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projektleiter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdbe8b08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Projektleiter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hin7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchCooperationDetailsQuery; });
function fetchCooperationDetailsQuery(id) {
  var variables = { id: id };

  return {
    operationName: 'fetchCooperationDetailsQuery',
    query: '\n      query fetchCooperationDetailsQuery($id: Int!) {\n        kooperation: cooperation(id: $id) {\n          _entityName\n          _stringRep\n          titelKooperation:title\n          kooperationsType:type\n          organisationseinheit:organisationalUnit {\n            _id:id\n            _entityName\n            _stringRep\n            parentOrgaName\n          }\n          relevantFuerWeitere:hasMultipleOus\n          weitereOrganisationseinheiten:additionalOrganisationalUnits {\n            _id:id\n            _stringRep\n            _entityName\n            parentOrgaName\n          }\n          ansprechpartner:contactPersons {\n            _entityName\n            _stringRep: fullName\n            fisPersid\n            orcid\n          }\n          beteiligtePersonen:involvedPersons {\n            _entityName\n            _stringRep: fullName\n            fisPersid\n            orcid\n          }\n          beteiligteOrganisationen:involvedOrganisations {\n            _entityName\n            _stringRep\n            name\n            kurzname:shortName\n            stadt:city\n            country {\n              _id:id\n              _stringRep\n              _entityName\n              nameDe\n              nameEn\n            }\n          }\n          _stringRep\n          beginn:startDate\n          ende:endDate\n          kurzbeschreibung:abstract\n          gastaufenthalte:guestStays\n          gegenseiteHilfe:mutualSupport\n          gemeinsameTagungen:jointMeetings\n          gemeinsameThemen:commonTopics\n          gemeinsamePublikationen:jointAuthoring\n          doktorandenProgramm:doctoralProgramme\n          andereKooperation:other\n          kooperationsartFreitext:cooperationDetails\n        }\n      }\n    ',
    variables: variables
  };
}



/***/ }),

/***/ "hs9L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fobclient__ = __webpack_require__("N5qN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fobclient___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fobclient__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");





var Connection = function () {
  function Connection(data) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Connection);

    this.baseURL = data.baseURL;
    this.port = data.port || '';
    this.username = data.username;
    this.password = data.password;
    this.token = data.token;
    this.path = data.path || '';
    this.transformator = data.transformator || function (x) {
      return x;
    };
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Connection, [{
    key: 'setConnection',
    value: function setConnection(_ref) {
      var baseURL = _ref.baseURL,
          username = _ref.username,
          password = _ref.password,
          port = _ref.port,
          path = _ref.path,
          transformator = _ref.transformator;

      this.baseURL = baseURL;
      this.username = username;
      this.password = password;
      this.path = path || '/login';
      this.port = port || '';
      this.transformator = transformator;
    }
  }, {
    key: 'getURIPrefix',
    value: function getURIPrefix() {
      var uriPrefix = this.baseURL;
      if (this.port) {
        uriPrefix += ':' + this.port;
      }
      uriPrefix += this.path;
      return uriPrefix;
    }
  }, {
    key: 'getBaseURL',
    value: function getBaseURL() {
      return this.baseURL;
    }
  }, {
    key: 'getPort',
    value: function getPort() {
      return this.port;
    }
  }, {
    key: 'getPath',
    value: function getPath() {
      return this.path;
    }
  }, {
    key: 'getTransformator',
    value: function getTransformator() {
      return this.transformator;
    }
  }, {
    key: 'getConnection',
    value: function getConnection() {
      return {
        baseURL: this.baseURL,
        username: this.username,
        password: this.password,
        port: this.port,
        token: this.token
      };
    }
  }, {
    key: 'getToken',
    value: function getToken() {
      return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['user/token'];
    }
  }, {
    key: 'setToken',
    value: function setToken() {
      // token not in connection, as pulled from store
    }
  }]);

  return Connection;
}();

__WEBPACK_IMPORTED_MODULE_2_fobclient___default.a.init(new Connection({
  baseURL: "",
  path: "/fob",
  port: ""
}),
// TOMANER
new Connection({
  baseURL: "" || "",
  port: "" || "",
  path: "/tomaner/login/",
  transformator: (function transformator(x) { return x.fob.body })
}));

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_fobclient___default.a);

/***/ }),

/***/ "ht1h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityListCompactCyan_vue__ = __webpack_require__("EBNI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cfb2db0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityListCompactCyan_vue__ = __webpack_require__("zjoM");
function injectStyle (ssrContext) {
  __webpack_require__("FYuD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityListCompactCyan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cfb2db0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityListCompactCyan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i0wJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"html-editor",class:{
    'is-invalid': _vm.showError
  }},[_c('vue-editor',{ref:"editor",staticClass:"has-background-white",attrs:{"id":"editor","editorToolbar":_vm.customToolbar,"editorOptions":_vm.editorOptions},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}}),_vm._v(" "),_c('div',{staticClass:"status-bar has-background-white has-text-right is-size-7"},[_c('span',{class:[_vm.textLength <= _vm.maxLength ? 'has-text-gray' : 'has-text-carnelian']},[_vm._v("\n      "+_vm._s(_vm.textLength)+"\n    ")]),_vm._v(" / "+_vm._s(_vm.maxLength)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i3YD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoading", function() { return isLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSchema", function() { return getSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getViewEntityType", function() { return getViewEntityType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getData", function() { return getData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getId", function() { return getId; });
var isLoading = function isLoading(state) {
  return state.loading;
};

var getSchema = function getSchema(state) {
  return state.schema;
};

var getViewEntityType = function getViewEntityType(state) {
  return state.viewEntityType;
};

var getData = function getData(state) {
  return state.data;
};

var getId = function getId(state) {
  return state.id;
};

/***/ }),

/***/ "i8BR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Label_vue__ = __webpack_require__("y1zz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48df630e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Label_vue__ = __webpack_require__("3LY0");
function injectStyle (ssrContext) {
  __webpack_require__("C+FT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Label_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48df630e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Label_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iAEu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoading", function() { return isLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSchema", function() { return getSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getViewEntityType", function() { return getViewEntityType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDirty", function() { return isDirty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getData", function() { return getData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getId", function() { return getId; });
var isLoading = function isLoading(state) {
  return state.loading;
};

var getSchema = function getSchema(state) {
  return state.schema;
};

var getViewEntityType = function getViewEntityType(state) {
  return state.viewEntityType;
};

var isDirty = function isDirty(state) {
  return state.data != null && state.data._dirty === true;
};

var getData = function getData(state) {
  return state.data;
};

var getId = function getId(state) {
  return state.id;
};

/***/ }),

/***/ "iBzs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityDetails_vue__ = __webpack_require__("cfU0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2430918a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityDetails_vue__ = __webpack_require__("tpr9");
function injectStyle (ssrContext) {
  __webpack_require__("NKc/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2430918a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2430918a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iFDA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PubIdent__ = __webpack_require__("2i92");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators_requiredIf__ = __webpack_require__("lEk1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators_requiredIf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators_requiredIf__);





var nonNullBoolean = function nonNullBoolean(to) {
  return to === true || to === false;
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var maxYear = new Date().getFullYear() || 2025;

  return {
    organisationseinheit: {
      name: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) }
    },
    // weitereOrganisationseinheiten: {
    //  name: {required: requiredIf((resourceDate) => resourceDate.relevantFuerWeitere === true)
    //  }
    // },
    titelPublikation: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) },
    publikationsTyp: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] },
    veroeffentlichungsJahr: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minValue"])(1409), maxValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxValue"])(maxYear) },
    // titelPublikation: {
    //  required: requiredIf((PubIdent) => PubIdent.Wert == null || PubIdent.Wert.lenght === 0)
    // },
    pubIdent: {
      $each: __WEBPACK_IMPORTED_MODULE_1__PubIdent__["a" /* default */]
    },
    author: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators_requiredIf___default()(function (resourceData) {
        return ['ARTIKEL', 'SAMMELBANDBEITRAG', 'TAGUNGSBEITRAG', 'BUCHBEITRAG', 'MONOGRAPHIE', 'BERICHT', 'WORKINGPAPER', 'BEITRAGINNICHTWISSENSCHAFTLICHENMEDIEN', 'DISSERTATION', 'HABILITATIONSSCHRIFT', 'SONSTIGE'].includes(resourceData.publikationsTyp);
      })
    },
    inProjekt: { nonNullBoolean: nonNullBoolean },
    herausgeber: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators_requiredIf___default()(function (resourceData) {
        return ['SAMMELBAND', 'TAGUNGSBAND', 'SONDERHEFT', 'QUELLENEDITION'].includes(resourceData.publikationsTyp);
      })
    },
    publicPubIdent: {
      $each: __WEBPACK_IMPORTED_MODULE_1__PubIdent__["a" /* default */]
    },
    forschungsprojekt: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators_requiredIf___default()(function (resourceData) {
        return resourceData.inProjekt === true;
      })
    }
  };
});

/***/ }),

/***/ "izx2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FilterSchema; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Forschungsprojekt__ = __webpack_require__("tZsR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ForschungsprojektFilter__ = __webpack_require__("KnrV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Publikation__ = __webpack_require__("eO8b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PublikationFilter__ = __webpack_require__("ubxp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Preis__ = __webpack_require__("Lh/Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PreisFilter__ = __webpack_require__("Go2m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Organisationseinheit__ = __webpack_require__("nceC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OrganisationseinheitFilter__ = __webpack_require__("r0gj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Person__ = __webpack_require__("afB/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PersonFilter__ = __webpack_require__("+qpY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AbstractPerson__ = __webpack_require__("DxGe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AbstractPersonFilter__ = __webpack_require__("pmQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ExterneOrganisation__ = __webpack_require__("aQYl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ExterneOrganisationFilter__ = __webpack_require__("4+79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Kooperation__ = __webpack_require__("04Ux");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__KooperationFilter__ = __webpack_require__("Cflg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Veranstaltung__ = __webpack_require__("GKHd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__VeranstaltungFilter__ = __webpack_require__("ze6G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Patent__ = __webpack_require__("yHJZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__PatentFilter__ = __webpack_require__("P1X8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Land__ = __webpack_require__("Eti6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__LandFilter__ = __webpack_require__("BygF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__AppUser__ = __webpack_require__("Extr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__AppUserFilter__ = __webpack_require__("3kht");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Mittelgeber__ = __webpack_require__("f+Bj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__MittelgeberFilter__ = __webpack_require__("4HNN");



























var ListSchema = {
  forschungsprojekt: __WEBPACK_IMPORTED_MODULE_0__Forschungsprojekt__["a" /* default */],
  externeorganisation: __WEBPACK_IMPORTED_MODULE_12__ExterneOrganisation__["a" /* default */],
  kooperation: __WEBPACK_IMPORTED_MODULE_14__Kooperation__["a" /* default */],
  publikation: __WEBPACK_IMPORTED_MODULE_2__Publikation__["a" /* default */],
  preis: __WEBPACK_IMPORTED_MODULE_4__Preis__["a" /* default */],
  person: __WEBPACK_IMPORTED_MODULE_8__Person__["a" /* default */],
  organisationseinheit: __WEBPACK_IMPORTED_MODULE_6__Organisationseinheit__["a" /* default */],
  abstractperson: __WEBPACK_IMPORTED_MODULE_10__AbstractPerson__["a" /* default */],
  veranstaltung: __WEBPACK_IMPORTED_MODULE_16__Veranstaltung__["a" /* default */],
  patent: __WEBPACK_IMPORTED_MODULE_18__Patent__["a" /* default */],
  land: __WEBPACK_IMPORTED_MODULE_20__Land__["a" /* default */],
  appuser: __WEBPACK_IMPORTED_MODULE_22__AppUser__["a" /* default */],
  mittelgeber: __WEBPACK_IMPORTED_MODULE_24__Mittelgeber__["a" /* default */]
};

var FilterSchema = {
  forschungsprojekt: __WEBPACK_IMPORTED_MODULE_1__ForschungsprojektFilter__["a" /* default */],
  externeorganisation: __WEBPACK_IMPORTED_MODULE_13__ExterneOrganisationFilter__["a" /* default */],
  kooperation: __WEBPACK_IMPORTED_MODULE_15__KooperationFilter__["a" /* default */],
  publikation: __WEBPACK_IMPORTED_MODULE_3__PublikationFilter__["a" /* default */],
  preis: __WEBPACK_IMPORTED_MODULE_5__PreisFilter__["a" /* default */],
  person: __WEBPACK_IMPORTED_MODULE_9__PersonFilter__["a" /* default */],
  organisationseinheit: __WEBPACK_IMPORTED_MODULE_7__OrganisationseinheitFilter__["a" /* default */],
  abstractperson: __WEBPACK_IMPORTED_MODULE_11__AbstractPersonFilter__["a" /* default */],
  veranstaltung: __WEBPACK_IMPORTED_MODULE_17__VeranstaltungFilter__["a" /* default */],
  patent: __WEBPACK_IMPORTED_MODULE_19__PatentFilter__["a" /* default */],
  land: __WEBPACK_IMPORTED_MODULE_21__LandFilter__["a" /* default */],
  appuser: __WEBPACK_IMPORTED_MODULE_23__AppUserFilter__["a" /* default */],
  mittelgeber: __WEBPACK_IMPORTED_MODULE_25__MittelgeberFilter__["a" /* default */]
};

/***/ }),

/***/ "j6WB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jJC0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMeListFilter_vue__ = __webpack_require__("yMki");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16564b1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutMeListFilter_vue__ = __webpack_require__("bmqV");
function injectStyle (ssrContext) {
  __webpack_require__("E7wU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMeListFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16564b1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutMeListFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jK7k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicListFilter_vue__ = __webpack_require__("snHa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63c9a610_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicListFilter_vue__ = __webpack_require__("ceHl");
function injectStyle (ssrContext) {
  __webpack_require__("Iy+K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicListFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63c9a610_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicListFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jd+X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Upload_vue__ = __webpack_require__("APWZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3be651e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Upload_vue__ = __webpack_require__("HfQr");
function injectStyle (ssrContext) {
  __webpack_require__("Fq9t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Upload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3be651e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Upload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jh8f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    userCanEditByKostenstelle: function userCanEditByKostenstelle(data) {
      if (this.$store.getters['user/isAuthorized']) {
        var userKst = this.$store.getters['user/selectedOrga'].kostenstelle;
        if (data.organisationseinheit != null && data.organisationseinheit.kostenstellenpfad != null) {
          var kostenstellen = data.organisationseinheit.kostenstellenpfad;
          if (data.weitereOrganisationseinheiten != null) {
            kostenstellen += data.weitereOrganisationseinheiten.map(function (x) {
              return x.kostenstellenpfad;
            }).join(' ');
          }
          return kostenstellen.includes(userKst) || this.$store.getters['user/roles'].ADMIN === true;
        } else {
          return this.$store.getters['user/roles'].ADMIN === true;
        }
      } else {
        return false;
      }
    }
  }
});

/***/ }),

/***/ "jo7G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',{attrs:{"type":_vm.type}},[_c('b-select',{attrs:{"icon":_vm.icon,"expanded":"","loading":_vm.loading},on:{"input":_vm.selectValue},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[(this.groupBy)?_vm._l((_vm.groupLabels),function(groupLabel){return _c('optgroup',{key:groupLabel,attrs:{"label":_vm.$gettext((_vm.entity + "." + _vm.groupBy + "." + groupLabel))}},_vm._l((_vm.groups[groupLabel]),function(option){return _c('option',{key:option._id,domProps:{"value":option._id}},[_vm._v("\n          "+_vm._s(option._stringRep)+"\n        ")])}))}):_vm._l((_vm.values),function(option){return _c('option',{key:option._id,domProps:{"value":option._id}},[_vm._v("\n        "+_vm._s(option._stringRep)+"\n      ")])})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kHs5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kL4d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoading", function() { return isLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDirty", function() { return isDirty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSchema", function() { return getSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getResourceType", function() { return getResourceType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getData", function() { return getData; });
var isLoading = function isLoading(state) {
  return state.loading;
};

var isDirty = function isDirty(state) {
  return state.data != null && state.data._dirty === true;
};

var getSchema = function getSchema(state) {
  return state.schema;
};

var getResourceType = function getResourceType(state) {
  if (state.schema != null) {
    return state.schema.route;
  } else {
    return null;
  }
};

var getData = function getData(state) {
  return state.data;
};

/***/ }),

/***/ "kU3t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_DateTimeHelper__ = __webpack_require__("5W2G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_compact_Publikation__ = __webpack_require__("LgZK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_EntityDecorator__ = __webpack_require__("vlR/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__schema__ = __webpack_require__("uDTM");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-entity-value',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_mixins_DateTimeHelper__["a" /* default */]],
  props: {
    isPublic: Boolean,
    bit: [String, Object],
    resourceData: {
      type: [String, Boolean, Number, Object, Array, Date],
      default: null
    },
    plain: {
      type: Boolean,
      default: false
    },
    linkNested: {
      type: String,
      default: null
    },
    maxLength: {
      type: Number,
      default: null
    },
    useCompactComponents: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: Boolean,
      default: null
    },
    linkProvider: {
      type: Function,
      default: function _default(data) {
        var type = data._entityName.split('.').splice(-1)[0].toLowerCase();
        return {
          name: 'anzeigen_einzeln',
          params: {
            resourceType: type,
            resourceId: data._id
          }
        };
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    loading: 'resource/isLoading',
    userRoles: 'user/roles'
  }), {
    isBitList: function isBitList() {
      var t = Object.prototype.toString.call(this.resourceData);
      return t === '[object Array]';
    },
    isFOBObject: function isFOBObject() {
      return this.resourceData !== null && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.resourceData) === 'object' && typeof this.resourceData._entityName !== 'undefined';
    },
    isArray: function isArray() {
      return Array.isArray(this.resourceData);
    },
    isUri: function isUri() {
      return this.resourceData.href === this.resourceData.text;
    },
    locale: function locale() {
      return this.$language.current.substring(0, 2).toLowerCase();
    }
  }),
  methods: {
    constructLink: function constructLink(entity) {
      return this.linkProvider(this.linkNested ? entity[this.linkNested] : entity);
    },
    stringRep: function stringRep(entity) {
      // TODO: Change 'stringRep' to '_stringRep' in schema definitions, remove second branch here
      if (this.bit.render === undefined) {
        return entity._stringRep;
      } else if (this.bit.render === 'stringRep') {
        return entity['_stringRep'];
      } else if (this.bit.render instanceof Function) {
        return this.bit.render(entity);
      } else {
        return entity[this.bit.render];
      }
    },
    labelFormatter: function labelFormatter(label) {
      var _this = this;

      if (this.bit.render !== undefined && typeof this.bit.render === 'function') {
        var rendered = this.bit.render(this.resourceData);

        if (!Array.isArray(rendered)) {
          rendered = [rendered];
        }

        if (this.bit.translatable) {
          rendered = rendered.map(function (s) {
            return _this.$gettext(s);
          });
        }

        return rendered.join(', ');
      }

      if (this.maxLength && label.length > this.maxLength) {
        return label.substring(0, this.maxLength) + '...';
      } else {
        return label;
      }
    },
    showTooltip: function showTooltip(label) {
      /* show tooltips if:
         - maxLength was set AND tooltip prop is true
         - maxLength was set AND tooltip prop is not set (null)
       */
      if (this.tooltip === false) {
        return false;
      } else if (this.maxLength && label.length > this.maxLength) {
        return true;
      } else {
        return false; // default
      }
    },
    sortedResourceData: function sortedResourceData() {
      var _this2 = this;

      if (this.bit.sortBy) {
        var copied = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.resourceData));
        return copied.sort(function (a, b) {
          var va = a[_this2.bit.sortBy].toLowerCase();
          var vb = b[_this2.bit.sortBy].toLowerCase();
          if (va < vb) {
            return -1;
          }
          if (va > vb) {
            return 1;
          }
          return 0;
        });
      } else {
        return this.resourceData;
      }
    },
    extractSelectLabelFromValue: function extractSelectLabelFromValue() {
      var _this3 = this;

      return this.bit.values.find(function (x) {
        return x.value === _this3.resourceData;
      }).label;
    },
    hasCompactComponent: function hasCompactComponent(schema) {
      if (schema != null && schema.className != null) {
        return 'fob-' + schema.className + '-compact' in this.$options.components;
      } else {
        return false;
      }
    },
    compactComponentName: function compactComponentName(schema) {
      return 'fob-' + schema.className + '-compact';
    },
    getFullSchema: function getFullSchema(className) {
      return __WEBPACK_IMPORTED_MODULE_7__schema__["a" /* default */][className];
    }
  },
  components: {
    'fob-publikation-compact': __WEBPACK_IMPORTED_MODULE_5__components_compact_Publikation__["a" /* default */],
    'fob-entity-decorator': __WEBPACK_IMPORTED_MODULE_6__components_EntityDecorator__["a" /* default */]
  }
});

/***/ }),

/***/ "kYS8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l14L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE_PAGE", function() { return CHANGE_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PER_PAGE", function() { return SET_PER_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_RESOURCE_TYPE", function() { return SET_RESOURCE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SORT_FIELD", function() { return SET_SORT_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SORT_ORDER", function() { return SET_SORT_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_FILTER", function() { return UPDATE_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_LIST_SCHEMA_FIELDS", function() { return UPDATE_LIST_SCHEMA_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PREFILL_ORGA", function() { return PREFILL_ORGA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOGGLE_COLUMNS", function() { return TOGGLE_COLUMNS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_LIST", function() { return RESET_LIST; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");





var CHANGE_PAGE = function CHANGE_PAGE(state, page) {
  state.config[state.resourceType].page = page;
};

var SET_PER_PAGE = function SET_PER_PAGE(state, perPage) {
  state.config[state.resourceType].perPage = perPage;
};

var SET_RESOURCE_TYPE = function SET_RESOURCE_TYPE(state, type) {
  state.resourceType = type;
};

var SET_SORT_FIELD = function SET_SORT_FIELD(state, sortField) {
  state.config[state.resourceType].sortField = sortField;
};

var SET_SORT_ORDER = function SET_SORT_ORDER(state, sortOrder) {
  state.config[state.resourceType].sortOrder = sortOrder;
};

var UPDATE_FILTER = function UPDATE_FILTER(state, updatedFilter) {
  state.filter[state.resourceType] = updatedFilter;
};

var UPDATE_LIST_SCHEMA_FIELDS = function UPDATE_LIST_SCHEMA_FIELDS(state, updatedListSchemaFields) {
  __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].set(state.listSchema[state.resourceType], 'fields', updatedListSchemaFields);
};

var PREFILL_ORGA = function PREFILL_ORGA(state, orga) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(state.filterSchema)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref = _step.value;

      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

      var entity = _ref2[0];
      var bit = _ref2[1];

      if (bit.fields.some(function (x) {
        return x.field === 'organisationseinheit';
      })) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].set(state.filter[entity], 'organisationseinheit', orga);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

var TOGGLE_COLUMNS = function TOGGLE_COLUMNS(state, columns) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.listSchema[state.resourceType].fields), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var field = _step2.value;

      if (columns.includes(field.field)) {
        field.tableVisible = true;
      } else {
        field.tableVisible = false;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
};

var RESET_LIST = function RESET_LIST(state) {
  state.data = {};
  state.id = null;
  state.resourceType = 'forschungsprojekt';
  state.filter = {
    forschungsprojekt: {
      kumuliert: false
    },
    kooperation: {
      kumuliert: false
    },
    publikation: {
      kumuliert: false
    },
    person: {},
    organisationseinheit: {},
    abstractperson: {},
    veranstaltung: {
      kumuliert: false
    },
    preis: {
      kumuliert: false
    },
    externeorganisation: {},
    patent: {
      kumuliert: false
    },
    land: {},
    appuser: {}
  };
  state.config = {
    forschungsprojekt: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    kooperation: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    publikation: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    veranstaltung: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    preis: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    abstractperson: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    organisationseinheit: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    person: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    externeorganisation: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    patent: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    land: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    appuser: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    }
  };
};

/***/ }),

/***/ "l2vt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[(_vm.title)?_c('div',[_c('span',{staticClass:"fob-compact-item-title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.data.projektLeiter)?_c('div',[_vm._v("\n      "+_vm._s(_vm.fullName(_vm.data.projektLeiter))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.data.projektBeginn !== null)?_c('div',[_c('i',[_c('translate',[_vm._v("Forschungsprojekt.compact.Laufzeit")])],1),_vm._v(": "+_vm._s(_vm.duration(_vm.data.projektBeginn, _vm.data.projektEnde))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.funding)?_c('div',[_c('span',{staticClass:"fob-compact-item-key"},[_c('translate',[_vm._v("Forschungsprojekt.compact.Mittelgeber")]),_vm._v(":")],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.funding))])]):_vm._e(),_vm._v(" "),(_vm.organisationalUnits)?_c('div',[_c('span',{staticClass:"fob-compact-item-key"},[_c('translate',[_vm._v("Forschungsprojekt.compact.organisationseinheiten")]),_vm._v(":")],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.organisationalUnits))])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lHMy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_public_PublicListCompact__ = __webpack_require__("8eFq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_public_PublicListOptions__ = __webpack_require__("uDp6");
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-public-list-view',
  props: ['resourceType'],
  components: {
    'fob-public-list-compact': __WEBPACK_IMPORTED_MODULE_0__components_public_PublicListCompact__["a" /* default */],
    'fob-public-list-options': __WEBPACK_IMPORTED_MODULE_1__components_public_PublicListOptions__["a" /* default */]
  }
});

/***/ }),

/***/ "lJUF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityMultiSelect_vue__ = __webpack_require__("xkmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a3dc68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityMultiSelect_vue__ = __webpack_require__("G9OK");
function injectStyle (ssrContext) {
  __webpack_require__("QLxO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityMultiSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a3dc68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityMultiSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lULL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_aboutme_AboutMeListCompact__ = __webpack_require__("5DfW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_aboutme_AboutMeListOptions__ = __webpack_require__("wX/P");
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-aboutme-list-view',
  props: ['resourceType'],
  components: {
    'fob-aboutme-list-compact': __WEBPACK_IMPORTED_MODULE_0__components_aboutme_AboutMeListCompact__["a" /* default */],
    'fob-aboutme-list-options': __WEBPACK_IMPORTED_MODULE_1__components_aboutme_AboutMeListOptions__["a" /* default */]
  }
});

/***/ }),

/***/ "ldSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-width":"800px"}},[_c('b-field',{attrs:{"label":_vm.$gettext('form.heading.choose_activity')}},[_c('fob-entity-palette',{ref:"palette",model:{value:(_vm.selectedType),callback:function ($$v) {_vm.selectedType=$$v},expression:"selectedType"}})],1),_vm._v(" "),(_vm.selectedType != null)?_c('div',{staticClass:"fob-box box",domProps:{"innerHTML":_vm._s(_vm.$gettext(_vm.selectedEntity + '.form.hinweistext'))}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[(_vm.resourceType != null && !_vm.loading)?_c('div',[_c('fob-entity-create-form',{key:_vm.selectedType,attrs:{"showErrors":_vm.showErrors,"type":_vm.resourceType,"schema":_vm.selectedSchema},on:{"update:invalid":function (value) { return _vm.isInvalid = value; }},model:{value:(_vm.resourceData),callback:function ($$v) {_vm.resourceData=$$v},expression:"resourceData"}}),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"40px"}},[_c('b-field',{attrs:{"grouped":""}},[_c('p',{staticClass:"control"},[_c('button',{staticClass:"button is-aquamarine",attrs:{"disabled":!_vm.isDirty},on:{"click":_vm.requestSave}},[_vm._v("Speichern")])]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('button',{staticClass:"button is-carnelian",on:{"click":_vm.close}},[_vm._v("Abbrechen")])])])],1)],1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lo1B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"fob-only-for-print-view fob-entity-list-options",staticStyle:{"display":"flex"}},[_c('div',[_c('transition',{attrs:{"name":"tags"}},[_c('b-field',{staticClass:"fob-entity-list-filter-tags fob-entity-list-options-tag-list-static",attrs:{"grouped":"","group-multiline":""}},[_c('div',{staticStyle:{"display":"flex","flex-flow":"row wrap","align-content":"space-between"}},_vm._l((_vm.activeFilter),function(value,field){return _c('div',{key:field},[(value && value.length > 0)?_c('b-taglist',{attrs:{"attached":""}},[_c('b-tag',{attrs:{"type":"is-aquamarine"}},[_vm._v("\n                  "+_vm._s(_vm.$gettext(_vm.labelForActiveFilterField(field)))+"\n                ")]),_vm._v(" "),_c('b-tag',{attrs:{"type":"is-basalt"}},[_vm._v("\n                  "+_vm._s(_vm.$gettext(_vm.labelForActiveFilterValue(field, value)))+"\n                ")])],1):_vm._e()],1)}))])],1)],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"print-metadata-box"},[_c('div',{staticClass:"print-metadata-columns"},[_c('div',{staticClass:"print-metadata-label"},[_c('translate',[_vm._v("tag.static.printedPageOfPagesLabel")])],1),_vm._v(" "),_c('div',{staticClass:"print-metadata-value"},[_c('translate',{attrs:{"translate-params":{page: _vm.page, totalTablePages: _vm.totalTablePages}}},[_vm._v("tag.static.printedPageOfPagesValue")])],1)]),_vm._v(" "),_c('div',{staticClass:"print-metadata-columns"},[_c('div',{staticClass:"print-metadata-label"},[_c('translate',[_vm._v("tag.static.resultCount")])],1),_vm._v(" "),_c('div',{staticClass:"print-metadata-value"},[_vm._v(_vm._s(_vm.total[_vm.resourceType]))])]),_vm._v(" "),_c('div',{staticClass:"print-metadata-columns"},[_c('div',{staticClass:"print-metadata-label"},[_c('translate',[_vm._v("tag.static.entriesPerPage")])],1),_vm._v(" "),_c('div',{staticClass:"print-metadata-value"},[_vm._v(_vm._s(_vm.config[_vm.resourceType].perPage))])])])])]),_vm._v(" "),_c('div',{staticClass:"fob-hide-in-print",staticStyle:{"display":"flex","margin-bottom":"15px","align-items":"center"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('b-icon',{staticClass:"has-text-aquamarine",staticStyle:{"margin-right":"10px"},attrs:{"pack":"fa","icon":"list-ul"}}),_vm._v(" "),_c('b-select',{staticStyle:{"margin-right":"0px"},on:{"input":_vm.onPerPageChange},model:{value:(_vm.config[_vm.resourceType].perPage),callback:function ($$v) {_vm.$set(_vm.config[_vm.resourceType], "perPage", $$v)},expression:"config[resourceType].perPage"}},[_c('option',{attrs:{"value":"5"}},[_vm._v("5 "),_c('translate',[_vm._v("list.header.perPage")])],1),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10 "),_c('translate',[_vm._v("list.header.perPage")])],1),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15 "),_c('translate',[_vm._v("list.header.perPage")])],1),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20 "),_c('translate',[_vm._v("list.header.perPage")])],1),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100 "),_c('translate',[_vm._v("list.header.perPage")])],1)])],1),_vm._v(" "),_c('fob-aboutme-list-sort',{key:_vm.resourceType,attrs:{"resourceType":_vm.resourceType,"sortOrder":_vm.config[_vm.resourceType].sortOrder,"sortField":_vm.config[_vm.resourceType].sortField,"sortFields":_vm.config[_vm.resourceType].sortFields},on:{"update:sortOrderAboutMe":_vm.onUpdateSortOrder,"update:sortFieldAboutMe":_vm.onUpdateSortField}})],1),_vm._v(" "),_c('div',{staticClass:"fob-hide-in-print",staticStyle:{"display":"flex","margin-bottom":"15px","align-items":"center"}},[_c('fob-aboutme-list-filter',{attrs:{"resourceType":_vm.resourceType}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lrJY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lwCg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return detailsQuery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql_tree__ = __webpack_require__("vc/A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphql_project__ = __webpack_require__("QGv4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_publication__ = __webpack_require__("RVzl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphql_award__ = __webpack_require__("ZCKo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_cooperation__ = __webpack_require__("BKPO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql_event__ = __webpack_require__("K8Lz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphql_staff__ = __webpack_require__("GcbJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__graphql_projectDetails__ = __webpack_require__("Noxu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graphql_publicationDetails__ = __webpack_require__("Q9ro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__graphql_awardDetails__ = __webpack_require__("Ql6K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__graphql_cooperationDetails__ = __webpack_require__("hin7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__graphql_eventDetails__ = __webpack_require__("IADm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__graphql_organisationalUnits__ = __webpack_require__("HiFQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__graphql_stats__ = __webpack_require__("8Dql");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__graphql_leurisProfile__ = __webpack_require__("ZMCW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__graphql_ouDetails__ = __webpack_require__("8IlM");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__graphql_tree__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__graphql_staff__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__graphql_project__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__graphql_publication__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__graphql_award__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__graphql_cooperation__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__graphql_event__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_12__graphql_organisationalUnits__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_12__graphql_organisationalUnits__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_13__graphql_stats__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_14__graphql_leurisProfile__["a"]; });
/* unused harmony reexport fetchOuDetailsQuery */
























var detailsQuery = {
  forschungsprojekt: __WEBPACK_IMPORTED_MODULE_7__graphql_projectDetails__["a" /* fetchResearchProjectDetailsQuery */],
  publikation: __WEBPACK_IMPORTED_MODULE_8__graphql_publicationDetails__["a" /* fetchPublicationDetailsQuery */],
  preis: __WEBPACK_IMPORTED_MODULE_9__graphql_awardDetails__["a" /* fetchAwardDetailsQuery */],
  kooperation: __WEBPACK_IMPORTED_MODULE_10__graphql_cooperationDetails__["a" /* fetchCooperationDetailsQuery */],
  veranstaltung: __WEBPACK_IMPORTED_MODULE_11__graphql_eventDetails__["a" /* fetchEventDetailsQuery */]
};

/***/ }),

/***/ "lwq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  now: new Date(),
  version: 'v0.48.1',
  lastVersion: '',
  serverVersion: '',
  language: 'de_DE',
  confirmPrivacyPolicy: false
});

/***/ }),

/***/ "m0ky":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Veranstaltung_vue__ = __webpack_require__("zaUY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_747164d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Veranstaltung_vue__ = __webpack_require__("gCeS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Veranstaltung_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_747164d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Veranstaltung_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m1CF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mJCd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mLW4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__("0xDb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-entity-create-modal',
  data: function data() {
    return {
      isInvalid: true,
      showErrors: false
    };
  },

  props: ['schema', 'value', 'active', 'field'],
  computed: {
    created: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    showCreateModal: {
      get: function get() {
        return this.active;
      },
      set: function set(value) {
        this.$emit('update:active', value);
      }
    }
  },
  methods: {
    requestSubmit: function requestSubmit() {
      if (this.isInvalid) {
        this.showErrors = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* ToastError */])(this.$gettext('toast.validation.failed'));
      } else {
        this.submitCreated();
      }
    },
    submitCreated: function submitCreated() {
      this.showCreateModal = false;
      this.$emit('submit', this.created);
    },
    cancel: function cancel() {
      this.showCreateModal = false;
      this.showErrors = false;
      this.$emit('cancel');
    }
  }
});

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "start", function() { return start; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "confirmPrivacyPolicy", function() { return confirmPrivacyPolicy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateLastVersion", function() { return updateLastVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setServerVersion", function() { return setServerVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetLoading", function() { return resetLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLanguage", function() { return setLanguage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var start = function start(_ref) {
  var commit = _ref.commit;

  setInterval(function () {
    commit('updateTime');
  }, 60 * 1000); // once a minute
};

var confirmPrivacyPolicy = function confirmPrivacyPolicy(_ref2) {
  var commit = _ref2.commit;

  commit('CONFIRM_PRIVACY_POLICY');
};

var updateLastVersion = function updateLastVersion(_ref3, newVersion) {
  var commit = _ref3.commit;

  commit('UPDATE_LAST_VERSION', newVersion);
};

var setServerVersion = function setServerVersion(_ref4, serverVersion) {
  var commit = _ref4.commit;

  commit('SET_SERVER_VERSION', serverVersion);
};

var resetLoading = function resetLoading(_ref5) {
  var commit = _ref5.commit;

  commit('resource/LOADING_DONE', { root: true });
  commit('editor/LOADING_DONE', { root: true });
  commit('user/LOADING_DONE', { root: true });
  commit('publicView/LOADING_DONE', { root: true });
  commit('publicView/LOADING_DONE_STAFF', { root: true });
  commit('tree/LOADING_DONE', { root: true });
  commit('aboutme/LOADING_DONE', { root: true });
};

var setLanguage = function setLanguage(_ref6, locale) {
  var commit = _ref6.commit;

  commit('SET_LANGUAGE', locale);
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.language = locale;
};

/***/ }),

/***/ "mYlC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-aboutme-list-sort',
  props: ['resourceType', 'sortField', 'sortFields', 'sortOrder'],
  computed: {
    localSortField: {
      get: function get() {
        return this.sortField;
      },
      set: function set(newSortField) {
        this.onSortFieldChange(newSortField);
        return newSortField;
      }
    },
    localSortOrder: {
      get: function get() {
        return this.sortOrder;
      },
      set: function set(newSortOrder) {
        this.onSortOrderChange(newSortOrder);
        return newSortOrder;
      }
    }
  },
  methods: {
    onSortFieldChange: function onSortFieldChange(sortField) {
      this.$emit('update:sortFieldAboutMe', sortField);
    },
    onSortOrderChange: function onSortOrderChange(sortOrder) {
      this.$emit('update:sortOrderAboutMe', sortOrder);
    }
  }
});

/***/ }),

/***/ "mkhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql__ = __webpack_require__("lwCg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schema_list__ = __webpack_require__("izx2");



/* harmony default export */ __webpack_exports__["a"] = ({
  loading: false,
  leurisProfile: null,
  fisPersid: null,
  favouredResearchActivity: {
    forschungsprojekt: [],
    kooperation: [],
    publikation: [],
    veranstaltung: [],
    preis: []
  },
  name: null,
  data: {
    forschungsprojekt: [],
    kooperation: [],
    publikation: [],
    veranstaltung: [],
    preis: []
  },
  total: {
    forschungsprojekt: 0,
    kooperation: 0,
    publikation: 0,
    veranstaltung: 0,
    preis: 0
  },
  activeTab: 0,
  resourceType: 'forschungsprojekt',
  resourceTypes: [{
    type: 'forschungsprojekt',
    label: 'Projekte',
    query: __WEBPACK_IMPORTED_MODULE_0__graphql__["b" /* fetchResearchProjectQuery */]
  }, {
    type: 'publikation',
    label: 'Publikationen',
    query: __WEBPACK_IMPORTED_MODULE_0__graphql__["c" /* fetchPublicationQuery */]
  }, {
    type: 'preis',
    label: 'Preise',
    query: __WEBPACK_IMPORTED_MODULE_0__graphql__["d" /* fetchAwardQuery */]
  }, {
    type: 'kooperation',
    label: 'Kooperationen',
    query: __WEBPACK_IMPORTED_MODULE_0__graphql__["e" /* fetchCooperationQuery */]
  }, {
    type: 'veranstaltung',
    label: 'Veranstaltungen',
    query: __WEBPACK_IMPORTED_MODULE_0__graphql__["f" /* fetchEventQuery */]
  }],
  listSchema: __WEBPACK_IMPORTED_MODULE_1__schema_list__["a" /* ListSchema */],
  filterSchema: __WEBPACK_IMPORTED_MODULE_1__schema_list__["b" /* FilterSchema */],
  filter: {
    forschungsprojekt: {
      filter: {},
      filters: [{ type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } }, { type: 'select', value: 'status', label: 'Public.filter.status', options: ['ONGOING', 'TERMINATED'] }, { type: 'input', value: 'funding', label: 'Public.filter.mittelgeber', icon: 'credit-card' }, { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' }, { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }]
    },
    kooperation: {
      filter: {},
      filters: [{ type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } }, { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' }, { type: 'input', value: 'externalPartner', label: 'Public.filter.externalPartner', icon: 'globe' }, { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }]
    },
    publikation: {
      filter: {},
      filters: [{ type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } }, { type: 'select', value: 'category', label: 'Public.filter.publikationstypen', options: ['ARTICLE', 'MONOGRAPHY', 'EDITORSHIP', 'CONTRIBUTION', 'REPORT'] }, { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' }, { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }]
    },
    veranstaltung: {
      filter: {},
      filters: [{ type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } }, { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' }, { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }]
    },
    preis: {
      filter: {},
      filters: [{ type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } }, { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' }, { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }]
    }
  },
  config: {
    forschungsprojekt: {
      page: 1,
      perPage: 10,
      sortField: 'START_DATE',
      sortFields: [
      // { field: 'TITLE_DE', label: 'Public.sort.titel', locale: 'de' },
      // { field: 'TITLE_EN', label: 'Public.sort.titel', locale: 'en' },
      { field: 'START_DATE', label: 'Public.sort.beginn' }],
      sortOrder: 'DESC'
    },
    kooperation: {
      page: 1,
      perPage: 10,
      sortField: 'START_DATE',
      sortFields: [
      // { field: 'TITLE', label: 'Public.sort.titel' },
      { field: 'START_DATE', label: 'Public.sort.beginn' }],
      sortOrder: 'DESC'
    },
    publikation: {
      page: 1,
      perPage: 10,
      sortField: 'YEAR',
      sortFields: [{ field: 'TYPE', label: 'Public.sort.typ' },
      // { field: 'TITLE', label: 'Public.sort.titel' },
      { field: 'YEAR', label: 'Public.sort.jahr' }],
      sortOrder: 'DESC'
    },
    veranstaltung: {
      page: 1,
      perPage: 10,
      sortField: 'START_DATE',
      sortFields: [{ field: 'TYPE', label: 'Public.sort.typ' }, { field: 'START_DATE', label: 'Public.sort.beginn'
        // { field: 'NAME', label: 'Public.sort.name' }
      }],
      sortOrder: 'DESC'
    },
    preis: {
      page: 1,
      perPage: 10,
      sortField: 'YEAR',
      sortFields: [{ field: 'TYPE', label: 'Public.sort.typ' }, { field: 'YEAR', label: 'Public.sort.jahr' }, { field: 'AWARDEE', label: 'Public.sort.preisTraeger'
        // { field: 'NAME', label: 'Public.sort.name' }
      }],
      sortOrder: 'DESC'
    }
  }
});

/***/ }),

/***/ "mlSf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mlar":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "myh2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nDDf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "login", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setupUserSession", function() { return setupUserSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logout", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeOrga", function() { return changeOrga; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveView", function() { return saveView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteView", function() { return deleteView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeViewState", function() { return activeViewState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__("eOoE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fobclient__ = __webpack_require__("hs9L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__("0xDb");






var login = function login(_ref, data) {
  var dispatch = _ref.dispatch,
      commit = _ref.commit;

  commit('LOADING_START');
  return __WEBPACK_IMPORTED_MODULE_3__fobclient__["a" /* default */].login({
    username: data.username,
    password: data.password
  }).then(function (response) {
    return dispatch('setupUserSession', response);
  });
};

var setupUserSession = function setupUserSession(_ref2, response) {
  var dispatch = _ref2.dispatch,
      commit = _ref2.commit;

  commit('LOADING_START');

  var error = {
    tomaner: response.status_code != null && response.status_code !== 200,
    fob: response.fob && response.fob.status_code != null && response.fob.status_code !== 200,
    maco: response.maco && response.maco.status_code && response.maco.status_code !== 200
  };

  if (error.tomaner || error.fob) {
    var throwError = { message: 'Permission denied', status: response.status };
    throw throwError;
  } else if (error.maco) {
    console.log('error on maco');
    // reset maco login information
    dispatch('tomaner/maco', { loggedIn: false, token: null, expiresAt: null }, { root: true });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* ToastError */])('Funktionalitäten der Leuris Profilseite im FOB nicht verfügbar.');
  }

  // save and init login on leuris maco
  if (!error.maco && response.maco.body) {
    var vuexMaco = { user: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, response.maco.body) };
    var selected = response.maco.body.authorisations.find(function (x) {
      return x.fisPersid === response.fob.body.fisPersid;
    });
    if (selected != null) {
      vuexMaco.user.selectedPerson = response.fob.body.fisPersid;
      vuexMaco.user.activeRole = selected.type;
    }

    dispatch('tomaner/maco', { loggedIn: true, token: vuexMaco.user.token, validUntil: vuexMaco.user.validUntil }, { root: true });
  }

  var orgasWithLinks = [];
  var fobResponse = response.fob.body;
  if (fobResponse.organisationseinheiten != null) {
    var orgas = fobResponse.organisationseinheiten;
    orgasWithLinks = orgas.map(function (orga) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(orga, {
        _url: __WEBPACK_IMPORTED_MODULE_2__axios__["d" /* baseURL */] + 'api/organisationseinheit/' + orga._id,
        _links: {
          self: {
            href: __WEBPACK_IMPORTED_MODULE_2__axios__["d" /* baseURL */] + 'api/organisationseinheit/' + orga._id
          }
        }
      });
    }).sort(function (o1, o2) {
      if (o1.name > o2.name) {
        return 1;
      } else if (o1.name < o2.name) {
        return -1;
      } else {
        return 0;
      }
    });
  }
  var refinedResponseData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(fobResponse, { organisationseinheiten: orgasWithLinks });
  commit('USER_LOGIN', refinedResponseData);
  // })
  dispatch('changeOrga', 0);
  console.log('User logged in successfully.');
  commit('LOADING_DONE');
};

var logout = function logout(_ref3) {
  var commit = _ref3.commit,
      dispatch = _ref3.dispatch;

  console.log('Logging out.');
  commit('USER_LOGOUT');
  dispatch('aboutme/reset', null, { root: true });
  dispatch('tomaner/reset', null, { root: true });
  // dispatch('list/resetList', null, { root: true })
};

var changeOrga = function changeOrga(_ref4, index) {
  var state = _ref4.state,
      dispatch = _ref4.dispatch,
      commit = _ref4.commit;

  // only select orga, if user has orgas
  if (state.orgas[index]) {
    commit('CHANGE_ORGA', index);
    dispatch('list/prefillOrga', state.orgas[index], { root: true });
  }
};

var saveView = function saveView(_ref5, viewConfiguration) {
  var state = _ref5.state,
      commit = _ref5.commit;

  commit('SAVE_VIEW', viewConfiguration);
};

var deleteView = function deleteView(_ref6, id) {
  var state = _ref6.state,
      commit = _ref6.commit;

  commit('DELETE_VIEW', id);
};

var activeViewState = function activeViewState(_ref7, id) {
  var state = _ref7.state,
      commit = _ref7.commit;

  commit('ACTIVE_VIEW_STATE', id);
};

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mixins_DynamicTitle__ = __webpack_require__("IqS5");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-login',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_mixins_DynamicTitle__["a" /* default */]],
  data: function data() {
    return {
      username: null,
      password: null,
      leurisHead: {
        inner: 'leuris:Forschungsbericht',
        complement: 'menu.login'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    userIsAuthorized: 'user/isAuthorized'
  })),
  methods: {
    getUsername: function getUsername() {
      // transform username
      //   - to lower case
      //   - extract username from e-mail
      // needed to avoid login failures
      return this.username.toLowerCase().split('@')[0];
    },
    login: function login() {
      var _this = this;

      this.$store.dispatch('user/login', {
        username: this.getUsername(),
        password: this.password
      }).then(function () {
        _this.$router.push({ name: 'start' });
      }).catch(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* ToastError */])(_this.$gettext('toast.login.failed'));
        _this.$store.dispatch('resetLoading');
      });
    }
  }
});

/***/ }),

/***/ "nO6C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_form_Label__ = __webpack_require__("i8BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_form_EntityTableSelectVertical__ = __webpack_require__("+rFF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_EntityDecorator__ = __webpack_require__("vlR/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-entity-multi-select',
  data: function data() {
    return {
      tableSelectVisible: false
    };
  },

  computed: {
    showLabel: function showLabel() {
      // since schema.editable might be undefined (which means here: implicitly true),
      // `schema.field === false` is NOT equivalent to `!schema.editable` since the latter
      // is `true` when schema.editable is false or undefined
      if (this.schema.editable === false) {
        return this.resourceData != null && this.resourceData.length !== 0;
      } else {
        return true;
      }
    },

    resourceData: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.$emit('input', newValue);
      }
    },
    deactivated: function deactivated() {
      if ('editable' in this.schema) {
        return !this.schema.editable;
      } else {
        return false;
      }
    }
  },
  props: {
    value: Array,
    schema: Object,
    asterisk: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    // currently unused, but ready for action
    // TODO: must also be passed down to the entityTableSelect
    draggable: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    dropRow: function dropRow(theid) {
      var newValue = this.resourceData.filter(function (item) {
        return item._id !== theid;
      });
      this.$emit('input', newValue);
    },
    showTableSelect: function showTableSelect() {
      this.tableSelectVisible = true;
    }
  },
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default.a,
    'fob-label': __WEBPACK_IMPORTED_MODULE_1__components_form_Label__["a" /* default */],
    'fob-entity-table-select': __WEBPACK_IMPORTED_MODULE_2__components_form_EntityTableSelectVertical__["a" /* default */],
    'fob-entity-decorator': __WEBPACK_IMPORTED_MODULE_3__components_EntityDecorator__["a" /* default */]
  }
});

/***/ }),

/***/ "nVE5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_DateTimeHelper__ = __webpack_require__("5W2G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mixins_OrgaDurationHelper__ = __webpack_require__("oSjT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mixins_DynamicTitle__ = __webpack_require__("IqS5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_EntityHeader__ = __webpack_require__("sGAB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_public_PublicSelect__ = __webpack_require__("gnid");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_public_PublicListView__ = __webpack_require__("oz0I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_public_PublicListViewHeader__ = __webpack_require__("+U2w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_public_PublicListQuickActions__ = __webpack_require__("BF6l");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import BackToTop from 'vue-backtotop'









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-public',
  mixins: [__WEBPACK_IMPORTED_MODULE_6__components_mixins_DynamicTitle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__components_mixins_DateTimeHelper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__components_mixins_OrgaDurationHelper__["a" /* default */]],
  data: function data() {
    return {
      printDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* currentDateString */])(),
      leurisHead: {
        inner: 'leuris:Portal',
        complement: 'menu.list.public'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    filter: 'publicView/getFilter',
    isLoading: 'publicView/isLoading',
    label: 'publicView/getLabel',
    leurisProfile: 'publicView/getLeurisProfile',
    leurisProfileFisPersid: 'publicView/getLeurisProfileFisPersid',
    orcid: 'publicView/getORCID',
    ulWebsiteProfile: 'publicView/getUlWebsiteProfile',
    sortOrder: 'publicView/getSortOrder',
    sortField: 'publicView/getSortField',
    resourceTypes: 'publicView/resourceTypes',
    selected: 'publicView/getSelected',
    selectedOrganisationalUnit: 'tree/selected',
    total: 'publicView/getTotal',
    userIsLoggedIn: 'user/isAuthorized',
    userFisPersid: 'user/fisPersid',
    orgaDescription: 'publicView/getOuDescription',
    orgaDetails: 'publicView/getOuDetails',
    rootQueryType: 'publicView/getRootQueryType'
  }), {
    orcidLink: function orcidLink() {
      return "https://orcid.org" + '/' + this.orcid;
    },

    activeTab: {
      get: function get() {
        return this.$store.getters['publicView/getActiveTab'];
      },
      set: function set(activeTab) {
        var _this = this;

        var params = this.$router.currentRoute.params;
        var query = this.$router.currentRoute.query;
        this.$store.dispatch('publicView/setActiveTab', activeTab).then(function () {
          _this.resourceTypes.forEach(function (resourceType, idx) {
            if (activeTab === idx) {
              params['resourceType'] = resourceType.type;
              _this.$router.replace({ name: 'public', params: params, query: query });
            }
          });
        });
      }
    },
    leurisProfileBaseUrl: function leurisProfileBaseUrl() {
      return '/profilseite';
    },

    showOrgaTree: {
      get: function get() {
        return this.$store.getters['publicView/getShowOrgaTree'];
      },
      set: function set(show) {
        // show persons
        return this.$store.dispatch('publicView/setShowOrgaTree', show);
      }
    },
    activeResource: function activeResource() {
      return this.resourceTypes[this.activeTab];
    },
    isCompactView: function isCompactView() {
      if (this.$route.meta.compact || this.$route.query.compact === true || this.$route.query.compact === 'true') {
        return true;
      } else if (this.$route.query.compact === null) {
        return false;
      } else {
        return false;
      }
    },
    qaShareSettings: function qaShareSettings() {
      return {
        compact: true,
        queryParams: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.filter[this.activeResource.type].filter, {
          sortOrder: this.sortOrder,
          sortField: this.sortField,
          lang: this.currentLocale
        })
      };
    }
  }),
  methods: {
    hasActiveFilter: function hasActiveFilter(resourceType) {
      var _this2 = this;

      var active = false;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filter[resourceType].filter).length > 0) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filter[resourceType].filter).some(function (filterKey) {
          var value = _this2.filter[resourceType].filter[filterKey];
          if (value && value.length > 0) {
            active = true;
          }
        });
      }
      return active;
    },
    setRoute: function setRoute(type, id) {
      var to = {
        name: 'public',
        params: {
          type: type,
          id: id,
          resourceType: this.activeResource.type
        }
      };

      if (this.isCompactView) {
        to.query = {
          compact: true
        };
      }
      this.$router.replace(to);
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    setInterval(function () {
      _this3.printDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* currentDateString */])();
    }, 30 * 1000);
  },

  components: {
    'fob-entity-header': __WEBPACK_IMPORTED_MODULE_7__components_EntityHeader__["a" /* default */],
    'fob-public-select': __WEBPACK_IMPORTED_MODULE_8__components_public_PublicSelect__["a" /* default */],
    'fob-public-list-view': __WEBPACK_IMPORTED_MODULE_9__components_public_PublicListView__["a" /* default */],
    'fob-public-list-view-header': __WEBPACK_IMPORTED_MODULE_10__components_public_PublicListViewHeader__["a" /* default */],
    'fob-public-list-quick-actions': __WEBPACK_IMPORTED_MODULE_11__components_public_PublicListQuickActions__["a" /* default */]
    // BackToTop
  }
});

/***/ }),

/***/ "nceC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFieldsGeneric__ = __webpack_require__("K13K");

var ListFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ListFieldsGeneric__["a" /* default */])('Organisationseinheit');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Organisationseinheit',
  route: 'organisationseinheit',
  className: 'organisationseinheit',
  fields: [ListFields.UnsortableReference('ueberOrganisationseinheit', false), ListFields.SortableField('name', true), ListFields.SortableDate('beginn', false), ListFields.SortableDate('ende', false), ListFields.SortableField('kostenstelle', true), ListFields.UnsortableReference('orgaIdent', false), ListFields.UnsortableReference('unterOrganisationseinheiten', false), ListFields.SortableBoolean('inPubfob', true), ListFields.SortableBoolean('obsolet', true)]
});

/***/ }),

/***/ "oE11":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    fisPersid: 'aboutme/fisPersid',
    activeTab: 'aboutme/getActiveTab',
    resourceTypes: 'aboutme/resourceTypes',
    name: 'aboutme/name'
  }), {
    activeResourceType: function activeResourceType() {
      return this.resourceTypes[this.activeTab].type;
    },
    toCurrentRoute: function toCurrentRoute() {
      var to = {
        name: 'aboutme',
        params: {
          type: 'person',
          id: this.fisPersid,
          resourceType: this.activeResourceType || 'forschungsprojekt'
        }
      };
      return to;
    }
  }),
  methods: {
    loadAsyncData: function loadAsyncData() {
      this.$store.dispatch('aboutme/fetchResearchActivities', this.activeResourceType);
    },
    setFirstPage: function setFirstPage() {
      this.$store.dispatch('aboutme/setConfig', {
        resourceType: this.activeResourceType,
        property: 'page',
        value: 1
      });
    }
  }
});

/***/ }),

/***/ "oOhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMeListSort_vue__ = __webpack_require__("mYlC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_398cc542_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutMeListSort_vue__ = __webpack_require__("JrBN");
function injectStyle (ssrContext) {
  __webpack_require__("Xcjk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMeListSort_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_398cc542_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutMeListSort_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oSjT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_DateTimeHelper__ = __webpack_require__("5W2G");


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_DateTimeHelper__["a" /* default */]],
  methods: {
    getOrgaDuration: function getOrgaDuration(orgaDetails) {
      if (orgaDetails.begin && orgaDetails.end) {
        return '(' + this.asDate(orgaDetails.begin) + ' - ' + this.asDate(orgaDetails.end) + ')';
      } else if (orgaDetails.begin) {
        return '(' + this.$gettext('Organisationseinheit.list.column.beginn').toLowerCase() + ' ' + this.asDate(orgaDetails.begin) + ')';
      } else if (orgaDetails.end) {
        return '(' + this.$gettext('Organisationseinheit.list.column.ende').toLowerCase() + ' ' + this.asDate(orgaDetails.end) + ')';
      } else {
        return '';
      }
    }
  },
  computed: {
    currentLocale: function currentLocale() {
      return this.$language.current.substring(0, 2).toLowerCase();
    }
  }
});

/***/ }),

/***/ "okCn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"datewrapper",staticClass:"nullable-date-picker",class:{ invalid: _vm.invalid }},[_c('div',{staticStyle:{"width":"18ch","position":"relative"}},[_c('b-datepicker',{ref:"nullableDate",attrs:{"placeholder":_vm.placeholder,"icon":"calendar","locale":"de-DE","readonly":false},on:{"input":_vm.emitInput},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},[_c('button',{staticClass:"button is-aquamarine",attrs:{"outlined":""},on:{"click":_vm.nullDate}},[_vm._v("\n        "+_vm._s(_vm.placeholder)+"\n      ")])]),_vm._v(" "),(_vm.invalid)?_c('span',{staticClass:"custom-icon has-text-danger"},[_c('i',{staticClass:"fa fa-exclamation-circle fa-lg"})]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oz0I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicListView_vue__ = __webpack_require__("lHMy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b089286_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicListView_vue__ = __webpack_require__("Ur8k");
function injectStyle (ssrContext) {
  __webpack_require__("kHs5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicListView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b089286_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicListView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pBfg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pLHl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__ = __webpack_require__("9fz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Person__ = __webpack_require__("Cfye");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FieldsGeneric__ = __webpack_require__("WWW9");





var Fields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__FieldsGeneric__["a" /* default */])('Preis');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Preis',
  route: 'preis',
  className: 'preis',
  class: __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__["Preis"],
  fields: [Fields.organisationseinheit, Fields.String('namePreis'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.PrefetchedSingleReference('preisBezeichnung', 'preisBezeichnung', 'folder-open', 'beschreibung', true), {
    orderBy: 'name',
    reorder: [1, 3, 29, 30, 31, 32, 2, 33, 4, 23, 6, 10, 11, 12, 14, 15, 16, 17, 34, 35, 36, 37, 18, 22, 28, 24, 21, 19, 9, 20, 27, 26, 25, 7, 5, 13]
  }), Fields.String('vergebenDurch'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.SingleReferenceByMultiValueSearchRep('preisTraeger', 'user', __WEBPACK_IMPORTED_MODULE_2__Person__["a" /* default */], false)), {
    label: 'Preis.form.hatPreisgeld',
    field: 'hatPreisgeld',
    type: 'select',
    translatable: true,
    values: [{
      value: true,
      label: 'Preis.hatPreisgeld.TRUE'
    }, {
      value: false,
      label: 'Preis.hatPreisgeld.FALSE'
    }, {
      value: null,
      label: ''
    }]
  }, Fields.Number('verleihungsJahr')]
});

/***/ }),

/***/ "pMZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SavedViews__ = __webpack_require__("QaL/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_DynamicTitle__ = __webpack_require__("IqS5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mixins_ExternalLinkProvider__ = __webpack_require__("1/AK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_mixins_DynamicTitle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__components_mixins_ExternalLinkProvider__["a" /* default */]],
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      leurisHead: {
        inner: 'leuris:Forschungsbericht',
        complement: 'menu.start'
      },
      hasNews: false,
      news: '',
      leurisNews: {
        de: '',
        en: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])({
    userIsAuthorized: 'user/isAuthorized',
    userHasOrga: 'user/hasOrga',
    version: 'getVersion',
    serverVersion: 'getServerVersion',
    userName: 'user/name'
  }), {
    hasUpdateAvailable: function hasUpdateAvailable() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* isLowerVersion */])(this.version, this.serverVersion);
    },
    currentLocale: function currentLocale() {
      return this.$language.current.substring(0, 2).toLowerCase();
    },
    renderedRouterLinkListActivities: function renderedRouterLinkListActivities() {
      var route = this.$router.resolve({ name: 'auflisten' }, this.$route);
      var linkText = this.$gettext('menu.list');
      return '<a href="' + route.href + '">' + linkText + '</a>';
    },
    subject: function subject() {
      return encodeURIComponent('[FOB] Keine Kostenstelle: ' + this.userName);
    }
  }),
  methods: {
    dropLocalStorage: function dropLocalStorage() {
      var _this = this;

      this.$dialog.confirm({
        title: 'Browserspeicher löschen',
        message: 'Sind Sie sicher, dass Sie alle im Browser gespeicherten FOB-relevanten Einstellungen <b>löschen</b> möchten? Diese Aktion kann nicht rückgängig gemacht werden!',
        cancelText: 'Abbrechen',
        confirmText: 'Speicher leeren',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: function onConfirm() {
          // remove localstorage
          window.localStorage.removeItem('de.ul.fob');
          _this.$dialog.alert({
            message: 'Speicher geleert! Seite wird neu geladen.',
            type: 'is-danger',
            onConfirm: function onConfirm() {
              return location.reload();
            }
          });
        }
      });
    },
    reloadPage: function reloadPage() {
      window.location.reload(true);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var news = [__WEBPACK_IMPORTED_MODULE_8_axios___default.a.get('/static/news/news_de.html').then(function (res) {
      return res.data;
    }).catch(function () {
      return '';
    }), __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get('/static/news/news_en.html').then(function (res) {
      return res.data;
    }).catch(function () {
      return '';
    })];

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(news).then(function (_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          newsDe = _ref2[0],
          newsEn = _ref2[1];

      _this2.leurisNews = {
        de: newsDe,
        en: newsEn
      };
      _this2.hasNews = _this2.leurisNews[_this2.currentLocale] !== '';
      _this2.news = _this2.leurisNews[_this2.currentLocale];
    });
  },

  watch: {
    currentLocale: function currentLocale() {
      this.hasNews = this.leurisNews[this.currentLocale] !== '';
      this.news = this.leurisNews[this.currentLocale];
    }
  },
  components: {
    'fob-saved-views': __WEBPACK_IMPORTED_MODULE_3__components_SavedViews__["a" /* default */]
  }
});

/***/ }),

/***/ "pRin":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",staticStyle:{"margin":"0 !important","max-width":"100% !important","width":"100% !important"}},[_c('b-loading',{attrs:{"is-full-page":false,"active":_vm.loading},on:{"update:active":function($event){_vm.loading=$event}}}),_vm._v(" "),_c('b-table',{key:_vm.resourceType,attrs:{"data":_vm.data,"backend-sorting":"","default-sort-direction":_vm.defaultSortOrder,"default-sort":[_vm.sortField, _vm.sortOrder]},on:{"sort":_vm.updateSorting},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b-table-column',{attrs:{"field":"id","label":"ID","sortable":""}},[_vm._v("\n        "+_vm._s(props.row._id)+"\n      ")]),_vm._v(" "),_c('b-table-column',{staticClass:"button-column"},[_c('b-field',{attrs:{"addon":""}},[_c('router-link',{staticClass:"control",attrs:{"to":{ name: _vm.entityDetailsRoute,
                  params: {
                    resourceType: props.row._entityName.split('.').splice(-1)[0].toLowerCase(),
                    resourceId: props.row._id
                  }
                }}},[_c('b-tooltip',{attrs:{"square":"","position":"is-top","label":_vm.$gettext('component.entity.list.table.details')}},[_c('b-icon',{attrs:{"icon":"search","type":"is-aquamarine"}})],1)],1),_vm._v(" "),_c('router-link',{staticClass:"control",attrs:{"to":{ name: _vm.entityEditRoute,
                  params: {
                    resourceType: props.row._entityName.split('.').splice(-1)[0].toLowerCase(),
                    resourceId: props.row._id
                  }
                }}},[(_vm.userCanEditByKostenstelle(props.row))?_c('b-tooltip',{attrs:{"square":"","position":"is-top","label":_vm.$gettext('component.entity.list.table.edit')}},[_c('b-icon',{attrs:{"icon":"edit","type":"is-aquamarine"}})],1):_vm._e()],1)],1)],1),_vm._v(" "),_vm._l((_vm.tableFields),function(bit){return _c('b-table-column',{key:bit.key || bit.field,attrs:{"label":_vm.$gettext(bit.label),"visible":bit.tableVisible,"field":bit.sortField ? bit.sortField : bit.field,"sortable":bit.sortable}},[_c('fob-entity-value',{attrs:{"bit":bit,"resourceData":props.row[bit.field],"plain":bit.plain,"linkNested":bit.linkNested}})],1)})]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pl+S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity__ = __webpack_require__("9fz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ExterneOrganisation__ = __webpack_require__("Vu0z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AbstractPerson__ = __webpack_require__("BP7K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Person__ = __webpack_require__("Cfye");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Land__ = __webpack_require__("eFxi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Organisationseinheit__ = __webpack_require__("tTX3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FieldsGeneric__ = __webpack_require__("WWW9");








var Fields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__FieldsGeneric__["a" /* default */])('Patent');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Patent',
  route: 'patent',
  className: 'patent',
  class: __WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity__["Patent"],
  entityName: 'de.ul.fob.domain.Patent',
  fields: [Fields.organisationseinheit, Fields.String('titel'), Fields.String('veroeffentlichungsnummer'), Fields.Date('datumDerPrioritaetsbegruendendenErstanmeldung'), {
    label: 'Patent.form.haupterfinder',
    field: 'haupterfinder',
    schema: __WEBPACK_IMPORTED_MODULE_2__AbstractPerson__["a" /* default */],
    finder: {
      name: 'byMultiValueSearchRep',
      multiValue: true,
      minLength: 3
    },
    icon: 'user',
    type: 'object',
    cardinality: 'many',
    render: 'stringRep'
  }, {
    label: 'Patent.form.anmelderExtern',
    singularLabel: 'Organisationseinheit',
    field: 'anmelderExtern',
    type: 'object',
    render: 'stringRep',
    icon: 'sitemap',
    cardinality: 'many',
    method: 'bySearchRepLike',
    schema: __WEBPACK_IMPORTED_MODULE_1__ExterneOrganisation__["a" /* default */],
    finder: {
      name: 'bySearchRepLike',
      multiValue: false,
      minLength: 0
    },
    allowCreate: true
  }, {
    label: 'Patent.form.anmelderIntern',
    singularLabel: 'Organisationseinheit',
    field: 'anmelderIntern',
    type: 'object',
    render: 'stringRep',
    icon: 'sitemap',
    cardinality: 'many',
    method: 'bySearchRepLike',
    schema: __WEBPACK_IMPORTED_MODULE_5__Organisationseinheit__["a" /* default */],
    finder: {
      name: 'bySearchRepLikeUnrestricted',
      multiValue: false,
      minLength: 0
    },
    allowCreate: true
  }, Fields.Text('lizenzen', 6000), Fields.URL('link'), Fields.String('forschungsgebiet'), Fields.Text('kurzbeschreibung', 6000), {
    label: 'Patent.form.ansprechpartner',
    field: 'ansprechpartner',
    schema: __WEBPACK_IMPORTED_MODULE_3__Person__["a" /* default */],
    icon: 'user',
    type: 'object',
    cardinality: 'single',
    render: 'stringRep',
    allowCreate: true,
    finder: {
      name: 'byMultiValueSearchRep',
      multiValue: true,
      minLength: 3
    }
  }, {
    label: 'Patent.form.land',
    field: 'land',
    schema: __WEBPACK_IMPORTED_MODULE_4__Land__["a" /* default */],
    icon: 'globe',
    type: 'object',
    cardinality: 'many',
    render: 'stringRep',
    allowCreate: false,
    finder: {
      name: 'byMultiValueSearchRep',
      multiValue: true,
      minLength: 2
    }
  }]
});

/***/ }),

/***/ "pmQV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__ = __webpack_require__("cigy");

var Filter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__["a" /* default */])('AbstractPerson');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Externe Person',
  route: 'abstractperson',
  fields: [Filter.String('vorname'), Filter.String('name'), Filter.String('personIdentWert')]
});

/***/ }),

/***/ "pwjD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_DateTimeHelper__ = __webpack_require__("5W2G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_EntityValue__ = __webpack_require__("YRcE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-projektleiter',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_DateTimeHelper__["a" /* default */]],
  components: {
    'fob-entity-value': __WEBPACK_IMPORTED_MODULE_1__components_EntityValue__["a" /* default */]
  },
  data: function data() {
    return {
      bit: {
        type: 'object',
        render: 'stringRep'
      }
    };
  },

  props: {
    resourceData: {
      type: Array
    },
    isPublic: {
      type: Boolean,
      default: true
    },
    linkProvider: {
      type: Function,
      default: function _default(data) {
        var type = data._entityName.split('.').splice(-1)[0].toLowerCase();
        return {
          name: 'anzeigen_einzeln',
          params: {
            resourceType: type,
            resourceId: data._id
          }
        };
      }
    }
  }
});

/***/ }),

/***/ "q+oM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fob-public-view"},[_c('div',{staticClass:"columns",staticStyle:{"margin-left":"0","margin-right":"0"}},[(!_vm.isCompactView)?_c('div',{staticClass:"column fob-hide-in-print",staticStyle:{"max-width":"400px"}},[(!_vm.isCompactView)?_c('div',{staticClass:"level fob-hide-in-print",staticStyle:{"padding-top":"5px"}},[_c('div',{staticClass:"field"},[_c('b-switch',{attrs:{"type":"is-switch-grey","size":"is-small"},model:{value:(_vm.showOrgaTree),callback:function ($$v) {_vm.showOrgaTree=$$v},expression:"showOrgaTree"}},[_c('translate',[_vm._v("Public.switch.ou.person")]),_vm._v(" "),_c('translate',{staticClass:"is-italic",class:{ 'has-text-weight-bold': !_vm.showOrgaTree }},[_vm._v("\n              Person\n            ")]),_vm._v(" "),_c('translate',[_vm._v("und")]),_vm._v(" "),_c('translate',{staticClass:"is-italic",class:{ 'has-text-weight-bold': _vm.showOrgaTree }},[_vm._v("\n              Organisationseinheit\n            ")])],1)],1)]):_vm._e(),_vm._v(" "),_c('fob-public-select',{attrs:{"type":_vm.showOrgaTree ? 'ou' : 'person'}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column"},[_c('fob-public-list-view-header',[_c('template',{slot:"heading"},[_vm._v("\n          "+_vm._s(_vm.label)+"\n        ")]),_vm._v(" "),(_vm.rootQueryType === 'organisationalUnit')?[_c('template',{slot:"subheading"},[(_vm.getOrgaDuration(_vm.orgaDetails))?_c('div',[_vm._v("\n              "+_vm._s(_vm.getOrgaDuration(_vm.orgaDetails))+"\n            ")]):_vm._e()]),_vm._v(" "),_c('template',{slot:"description"},[(_vm.orgaDescription)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.orgaDescription[_vm.currentLocale])}}):_vm._e()])]:_vm._e(),_vm._v(" "),(_vm.rootQueryType === 'person')?[_c('template',{slot:"subheading"},[(_vm.leurisProfile && _vm.orcid)?[_c('div',{staticClass:"is-size-6"},[_c('a',{attrs:{"href":"https://orcid.org","target":"_blank"}},[_c('img',{attrs:{"width":"16","height":"16","hspace":"4","vspace":"3","src":__webpack_require__("tNDU")}})]),_vm._v(" "),_c('a',{attrs:{"href":_vm.orcidLink,"target":"_blank"}},[_vm._v("\n                  "+_vm._s(_vm.orcidLink)+"\n                ")])])]:_vm._e(),_vm._v(" "),(_vm.ulWebsiteProfile[_vm.currentLocale])?_c('div',{staticStyle:{"margin":"4px 0 8px 4px"}},[_c('a',{attrs:{"href":_vm.ulWebsiteProfile[_vm.currentLocale],"target":"_blank"}},[_c('b-icon',{staticStyle:{"margin-right":"4px"},attrs:{"icon":"sign-in","size":"is-small"}}),_vm._v(" "),_c('translate',[_vm._v("UL Profile Link")])],1)]):_vm._e()],2),_vm._v(" "),_c('template',{slot:"description"},[(_vm.leurisProfile || _vm.leurisProfileFisPersid)?_c('div',[(_vm.leurisProfile)?[_c('div',{domProps:{"innerHTML":_vm._s(_vm.leurisProfile.abstract[_vm.currentLocale])}})]:_vm._e(),_vm._v(" "),(_vm.userIsLoggedIn && (_vm.leurisProfileFisPersid === _vm.userFisPersid))?[(_vm.leurisProfile == null || (_vm.leurisProfile && !_vm.leurisProfile.abstract[_vm.currentLocale]))?_c('div',[_c('em',[_c('translate',[_vm._v("LeurisProfile.abstract.empty")])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"1rem 0 1rem 0"}},[_c('b-icon',{staticStyle:{"margin-right":"0.25rem"},attrs:{"icon":"pencil","size":"is-small"}}),_vm._v(" "),_c('a',{attrs:{"href":(_vm.leurisProfileBaseUrl + "/" + _vm.leurisProfileFisPersid + "/drafts/abstract")}},[_c('translate',[_vm._v("LeurisProfile.abstract.edit")])],1)],1)]:_vm._e()],2):_vm._e()])]:_vm._e(),_vm._v(" "),_c('template',{slot:"quick-actions"},[_c('fob-public-list-quick-actions',{attrs:{"qa-share":_vm.qaShareSettings,"qa-print":true,"qa-export":true}})],1)],2),_vm._v(" "),_c('div',[_c('span',{staticClass:"fob-only-for-print-view is-size-7",staticStyle:{"margin-top":"20px"}},[_c('translate',[_vm._v(_vm._s(_vm.activeResource.label))])],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('b-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},_vm._l((_vm.resourceTypes),function(resourceType){return _c('b-tab-item',{key:resourceType.type,staticStyle:{"flex":"0 0 auto"},attrs:{"disabled":resourceType.disabled}},[_c('template',{slot:"header"},[_c('span',{class:{'fob-is-filtered': _vm.hasActiveFilter(resourceType.type)}},[_c('translate',[_vm._v(_vm._s(resourceType.label))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(("(" + (_vm.total[resourceType.type]) + ")")))])],1)]),_vm._v(" "),(!resourceType.disabled)?_c('div',[_c('fob-public-list-view',{staticStyle:{"height":"100%"},attrs:{"resource-type":resourceType.type}})],1):_vm._e()],2)}))],1)],1)]),_vm._v(" "),_c('div',{staticClass:"print-footer"},[_c('span',[_c('translate',{attrs:{"translate-params":{printDate: _vm.printDate}}},[_vm._v("details.printedOn")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q4Jw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__ = __webpack_require__("9fz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Organisationseinheit__ = __webpack_require__("tTX3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FieldsGeneric__ = __webpack_require__("WWW9");





var Fields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__FieldsGeneric__["a" /* default */])('AppUser');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'App User',
  route: 'appuser',
  className: 'appUser',
  class: __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__["AppUser"],
  fields: [Fields.String('userName'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.UneditableDate('lastLogin'), {
    inEditView: false
  }), Fields.SimpleMultiReference('applicationRoles', 'folder-open', {
    route: 'approle',
    className: 'appRole',
    fields: [{
      field: 'name',
      table: true
    }]
  }), Fields.UneditableSimpleMultiReference('organisationseinheiten', 'sitemap', __WEBPACK_IMPORTED_MODULE_2__Organisationseinheit__["a" /* default */], false), Fields.SimpleMultiReference('zstzlOrganisationseinheiten', 'sitemap', __WEBPACK_IMPORTED_MODULE_2__Organisationseinheit__["a" /* default */], false), {
    label: 'AppUser.form.forscher',
    field: 'forscher',
    type: Boolean
  }]
});

/***/ }),

/***/ "qDbP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_LEURIS_PROFILE", function() { return SET_LEURIS_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_RESEARCH_ACTIVITY_AS_FAVOURITE", function() { return SET_RESEARCH_ACTIVITY_AS_FAVOURITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_FISPERSID", function() { return SET_FISPERSID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_NAME", function() { return SET_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IS_LOADING", function() { return IS_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOADING_DONE", function() { return LOADING_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE_PAGE", function() { return CHANGE_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ACTIVE_TAB", function() { return SET_ACTIVE_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CONFIG", function() { return SET_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DATA", function() { return SET_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TOTAL", function() { return SET_TOTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE_PER_PAGE", function() { return CHANGE_PER_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_RESOURCE_TYPE", function() { return SET_RESOURCE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SORT_FIELD", function() { return SET_SORT_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SORT_ORDER", function() { return SET_SORT_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_FILTER", function() { return UPDATE_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET", function() { return RESET; });
var SET_LEURIS_PROFILE = function SET_LEURIS_PROFILE(state, data) {
  state.leurisProfile = data;
};

var SET_RESEARCH_ACTIVITY_AS_FAVOURITE = function SET_RESEARCH_ACTIVITY_AS_FAVOURITE(state, data) {
  state.favouredResearchActivity = data;
};

var SET_FISPERSID = function SET_FISPERSID(state, fisPersid) {
  state.fisPersid = fisPersid;
};

var SET_NAME = function SET_NAME(state, name) {
  state.name = name;
};

var IS_LOADING = function IS_LOADING(state, loadingState) {
  state.loading = loadingState || false;
};

var LOADING_DONE = function LOADING_DONE(state) {
  state.loading = false;
};

var CHANGE_PAGE = function CHANGE_PAGE(state, _ref) {
  var resourceType = _ref.resourceType,
      page = _ref.page;

  state.config[resourceType].page = page;
};

var SET_ACTIVE_TAB = function SET_ACTIVE_TAB(state, activeTab) {
  state.activeTab = activeTab;
};

var SET_CONFIG = function SET_CONFIG(state, _ref2) {
  var resourceType = _ref2.resourceType,
      property = _ref2.property,
      value = _ref2.value;

  state.config[resourceType][property] = value;
};

var SET_DATA = function SET_DATA(state, _ref3) {
  var resourceType = _ref3.resourceType,
      data = _ref3.data;

  state.data[resourceType] = data;
};

var SET_TOTAL = function SET_TOTAL(state, _ref4) {
  var resourceType = _ref4.resourceType,
      total = _ref4.total;

  state.total[resourceType] = total;
};

var CHANGE_PER_PAGE = function CHANGE_PER_PAGE(state, _ref5) {
  var resourceType = _ref5.resourceType,
      perPage = _ref5.perPage;

  state.config[resourceType].perPage = perPage;
};

var SET_RESOURCE_TYPE = function SET_RESOURCE_TYPE(state, type) {
  state.resourceType = type;
};

var SET_SORT_FIELD = function SET_SORT_FIELD(state, _ref6) {
  var resourceType = _ref6.resourceType,
      sortField = _ref6.sortField;

  state.config[resourceType].sortField = sortField;
};

var SET_SORT_ORDER = function SET_SORT_ORDER(state, _ref7) {
  var resourceType = _ref7.resourceType,
      sortOrder = _ref7.sortOrder;

  state.config[resourceType].sortOrder = sortOrder;
};

var UPDATE_FILTER = function UPDATE_FILTER(state, updatedFilter) {
  state.filter[state.resourceType] = updatedFilter;
};

var RESET = function RESET(state) {
  state.leurisProfile = null;
  state.fisPersid = null;
  state.name = null;

  // reset total
  state.total = {
    forschungsprojekt: 0,
    kooperation: 0,
    publikation: 0,
    veranstaltung: 0,
    preis: 0
    // reset data
  };state.data = {
    forschungsprojekt: [],
    kooperation: [],
    publikation: [],
    veranstaltung: [],
    preis: []
    // reset config
  };state.filter = {
    forschungsprojekt: {
      filter: {},
      filters: [{ type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } }, { type: 'select', value: 'status', label: 'Public.filter.status', options: ['ONGOING', 'TERMINATED'] }, { type: 'input', value: 'funding', label: 'Public.filter.mittelgeber', icon: 'credit-card' }, { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' }, { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }]
    },
    kooperation: {
      filter: {},
      filters: [{ type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } }, { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' }, { type: 'input', value: 'externalPartner', label: 'Public.filter.externalPartner', icon: 'globe' }, { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }]
    },
    publikation: {
      filter: {},
      filters: [{ type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } }, { type: 'select', value: 'category', label: 'Public.filter.publikationstypen', options: ['ARTICLE', 'MONOGRAPHY', 'EDITORSHIP', 'CONTRIBUTION', 'REPORT'] }, { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' }, { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }]
    },
    veranstaltung: {
      filter: {},
      filters: [{ type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } }, { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' }, { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }]
    },
    preis: {
      filter: {},
      filters: [{ type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } }, { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' }, { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }]
    }
    // reset config
  };state.config = {
    forschungsprojekt: {
      page: 1,
      perPage: 10,
      sortField: 'START_DATE',
      sortFields: [
      // { field: 'TITLE_DE', label: 'Public.sort.titel', locale: 'de' },
      // { field: 'TITLE_EN', label: 'Public.sort.titel', locale: 'en' },
      { field: 'START_DATE', label: 'Public.sort.beginn' }],
      sortOrder: 'DESC'
    },
    kooperation: {
      page: 1,
      perPage: 10,
      sortField: 'START_DATE',
      sortFields: [
      // { field: 'TITLE', label: 'Public.sort.titel' },
      { field: 'START_DATE', label: 'Public.sort.beginn' }],
      sortOrder: 'DESC'
    },
    publikation: {
      page: 1,
      perPage: 10,
      sortField: 'YEAR',
      sortFields: [{ field: 'TYPE', label: 'Public.sort.typ' },
      // { field: 'TITLE', label: 'Public.sort.titel' },
      { field: 'YEAR', label: 'Public.sort.jahr' }],
      sortOrder: 'DESC'
    },
    veranstaltung: {
      page: 1,
      perPage: 10,
      sortField: 'START_DATE',
      sortFields: [{ field: 'TYPE', label: 'Public.sort.typ' }, { field: 'START_DATE', label: 'Public.sort.beginn'
        // { field: 'NAME', label: 'Public.sort.name' }
      }],
      sortOrder: 'DESC'
    },
    preis: {
      page: 1,
      perPage: 10,
      sortField: 'YEAR',
      sortFields: [{ field: 'TYPE', label: 'Public.sort.typ' }, { field: 'YEAR', label: 'Public.sort.jahr' }, { field: 'AWARDEE', label: 'Public.sort.preisTraeger'
        // { field: 'NAME', label: 'Public.sort.name' }
      }],
      sortOrder: 'DESC'
    }
  };
};

/***/ }),

/***/ "qQrW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  route: 'organisationseinheit',
  fields: [{
    label: 'Name',
    field: 'name',
    type: 'string'
  }, {
    label: 'Kostenstelle',
    field: 'kostenstelle',
    type: 'string'
    // {
    //   label: 'Übergeordnete Organisationseinheit',
    //   cardinality: 'single',
    //   field: 'ueberOrganisationseinheit',
    //   type: 'object',
    //   schema: {
    //     route: 'organisationseinheit',
    //     fields: [
    //       {
    //         label: 'Name',
    //         field: 'name'
    //       },
    //       {
    //         label: 'Kostenstelle',
    //         field: 'kostenstelle'
    //       }
    //     ]
    //   },
    //   nested: false
    // }
  }]
});

/***/ }),

/***/ "qSdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__("pMZz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28a1aafd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__("Du0s");
function injectStyle (ssrContext) {
  __webpack_require__("/RB0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28a1aafd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qk16":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tree_TreeItem__ = __webpack_require__("XECV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql__ = __webpack_require__("lwCg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__axios__ = __webpack_require__("eOoE");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ('treeItem', {
  name: 'fob-tree',
  data: function data() {
    return {
      error: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    isLoading: 'tree/isLoading',
    rootData: 'tree/rootData'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    'saveRootData': 'tree/saveRootData',
    'startLoading': 'tree/startLoading',
    'stopLoading': 'tree/stopLoading'
  }), {
    loadAsyncData: function loadAsyncData() {
      var _this = this;

      this.startLoading();
      this.loadingMsg = 'tree.loading';
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__axios__["a" /* graphql */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__graphql__["j" /* fetchOuQuery */])(1)).then(function (response) {
        _this.saveRootData(response.data.data.organisationalUnit);
        _this.stopLoading();
        _this.error = false;
      }).catch(function () {
        _this.stopLoading();
        _this.error = true;
      });
    }
  }),
  created: function created() {
    if (!this.rootData.children) {
      this.loadAsyncData();
    }
  },

  components: {
    'fob-tree-item': __WEBPACK_IMPORTED_MODULE_1__components_tree_TreeItem__["a" /* default */]
  }
});

/***/ }),

/***/ "r0gj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__ = __webpack_require__("cigy");

var Filter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__["a" /* default */])('Organisationseinheit');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Person',
  route: 'person',
  fields: [Filter.ReferenceByMultiValueSearchRep('ueberOrganisationseinheit', 'sitemap', 'organisationseinheit'), Filter.String('name'), Filter.String('kostenstelle'), {
    label: 'Organisationseinheit.list.filter.inPubfob',
    field: 'inPubfob',
    type: 'select',
    translatable: true,
    values: [{
      value: 'TRUE',
      label: 'Organisationseinheit.inPubfob.TRUE'
    }, {
      value: 'FALSE',
      label: 'Organisationseinheit.inPubfob.FALSE'
    }]
  }]
});

/***/ }),

/***/ "riDJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rwyJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityCompactCyan_vue__ = __webpack_require__("JqIW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ee48e2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityCompactCyan_vue__ = __webpack_require__("3bPL");
function injectStyle (ssrContext) {
  __webpack_require__("bBfD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityCompactCyan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ee48e2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityCompactCyan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s17A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);


var isAtLeast = function isAtLeast(field) {
  return function (to, vm) {
    var from = vm[field];
    if (to && from) {
      return from <= to;
    } else {
      return true;
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  ueberOrganisationseinheit: {
    name: {
      required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
      minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1)
    }
  },
  name: {
    required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
    minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1)
  },
  ende: {
    isAtLeast: isAtLeast('beginn')
  },
  kostenstelle: {
    required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
  }
});

/***/ }),

/***/ "s21u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__ = __webpack_require__("9fz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldsGeneric__ = __webpack_require__("WWW9");




var Fields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__FieldsGeneric__["a" /* default */])('PubIdentTyp');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'PubIdentTyp',
  route: 'pubIdentTyp',
  class: __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__["PubIdentTyp"],
  className: 'pubIdentTyp',
  fields: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.String('kennung'), {
    table: true
  }), Fields.String('anmerkung')]
});

/***/ }),

/***/ "sCuL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityEdit_vue__ = __webpack_require__("d2ya");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_164ee81c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityEdit_vue__ = __webpack_require__("z1hL");
function injectStyle (ssrContext) {
  __webpack_require__("aGWv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_164ee81c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sDBV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_EntityValue__ = __webpack_require__("YRcE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_EntityCreateModal__ = __webpack_require__("tyB9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_EntityDecorator__ = __webpack_require__("vlR/");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-entity-table-select',
  data: function data() {
    return {
      justSelected: null,
      created: null,
      showCreateModal: false,
      tableQuery: '',
      isFetching: false,
      tableContent: [],
      selectedContent: this.value || []
    };
  },

  props: {
    route: String,
    field: String,
    method: Object,
    schema: Object,
    allowCreate: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a,
    'fob-entity-value': __WEBPACK_IMPORTED_MODULE_5__components_EntityValue__["a" /* default */],
    'fob-entity-create-modal': __WEBPACK_IMPORTED_MODULE_6__components_form_EntityCreateModal__["a" /* default */],
    'fob-entity-decorator': __WEBPACK_IMPORTED_MODULE_7__components_EntityDecorator__["a" /* default */]
  },
  methods: {
    prepareCreation: function prepareCreation() {
      var Constructor = this.schema.class;
      this.created = new Constructor({
        _id: '__' + Date.now()
      });
      this.showCreateModal = true;
    },
    submitCreated: function submitCreated() {
      var Constructor = this.schema.class;
      var newPerson = new Constructor(this.created);
      newPerson._stringRep = this.schema.preliminaryStringRep(newPerson);
      this.selectedContent.push(newPerson);
      this.$emit('input', this.selectedContent);
    },
    dropRow: function dropRow(theid) {
      this.selectedContent = this.selectedContent.filter(function (item) {
        return item._id !== theid;
      });
      this.$emit('input', this.selectedContent);
    },
    selectRow: function selectRow(theid) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result, rightCol;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = _this.tableContent.find(function (data) {
                  return data._id === theid;
                });

                if (_this.selectedContent.includes(result)) {
                  _context.next = 9;
                  break;
                }

                _this.selectedContent.push(result);
                _this.$emit('input', _this.selectedContent);
                _this.justSelected = theid;
                _context.next = 7;
                return _this.$nextTick();

              case 7:
                rightCol = document.querySelector('#right-col-selection');

                rightCol.scrollTop = rightCol.scrollHeight - rightCol.clientHeight;

              case 9:

                // if filteredTableContent length is 1,
                // then reset input (correct empty table message)
                if (_this.filteredTableContent.length === 0) {
                  _this.tableQuery = '';
                }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    queryForTable: function queryForTable() {
      var _this2 = this;

      if (this.tableQuery.length >= this.method.minLength) {
        this.isFetching = true;
        var param = void 0;
        if (this.method.multiValue) {
          param = this.tableQuery.split(/\s+/).filter(function (x) {
            return x !== '';
          });
        } else {
          param = this.tableQuery;
        }

        var opts = this.method.opts || {};

        this.autocomplete(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ rep: param }, opts)).then(function (result) {
          // optional chaining `result?.data` not supported
          var data = result ? result.data : null;

          if (_this2.data && _this2.data.length === 0) {
            _this2.tableContent = [];
          } else if (data) {
            _this2.tableContent = data;
          } else {
            _this2.tableContent = [];
          }
          _this2.isFetching = false;
        }, function (response) {
          _this2.isFetching = false;
        });
      }
    }
  },
  mounted: function mounted() {
    this.$refs.input.focus();
    // if minlength is set to zero on start,
    // trigger fetching available data and show it on table
    this.queryForTable();
  },

  computed: {
    tableColumns: function tableColumns() {
      if (this.schema) {
        if (this.schema.tableSelectColumns) {
          return this.schema.tableSelectColumns;
        }
        return this.schema.fields.filter(function (x) {
          return x.table === true;
        });
      } else {
        return [{
          field: '_id',
          label: 'ID',
          width: '50'
        }, {
          field: 'vorname',
          label: 'Vorname',
          width: '200'
        }, {
          field: 'name',
          label: 'Nachame',
          width: '200'
        }];
      }
    },
    entityName: function entityName() {
      return this.schema.className[0].toUpperCase() + this.schema.className.slice(1);
    },
    autocomplete: function autocomplete() {
      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].methods.autocomplete(this.route, this.method.name);
    },
    filteredTableContent: function filteredTableContent() {
      var _this3 = this;

      return this.tableContent.filter(function (item) {
        return !_this3.selectedContent.some(function (selected) {
          return item._id === selected._id;
        });
      });
    },
    filteredDataArray: function filteredDataArray() {
      var _this4 = this;

      return this.arrayExample.data.filter(function (option) {
        return option.toString().toLowerCase().indexOf(_this4.arrayExample.name.toLowerCase()) >= 0;
      });
    }
  }
});

/***/ }),

/***/ "sGAB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityHeader_vue__ = __webpack_require__("85W9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_621b32f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityHeader_vue__ = __webpack_require__("5krH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_621b32f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sM6F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) },
  finSchluessel: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) }
});

/***/ }),

/***/ "sY2r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntitySelectPrefetched_vue__ = __webpack_require__("Zqee");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0370e46a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntitySelectPrefetched_vue__ = __webpack_require__("jo7G");
function injectStyle (ssrContext) {
  __webpack_require__("MwCT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntitySelectPrefetched_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0370e46a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntitySelectPrefetched_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "scTh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_form_EntityCreateModal__ = __webpack_require__("tyB9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_form_Label__ = __webpack_require__("i8BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_EntityDecorator__ = __webpack_require__("vlR/");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-entity-select',
  components: {
    'fob-entity-create-modal': __WEBPACK_IMPORTED_MODULE_2__components_form_EntityCreateModal__["a" /* default */],
    'fob-entity-decorator': __WEBPACK_IMPORTED_MODULE_4__components_EntityDecorator__["a" /* default */],
    'fob-label': __WEBPACK_IMPORTED_MODULE_3__components_form_Label__["a" /* default */]
  },
  data: function data() {
    return {
      justEmptied: false,
      selectModel: {
        data: [],
        displayName: this.value ? this.value._stringRep : '',
        isFetching: false
      },
      lastSelected: null,
      created: null,
      showCreateModal: false
    };
  },

  props: {
    route: String,
    schema: Object,
    type: String,
    allowCreate: {
      type: Boolean,
      default: true
    },
    method: Object,
    label: String,
    asterisk: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    extraButton: Object,
    value: {
      type: Object,
      default: function _default() {
        return {
          name: ''
        };
      }
    }
  },
  computed: {
    autocomplete: function autocomplete() {
      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].methods.autocomplete(this.route, this.method.name);
    },
    derivedType: function derivedType() {
      if (this.value != null && this.value.name !== undefined && this.value.name !== '') {
        return 'is-success';
      } else {
        return this.type;
      }
    }
  },
  mounted: function mounted() {
    this.lastSelected = this.value;
    /*
    When the input field of the b-autocomplete is changed, the
    `selected` attribute will be set to `null`. If this is a an actual
    change (e.g. from some value to null), the `select` event will be
    triggered.
     If we set a value when mounting the component, the `selected`
    attribute is not set automatically and hence the `select` event
    will not be triggered when changing the value. This code
    circumvents this behaviour.
    */
    if (this.value) {
      this.$refs.select.setSelected(this.value);
    }
  },

  watch: {
    value: function value() {
      // needed to update field when value is set by changing value
      this.$refs.select.setSelected(this.value);
    }
  },
  methods: {
    prepareCreation: function prepareCreation() {
      if (this.created == null) {
        var Constructor = this.schema.class;
        this.created = new Constructor({
          _id: '__' + Date.now(),
          _entityName: 'de.ul.fob.domain.AbstractPerson'
        });
      }
      this.showCreateModal = true;
    },
    submitCreated: function submitCreated() {
      // avoid direct wiring of person in create modal and data in select
      var Constructor = this.schema.class;
      var newPerson = new Constructor(this.created);
      newPerson._stringRep = this.schema.preliminaryStringRep(newPerson);
      this.selectModel.data = [newPerson];
      this.$refs.select.setSelected(newPerson);
      this.showCreateModal = false;
      this.emitChange(newPerson);
    },
    emitChange: function emitChange(option) {
      if (this.lastSelected !== option) {
        if (option) {
          this.$emit('input', option);
          this.lastSelected = option;
        } else {
          this.$emit('input', null);
          this.lastSelected = null;
        }
      }
    },
    emptyField: function emptyField() {
      this.justEmptied = true;
      this.created = null;
      this.$emit('input', { name: '' });
      this.selectModel.displayName = '';
    },
    clicked: function clicked() {
      if (!this.$refs.select.isActive) {
        this.getAsyncData();
      }
    },
    getAsyncData: function getAsyncData(currentDisplayName) {
      var _this = this;

      if (!this.justEmptied) {
        if (this.value === null || this.value.name === '' || currentDisplayName != null && currentDisplayName !== this.value._stringRep) {
          if (this.method.minLength === 0 || currentDisplayName != null && currentDisplayName.length >= this.method.minLength) {
            var param = void 0;
            if (this.method.multiValue) {
              if (currentDisplayName != null) {
                param = currentDisplayName.split(/\s+/).filter(function (x) {
                  return x !== '';
                });
              } else {
                param = '';
              }
            } else {
              param = currentDisplayName || '';
            }

            var opts = this.method.opts || {};

            this.selectModel.data = [];
            this.selectModel.isFetching = true;
            this.autocomplete(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ rep: param }, opts)).then(function (_ref) {
              var data = _ref.data;

              data.forEach(function (item) {
                _this.selectModel.data.push(item);
              });
              _this.selectModel.isFetching = false;
              _this.$refs.select.isActive = true;
            }, function (response) {
              _this.selectModel.isFetching = false;
            });
          }
        }
      } else {
        this.selectModel.data = [];
        this.justEmptied = false;
      }
    }
  }
});

/***/ }),

/***/ "snHa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debounce__ = __webpack_require__("HhAh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mixins_PublicViewHelper__ = __webpack_require__("VlMm");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-public-list-filter',
  props: ['resourceType'],
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_mixins_PublicViewHelper__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    userIsLoggedIn: 'user/isAuthorized',
    filter: 'publicView/getFilter'
  }), {
    userIsAdmin: function userIsAdmin() {
      return this.userIsLoggedIn && this.$store.getters['user/roles'].ADMIN === true;
    },
    inProject: function inProject() {
      if (this.resourceType === 'publikation') {
        return this.filter[this.resourceType].filter.inProject;
      } else {
        return false;
      }
    }
  }),
  methods: {
    onFilter: __WEBPACK_IMPORTED_MODULE_2_debounce___default()(function () {
      this.setFirstPage();
      this.loadAsyncData();
    }, 500)
  }
});

/***/ }),

/***/ "srBO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "suVi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-width":"1000px"}},[(_vm.resourceSchema)?_c('div',[(!_vm.loading)?_c('div',[_c('fob-entity-header',{staticClass:"fob-entity-header",attrs:{"type":_vm.resourceSchema.className,"title":_vm.resourceData._stringRep,"createUser":_vm.resourceData._createUser,"createDate":_vm.resourceData._createDate,"updateUser":_vm.resourceData._updateUser,"updateDate":_vm.resourceData._updateDate}}),_vm._v(" "),_c('fob-entity-details',{staticClass:"fob-entity-details",attrs:{"resourceData":_vm.resourceData,"resourceSchema":_vm.resourceSchema,"resourceId":_vm.resourceId}}),_vm._v(" "),_c('b-field',{staticClass:"fob-hide-in-print",staticStyle:{"margin-top":"40px"},attrs:{"grouped":""}},[(_vm.userCanEdit)?_c('router-link',{staticClass:"control",attrs:{"to":{
          name: 'editieren',
          params: {
            resourceType: _vm.resourceData._entityName.split('.').splice(-1)[0].toLowerCase(),
            resourceId: _vm.resourceId
          }
        }}},[_c('button',{staticClass:"control button is-primary"},[_c('b-icon',{attrs:{"pack":"fa","icon":"edit"}}),_vm._v(" "),_c('translate',[_vm._v("details.button.edit")])],1)]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"control button is-primary",on:{"click":_vm.print}},[_c('b-icon',{attrs:{"pack":"fa","icon":"print"}}),_vm._v(" "),_c('translate',[_vm._v("details.button.print")])],1),_vm._v(" "),_c('b-tooltip',{attrs:{"label":"Needs proper deduplication","position":"is-right","type":"is-danger","active":_vm.needsDeduplication}},[(_vm.userCanEdit && _vm.userIsAtLeastManager)?_c('button',{staticClass:"control button is-danger",attrs:{"disabled":_vm.needsDeduplication},on:{"click":function($event){_vm.deleteEntity()}}},[_c('b-icon',{attrs:{"pack":"fa","icon":"trash"}}),_vm._v(" "),_c('translate',[_vm._v("details.button.delete")])],1):_vm._e()])],1)],1):_vm._e()]):_c('div',{staticClass:"section",staticStyle:{"max-width":"1200px"}},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column",staticStyle:{"max-width":"50px"}},[_c('b-icon',{attrs:{"icon":"exclamation","type":"is-aquamarine","size":"is-large"}})],1),_vm._v(" "),_c('div',{staticClass:"column"},[_vm._v("\n        Hier sehen Sie alle Details zu einer einzelnen Ressource / Forschungsaktivität. Im Moment haben Sie noch\n        "),_c('strong',[_vm._v("keine")]),_vm._v(" Ressource zur Anzeige ausgewählt. Nutzen Sie dafür\n        die "),_c('router-link',{attrs:{"to":"auflisten"}},[_vm._v("Listenansicht")]),_vm._v(".\n      ")],1)])]),_vm._v(" "),_c('div',{staticClass:"print-footer"},[_c('span',[_c('translate',{attrs:{"translate-params":{printDate: _vm.printDate}}},[_vm._v("details.printedOn")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t04V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityListTable_vue__ = __webpack_require__("AROG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ee8ca18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityListTable_vue__ = __webpack_require__("pRin");
function injectStyle (ssrContext) {
  __webpack_require__("lrJY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityListTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ee8ca18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityListTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t1ej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);


/* harmony default export */ __webpack_exports__["a"] = ({
  organisationseinheit: {
    name: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) }
  },
  titel: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) },
  veroeffentlichungsnummer: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) },
  haupterfinder: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) },
  link: { url: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["url"] },
  ansprechpartner: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) }
});

/***/ }),

/***/ "tJdp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:{ 'is-selected' : _vm.id == _vm.selectedOrganisationalUnit.id }},[_c('div',{staticClass:"test-item columns"},[_c('div',{staticClass:"column",class:{'tree-branch-icon': !_vm.isFolder},staticStyle:{"max-width":"10px","margin-right":"5px"},on:{"click":_vm.toggle}},[(_vm.isFolder && !_vm.open)?_c('b-icon',{attrs:{"pack":"fa","icon":"angle-right","size":"is-small","title":_vm.$gettext('tree.open')}}):_vm._e(),_vm._v(" "),(_vm.isFolder && _vm.open)?_c('b-icon',{attrs:{"pack":"fa","icon":"angle-down","size":"is-small","title":_vm.$gettext('tree.collapse')}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"ou-item column"},[_c('div',{staticClass:"ou-item-title",on:{"click":function($event){_vm.select(_vm.model)}}},[_c('router-link',{staticStyle:{"color":"inherit","text-decoration":"none"},attrs:{"tag":"a","to":{
            name: 'public',
            params: {
              type: 'ou',
              id: _vm.model.id,
              resourceType: _vm.activeResourceType
            }
          }}},[_vm._v("\n          "+_vm._s(_vm.model.name)+" \n          "),(_vm.getOrgaDuration(_vm.model))?_c('div',{staticClass:"has-text-grey"},[_vm._v("\n            "+_vm._s(_vm.getOrgaDuration(_vm.model))+"\n          ")]):_vm._e()])],1)])]),_vm._v(" "),(_vm.isFolder)?_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.open),expression:"open"}]},[(_vm.loading)?_c('li',{staticStyle:{"margin-left":"30px"}},[_c('translate',[_vm._v("tree.loading")]),_vm._v("...")],1):_vm._e(),_vm._v(" "),_vm._l((_vm.childData.children),function(childData,index){return _c('fob-tree-item',{key:index,staticClass:"item",staticStyle:{"margin-left":"20px"},attrs:{"parent":_vm.newParent,"isOpen":childData.id == _vm.openBranch,"model":childData},on:{"open":_vm.handleOpenEvent}})})],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tLDE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tNDU":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAyNTYgMjU2IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNTYgMjU2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojQTZDRTM5O30NCgkuc3Qxe2ZpbGw6I0ZGRkZGRjt9DQo8L3N0eWxlPg0KPHBhdGggY2xhc3M9InN0MCIgZD0iTTI1NiwxMjhjMCw3MC43LTU3LjMsMTI4LTEyOCwxMjhDNTcuMywyNTYsMCwxOTguNywwLDEyOEMwLDU3LjMsNTcuMywwLDEyOCwwQzE5OC43LDAsMjU2LDU3LjMsMjU2LDEyOHoiLz4NCjxnPg0KCTxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik04Ni4zLDE4Ni4ySDcwLjlWNzkuMWgxNS40djQ4LjRWMTg2LjJ6Ii8+DQoJPHBhdGggY2xhc3M9InN0MSIgZD0iTTEwOC45LDc5LjFoNDEuNmMzOS42LDAsNTcsMjguMyw1Nyw1My42YzAsMjcuNS0yMS41LDUzLjYtNTYuOCw1My42aC00MS44Vjc5LjF6IE0xMjQuMywxNzIuNGgyNC41DQoJCWMzNC45LDAsNDIuOS0yNi41LDQyLjktMzkuN2MwLTIxLjUtMTMuNy0zOS43LTQzLjctMzkuN2gtMjMuN1YxNzIuNHoiLz4NCgk8cGF0aCBjbGFzcz0ic3QxIiBkPSJNODguNyw1Ni44YzAsNS41LTQuNSwxMC4xLTEwLjEsMTAuMWMtNS42LDAtMTAuMS00LjYtMTAuMS0xMC4xYzAtNS42LDQuNS0xMC4xLDEwLjEtMTAuMQ0KCQlDODQuMiw0Ni43LDg4LjcsNTEuMyw4OC43LDU2Ljh6Ii8+DQo8L2c+DQo8L3N2Zz4="

/***/ }),

/***/ "tTX3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__ = __webpack_require__("9fz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schema_OrgaIdent__ = __webpack_require__("W+k1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FieldsGeneric__ = __webpack_require__("WWW9");





var Fields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__FieldsGeneric__["a" /* default */])('Organisationseinheit');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Organisationseinheit',
  route: 'organisationseinheit',
  class: __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__["Organisationseinheit"],
  className: 'organisationseinheit',
  tableSelectColumns: [{
    label: 'name',
    field: 'name'
  }, {
    label: 'parent',
    field: 'parentOrgaName'
  }, {
    label: 'kostenstelle',
    field: 'kostenstelle'
  }],
  fields: [{
    label: 'Organisationseinheit.form.ueberOrganisationseinheit',
    cardinality: 'single',
    icon: 'sitemap',
    field: 'ueberOrganisationseinheit',
    type: 'object',
    // schema: 'parent',
    schema: {
      route: 'organisationseinheit',
      className: 'organisationseinheit',
      fields: [{
        label: 'Name',
        field: 'name'
      }, {
        label: 'Kostenstelle',
        field: 'kostenstelle'
      }]
    },
    finder: {
      name: 'bySearchRepLike',
      multiValue: false,
      minLength: 0
    },
    // true and false make different fields correct!
    nested: false
  }, Fields.String('name'), Fields.Date('beginn'), Fields.Date('ende'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.Text('beschreibungDE', 6000), {
    render: 'html'
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.Text('beschreibungEN', 6000), {
    render: 'html'
  }), Fields.String('kostenstelle'), {
    label: 'Organisationseinheit.form.orgaIdent',
    field: 'orgaIdent',
    type: 'object',
    cardinality: 'many',
    onlyCreate: true,
    render: 'stringRep',
    schema: __WEBPACK_IMPORTED_MODULE_2__schema_OrgaIdent__["a" /* default */]
  }, Fields.Boolean('inPubfob'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.Boolean('obsolet'), {
    view: function view(data, user) {
      return user.roles.ADMIN === true;
    }
  }), {
    label: 'Organisationseinheit.form.unterOrganisationseinheiten',
    field: 'unterOrganisationseinheiten',
    sortBy: 'kostenstelle',
    inEditView: false
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.Boolean('skipValidation'), {
    label: 'skipValidation',
    view: function view() {
      return false;
    },
    inEditView: true
  })]
});

/***/ }),

/***/ "tZsR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListFieldsGeneric__ = __webpack_require__("K13K");


var ListFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ListFieldsGeneric__["a" /* default */])('Forschungsprojekt');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Forschungsprojekt',
  route: 'forschungsprojekt',
  className: 'forschungsprojekt',
  fields: [ListFields.SortableTimestamp('_updateDate', false, 'updateDate', true), ListFields.SortableTimestamp('_createDate', false, 'createDate', true), ListFields.SortableReference('organisationseinheit', false), ListFields.UnsortableReference('weitereOrganisationseinheiten', false),
  // deprecated
  // ListFields.SortableReference('projektLeiter', true),
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, ListFields.UnsortableReference('projektleiter', true), {
    linkNested: 'person'
  }), ListFields.UnsortableReference('antragsteller', false), ListFields.SortableField('titelDE', true), ListFields.SortableField('titelEN', true), ListFields.SortableDate('projektBeginn', false), ListFields.SortableDate('projektEnde', false), ListFields.UnsortableReference('foerderung', false, true), {
    label: 'Forschungsprojekt.list.column.sdg',
    field: 'sdg',
    key: 'sdg',
    render: 'stringRep',
    tableVisible: false,
    plain: true
  }, {
    label: 'Forschungsprojekt.list.column.foerderkennzeichen',
    field: 'foerderung',
    key: 'fkz',
    render: function render(f) {
      return f.foerderkennzeichen;
    },
    tableVisible: false,
    plain: true
  }, ListFields.SortableBoolean('istFinal', false), ListFields.SortableField('uebergeordnetesProjekt', false)]
});

/***/ }),

/***/ "tbhY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setViewEntityType", function() { return setViewEntityType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "doDelete", function() { return doDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setResource", function() { return setResource; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_buefy__ = __webpack_require__("MMSg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_buefy__);



var setViewEntityType = function setViewEntityType(_ref, type) {
  var state = _ref.state,
      commit = _ref.commit;

  commit('SET_VIEW_ENTITY_TYPE', type);
};

var doDelete = function doDelete(_ref2) {
  var state = _ref2.state,
      commit = _ref2.commit;

  commit('LOADING_START');
  return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].methods.deleteEntity(state.data).then(function () {
    commit('SET_DATA', {});
    commit('SET_ID', null);
    commit('SET_VIEW_ENTITY_TYPE', null);
    commit('SET_SCHEMA', null);
    commit('LOADING_DONE');
  });
};

var setResource = function setResource(_ref3, _ref4) {
  var state = _ref3.state,
      commit = _ref3.commit;
  var id = _ref4.id,
      type = _ref4.type,
      schema = _ref4.schema;

  commit('LOADING_START');
  if (id != null) {
    commit('SET_ID', id);
  }
  if (schema != null) {
    commit('SET_SCHEMA', schema);
    commit('SET_VIEW_ENTITY_TYPE', type);
  }

  return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].methods.fetchResource(state.schema.className, state.id).then(function (data) {
    commit('SET_DATA', data);
    commit('LOADING_DONE');
  }).catch(function (error) {
    // Error
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log(error.response);
      // this.$snackbar.open(`Default, positioned bottom-right with a green 'OK' button`)
      __WEBPACK_IMPORTED_MODULE_1_buefy__["Toast"].open({
        duration: 5000,
        message: state.schema.route + ' ' + state.id + '<br />\n                    [' + error.response.status + '] ' + error.response.statusText,
        position: 'is-bottom',
        type: 'is-carnelian'
      });
      commit('SET_DATA', null);
      commit('LOADING_DONE');
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message);
    }
    console.log(error.config);
  });
};

/***/ }),

/***/ "teIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("HCTz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f7bff1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("0IiM");
function injectStyle (ssrContext) {
  __webpack_require__("SdEH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f7bff1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tpr9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fob-entity",class:{ 'compact-print-view': _vm.resourceSchema.compactPrintView}},[_c('div',{staticClass:"columns"},[(!_vm.loading && _vm.resourceData)?_c('div',{key:_vm.resourceId || -1,staticClass:"column"},_vm._l((_vm.displayFields),function(bit,i){return _c('div',{key:i},[(bit.view === undefined || bit.view(_vm.resourceData, _vm.user, _vm.isPublic))?[_c('div',{class:bit.appendClass},[(bit.render === 'projektleiter')?[_c('fob-projektleiter',{attrs:{"resourceData":_vm.resourceData[bit.field],"isPublic":_vm.isPublic,"linkProvider":_vm.linkProvider}})]:(bit.render === 'embedded')?[_c('div',{staticClass:"panel fobpanel"},[_c('div',{staticClass:"panel-heading"},[_c('translate',[_vm._v(_vm._s(bit.label))])],1),_vm._v(" "),_c('div',{staticClass:"panel-block"},[_c('fob-entity-value',{staticStyle:{"width":"100%"},attrs:{"bit":bit,"resourceData":_vm.resourceData[bit.field],"linkProvider":_vm.linkProvider,"isPublic":_vm.isPublic,"useCompactComponents":_vm.useCompactComponents,"plain":bit.plain}})],1)])]:[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column column-key is-narrow has-text-weight-bold has-text-basalt",staticStyle:{"width":"280px"}},[_c('translate',[_vm._v(_vm._s(bit.label))]),_vm._v(" "),(_vm.isPublic && bit.field === 'sdg')?_c('div',[_c('a',{staticClass:"fob-hide-in-print",staticStyle:{"font-size":"0.9em"},attrs:{"href":_vm.sdgPortalLink,"target":"_blank"}},[_c('translate',[_vm._v("ReadMore")]),_vm._v(" "),_c('b-icon',{attrs:{"icon":"external-link","size":"is-small"}})],1)]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"column column-value fix-flex-ms-column-width"},[(!_vm.isPublic || bit.field !== 'sdg')?[_c('fob-entity-value',{attrs:{"v-if":bit.type !== 'label',"bit":bit,"resourceData":_vm.resourceData[bit.field],"linkProvider":_vm.linkProvider,"isPublic":_vm.isPublic,"useCompactComponents":_vm.useCompactComponents,"plain":bit.plain}})]:_vm._e(),_vm._v(" "),(bit.field === 'sdg')?_c('div',[_c('ul',{staticClass:"iconFlexRow"},_vm._l((_vm.resourceData[bit.field]),function(sdg,index){return _c('li',{key:index},[_c('b-tooltip',{attrs:{"label":"SDG " + (sdg._id) + ": " + _vm.$gettext(("Sdg.SDG" + (sdg._id))),"position":"is-top"}},[_c('router-link',{attrs:{"to":_vm.currentPublicRoute().withQuery({ sdg: ("SDG" + (sdg._id)) })}},[_c('img',{attrs:{"src":_vm.sdgLink(sdg._id),"width":"80"}})])],1)],1)}))]):_vm._e()],2)])]],2)]:_vm._e()],2)})):_vm._e(),_vm._v(" "),(_vm.resourceData.logo != null && (_vm.resourceSchema.className === 'foerderung' || _vm.resourceSchema.className === 'mittelgeber') )?_c('div',{staticClass:"column is-narrow"},[_c('img',{staticStyle:{"margin":"4px 4px 4px 4px"},attrs:{"src":_vm.resourceData.logo,"alt":("Logo " + (_vm.resourceData._stringRep))}})]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tyB9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityCreateModal_vue__ = __webpack_require__("mLW4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66b43348_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityCreateModal_vue__ = __webpack_require__("zUxD");
function injectStyle (ssrContext) {
  __webpack_require__("6oxK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityCreateModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66b43348_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityCreateModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uDTM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Forschungsprojekt__ = __webpack_require__("bMTA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AbstractPerson__ = __webpack_require__("BP7K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Kooperation__ = __webpack_require__("NWfb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Organisationseinheit__ = __webpack_require__("tTX3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrgaIdent__ = __webpack_require__("W+k1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ExterneOrganisation__ = __webpack_require__("Vu0z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Publikation__ = __webpack_require__("6kgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PreisBezeichnung__ = __webpack_require__("1NbI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Land__ = __webpack_require__("eFxi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Mittelgeber__ = __webpack_require__("TFk4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Veranstaltung__ = __webpack_require__("I5KR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Parent__ = __webpack_require__("qQrW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Patent__ = __webpack_require__("pl+S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Person__ = __webpack_require__("Cfye");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PersonIdent__ = __webpack_require__("y/j1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PersonIdentTyp__ = __webpack_require__("wmUm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PubIdent__ = __webpack_require__("NUk6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__PubIdentTyp__ = __webpack_require__("s21u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Preis__ = __webpack_require__("pLHl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__AppUser__ = __webpack_require__("q4Jw");





















/* harmony default export */ __webpack_exports__["a"] = ({
  baseTypes: [{
    label: 'Forschungsprojekt',
    schema: __WEBPACK_IMPORTED_MODULE_0__Forschungsprojekt__["a" /* default */]
  }, {
    label: 'Publikation',
    schema: __WEBPACK_IMPORTED_MODULE_6__Publikation__["a" /* default */]
  }, {
    label: 'Veranstaltung',
    schema: __WEBPACK_IMPORTED_MODULE_10__Veranstaltung__["a" /* default */]
  }, {
    label: 'Externe Organisationseinheit',
    schema: __WEBPACK_IMPORTED_MODULE_5__ExterneOrganisation__["a" /* default */]
  }, {
    label: 'Patent',
    schema: __WEBPACK_IMPORTED_MODULE_12__Patent__["a" /* default */]
  }, {
    label: 'Organisationseinheit',
    schema: __WEBPACK_IMPORTED_MODULE_3__Organisationseinheit__["a" /* default */]
  }, {
    label: 'Preis',
    schema: __WEBPACK_IMPORTED_MODULE_18__Preis__["a" /* default */]
  }, {
    label: 'Kooperation',
    schema: __WEBPACK_IMPORTED_MODULE_2__Kooperation__["a" /* default */]
  }, {
    label: 'Interne Person',
    schema: __WEBPACK_IMPORTED_MODULE_13__Person__["a" /* default */]
  }, {
    label: 'Externe Person',
    schema: __WEBPACK_IMPORTED_MODULE_1__AbstractPerson__["a" /* default */]
  }, {
    label: 'Land',
    schema: __WEBPACK_IMPORTED_MODULE_8__Land__["a" /* default */]
  }, {
    label: 'Mittelgeber',
    schema: __WEBPACK_IMPORTED_MODULE_9__Mittelgeber__["a" /* default */]
  }],
  // research activities
  forschungsprojekt: __WEBPACK_IMPORTED_MODULE_0__Forschungsprojekt__["a" /* default */],
  kooperation: __WEBPACK_IMPORTED_MODULE_2__Kooperation__["a" /* default */],
  publikation: __WEBPACK_IMPORTED_MODULE_6__Publikation__["a" /* default */],
  parent: __WEBPACK_IMPORTED_MODULE_11__Parent__["a" /* default */],
  patent: __WEBPACK_IMPORTED_MODULE_12__Patent__["a" /* default */],
  veranstaltung: __WEBPACK_IMPORTED_MODULE_10__Veranstaltung__["a" /* default */],
  preis: __WEBPACK_IMPORTED_MODULE_18__Preis__["a" /* default */],
  // UL master data
  abstractperson: __WEBPACK_IMPORTED_MODULE_1__AbstractPerson__["a" /* default */],
  organisationseinheit: __WEBPACK_IMPORTED_MODULE_3__Organisationseinheit__["a" /* default */],
  orgaident: __WEBPACK_IMPORTED_MODULE_4__OrgaIdent__["a" /* default */],
  person: __WEBPACK_IMPORTED_MODULE_13__Person__["a" /* default */],
  personident: __WEBPACK_IMPORTED_MODULE_14__PersonIdent__["a" /* default */],
  personidenttyp: __WEBPACK_IMPORTED_MODULE_15__PersonIdentTyp__["a" /* default */],
  preisbezeichnung: __WEBPACK_IMPORTED_MODULE_7__PreisBezeichnung__["a" /* default */],
  pubident: __WEBPACK_IMPORTED_MODULE_16__PubIdent__["a" /* default */],
  pubidenttyp: __WEBPACK_IMPORTED_MODULE_17__PubIdentTyp__["a" /* default */],
  // external data
  externeorganisation: __WEBPACK_IMPORTED_MODULE_5__ExterneOrganisation__["a" /* default */],
  land: __WEBPACK_IMPORTED_MODULE_8__Land__["a" /* default */],
  mittelgeber: __WEBPACK_IMPORTED_MODULE_9__Mittelgeber__["a" /* default */],
  // administration
  appuser: __WEBPACK_IMPORTED_MODULE_19__AppUser__["a" /* default */]
});

/***/ }),

/***/ "uDp6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicListOptions_vue__ = __webpack_require__("7Qhh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38c49636_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicListOptions_vue__ = __webpack_require__("B91y");
function injectStyle (ssrContext) {
  __webpack_require__("pBfg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicListOptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38c49636_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicListOptions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uV+n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityMultiSelectVertical_vue__ = __webpack_require__("nO6C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ec0ae62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityMultiSelectVertical_vue__ = __webpack_require__("7KWU");
function injectStyle (ssrContext) {
  __webpack_require__("Vr8j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityMultiSelectVertical_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ec0ae62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityMultiSelectVertical_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ubxp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schema_PublikationsTyp__ = __webpack_require__("IhzH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListFilterFieldsGeneric__ = __webpack_require__("cigy");



var Filter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ListFilterFieldsGeneric__["a" /* default */])('Publikation');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Publikation',
  route: 'publikation',
  fields: [Filter.ReferenceByMultiValueSearchRep('organisationseinheit', 'sitemap', 'organisationseinheit'), Filter.kumuliert(), {
    label: 'Publikation.list.filter.veroeffentlichungsJahr',
    field: 'veroeffentlichungsJahr',
    type: Number,
    icon: 'calendar-o'
  }, {
    label: 'Publikation.list.filter.beteiligte',
    field: 'beteiligte',
    cardinality: 'single',
    icon: 'user',
    type: 'object',
    schema: {
      route: 'abstractperson',
      className: 'abstractPerson'
    },
    finder: {
      name: 'byMultiValueSearchRep',
      multiValue: true,
      minLength: 3
    }
  }, Filter.String('titelPublikation'), __WEBPACK_IMPORTED_MODULE_0__schema_PublikationsTyp__["a" /* default */], Filter.Reference('author', 'user', 'abstractPerson', {
    name: 'byMultiValueSearchRep',
    multiValue: true,
    minLength: 4
  }), {
    label: 'Publikation.list.filter.herausgeber',
    field: 'herausgeber',
    cardinality: 'single',
    icon: 'user',
    type: 'object',
    schema: {
      route: 'abstractperson',
      className: 'abstractPerson'
    },
    finder: {
      name: 'byMultiValueSearchRep',
      multiValue: true,
      minLength: 3
    }
  }, {
    label: 'Publikation.list.filter.freieID',
    field: 'freieID',
    type: 'string'
  }, {
    label: 'Publikation.list.filter.validiert',
    field: 'validiert',
    type: 'select',
    translatable: true,
    values: [{
      value: 'TRUE',
      label: 'PublikationValidiert.TRUE'
    }, {
      value: 'FALSE',
      label: 'PublikationValidiert.FALSE'
    }]
  }]
});

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONFIRM_PRIVACY_POLICY", function() { return CONFIRM_PRIVACY_POLICY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_LOADING", function() { return SET_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_LANGUAGE", function() { return SET_LANGUAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SERVER_VERSION", function() { return SET_SERVER_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateTime", function() { return updateTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_LAST_VERSION", function() { return UPDATE_LAST_VERSION; });
var CONFIRM_PRIVACY_POLICY = function CONFIRM_PRIVACY_POLICY(state) {
  state.confirmPrivacyPolicy = true;
};

var SET_LOADING = function SET_LOADING(state, data) {
  state.loading = data;
};

var SET_LANGUAGE = function SET_LANGUAGE(state, locale) {
  state.language = locale;
};

var SET_SERVER_VERSION = function SET_SERVER_VERSION(state, serverVersion) {
  state.serverVersion = serverVersion;
};

var updateTime = function updateTime(state) {
  state.now = new Date();
};

var UPDATE_LAST_VERSION = function UPDATE_LAST_VERSION(state, newVersion) {
  state.lastVersion = newVersion;
};

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vLmL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vOD2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vXi7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tree_vue__ = __webpack_require__("qk16");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_677291da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tree_vue__ = __webpack_require__("FBWx");
function injectStyle (ssrContext) {
  __webpack_require__("riDJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_677291da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vahH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_public_PublicSelectOrganisationalUnit__ = __webpack_require__("zHdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_public_PublicSelectPerson__ = __webpack_require__("9+AE");
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-public-select',
  props: {
    type: { default: 'ou' }
  },
  components: {
    'fob-public-select-organisational-unit': __WEBPACK_IMPORTED_MODULE_0__components_public_PublicSelectOrganisationalUnit__["a" /* default */],
    'fob-public-select-person': __WEBPACK_IMPORTED_MODULE_1__components_public_PublicSelectPerson__["a" /* default */]
  }
});

/***/ }),

/***/ "vc/A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchOuQuery; });
function fetchOuQuery(id) {
  return {
    operationName: 'fetchOuQuery',
    query: '\n      query fetchOuQuery($id: ID!) { organisationalUnit(id: $id) {\n        id\n        name: titleDe\n        begin\n        end\n        children: subOrganisationalUnits {\n          id\n          name: titleDe\n          begin\n          end\n          children: subOrganisationalUnits {\n            id\n            name: titleDe\n            begin\n            end\n            }\n          }\n        }\n      }\n    ',
    variables: {
      id: Number(id) || null
    }
  };
}



/***/ }),

/***/ "vlR/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityDecorator_vue__ = __webpack_require__("R0D5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_934af1fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityDecorator_vue__ = __webpack_require__("PxRq");
function injectStyle (ssrContext) {
  __webpack_require__("kYS8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-934af1fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityDecorator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_934af1fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityDecorator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w+Sa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);


// import Foerderung from './Foerderung'

/* harmony default export */ __webpack_exports__["a"] = ({
  organisationseinheit: {
    name: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) }
  },
  titelKooperation: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(1) },

  beginn: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] }
});

/***/ }),

/***/ "wX/P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMeListOptions_vue__ = __webpack_require__("If87");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5066daac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutMeListOptions_vue__ = __webpack_require__("lo1B");
function injectStyle (ssrContext) {
  __webpack_require__("vLmL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMeListOptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5066daac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutMeListOptions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wZvs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fob-entity-header',{staticStyle:{"margin-bottom":"0rem","font-weight":"bold"},attrs:{"type":"Public.headline.organisationalUnit"}}),_vm._v(" "),_c('div',[_c('fob-public-select-tag',{attrs:{"view":"ou"}}),_vm._v(" "),_c('b-field',{staticStyle:{"margin-top":"1rem"},attrs:{"grouped":""}},[_c('b-field',{staticStyle:{"margin":"0 1rem 1rem 0","min-width":"300px","display":"block"}},[_c('b-autocomplete',{attrs:{"icon":"search","data":_vm.data,"loading":_vm.isFetching,"clear-on-select":true,"placeholder":_vm.$gettext('Public.placeholder.ousearch')},on:{"input":_vm.loadAsyncOrganisationalUnits,"select":_vm.selectOrganisationalUnit},scopedSlots:_vm._u([{key:"default",fn:function(ou){return [_c('div',{staticClass:"media"},[_vm._v("\n                "+_vm._s(ou.option.title)+"\n              ")])]}}]),model:{value:(_vm.searchStr),callback:function ($$v) {_vm.searchStr=$$v},expression:"searchStr"}})],1),_vm._v(" "),_c('b-tooltip',{staticStyle:{"min-width":"35px"},attrs:{"square":"","position":"is-top","label":_vm.$gettext("form.xbutton")}},[_c('button',{staticClass:"button contol is-aquamarine",attrs:{"tabindex":"-1"},on:{"click":function($event){_vm.searchStr = ''}}},[_c('b-icon',{attrs:{"icon":"times","size":"is-small"}})],1)])],1),_vm._v(" "),_c('hr',{staticClass:"fob-public-select-divider",attrs:{"align":"left"}}),_vm._v(" "),_c('fob-tree')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "whBG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-card fob-table-select-modal"},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_c('translate',[_vm._v("tableSelect.header."+_vm._s(_vm.field))])],1)]),_vm._v(" "),_c('section',{staticClass:"modal-card-body table-select table-select-vertical"},[_c('div',{staticClass:"left-col",staticStyle:{"gap":"5px"}},[_c('div',[_c('b-field',{attrs:{"label":_vm.$gettext('tableSelect.queryString')}},[_c('b-input',{ref:"input",attrs:{"icon":_vm.icon,"value":"","placeholder":"Start typing..."},on:{"input":_vm.queryForTable},model:{value:(_vm.tableQuery),callback:function ($$v) {_vm.tableQuery=$$v},expression:"tableQuery"}})],1)],1),_vm._v(" "),_c('div',{staticStyle:{"overflow-x":"hidden","overflow-y":"auto"}},[_c('b-table',{attrs:{"narrowed":"","paginated":false,"loading":_vm.isFetching,"data":_vm.filteredTableContent},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._l((_vm.tableColumns),function(col,i){return _c('b-table-column',{key:i,attrs:{"label":_vm.$gettext((_vm.entityName + ".form.tableSelect." + (col.label))),"width":col.width}},[(col.field === '_stringRep')?[_c('fob-entity-decorator',{attrs:{"resourceData":props.row}},[_vm._v("\n              "+_vm._s(props.row[col.field])+"\n            ")]),_vm._v(" "),_c('div',[_vm._v("\n              "+_vm._s(props.row["orcidId"])+"\n            ")])]:[_vm._v("\n            "+_vm._s(props.row[col.field])+"\n          ")]],2)}),_vm._v(" "),_c('b-table-column',{attrs:{"label":"","width":"40"}},[_c('b-tooltip',{attrs:{"label":"Hinzufügen","position":"is-left"}},[_c('a',{staticClass:"is-primary",on:{"click":function($event){_vm.selectRow(props.row._id)}}},[_c('b-icon',{attrs:{"size":"is-small","icon":"chevron-right"}})],1)])],1)]}}])},[_c('template',{slot:"empty"},[_c('section',{staticClass:"section"},[_c('div',{staticClass:"content has-text-grey has-text-centered"},[_c('p',[_c('b-icon',{attrs:{"icon":"exclamation","size":"is-large"}})],1),_vm._v(" "),(_vm.isFetching)?[_c('translate',[_vm._v("tableSelect.emptyTablePlaceholder.isFetching")])]:(_vm.tableQuery.length === 0)?[_c('translate',[_vm._v("tableSelect.emptyTablePlaceholder.noInput")])]:(_vm.tableQuery.length > 0 && _vm.tableQuery.length < _vm.method.minLength)?[_c('translate',[_vm._v("tableSelect.emptyTablePlaceholder.minLength")])]:(_vm.tableQuery.length >= _vm.method.minLength)?[_c('p',[_c('translate',[_vm._v("tableSelect.emptyTablePlaceholder.noResults")])],1)]:_vm._e()],2)])])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"right-col"},[_c('h3',{staticClass:"is-size-6",staticStyle:{"margin-top":"20px"}},[_c('strong',[_c('translate',[_vm._v("tableSelect.selected")])],1)]),_vm._v(" "),_c('div',{staticStyle:{"height":"90%","overflow-y":"scroll","overflow-x":"hidden"},attrs:{"id":"right-col-selection"}},[_c('table',{staticClass:"table is-narrow has-mobile-cards",staticStyle:{"width":"100%"}},[_c('thead',[_c('tr',{staticClass:"is-unselectable"},[_c('th',{staticStyle:{"width":"40px"}}),_vm._v(" "),_vm._l((_vm.tableColumns),function(col,i){return _c('th',{key:i,style:({ width: col.width + 'px' })},[_c('translate',[_vm._v(_vm._s((_vm.entityName + ".form.tableSelect." + (col.label))))])],1)})],2)]),_vm._v(" "),_c('draggable',{attrs:{"element":'tbody',"options":{
            draggable: 'tr',
            filter: '.delete-icon'
          }},on:{"change":function($event){_vm.$emit('input', _vm.selectedContent)}},model:{value:(_vm.selectedContent),callback:function ($$v) {_vm.selectedContent=$$v},expression:"selectedContent"}},_vm._l((_vm.selectedContent),function(line,i){return _c('tr',{key:i,class:{'just-selected': line._id === _vm.justSelected }},[_c('td',{staticClass:"delete-icon",staticStyle:{"width":"40px"}},[_c('b-tooltip',{attrs:{"label":"Entfernen","position":"is-right","type":"is-carnelian"}},[_c('a',{staticClass:"is-primary",on:{"click":function($event){_vm.dropRow(line._id)}}},[_c('b-icon',{attrs:{"type":"is-carnelian","size":"is-small","icon":"minus"}})],1)])],1),_vm._v(" "),_vm._l((_vm.tableColumns),function(col,i){return _c('td',{key:i,staticStyle:{"cursor":"move"}},[(col.field === '_stringRep')?[_c('fob-entity-decorator',{attrs:{"resourceData":line}},[_vm._v("\n                    "+_vm._s(line[col.field])+"\n                  ")])]:[_vm._v("\n                  "+_vm._s(line[col.field])+"\n                ")]],2)})],2)}))],1)])])]),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('button',{staticClass:"button is-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.$parent.close()}}},[_c('translate',[_vm._v("tableSelect.button.close")])],1),_vm._v(" "),(_vm.allowCreate)?_c('button',{staticClass:"button",attrs:{"type":"button"},on:{"click":_vm.prepareCreation}},[_c('translate',[_vm._v("tableSelect.button.create")])],1):_vm._e()]),_vm._v(" "),_c('fob-entity-create-modal',{attrs:{"active":_vm.showCreateModal,"schema":_vm.schema,"field":_vm.field},on:{"update:active":function($event){_vm.showCreateModal=$event},"submit":_vm.submitCreated},model:{value:(_vm.created),callback:function ($$v) {_vm.created=$$v},expression:"created"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wmBm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "wmUm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__ = __webpack_require__("9fz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldsGeneric__ = __webpack_require__("WWW9");




var Fields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__FieldsGeneric__["a" /* default */])('PersonIdentTyp');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'PersonIdentTyp',
  route: 'personIdentTyp',
  class: __WEBPACK_IMPORTED_MODULE_1_fobclient_lib_entity__["PersonIdentTyp"],
  className: 'personIdentTyp',
  fields: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Fields.String('kennung'), {
    table: true
  }), Fields.String('anmerkung')]
});

/***/ }),

/***/ "wx9V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validIsoLangCodes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);

var validIsoLangCodes = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(['aar', 'abk', 'ace', 'ach', 'ada', 'ady', 'afa', 'afh', 'afr', 'ain', 'aka', 'akk', 'alb', 'ale', 'alg', 'alt', 'amh', 'ang', 'anp', 'apa', 'ara', 'arc', 'arg', 'arm', 'arn', 'arp', 'art', 'arw', 'asm', 'ast', 'ath', 'aus', 'ava', 'ave', 'awa', 'aym', 'aze', 'bad', 'bai', 'bak', 'bal', 'bam', 'ban', 'baq', 'bas', 'bat', 'bej', 'bel', 'bem', 'ben', 'ber', 'bho', 'bih', 'bik', 'bin', 'bis', 'bla', 'bnt', 'tib', 'bos', 'bra', 'bre', 'btk', 'bua', 'bug', 'bul', 'bur', 'byn', 'cad', 'cai', 'car', 'cat', 'cau', 'ceb', 'cel', 'cze', 'cha', 'chb', 'che', 'chg', 'chi', 'chk', 'chm', 'chn', 'cho', 'chp', 'chr', 'chu', 'chv', 'chy', 'cmc', 'cop', 'cor', 'cos', 'cpe', 'cpf', 'cpp', 'cre', 'crh', 'crp', 'csb', 'cus', 'wel', 'dak', 'dan', 'dar', 'day', 'del', 'den', 'ger', 'dgr', 'din', 'div', 'doi', 'dra', 'dsb', 'dua', 'dum', 'dut', 'dyu', 'dzo', 'efi', 'egy', 'eka', 'gre', 'elx', 'eng', 'enm', 'epo', 'est', 'ewe', 'ewo', 'fan', 'fao', 'per', 'fat', 'fij', 'fil', 'fin', 'fiu', 'fon', 'fre', 'frm', 'fro', 'frr', 'frs', 'fry', 'ful', 'fur', 'gaa', 'gay', 'gba', 'gem', 'geo', 'gez', 'gil', 'gla', 'gle', 'glg', 'glv', 'gmh', 'goh', 'gon', 'gor', 'got', 'grb', 'grc', 'grn', 'gsw', 'guj', 'gwi', 'hai', 'hat', 'hau', 'haw', 'heb', 'her', 'hil', 'him', 'hin', 'hit', 'hmn', 'hmo', 'hrv', 'hsb', 'hun', 'hup', 'iba', 'ibo', 'ice', 'ido', 'iii', 'ijo', 'iku', 'ile', 'ilo', 'ina', 'inc', 'ind', 'ine', 'inh', 'ipk', 'ira', 'iro', 'ita', 'jav', 'jbo', 'jpn', 'jpr', 'jrb', 'kaa', 'kab', 'kac', 'kal', 'kam', 'kan', 'kar', 'kas', 'kau', 'kaw', 'kaz', 'kbd', 'kha', 'khi', 'khm', 'kho', 'kik', 'kin', 'kir', 'kmb', 'kok', 'kom', 'kon', 'kor', 'kos', 'kpe', 'krc', 'krl', 'kro', 'kru', 'kua', 'kum', 'kur', 'kut', 'lad', 'lah', 'lam', 'lao', 'lat', 'lav', 'lez', 'lim', 'lin', 'lit', 'lol', 'loz', 'ltz', 'lua', 'lub', 'lug', 'lui', 'lun', 'luo', 'lus', 'mac', 'mad', 'mag', 'mah', 'mai', 'mak', 'mal', 'man', 'mao', 'map', 'mar', 'mas', 'may', 'mdf', 'mdr', 'men', 'mga', 'mic', 'min', 'mis', 'mkh', 'mlg', 'mlt', 'mnc', 'mni', 'mno', 'moh', 'mon', 'mos', 'mul', 'mun', 'mus', 'mwl', 'mwr', 'myn', 'myv', 'nah', 'nai', 'nap', 'nau', 'nav', 'nbl', 'nde', 'ndo', 'nds', 'nep', 'new', 'nia', 'nic', 'niu', 'nno', 'nob', 'nog', 'non', 'nor', 'nqo', 'nso', 'nub', 'nwc', 'nya', 'nym', 'nyn', 'nyo', 'nzi', 'oci', 'oji', 'ori', 'orm', 'osa', 'oss', 'ota', 'oto', 'paa', 'pag', 'pal', 'pam', 'pan', 'pap', 'pau', 'peo', 'phi', 'phn', 'pli', 'pol', 'pon', 'por', 'pra', 'pro', 'pus', 'que', 'raj', 'rap', 'rar', 'roa', 'roh', 'rom', 'rum', 'run', 'rup', 'rus', 'sad', 'sag', 'sah', 'sai', 'sal', 'sam', 'san', 'sas', 'sat', 'scn', 'sco', 'sel', 'sem', 'sga', 'sgn', 'shn', 'sid', 'sin', 'sio', 'sit', 'sla', 'slo', 'slv', 'sma', 'sme', 'smi', 'smj', 'smn', 'smo', 'sms', 'sna', 'snd', 'snk', 'sog', 'som', 'son', 'sot', 'spa', 'srd', 'srn', 'srp', 'srr', 'ssa', 'ssw', 'suk', 'sun', 'sus', 'sux', 'swa', 'swe', 'syc', 'syr', 'tah', 'tai', 'tam', 'tat', 'tel', 'tem', 'ter', 'tet', 'tgk', 'tgl', 'tha', 'tig', 'tir', 'tiv', 'tkl', 'tlh', 'tli', 'tmh', 'tog', 'ton', 'tpi', 'tsi', 'tsn', 'tso', 'tuk', 'tum', 'tup', 'tur', 'tut', 'tvl', 'twi', 'tyv', 'udm', 'uga', 'uig', 'ukr', 'umb', 'und', 'urd', 'uzb', 'vai', 'ven', 'vie', 'vol', 'vot', 'wak', 'wal', 'war', 'was', 'wen', 'wln', 'wol', 'xal', 'xho', 'yao', 'yap', 'yid', 'yor', 'ypk', 'zap', 'zbl', 'zen', 'zgh', 'zha', 'znd', 'zul', 'zun', 'zxx', 'zza']);

/***/ }),

/***/ "xCOD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  loading: false,
  schema: null,
  data: {},
  id: null,
  viewEntityType: null
});

/***/ }),

/***/ "xEeK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("2Jc1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__("JK/4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__("l14L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("+pJ7");





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__
});

/***/ }),

/***/ "xHvv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOADING_START", function() { return LOADING_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOADING_DONE", function() { return LOADING_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAVE_ROOT_DATA", function() { return SAVE_ROOT_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAVE_OPEN_BRANCH", function() { return SAVE_OPEN_BRANCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVE_OPEN_BRANCH", function() { return REMOVE_OPEN_BRANCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET", function() { return RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAVE_BRANCH_DATA", function() { return SAVE_BRANCH_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SELECT_BRANCH", function() { return SELECT_BRANCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_LOADING", function() { return SET_LOADING; });
var LOADING_START = function LOADING_START(state) {
  state.loading = true;
};

var LOADING_DONE = function LOADING_DONE(state) {
  state.loading = false;
};

var SAVE_ROOT_DATA = function SAVE_ROOT_DATA(state, data) {
  if (data.children && data.children.length > 0) {
    state.rootData = data;
  }
};

var SAVE_OPEN_BRANCH = function SAVE_OPEN_BRANCH(state, id) {
  var idx = state.open.indexOf(id);
  if (idx === -1) {
    state.open.push(id);
  }
};

var REMOVE_OPEN_BRANCH = function REMOVE_OPEN_BRANCH(state, id) {
  var idx = state.open.indexOf(id);
  if (idx > -1) {
    state.open.splice(idx, 1);
  }
};

var RESET = function RESET(state) {
  state.selected = {
    id: 1,
    name: 'Universität Leipzig'
  };
};

var SAVE_BRANCH_DATA = function SAVE_BRANCH_DATA(state, treeItemData) {
  state.branch[treeItemData.id] = treeItemData;
};

var SELECT_BRANCH = function SELECT_BRANCH(state, branch) {
  if (branch && branch.id && branch.id > -1) {
    state.selected = branch;
  }
};

var SET_LOADING = function SET_LOADING(state, bool) {
  if (bool === true) {
    state.loading = true;
  } else {
    // all other value leads to false
    state.loading = false;
  }
};

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mixins_DateTimeHelper__ = __webpack_require__("5W2G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Footer__ = __webpack_require__("TVmP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Menu__ = __webpack_require__("ccZh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob2017',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_mixins_DateTimeHelper__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    confirmPrivacyPolicy: 'confirmPrivacyPolicy',
    authorized: 'user/isAuthorized'
  }), {
    isLoading: function isLoading() {
      return this.$store.getters['isLoading'];
    },
    isIE: function isIE() {
      var version = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* DetectMSBrowser */])();
      return version && version < 12;
    }
  }),
  methods: {
    showCookieSnackbar: function showCookieSnackbar() {
      var _this = this;

      // only show snackbar if it is not confirmed
      if (!this.confirmPrivacyPolicy) {
        this.$snackbar.open({
          indefinite: true,
          message: this.$gettext('confirmPrivacyPolicy'),
          type: 'is-primary',
          position: 'is-bottom-right',
          actionText: 'OK',
          queue: false,
          onAction: function onAction() {
            _this.$store.dispatch('confirmPrivacyPolicy');
          }
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    // check confirmation for privacy policy on each application launch
    this.showCookieSnackbar();

    var responseData = localStorage.getItem('leuris:login-response');
    if (responseData) {
      var response = JSON.parse(responseData);
      this.$store.dispatch('user/setupUserSession', response).then(function () {
        if (_this2.$leurisMode === 'FOB' && _this2.$route.name === 'login') {
          _this2.$router.push({ name: 'start' });
        }
      });
    } else {
      this.$store.dispatch('user/logout').then(function () {
        if (_this2.$leurisMode === 'FOB') {
          _this2.$router.push({ name: 'login' });
        }
      });
    }

    var language = localStorage.getItem('leuris:current-lang');
    if (language === 'en') {
      this.$store.dispatch('setLanguage', 'en_150');
    } else {
      this.$store.dispatch('setLanguage', 'de_DE');
    }

    window.addEventListener('leuris:user-logged-in', function (_e) {
      var responseData = localStorage.getItem('leuris:login-response');
      var response = JSON.parse(responseData);
      _this2.$store.dispatch('user/setupUserSession', response).then(function () {
        if (_this2.$leurisMode === 'FOB' && _this2.$route.name === 'login') {
          _this2.$router.push({ name: 'start' });
        }
      });
    });

    window.addEventListener('leuris:user-logged-out', function (_e) {
      _this2.$store.dispatch('user/logout').then(function () {
        if (_this2.$leurisMode === 'FOB') {
          _this2.$router.push({ name: 'login' });
        }
      });
    });

    window.addEventListener('leuris:language-changed', function (e) {
      if (e.detail === 'de') {
        _this2.$store.dispatch('setLanguage', 'de_DE');
      } else {
        _this2.$store.dispatch('setLanguage', 'en_150');
      }
    });
  },

  watch: {
    currentLocale: function currentLocale() {
      // if language has changed and snackbar for privacy policy is not already confirmed
      // close exisiting snackbar and relaunch with correct current locale text message
      // (due to static text message on buefy snackbars)
      var snackbarItems = document.getElementsByClassName('notices');
      while (snackbarItems.length > 0) {
        snackbarItems[0].parentNode.removeChild(snackbarItems[0]);
      }
      this.showCookieSnackbar();
    }
  },
  components: {
    'fob-footer': __WEBPACK_IMPORTED_MODULE_4__components_Footer__["a" /* default */],
    'fob-header': __WEBPACK_IMPORTED_MODULE_5__components_Header__["a" /* default */],
    'fob-menu': __WEBPACK_IMPORTED_MODULE_6__components_Menu__["a" /* default */]
  }
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ad35e14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("WdLZ");
function injectStyle (ssrContext) {
  __webpack_require__("A1GC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ad35e14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xNE7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListFilterFieldsGeneric__ = __webpack_require__("cigy");


var Formfields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ListFilterFieldsGeneric__["a" /* default */])('Export');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Export',
  route: 'export',
  className: 'export',
  fields: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Formfields.ReferenceBySearchRep('organisationseinheit', 'sitemap', 'organisationseinheit'), {
    // not ideal since this finder isn't restricted to orga listed in leuris:Portal
    // finder: {
    //   name: 'bySearchRepLikeUnrestricted',
    //   multiValue: false,
    //   minLength: 0
    // }
    extraButton: {
      icon: 'map-marker',
      event: 'current-orga',
      tooltip: 'Export.currentOrga'
    }
  }), Formfields.Number('jahr', 'calendar-o'), {
    label: 'Export.list.filter.format',
    field: 'format',
    type: 'select',
    translatable: false,
    nullable: false,
    inEditView: function inEditView(_data, user) {
      return user.roles.ADMIN === true;
    },
    values: [{ value: 'PDF', label: 'PDF' }, { value: 'CSV', label: 'CSV' }]
  }, Formfields.String('email')]
});

/***/ }),

/***/ "xkmr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_form_Label__ = __webpack_require__("i8BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_form_EntityTableSelect__ = __webpack_require__("z/W/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_EntityDecorator__ = __webpack_require__("vlR/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-entity-multi-select',
  data: function data() {
    return {
      tableSelectVisible: false
    };
  },

  computed: {
    showLabel: function showLabel() {
      // since schema.editable might be undefined (which means here: implicitly true),
      // `schema.field === false` is NOT equivalent to `!schema.editable` since the latter
      // is `true` when schema.editable is false or undefined
      if (this.schema.editable === false) {
        return this.resourceData != null && this.resourceData.length !== 0;
      } else {
        return true;
      }
    },

    resourceData: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.$emit('input', newValue);
      }
    },
    deactivated: function deactivated() {
      if ('editable' in this.schema) {
        return !this.schema.editable;
      } else {
        return false;
      }
    }
  },
  props: {
    value: Array,
    schema: Object,
    asterisk: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    // currently unused, but ready for action
    // TODO: must also be passed down to the entityTableSelect
    draggable: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    dropRow: function dropRow(theid) {
      var newValue = this.resourceData.filter(function (item) {
        return item._id !== theid;
      });
      this.$emit('input', newValue);
    },
    showTableSelect: function showTableSelect() {
      this.tableSelectVisible = true;
    }
  },
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default.a,
    'fob-label': __WEBPACK_IMPORTED_MODULE_1__components_form_Label__["a" /* default */],
    'fob-entity-table-select': __WEBPACK_IMPORTED_MODULE_2__components_form_EntityTableSelect__["a" /* default */],
    'fob-entity-decorator': __WEBPACK_IMPORTED_MODULE_3__components_EntityDecorator__["a" /* default */]
  }
});

/***/ }),

/***/ "xljB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_form_EntitySelect__ = __webpack_require__("TzBH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_form_EntitySelectPrefetched__ = __webpack_require__("sY2r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_EntityMultiSelect__ = __webpack_require__("lJUF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_EntityMultiSelectVertical__ = __webpack_require__("uV+n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_form_Projektleiter__ = __webpack_require__("hZZj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_form_Label__ = __webpack_require__("i8BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__validation__ = __webpack_require__("2zM6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_fobclient_lib_entity_entityProvider__ = __webpack_require__("kia4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_fobclient_lib_entity_entityProvider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_fobclient_lib_entity_entityProvider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_form_HTMLEditor__ = __webpack_require__("UtpS");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-entity-create-form',
  data: function data() {
    var today = new Date();

    return {
      modalState: {},
      resourceData: this.value,
      maxDate: new Date(today.getFullYear() + 10, 11, 31)
    };
  },
  validations: function validations() {
    if (this.resourceData.skipValidation === true) {
      return {
        resourceData: {}
      };
    }
    if (this.schema.className in __WEBPACK_IMPORTED_MODULE_9__validation__["a" /* default */]) {
      if (['publikation', 'preis'].includes(this.schema.className)) {
        return {
          resourceData: __WEBPACK_IMPORTED_MODULE_9__validation__["a" /* default */][this.schema.className]()
        };
      } else if (['forschungsprojekt'].includes(this.schema.className)) {
        return {
          resourceData: __WEBPACK_IMPORTED_MODULE_9__validation__["a" /* default */][this.schema.className](this.resourceData.projektBeginn, this.resourceData.projektEnde)
        };
      } else {
        return {
          resourceData: __WEBPACK_IMPORTED_MODULE_9__validation__["a" /* default */][this.schema.className]
        };
      }
    } else {
      return {
        resourceData: {}
      };
    }
  },

  props: {
    schema: Object,
    showErrors: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    user: function user() {
      return this.$store.getters['user/getUser'];
    }
  },
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_10_vuedraggable___default.a,
    'fob-entity-select': __WEBPACK_IMPORTED_MODULE_3__components_form_EntitySelect__["a" /* default */],
    'fob-entity-select-prefetched': __WEBPACK_IMPORTED_MODULE_4__components_form_EntitySelectPrefetched__["a" /* default */],
    // 'fob-entity-table-select': EntityTableSelect,
    'fob-entity-multi-select': __WEBPACK_IMPORTED_MODULE_5__components_form_EntityMultiSelect__["a" /* default */],
    'fob-entity-multi-select-vertical': __WEBPACK_IMPORTED_MODULE_6__components_form_EntityMultiSelectVertical__["a" /* default */],
    'fob-projektleiter': __WEBPACK_IMPORTED_MODULE_7__components_form_Projektleiter__["a" /* default */],
    'fob-label': __WEBPACK_IMPORTED_MODULE_8__components_form_Label__["a" /* default */],
    'fob-html-editor': __WEBPACK_IMPORTED_MODULE_12__components_form_HTMLEditor__["a" /* default */]
  },
  methods: {
    inEditView: function inEditView(field) {
      if (field.inEditView instanceof Function) {
        return field.inEditView(this.resourceData, this.user);
      } else {
        return field.inEditView;
      }
    },
    hasAsterisk: function hasAsterisk(field) {
      return this.$v.resourceData[field] != null && this.$v.resourceData[field].$each == null && (this.$v.resourceData[field].minLength != null || this.$v.resourceData[field].required != null || this.$v.resourceData[field].name != null || this.$v.resourceData[field].$params != null && this.$v.resourceData[field].$params.required != null);
    },
    emptyField: function emptyField(field) {
      var component = this.$refs[field];
      if (component) {
        /*
        Why is $refs[field] an array of length 1 here, while in contrast
        just a single component in the entityListOptions.refs?
        */
        component[0].emptyField();
      }
    },
    touchField: function touchField(field) {
      if (this.$v.resourceData[field] != null) {
        this.$v.resourceData[field].$touch();
      }
    },
    isInvalid: function isInvalid(field) {
      var componentInvalid = false;
      var schema = this.schema.fields.find(function (fieldSchema) {
        return fieldSchema.field === field;
      });
      if (schema.type === 'html-text') {
        componentInvalid = !this.$refs[field][0].componentValid;
      }

      if (this.$v.resourceData[field] != null) {
        return componentInvalid || this.$v.resourceData[field].$invalid;
      } else {
        return componentInvalid;
      }
    },
    showModal: function showModal(field) {
      var added = {};
      added[field] = true;
      this.modalState = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.modalState, added);
    },
    pushToEmbedded: function pushToEmbedded(field, entityName) {
      if (!this.resourceData[field]) {
        this.$set(this.resourceData, field, []);
      }
      // provide fake ID
      var newEmbedded = new (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_fobclient_lib_entity_entityProvider__["EntityProvider"])(entityName))({ _id: '__' + Date.now() });
      newEmbedded._entityName = entityName;
      this.resourceData[field].push(newEmbedded);
    },
    removeEmbedded: function removeEmbedded(field, idx) {
      this.$set(this.resourceData, field, this.resourceData[field].filter(function (x, i) {
        return i !== idx;
      }));
    },

    // Function has to wait until watcher updates the data of the html-editor-component
    isResourceDataInvalid: function isResourceDataInvalid() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var fields;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$nextTick();

              case 2:
                fields = _this.schema.fields.map(function (fieldSchema) {
                  return fieldSchema.field;
                });
                return _context.abrupt('return', fields.map(_this.isInvalid).some(function (x) {
                  return x;
                }));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    // this is required so that the parent component gets the current state when
    // navigating to an partially filled in form
    this.isResourceDataInvalid().then(function (val) {
      return _this2.$emit('update:invalid', val);
    });
  },

  watch: {
    resourceData: {
      handler: function handler(val) {
        var _this3 = this;

        this.$set(val, '_dirty', true);
        this.$emit('input', val);
        this.isResourceDataInvalid().then(function (val) {
          return _this3.$emit('update:invalid', val);
        });
      },

      deep: true
    }
  }
});

/***/ }),

/***/ "y/j1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity__ = __webpack_require__("9fz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity__);


/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'PersonIdent',
  field: 'personIdent',
  type: 'object',
  cardinality: 'many',
  onlyCreate: true,
  render: 'embedded',
  schema: {
    route: 'personIdent',
    class: __WEBPACK_IMPORTED_MODULE_0_fobclient_lib_entity__["PersonIdent"],
    className: 'personIdent',
    entityName: 'de.ul.fob.domain.PersonIdent',
    fields: [{
      label: 'PersonIdent.form.personIdentTyp',
      field: 'personIdentTyp',
      entity: 'personIdentTyp',
      type: 'prefetchedObject',
      render: 'stringRep',
      cardinality: 'single',
      schema: {
        route: 'personidenttyp',
        className: 'personIdentTyp',
        fields: [{
          label: 'Name',
          field: 'name'
        }]
      },
      finder: {
        name: 'bySearchRepLike',
        multiValue: false,
        minLength: 0
      }
    }, {
      label: 'PersonIdent.form.wert',
      field: 'wert',
      view: function view(data) {
        return !(data.externalLink && data.externalLink.href);
      }
    }, {
      field: 'externalLink',
      label: 'PersonIdent.form.wert',
      type: 'link',
      view: function view(data) {
        return data.externalLink && data.externalLink.href;
      },
      computed: function computed(data) {
        var hrefs = {
          gepris: function gepris(id) {
            return 'https://gepris.dfg.de/gepris/person/' + id;
          },
          orcid: function orcid(id) {
            return 'https://orcid.org/' + id;
          },
          researcherid: function researcherid(id) {
            return 'https://publons.com/researcher/' + id;
          },
          'gnd-id': function gndId(id) {
            return 'https://d-nb.info/gnd/' + id;
          },
          'scopus author id': function scopusAuthorId(id) {
            return 'https://www.scopus.com/authid/detail.uri?authorId=' + id;
          },
          uri: function uri(id) {
            return id;
          }
        };
        var ityp = data.personIdentTyp.kennung.toLowerCase();
        var wert = data.wert.trim();
        var href = null;

        if (hrefs[ityp] && hrefs[ityp](wert)) {
          href = encodeURI(hrefs[ityp](wert));
        }

        return { href: href, text: wert };
      }
    }]
  }
});

/***/ }),

/***/ "y1zz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-label',
  props: ['label', 'asterisk']
});

/***/ }),

/***/ "yCdw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yCrn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.data[_vm.activeResourceType] && _vm.data[_vm.activeResourceType].length > 0)?_c('div',[_c('fob-entity-list-pagination',{attrs:{"disable-switch":true,"per-page":_vm.config[_vm.activeResourceType].perPage,"page":_vm.config[_vm.activeResourceType].page,"total":_vm.total[_vm.activeResourceType]},on:{"update:current":_vm.onPageChange}}),_vm._v(" "),_c('div',{staticClass:"fob-entity-compact-view"},[_c('fob-entity-list-compact-cyan',{attrs:{"data":_vm.data[_vm.activeResourceType],"show-publications-count":_vm.activeResourceType === 'forschungsprojekt',"show-publication-type":_vm.activeResourceType === 'publikation',"loading":_vm.isLoading,"entityDetailsRoute":"public_details","entityEditRoute":"editieren"}})],1),_vm._v(" "),_c('fob-entity-list-pagination',{attrs:{"disable-switch":true,"per-page":_vm.config[_vm.activeResourceType].perPage,"page":_vm.config[_vm.activeResourceType].page,"total":_vm.total[_vm.activeResourceType]},on:{"update:current":_vm.onPageChange}})],1):_c('div',{staticClass:"fob-public-view-no-data",staticStyle:{"padding":"1rem"}},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column",staticStyle:{"max-width":"50px"}},[_c('b-icon',{attrs:{"icon":"exclamation","type":"is-garnet"}})],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('em',[_c('translate',[_vm._v("list.noData")])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yGR3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preis_vue__ = __webpack_require__("YCNd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bbdeccc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preis_vue__ = __webpack_require__("7Igb");
function injectStyle (ssrContext) {
  __webpack_require__("vOD2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preis_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bbdeccc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preis_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yHJZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFieldsGeneric__ = __webpack_require__("K13K");

var ListFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ListFieldsGeneric__["a" /* default */])('Patent');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Patent',
  route: 'patent',
  className: 'patent',
  fields: [ListFields.SortableField('titel', true), ListFields.UnsortableReference('haupterfinder', true), ListFields.SortableField('veroeffentlichungsnummer', true), ListFields.SortableDate('datumDerPrioritaetsbegruendendenErstanmeldung', true), ListFields.SortableField('lizenzen', false), ListFields.SortableField('forschungsgebiet', false), ListFields.UnsortableReference('anmelderExtern', false), ListFields.UnsortableReference('anmelderIntern', false), ListFields.UnsortableReference('ansprechpartner', false), ListFields.UnsortableReference('land', true)]
});

/***/ }),

/***/ "yMki":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debounce__ = __webpack_require__("HhAh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mixins_AboutMeHelper__ = __webpack_require__("oE11");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-aboutme-list-filter',
  props: ['resourceType'],
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_mixins_AboutMeHelper__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    filter: 'aboutme/getFilter'
  })),
  methods: {
    onFilter: __WEBPACK_IMPORTED_MODULE_2_debounce___default()(function () {
      this.setFirstPage();
      this.loadAsyncData();
    }, 500)
  }
});

/***/ }),

/***/ "yasp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projektleiter_vue__ = __webpack_require__("pwjD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ec3e68d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Projektleiter_vue__ = __webpack_require__("BPUV");
function injectStyle (ssrContext) {
  __webpack_require__("mlSf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ec3e68d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projektleiter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ec3e68d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Projektleiter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z/W/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityTableSelect_vue__ = __webpack_require__("71Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ec7fbbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityTableSelect_vue__ = __webpack_require__("H80q");
function injectStyle (ssrContext) {
  __webpack_require__("PdFZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EntityTableSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ec7fbbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EntityTableSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z1hL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.resourceType)?_c('div',{staticStyle:{"max-width":"800px"}},[(!_vm.loading)?_c('div',[_c('fob-entity-header',{attrs:{"type":_vm.resourceSchema.label,"title":_vm.resourceData._stringRep,"createUser":_vm.resourceData._createUser,"createDate":_vm.resourceData._createDate,"updateUser":_vm.resourceData._updateUser,"updateDate":_vm.resourceData._updateDate}}),_vm._v(" "),_c('fob-entity-create-form',{key:_vm.$route.params.id,attrs:{"showErrors":_vm.showErrors,"type":_vm.resourceType,"schema":_vm.resourceSchema},on:{"update:invalid":function (value) { return _vm.isInvalid = value; },"input":function($event){_vm.updateData()}},model:{value:(_vm.resourceData),callback:function ($$v) {_vm.resourceData=$$v},expression:"resourceData"}}),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"40px"}},[_c('b-field',{attrs:{"grouped":""}},[_c('p',{staticClass:"control"},[_c('button',{staticClass:"button is-aquamarine",attrs:{"disabled":!_vm.isDirty},on:{"click":_vm.requestSave}},[_vm._v("Speichern")])]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('button',{staticClass:"button is-carnelian",attrs:{"disabled":!_vm.isDirty},on:{"click":function($event){_vm.close()}}},[_vm._v("Änderungen verwerfen")])])])],1)],1):_vm._e()]):_c('div',{staticClass:"section",staticStyle:{"max-width":"1200px"}},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column",staticStyle:{"max-width":"50px"}},[_c('b-icon',{attrs:{"icon":"exclamation","type":"is-aquamarine","size":"is-large"}})],1),_vm._v(" "),_c('div',{staticClass:"column"},[_vm._v("\n      Hier können Sie eine bereits angelegte Ressource / Forschungsaktivität bearbeiten und eine\n      aktualisierte Version speichern. Im Moment haben Sie noch "),_c('strong',[_vm._v("keine")]),_vm._v(" Ressource\n      zur Bearbeitung ausgewählt. Nutzen Sie dafür die "),_c('router-link',{attrs:{"to":"auflisten"}},[_vm._v("Listenansicht")]),_vm._v("\n      oder den \"Bearbeiten\"-Button in der "),_c('router-link',{attrs:{"to":"zeige"}},[_vm._v("Detailansicht.")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zEQw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttons quick-actions"},[(_vm.exportButtonActive)?_c('b-tooltip',{attrs:{"label":_vm.$gettext('Public.action.export'),"position":"is-top"}},[_c('button',{staticClass:"button",staticStyle:{"border":"0px","background-color":"transparent"},on:{"click":function($event){_vm.showExportModal = true}}},[_c('b-icon',{attrs:{"pack":"fa","icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.exportButtonDisabled)?_c('b-tooltip',{attrs:{"label":_vm.$gettext('Public.action.export.disabled'),"position":"is-top","multilined":""}},[_c('button',{staticClass:"button",staticStyle:{"border":"0px","background-color":"transparent"},attrs:{"disabled":""}},[_c('b-icon',{attrs:{"type":"is-lightgray","pack":"fa","icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.qaShare)?_c('b-tooltip',{attrs:{"label":_vm.$gettext('Public.action.share'),"position":"is-top"}},[_c('b-dropdown',{attrs:{"position":"is-bottom-left"}},[_c('button',{staticClass:"button",staticStyle:{"border":"0px","background-color":"transparent"},attrs:{"slot":"trigger"},slot:"trigger"},[_c('b-icon',{attrs:{"pack":"fa","icon":"link"}})],1),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.shareAsSimple()}}},[_c('translate',[_vm._v("Public.action.share.default")])],1),_vm._v(" "),(_vm.hasQueryParams())?_c('b-dropdown-item',{on:{"click":function($event){_vm.shareAsSimpleWithQueryParams()}}},[_c('translate',[_vm._v("Public.action.share.defaultWithSearchOptions")])],1):_vm._e(),_vm._v(" "),(_vm.isCompact())?_c('b-dropdown-item',{on:{"click":function($event){_vm.shareAsCompact()}}},[_c('translate',[_vm._v("Public.action.share.compact")])],1):_vm._e(),_vm._v(" "),(_vm.isCompact() && _vm.hasQueryParams())?_c('b-dropdown-item',{on:{"click":function($event){_vm.shareAsCompactWithQueryParams()}}},[_c('translate',[_vm._v("Public.action.share.compactWithSearchOptions")])],1):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.qaPrint)?_c('b-tooltip',{attrs:{"label":_vm.$gettext('Public.action.print'),"position":"is-top"}},[_c('button',{staticClass:"button",staticStyle:{"border":"0px","background-color":"transparent"},on:{"click":_vm.print}},[_c('b-icon',{attrs:{"pack":"fa","icon":"print"}})],1)]):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"fobExportModal",attrs:{"active":_vm.showExportModal,"has-modal-card":"","scroll":"keep"},on:{"update:active":function($event){_vm.showExportModal=$event}}},[_c('fob-public-list-export')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zHdJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicSelectOrganisationalUnit_vue__ = __webpack_require__("Pxwp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53167d1f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicSelectOrganisationalUnit_vue__ = __webpack_require__("wZvs");
function injectStyle (ssrContext) {
  __webpack_require__("2WFi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicSelectOrganisationalUnit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53167d1f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicSelectOrganisationalUnit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zUxD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"active":_vm.showCreateModal,"has-modal-card":""},on:{"update:active":function($event){_vm.showCreateModal=$event}}},[_c('div',{staticClass:"modal-card"},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_c('translate',[_vm._v("createModal.header."+_vm._s(_vm.field))])],1)]),_vm._v(" "),_c('section',{staticClass:"modal-card-body",staticStyle:{"overflow-x":"hidden"}},[_c('fob-entity-create-form',{attrs:{"showErrors":_vm.showErrors,"name":"fob-modal-create-form-modal","schema":_vm.schema},on:{"update:invalid":function (value) { return _vm.isInvalid = value; }},model:{value:(_vm.created),callback:function ($$v) {_vm.created=$$v},expression:"created"}})],1),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('button',{staticClass:"button is-danger",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_c('translate',[_vm._v("createModal.button.cancel")])],1),_vm._v(" "),_c('button',{staticClass:"button is-primary",on:{"click":_vm.requestSubmit}},[_c('translate',[_vm._v("createModal.button.create")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zY9s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_EntityListCompactCyan__ = __webpack_require__("ht1h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_EntityListPagination__ = __webpack_require__("LXsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_AboutMeHelper__ = __webpack_require__("oE11");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-aboutme-list-compact',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_mixins_AboutMeHelper__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    data: 'aboutme/getData',
    config: 'aboutme/getConfig',
    schema: 'aboutme/getSchema',
    total: 'aboutme/getTotal',
    isLoading: 'aboutme/isLoading'
  })),
  methods: {
    onPageChange: function onPageChange(page) {
      this.$store.dispatch('aboutme/changePage', {
        resourceType: this.activeResourceType,
        page: page
      });
      this.loadAsyncData();
    }
  },
  components: {
    'fob-entity-list-compact-cyan': __WEBPACK_IMPORTED_MODULE_2__components_EntityListCompactCyan__["a" /* default */],
    'fob-entity-list-pagination': __WEBPACK_IMPORTED_MODULE_3__components_EntityListPagination__["a" /* default */]
  }
});

/***/ }),

/***/ "zaUY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_DateTimeHelper__ = __webpack_require__("5W2G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_CompactViewHelper__ = __webpack_require__("TGNV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fob-veranstaltung-compact',
  props: ['schema', 'data'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_DateTimeHelper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__components_mixins_CompactViewHelper__["a" /* default */]],
  computed: {
    veranstalter: function veranstalter() {
      return this.data.veranstalter.map(this.fullName).join('; ');
    },
    dateRange: function dateRange() {
      var range = [];
      var start = void 0;
      var end = void 0;
      if (this.data.veranstaltungStart != null) {
        start = this.asDate(this.data.veranstaltungStart);
        range.push(start);
      }
      if (this.data.veranstaltungEnde != null) {
        end = this.asDate(this.data.veranstaltungEnde);
        if (start !== end) {
          range.push(end);
        }
      }
      return range.join(' - ');
    },
    hasAdditionalOUs: function hasAdditionalOUs() {
      return this.data.weitereOrganisationseinheiten != null && this.data.weitereOrganisationseinheiten.length > 0;
    },
    additionalOUs: function additionalOUs() {
      return this.data.weitereOrganisationseinheiten.map(function (x) {
        return x.name;
      }).join('; ');
    }
  }
});

/***/ }),

/***/ "ze6G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__ = __webpack_require__("cigy");

var Filter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ListFilterFieldsGeneric__["a" /* default */])('Veranstaltung');

/* harmony default export */ __webpack_exports__["a"] = ({
  label: 'Veranstaltung',
  route: 'veranstaltung',
  fields: [Filter.ReferenceByMultiValueSearchRep('organisationseinheit', 'sitemap', 'organisationseinheit'), Filter.kumuliert(), Filter.Number('berichtsjahr', 'calendar-o'), Filter.ReferenceByMultiValueSearchRep('veranstalter', 'user', 'abstractPerson'), Filter.String('name'), Filter.String('veranstaltungsTyp'), Filter.String('stadt'), Filter.ReferenceBySearchRep('land'), {
    label: 'Veranstaltung.list.filter.virtuell',
    field: 'virtuell',
    type: 'select',
    translatable: true,
    values: [{
      value: 'TRUE',
      label: 'Veranstaltung.virtuell.TRUE'
    }, {
      value: 'FALSE',
      label: 'Veranstaltung.virtuell.FALSE'
    }, {
      value: null,
      label: ''
    }]
  }]
});

/***/ }),

/***/ "zjDv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zjoM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticStyle:{"padding":"1em"}},_vm._l((_vm.data),function(item){return _c('li',{key:item._id,staticStyle:{"margin-bottom":"1rem"}},[_c('fob-entity-compact-cyan',{attrs:{"data":item,"entityDetailsRoute":_vm.entityDetailsRoute,"entityEditRoute":_vm.entityEditRoute,"show-publications-count":_vm.showPublicationsCount,"show-publication-type":_vm.showPublicationType,"show-star":_vm.showStar}})],1)})),_vm._v(" "),_c('b-loading',{attrs:{"is-full-page":false,"active":_vm.loading},on:{"update:active":function($event){_vm.loading=$event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.de54494fa5a1efc21b70.js